webpackJsonp([1],{

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap) {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
  var base64 = new Buffer(JSON.stringify(sourceMap)).toString('base64');
  var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

  return '/*# ' + data + ' */';
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(298).Buffer))

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  scopeId,
  cssModules
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  // inject cssModules
  if (cssModules) {
    var computed = Object.create(options.computed || null)
    Object.keys(cssModules).forEach(function (key) {
      var module = cssModules[key]
      computed[key] = function () { return module }
    })
    options.computed = computed
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(643)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),

/***/ 157:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(636)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(287),
  /* template */
  __webpack_require__(613),
  /* scopeId */
  "data-v-46d17f63",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 168:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var SIGN_REGEXP = /([yMdhsm])(\1*)/g;
var DEFAULT_PATTERN = 'yyyy-MM-dd hh:mm:ss';
function padding(s, len) {
    var len = len - (s + '').length;
    for (var i = 0; i < len; i++) {
        s = '0' + s;
    }
    return s;
};

function switchResizePostfix(url, postfix) {
    var pos = url.lastIndexOf('!');
    if (pos != -1) {
        url = url.substring(0, pos);
    }
    return url + postfix;
}

/* harmony default export */ __webpack_exports__["a"] = ({
    formatDate: {
        format: function format(date, pattern) {
            pattern = pattern || DEFAULT_PATTERN;
            return pattern.replace(SIGN_REGEXP, function ($0) {
                switch ($0.charAt(0)) {
                    case 'y':
                        return padding(date.getFullYear(), $0.length);
                    case 'M':
                        return padding(date.getMonth() + 1, $0.length);
                    case 'd':
                        return padding(date.getDate(), $0.length);
                    case 'w':
                        return date.getDay() + 1;
                    case 'h':
                        return padding(date.getHours(), $0.length);
                    case 'm':
                        return padding(date.getMinutes(), $0.length);
                    case 's':
                        return padding(date.getSeconds(), $0.length);
                }
            });
        },
        parse: function parse(dateString, pattern) {
            var matchs1 = pattern.match(SIGN_REGEXP);
            var matchs2 = dateString.match(/(\d)+/g);
            if (matchs1.length == matchs2.length) {
                var _date = new Date(1970, 0, 1);
                for (var i = 0; i < matchs1.length; i++) {
                    var _int = parseInt(matchs2[i]);
                    var sign = matchs1[i];
                    switch (sign.charAt(0)) {
                        case 'y':
                            _date.setFullYear(_int);break;
                        case 'M':
                            _date.setMonth(_int - 1);break;
                        case 'd':
                            _date.setDate(_int);break;
                        case 'h':
                            _date.setHours(_int);break;
                        case 'm':
                            _date.setMinutes(_int);break;
                        case 's':
                            _date.setSeconds(_int);break;
                    }
                }
                return _date;
            }
            return null;
        }

    },

    resizeOSSImage: {
        postfixThumbnail: '!thumbnail',

        switchResizeToPreview: function switchResizeToPreview(url) {
            return switchResizePostfix(url, '!resize');
        },
        switchResizeToThumbnail: function switchResizeToThumbnail(url) {
            return switchResizePostfix(url, '!thumbnail');
        },
        switchResizeToInit: function switchResizeToInit(url) {
            return switchResizePostfix(url, '');
        }
    }
});

/***/ }),

/***/ 223:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "epq_forms1-13.docx";

/***/ }),

/***/ 226:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(626)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(285),
  /* template */
  __webpack_require__(604),
  /* scopeId */
  "data-v-1b85e906",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(622)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(286),
  /* template */
  __webpack_require__(616),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(628)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(288),
  /* template */
  __webpack_require__(606),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(624)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction) {
  isProduction = _isProduction

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[data-vue-ssr-id~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),

/***/ 230:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


// Global defaults
__WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.baseURL = '/api';

// 封装失败返回结果
var errorRes = {
    code: 99,
    message: ''
};

__WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['Cache-Control'] = 'no-cache';
__WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['If-Modified-Since'] = '0';

var interceptor = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.interceptors.response.use(function (response) {
    var _response$data = response.data,
        c = _response$data.c,
        r = _response$data.r,
        i = _response$data.i;

    var res = void 0;
    switch (c) {
        case 0:
            // 成功则直接返回数据对象
            res = Promise.resolve(r);
            break;
        default:
            // 各种失败统一封装
            console.log(i);
            errorRes.code = c;
            errorRes.message = i;
            res = Promise.reject(errorRes);
            break;
    }
    return res;
}, function (error) {
    if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
    } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.log(error.request);
    } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error.message);
    }
    console.log(error.config);

    errorRes.code = 99;
    errorRes.message = 'Service unavailable, please try again later.';

    return Promise.reject(errorRes);
});

__WEBPACK_IMPORTED_MODULE_0_axios___default.a.instance = function () {
    var instance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create();
    instance.interceptors.response.eject(interceptor);
    return instance;
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_axios___default.a);

/***/ }),

/***/ 231:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_Login_vue__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_Login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__views_Login_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_404_vue__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_404_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__views_404_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_admin_Student_vue__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_admin_Student_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_admin_Student_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_admin_Teacher_vue__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_admin_Teacher_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_admin_Teacher_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_admin_Ta_vue__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_admin_Ta_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_admin_Ta_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_admin_Trash_vue__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_admin_Trash_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_admin_Trash_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_admin_Relation_vue__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_admin_Relation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_admin_Relation_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_admin_Trip_vue__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_admin_Trip_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_admin_Trip_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_student_Report_vue__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_student_Report_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__views_student_Report_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_student_Evidence_vue__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_student_Evidence_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_student_Evidence_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_teacher_Progress_vue__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_teacher_Progress_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__views_teacher_Progress_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_teacher_TeacherRelation_vue__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_teacher_TeacherRelation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__views_teacher_TeacherRelation_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_Notification_vue__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_Notification_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__views_Notification_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_Home_vue__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_Home_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__views_Home_vue__);
















var routes = [{
    path: '/login',
    component: __WEBPACK_IMPORTED_MODULE_0__views_Login_vue___default.a,
    alias: '/',
    name: ''
},
// TODO: logout refactor
// { path: '/logout',
//     beforeEnter (to, from, next) {
//         // auth.logout()
//         next('/')
//     }
// },
{
    path: '/404',
    component: __WEBPACK_IMPORTED_MODULE_1__views_404_vue___default.a,
    name: ''
}, {
    path: '/notification',
    component: __WEBPACK_IMPORTED_MODULE_12__views_Notification_vue___default.a,
    name: ''
}, {
    path: '/admin',
    component: __WEBPACK_IMPORTED_MODULE_13__views_Home_vue___default.a,
    meta: { role: 'admin' },
    children: [{ path: 'student', component: __WEBPACK_IMPORTED_MODULE_2__views_admin_Student_vue___default.a, name: 'Student', iconCls: 'icon ion-person-stalker' }, { path: 'sa', component: __WEBPACK_IMPORTED_MODULE_3__views_admin_Teacher_vue___default.a, name: 'SA', iconCls: 'icon ion-person' }, { path: 'ta', component: __WEBPACK_IMPORTED_MODULE_4__views_admin_Ta_vue___default.a, name: 'TA', iconCls: 'icon ion-person' }, { path: 'bin', component: __WEBPACK_IMPORTED_MODULE_5__views_admin_Trash_vue___default.a, name: 'Bin', iconCls: 'icon ion-trash-a' }, { path: 'relation', component: __WEBPACK_IMPORTED_MODULE_6__views_admin_Relation_vue___default.a, name: 'Relation', iconCls: 'icon ion-network' }, { path: 'trip', component: __WEBPACK_IMPORTED_MODULE_7__views_admin_Trip_vue___default.a, name: 'Trip', iconCls: 'icon ion-plane' }]
}, {
    path: '/student',
    component: __WEBPACK_IMPORTED_MODULE_13__views_Home_vue___default.a,
    meta: { role: 'student' },
    children: [{ path: 'cope', component: __WEBPACK_IMPORTED_MODULE_8__views_student_Report_vue___default.a, name: 'EPQ', iconCls: 'icon ion-university' }, { path: 'aope', component: __WEBPACK_IMPORTED_MODULE_8__views_student_Report_vue___default.a, name: 'LOG', iconCls: 'icon ion-university' }, { path: 'cope/evidence', component: __WEBPACK_IMPORTED_MODULE_9__views_student_Evidence_vue___default.a, name: 'CoPEEvidence', iconCls: 'icon ion-university', hiddenFromMenu: true }, { path: 'aope/evidence', component: __WEBPACK_IMPORTED_MODULE_9__views_student_Evidence_vue___default.a, name: 'AoPEEvidence', iconCls: 'icon ion-university', hiddenFromMenu: true }]
}, {
    path: '/teacher',
    component: __WEBPACK_IMPORTED_MODULE_13__views_Home_vue___default.a,
    meta: { role: 'teacher' },
    children: [{ path: 'progress', component: __WEBPACK_IMPORTED_MODULE_10__views_teacher_Progress_vue___default.a, name: 'Student Progress', iconCls: 'icon ion-university' },
    // {path: 'relation', component: teacherRelation, name: 'Manage Relations', iconCls: 'icon ion-university',},
    { path: 'progress/evidence', component: __WEBPACK_IMPORTED_MODULE_9__views_student_Evidence_vue___default.a, name: 'TeacherEvidence', iconCls: 'icon ion-university', hiddenFromMenu: true }]
}, {
    path: '/ta',
    component: __WEBPACK_IMPORTED_MODULE_13__views_Home_vue___default.a,
    meta: { role: 'ta' },
    children: [{ path: 'progress', component: __WEBPACK_IMPORTED_MODULE_10__views_teacher_Progress_vue___default.a, name: 'Student Progress', iconCls: 'icon ion-university' },
    // {path: 'relation', component: teacherRelation, name: 'Manage Relations', iconCls: 'icon ion-university',},
    { path: 'progress/evidence', component: __WEBPACK_IMPORTED_MODULE_9__views_student_Evidence_vue___default.a, name: 'TeacherEvidence', iconCls: 'icon ion-university', hiddenFromMenu: true }]
}, {
    path: '*',
    redirect: { path: '/404' }
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ 233:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 234:
/***/ (function(module, exports) {

/**
 * Vue.js 2.0 plugin
 *
 */

function formatComponentName(vm) {
  if (vm.$root === vm) {
    return 'root instance';
  }
  var name = vm._isVue ? vm.$options.name || vm.$options._componentTag : vm.name;
  return (
    (name ? 'component <' + name + '>' : 'anonymous component') +
    (vm._isVue && vm.$options.__file ? ' at ' + vm.$options.__file : '')
  );
}

function vuePlugin(Raven, Vue) {
  Vue = Vue || window.Vue;

  // quit if Vue isn't on the page
  if (!Vue || !Vue.config) return;

  var _oldOnError = Vue.config.errorHandler;
  Vue.config.errorHandler = function VueErrorHandler(error, vm, info) {
    var metaData = {};

    // vm and lifecycleHook are not always available
    if (Object.prototype.toString.call(vm) === '[object Object]') {
      metaData.componentName = formatComponentName(vm);
      metaData.propsData = vm.$options.propsData;
    }

    if (typeof info !== 'undefined') {
      metaData.lifecycleHook = info;
    }

    Raven.captureException(error, {
      extra: metaData
    });

    if (typeof _oldOnError === 'function') {
      _oldOnError.call(this, error, vm, info);
    }
  };
}

module.exports = vuePlugin;


/***/ }),

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(633)
__webpack_require__(634)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(275),
  /* template */
  __webpack_require__(611),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 275:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app',
    components: {}
});

/***/ }),

/***/ 276:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_Header_vue__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_Header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_Header_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        'common-header': __WEBPACK_IMPORTED_MODULE_0__common_Header_vue___default.a
    },
    data: function data() {
        return {
            screenHeight: document.body.clientHeight - 60 - 40, //减去header的60px
            Role: __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.get('role'),
            tips: ''
        };
    },


    methods: {
        matchedPath: function matchedPath(roleRoot) {
            // TODO:去掉需要polyfill的find方法
            return roleRoot.path === this.$route.matched.find(function (record) {
                return !record.parent;
            }).path;
        },
        getMenuActive: function getMenuActive() {
            // 导航路径层级+1，目前是两层路径
            var menuDepth = 3;
            var path = this.$route.path;
            // 超过导航层级则菜单只按照目前最高层匹配
            if (path.split('/').length > menuDepth) {
                return path.slice(0, path.lastIndexOf('/'));
            } else {
                return path;
            }
        },
        handleTips: function handleTips(val) {
            console.log(val, "ab;;;;;");
            this.tips = val;
        }
    },
    mounted: function mounted() {
        var _this = this;

        document.getElementById('main').style.minHeight = this.screenHeight + "px"; //页面初始化设置最小高度
        //                document.getElementById('main').style.background='white';//页面初始化
        window.onresize = function () {
            return function () {
                _this.screenHeight = document.body.clientHeight;
                alert(_this.screenHeight);
            };
        };
    },

    watch: {
        screenHeight: function screenHeight(val) {
            this.screenHeight = val;
            document.getElementById('main').style.height = this.screenHeight - 100 + "px"; //检测窗口的大小，并赋值
        }
    }
});

/***/ }),

/***/ 277:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component_md5__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__component_md5__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            activeIndex2: '1',
            input: '',
            Emaxlength: 255,
            Pmaxlength: 20,

            logform: {
                username: '',
                password: ''
            },
            rules: {
                username: [{ required: true, message: 'Email address is required', trigger: 'blur' }, { type: 'email', message: 'Invalid email address', trigger: 'blur' }],
                password: [{ required: true, message: 'Password is required', trigger: 'blur' }]
            }
        };
    },

    methods: {
        //前端验证并跳转
        submitForm: function submitForm(formName) {
            var _this = this;

            this.$refs[formName].validate(function (valid) {
                if (valid) {
                    var passward_md5 = __WEBPACK_IMPORTED_MODULE_0__component_md5___default.a.hex_md5(_this.logform.password);
                    _this.$http.post('user/login', {}, {
                        params: {
                            username: _this.logform.username,
                            password: passward_md5
                        }
                    }).then(function (response) {
                        switch (response) {
                            case 'admin':
                                _this.$router.push('/admin/student');
                                break;
                            case 'teacher':
                                _this.$router.push('/teacher/progress');
                                break;
                            case 'ta':
                                _this.$router.push('/ta/progress');
                                break;
                            case 'student':
                                _this.$router.push('/student/cope');
                                break;
                        }
                    }).catch(function (error) {
                        _this.$message.error(error.message);
                    });
                } else {
                    return false;
                }
            });
        }
    }
});

/***/ }),

/***/ 278:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_Header_vue__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_Header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_Header_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_ReportDialog_vue__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_ReportDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_ReportDialog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_EvidenceDialog_vue__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_EvidenceDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_EvidenceDialog_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        SkillDialog: __WEBPACK_IMPORTED_MODULE_2__common_ReportDialog_vue___default.a,
        'common-header': __WEBPACK_IMPORTED_MODULE_0__common_Header_vue___default.a,
        'skill-dialog': __WEBPACK_IMPORTED_MODULE_2__common_ReportDialog_vue___default.a,
        'evidence-dialog': __WEBPACK_IMPORTED_MODULE_3__common_EvidenceDialog_vue___default.a
    },
    data: function data() {
        return {
            screenHeight: document.body.clientHeight - 60 - 40, //减去header的60px
            activeName: '1', //tab默认值为'未读'
            isNextPage: false, //判断是否点击了第二个tab
            tabLabel: [],
            loading: true,
            role: '', //cookie读取
            teacherId: 0, //cookie读取
            userid: 0, //cookie读取

            selectStu: '',
            selectStuUserId: 0,
            stuOptions: [],
            //列表分页
            order: '',
            isLineRead: false, //弹窗关闭时通过此来判断是否还需标为已读
            notificationId: 0, //弹窗关闭时将此条标为已读
            tableLoading: false,
            unReadTableData: [],
            tableData: [],
            currentPage: 1,
            totalPages: 1,
            size: 15,
            queryStudentId: 0, //从progress跳转过来的学生id

            report: {},
            notificationUserId: 0,

            // 控制mark all as Read按钮 loading状态
            allReadLoading: false,
            studentReadLoading: false,
            isStuReadDisabled: true
        };
    },
    mounted: function mounted() {
        var _this2 = this;

        this.$nextTick(function () {
            _this2.init();
            _this2.getNotification();
            _this2.getProfile();
            _this2.getUnreadNotification();
            if (_this2.role === 'teacher' || _this2.role === 'ta') {
                _this2.getUsers();
            }
            document.getElementById('main').style.minHeight = _this2.screenHeight + "px"; //页面初始化设置最小高度
        });
    },

    methods: {
        sortList: function sortList(sort) {
            this.order = sort.order;
            this.currentPage = 1;
            this.getNotification(this.order);
        },
        init: function init() {
            this.teacherId = __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.get('teacherId');
            this.studentId = __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.get('studentId');
            this.userid = __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.get('userid');
            this.role = __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.get('role');
            this.tabLabel.push({ //tab状态
                title: 'Unread',
                name: '1',
                role: this.role,
                isAllRead: false

            }, {
                title: 'All',
                name: '2',
                role: this.role,
                isAllRead: false
            });
            var query = this.$route.query;
            if (query) {
                this.queryStudentId = query.studentId;
                this.selectStu = query.studentName;
            } else {
                this.$message.error('Cannot get notification');
            }
        },


        //获取学生列表
        getUsers: function getUsers() {
            var _this3 = this;

            if (this.role === 'teacher' || this.role === 'ta') {
                this.loading = false;
                this.$http.get('notification/student', {
                    params: {
                        teacherId: this.teacherId,
                        all: this.isNextPage //all为true返回全部列表，false返回未读列表
                    }
                }).then(function (response) {
                    //渲染数据
                    _this3.stuOptions = response;
                }).catch(function (error) {
                    _this3.$message.error(error.message);
                });
            }
        },


        //获取notification
        getNotification: function getNotification(order) {
            var _this4 = this;

            this.tableLoading = true;
            this.$http.get('notification', {
                params: {
                    role: this.role,
                    id: this.role === 'student' ? this.studentId : this.teacherId,
                    size: this.size,
                    //从progress跳转过来时this.selectStu即select值为字符串，则从query直接取id
                    studentId: typeof this.selectStu !== 'number' && this.selectStu !== '' ? this.queryStudentId : this.selectStu,
                    read: this.isNextPage, //isNextPage为true表示查看下一tab全部列表，false返回未读列表
                    page: this.currentPage - 1,
                    //element order有三种结果 ：'descending'，'ascending'，null，初始化时undefinded，默认情况sort设为true，否则按order 来
                    sort: order === undefined || order === '' || order === 'descending'
                    //                        sort:(order !=='descending'||'ascending'?true:(order === 'descending'))
                }
            }).then(function (response) {
                //渲染数据
                _this4.tableData = response.list;
                _this4.studentReadLoading = true;
                _this4.isStuReadDisabled = true;
                //                    var templateText = ['Witness testimony', 'Peer/Witness statement', 'Team action plan', 'Personal action plan', 'Action plan', 'PDF', 'Photographic', 'Team Video'];
                var templateText = ['PDF', 'Photographic', 'Team Video', 'Peer/Witness statement', 'Observation checklist', 'Observation checklist', 'Observation checklist'];
                for (var i = 0; i < _this4.tableData.length; i++) {
                    if (_this4.tableData[i].type === 'comment') {
                        _this4.$set(_this4.tableData[i], 'typeName', 'Commented');
                    } else if (_this4.tableData[i].type === 'pageEvidence') {
                        _this4.$set(_this4.tableData[i], 'typeName', 'Edited evidence');
                    } else {
                        _this4.$set(_this4.tableData[i], 'typeName', 'Edited');
                    }
                    if (_this4.tableData[i].templateType !== null) {
                        _this4.tableData[i].templateHtml = templateText[_this4.tableData[i].templateType];
                    }
                }

                var _this = _this4;
                if (_this4.selectStu > 0) {
                    response.list.forEach(function (pro) {
                        if (pro.read == false) {
                            _this.isStuReadDisabled = false; //如果该学生搜出来的通知一旦有未读的， 则student read按钮可用
                            return false;
                        }
                    });
                }

                _this4.totalPages = response.totalPages;
                _this4.tableLoading = false;
                // 控制mark all as Read按钮loading
                _this4.allReadLoading = false;
                _this4.studentReadLoading = false;
            }).catch(function (error) {
                _this4.$message.error(error.message);
                _this4.tableLoading = false;
                _this4.allReadLoading = false;
                _this4.studentReadLoading = false;
            });
        },


        //获取未读notification总数
        getUnreadNotification: function getUnreadNotification(order) {
            var _this5 = this;

            this.tableLoading = true;
            this.$http.get('notification', {
                params: {
                    role: this.role,
                    id: this.role === 'student' ? this.studentId : this.teacherId,
                    size: this.size,
                    //isNextPage为true表示查看下一tab全部列表，false返回未读列表
                    studentId: typeof this.selectStu !== 'number' && this.selectStu !== '' ? this.queryStudentId : this.selectStu,
                    read: false,
                    page: this.currentPage - 1,
                    sort: true
                }
            }).then(function (response) {
                //渲染数据
                _this5.unReadTableData = response.list;
                if (_this5.unReadTableData.length === 0) {
                    var _this = _this5;
                    _this.tabLabel.forEach(function (val, index) {
                        _this.$set(_this.tabLabel[index], 'isAllRead', true);
                    });
                }
                _this5.tableLoading = false;
                // 控制mark all as Read按钮loading
                _this5.allReadLoading = false;
            }).catch(function (error) {
                _this5.$message.error(error.message);
                _this5.tableLoading = false;
                _this5.allReadLoading = false;
            });
        },


        //改变当前页函数
        changeCurrentPage: function changeCurrentPage(val) {
            this.currentPage = val;
            this.getNotification(this.order);
        },


        //搜索某学生
        selectStuNoti: function selectStuNoti(ev) {
            this.currentPage = 1;
            this.selectStu = ev;
            var _this = this;
            if (ev !== '') {
                _this.stuOptions.forEach(function (pro) {
                    if (pro.id === ev) {
                        _this.selectStuUserId = pro.userId;
                    }
                });
            }
            this.getNotification();
        },


        //TAB切换
        handleClick: function handleClick(tab, event) {
            if (tab.index == 0) {
                this.isNextPage = false;
            } else {
                this.isNextPage = true;
            }
            this.currentPage = 1;
            this.selectStu = '';
            this.isStuReadDisabled = true;
            this.getUsers();
            this.getNotification();
        },


        //点击按钮标记改行为已读
        setCurrentLine: function setCurrentLine(row) {
            var _this6 = this;

            this.tableLoading = true;
            this.$http.patch('notification/read/' + row.id).then(function (response) {
                //渲染数据
                _this6.getNotification(_this6.order);
                _this6.getUnreadNotification();
                // 点击按钮后更新通知数量
                _this6.$refs.header.getNotificationCount();
                _this6.tableLoading = false;
                _this6.isLineRead = false; //初始关闭弹窗后是否标记已读的判断条件
                _this6.notificationId = 0; //初始关闭弹窗后标记的行
            }).catch(function (error) {
                _this6.$message.error(error.message);
                _this6.tableLoading = false;
            });
        },


        //标记所有
        markAll: function markAll() {
            var _this7 = this;

            this.allReadLoading = true;
            this.tableLoading = true;
            this.$http.patch('notification/readAll/' + this.userid).then(function (response) {
                //渲染数据
                _this7.getNotification();
                _this7.getUnreadNotification();
                // 点击按钮后更新通知数量
                _this7.$refs.header.getNotificationCount();
            }).catch(function (error) {
                _this7.$message.error(error.message);
                _this7.allReadLoading = false;
                _this7.tableLoading = false;
            });
        },


        //标记当前学生
        markThisStudent: function markThisStudent() {
            var _this8 = this;

            this.studentReadLoading = true;
            this.tableLoading = true;
            this.$http.patch('notification/readByStudent/' + this.selectStuUserId).then(function (response) {
                //渲染数据
                _this8.getUsers();
                _this8.selectStu = '';
                _this8.isStuReadDisabled = true;
                _this8.getNotification();
                _this8.getUnreadNotification();
                // 点击按钮后更新通知数量
                _this8.$refs.header.getNotificationCount();
            }).catch(function (error) {
                _this8.$message.error(error.message);
                _this8.studentReadLoading = false;
                _this8.tableLoading = false;
            });
        },
        whetherMarkAll: function whetherMarkAll() {
            var _this9 = this;

            this.$confirm('This will mark all unread messages as read.', 'Confirm', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(function () {
                _this9.markAll();
            }).catch(function () {//弹窗点击cancel后执行的方法

            });
        },
        whetherMarkStudent: function whetherMarkStudent() {
            var _this10 = this;

            this.$confirm('This will mark the unread messages of the current selected student as read. ', 'Confirm', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(function () {
                _this10.markThisStudent();
            }).catch(function () {//弹窗点击cancel后执行的方法

            });
        },


        //学生端获取学生个人信息（拼音）
        getProfile: function getProfile() {
            var _this11 = this;

            if (this.role === 'student') {
                this.$http.get('student/' + this.studentId).then(function (response) {
                    _this11.displayName = response.displayName + ' - ' + response.givenName + '  ' + response.familyName;
                }).catch(function (error) {
                    _this11.$message.error(error.message);
                });
            }
        },
        toDialog: function toDialog(notification) {
            var _this12 = this;

            console.log('todailog');
            this.report.id = notification.reportId;
            this.notificationUserId = notification.fromUserId;
            if (notification.questionId !== null) {
                this.$http.get('question/skill/' + notification.questionId).then(function (response) {
                    var skill = response;
                    var page = void 0;
                    var studentId = _this12.role === 'student' ? _this12.studentId : notification.fromStudentId;
                    var studentName = _this12.role === 'student' ? _this12.displayName : notification.fromName + ' - ' + notification.fromGivenName + ' ' + notification.fromFamilyName;
                    for (var i = 0; i < skill.pageList.length; i++) {
                        if (skill.pageList[i].confirmed) page = skill.pageList[i];
                    }
                    _this12.$refs.reportDialog.showDialogFromNoti(_this12.report, skill, page, {
                        commentId: notification.commentId,
                        type: notification.type,
                        studentId: studentId,
                        studentName: studentName,
                        questionId: notification.questionId
                    });
                }).catch(function (error) {
                    _this12.$message.error(error.message);
                });
            }
            if (notification.pageEvidenceId !== null) {
                this.$refs.evidenceDialog.showEvidenceDialog(notification.templateType, notification.pageEvidenceId, {
                    commentId: notification.commentId,
                    type: notification.type,
                    questionId: notification.pageEvidenceQuestionId
                });
            }
            this.notificationId = notification.id;
            this.isLineRead = notification.read;
        }
    }
});

/***/ }),

/***/ 279:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_TransferBox_vue__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_TransferBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_TransferBox_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        "transfer-box": __WEBPACK_IMPORTED_MODULE_0__common_TransferBox_vue___default.a
    },
    data: function data() {
        return {
            selecttripvalue: '',
            selectTeacherValue: '',
            // 教师数据----
            teacherId: '',
            teachers: [],
            currentPage: 1,
            totalPages: 1,
            loading: true,
            //----教师数据
            options: [],
            size: 500 // 现在设为200，是为了获取全部教师数据
        };
    },
    created: function created() {
        this.getusers();
        this.selectTrip();
    },

    methods: {
        //获取trip列表
        selectTrip: function selectTrip() {
            var _this = this;

            this.$http.get('trip/list').then(function (response) {
                _this.options = response;
            }).catch(function (error) {
                _this.$message.error(error.message);
            });
        },

        //获取教师列表通用函数
        getusers: function getusers() {
            var _this2 = this;

            this.loading = true;
            // 请求教师接口query数据
            var teacherQuery = {
                role: 'sata',
                trashed: 0,
                // page: this.currentPage,
                tripId: this.selecttripvalue,
                // keywords: '',
                size: this.size
            };
            this.$http.get('user', {
                // params => 用于设置请求头query数据
                params: teacherQuery
            }).then(function (response) {
                //渲染数据
                _this2.teachers = response.list;
                _this2.totalPages = response.totalPages;
            }).catch(function (error) {
                _this2.$message.error(error.message);
            });
        },
        changeTeacherId: function changeTeacherId(currentTeacherName) {
            var teacher = this.teachers.filter(function (value) {
                return value['displayName'] === currentTeacherName;
            });
            this.teacherId = teacher[0]['id'];
        }
    }
});

/***/ }),

/***/ 280:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component_md5__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__component_md5__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        var _this = this;

        //修改用户信息密码自动验证
        var validatePass = function validatePass(rule, value, callback) {
            if (value === '') {
                callback(new Error('Password Required'));
            } else {
                if (_this.editform.EconfirmPassword !== '') {
                    _this.$refs.editform.validateField('EconfirmPassword');
                }
                callback();
            }
        };
        var validatePass2 = function validatePass2(rule, value, callback) {
            if (value === '') {
                callback(new Error('ConfirmPassword Required'));
            } else if (value !== _this.editform.Epassword) {
                callback(new Error('Passwords do not match!'));
            } else {
                callback();
            }
        };
        return {
            templateUrl: __webpack_require__(568),
            //搜索栏
            message: '',
            selecttripvalue: '',
            options: [{
                id: 0,
                name: ''
            }],
            users: [], //学生表格
            role: 'student', //student代表未查看学生列表
            trashed: 0, //0代表未删除学生
            currentPage: 1,
            size: 15,
            totalPages: 1,
            // loading过渡效果变量
            loading: true,
            saveBtnIsLoading: false,

            isDirty: false,
            isTripDirty: false,

            //修改信息弹窗
            dialogtripvalue: '',
            dialogtripid: '',
            formLabelWidth: '130px',
            checked: false,
            willshow: false, //修改弹窗修密码框是否显示
            Editdialog: false,
            editform: {
                EDeadline2: '',
                EDeadline1: '',
                EmotherPhone: '',
                EfatherPhone: '',
                Eschool: '',
                EdisplayName: '',
                EfamilyName: '',
                EgivenName: '',
                Eemail: '',
                EmobilePhone: '',
                Epassword: '',
                EconfirmPassword: ''
            },
            pickerOptions: {
                //修改弹窗deadline
                disabledDate: function disabledDate(time) {
                    return time.getTime() < Date.now() - 8.64e7;
                }
            },
            editrules: {
                Eemail: [{ required: true, message: 'Email Adress Required', trigger: 'blur' }, { type: 'email', message: 'Email format invalid.' }],
                Epassword: [{ required: true, message: 'Password Required', trigger: 'blur' }, { validator: validatePass, trigger: 'blur' }, { min: 8, max: 20, message: 'Password should contain 8 to 20 characters.', trigger: 'blur' }, { pattern: /^\w{8,20}$/, message: "Only numbers, letters, and underscores allowed.", trigger: 'blur' }],
                EconfirmPassword: [{ required: true, message: 'Confirm Password Required', trigger: 'blur' }, { validator: validatePass2, trigger: 'blur' }],
                EgivenName: [{ required: true, message: 'GivenName Required', trigger: 'blur' }, { max: 30, message: 'givenName should not more than 30 characters.', trigger: 'blur' }],
                EfamilyName: [{ required: true, message: 'FamilyName Required', trigger: 'blur' }, { max: 30, message: 'familyName should not more tha 30 characters.', trigger: 'blur' }],
                EdisplayName: [{ required: true, message: 'DisplayName Required', trigger: 'blur' }, { max: 60, message: 'displayName should not more tha 60 characters.', trigger: 'blur' }],
                Eschool: [{ required: true, message: 'Affiliation Required', trigger: 'blur' }, { max: 100, message: 'Affiliation Name should not more tha 100 characters.', trigger: 'blur' }],
                EmobilePhone: [{ required: false }, { pattern: /^1\d{10}$/, message: 'Phone number format invalid.', trigger: 'blur' }],
                EmotherPhone: [{ required: false }, { pattern: /^1\d{10}$/, message: 'Phone number format invalid.', trigger: 'blur' }],
                EfatherPhone: [{ required: false }, { pattern: /^1\d{10}$/, message: 'Phone number format invalid.', trigger: 'blur' }]
            },

            //导入学生
            saving: false,
            fileName: '',
            warningList: [],
            errorList: [],
            existeddialog: false,
            existeddialog_title: '',
            existedList: [],
            ExistAction: [],

            successCount: 0,
            warningCount: 0,
            warningMessage: '',
            errorCount: 0,
            errorMessage: ''

        };
    },

    mounted: function mounted() {
        this.$nextTick(function () {
            this.getusers();
            this.getTrip();
            this.getEditEnabled();
        });
    },
    methods: {
        editEnable: function editEnable(student) {
            var _this2 = this;

            this.$http.get('/student/editEnable/' + student.id + '?enabled=' + student.editEnabled).catch(function (error) {
                _this2.$message.error(error.message);
            });
        },


        //获取学生列表通用函数
        getusers: function getusers() {
            var _this3 = this;

            this.loading = true;
            this.$http.get('user?role=' + this.role + '&trashed=' + this.trashed + '&page=' + (this.currentPage - 1) + '&tripId=' + this.selecttripvalue + '&keywords=' + this.message).then(function (response) {
                //渲染数据
                _this3.users = response.list;
                _this3.totalPages = response.totalPages;
                _this3.loading = false;
            }).catch(function (error) {
                _this3.loading = false;
                _this3.$message.error(error.message);
            });
        },


        //获取弹窗信息
        Editstudent: function Editstudent(user) {
            this.id = user.id;
            this.editform.EmotherPhone = user.motherPhone;
            this.editform.EfatherPhone = user.fatherPhone;
            this.editform.Eschool = user.school;
            this.dialogtripid = user.tripId;
            this.editform.EdisplayName = user.displayName;
            this.editform.EfamilyName = user.familyName;
            this.editform.EgivenName = user.givenName;
            this.editform.Eemail = user.email;
            this.editform.EmobilePhone = user.mobilePhone;
            this.editform.EDeadline1 = user.deadline1;
            this.editform.EDeadline2 = user.deadline2;
            this.Editdialog = true;
            this.editform.Epassword = '';
            this.editform.EconfirmPassword = '';
            this.checked = false;
            this.willshow = false;
        },


        //获取trip列表
        getTrip: function getTrip() {
            var _this4 = this;

            this.$http.get('trip/list').then(function (response) {
                _this4.options = response;
            }).catch(function (error) {
                _this4.$message.error(error.message);
            });
        },
        showTripList: function showTripList() {
            this.getTrip();
        },


        //给学生修改trip
        ChangeTrip: function ChangeTrip() {
            var _this5 = this;

            //                if(this.dialogtripid != null){
            if (this.isTripDirty) {
                this.$http.put('trip/choose?studentId=' + this.id + '&tripId=' + this.dialogtripid).then(function (response) {
                    _this5.getusers();
                    _this5.Editdialog = false;
                }).catch(function (error) {
                    _this5.$message.error(error.message);
                    _this5.getusers();
                    _this5.Editdialog = false;
                });
            } else {
                this.getusers();
                this.Editdialog = false;
            }
            //                }else{
            //                    this.getusers();
            //                    this.Editdialog = false;
            //                }
            this.isTripDirty = false;
        },


        //输入关键字搜索
        handleIconClick: function handleIconClick() {
            this.getusers();
        },


        //改变当前页函数
        pageCurrentChange: function pageCurrentChange(val) {
            this.currentPage = val;
            this.getusers();
        },


        //选择trip条件后获取学生列表
        getselectlist: function getselectlist() {
            this.getusers();
        },


        //删除学生
        removestudent: function removestudent(user) {
            var _this6 = this;

            this.$confirm('Are you sure you want to trash user: ' + user.displayName + '-' + user.givenName + '  ' + user.familyName, 'Trash User', {
                confirmButtonText: 'Trash',
                cancelButtonText: 'Cancel',
                confirmButtonClass: 'el-button--danger',
                type: 'warning',
                confirmButtonLoading: false,
                beforeClose: function beforeClose(action, instance, done) {
                    if (action === 'confirm') {
                        instance.confirmButtonLoading = true;
                        done();
                    } else {
                        instance.confirmButtonLoading = false;
                        done();
                    }
                }
            }).then(function () {
                _this6.$http.patch('user/trash/' + user.userId).then(function (response) {
                    _this6.getusers();
                }).catch(function (error) {
                    _this6.Trashdialog = false;
                    _this6.$message.error(error.message);
                });
            }).catch(function () {//弹窗点击cancel后执行的方法

            });
        },


        //编辑学生
        changePass: function changePass() {
            if (this.checked === true) {
                this.willshow = true;
                this.isDirty = true;
            } else {
                this.willshow = false;
            }
        },
        submitedit: function submitedit(formName) {
            var _this7 = this;

            //                console.log('TripDirty:'+ this.isTripDirty)
            //                console.log('Dirty:'+ this.isDirty)
            if (!this.isDirty && !this.isTripDirty) {
                //没有修改过弹窗则点击提交直接关闭
                this.Editdialog = false;
                return;
            }
            this.$refs[formName].validate(function (valid) {
                if (valid) {
                    _this7.saveBtnIsLoading = true;
                    var api = {
                        email: _this7.editform.Eemail,
                        familyName: _this7.editform.EfamilyName,
                        givenName: _this7.editform.EgivenName,
                        displayName: _this7.editform.EdisplayName,
                        mobilePhone: _this7.editform.EmobilePhone
                    };
                    if (_this7.checked === true) {
                        var EPwd_md5 = __WEBPACK_IMPORTED_MODULE_0__component_md5___default.a.hex_md5(_this7.editform.Epassword);
                        api.password = EPwd_md5;
                    }
                    //                        console.log(api);
                    _this7.$http.put('student', {
                        id: _this7.id,
                        motherPhone: _this7.editform.EmotherPhone,
                        fatherPhone: _this7.editform.EfatherPhone,
                        school: _this7.editform.Eschool,
                        deadline1: _this7.editform.EDeadline1,
                        deadline2: _this7.editform.EDeadline2,
                        user: api
                    }).then(function (response) {
                        _this7.ChangeTrip();
                        _this7.loading = true;
                        api.password = undefined;
                        //                            this.getusers();
                        _this7.saveBtnIsLoading = false;
                    }).catch(function (error) {
                        _this7.loading = false;
                        _this7.Editdialog = false;
                        _this7.saveBtnIsLoading = false;
                        _this7.$message.error(error.message);
                    });
                } else {
                    return false;
                }
            });
            // 提交修改不主动将表单是否改动变为false，解决当修改密码时出现警告提示，并且前后修改了其他信息，此时提交发现不成功。
            // 于是选择不修改密码，再次保存修改，会发现之前修改的其他信息并没有被保存，因为第一次保存后isDirty已经变成false了，
            // 第二次再保存时，被认为是表单未修改状态，Dialog直接= > false的情况。
            // this.isDirty = false;
        },


        //导入学生
        importStudent: function importStudent(importres, file, fileList) {
            var _this8 = this;

            this.warningList = importres.r.warningList;
            this.errorList = importres.r.errorList;
            this.existedList = importres.r.existedList;
            this.ExistAction = new Array(); //定义radio的model只为数组，index加索引
            var h = this.$createElement;

            for (var a = 0; a < importres.r.existedList.length; a++) {
                //Update
                this.ExistAction.push('Update');
            }

            //成功提示
            this.successCount = importres.r.successCount; //记录第一次成功几条

            //警告列表
            this.warningCount = importres.r.warningList.length; //记录第一次警告几条信息
            for (var i = 0; i < this.warningCount; i++) {
                if (importres.r.warningList[i].name != "") {
                    this.warningMessage += '(' + (i + 1) + ')' + importres.r.warningList[i].name + ': ' + importres.r.warningList[i].field + ' ' + importres.r.warningList[i].type + '\n';
                } else {
                    this.warningMessage += '(' + (i + 1) + ')' + importres.r.warningList[i].email + ': ' + importres.r.warningList[i].field + ' ' + importres.r.warningList[i].type + '\n';
                }
            }

            //错误列表
            for (var j = 0; j < importres.r.errorList.length; j++) {
                if (importres.r.errorList[j].email !== "") {
                    if (importres.r.errorList[j].name !== "") {
                        //如果那么不存在则显示邮箱
                        this.errorMessage += '(' + (j + 1) + ')' + importres.r.errorList[j].name + ': ' + importres.r.errorList[j].field + ' ' + importres.r.errorList[j].type + '\n';
                    } else {
                        this.errorMessage += '(' + (j + 1) + ')' + importres.r.errorList[j].email + ': ' + importres.r.errorList[j].field + ' ' + importres.r.errorList[j].type + '\n';
                    }
                } else {
                    this.errorMessage += '(' + (j + 1) + ')' + 'Empty email or line' + '\n';
                }
                this.errorCount++;
            }

            //如果不存在系统已有用户，则直接弹窗结果
            if (importres.r.existedList.length === 0) {
                if (this.successCount > 0) {
                    setTimeout(function () {
                        _this8.$notify.success({
                            title: 'Success',
                            message: h('div', { style: { wordWrap: 'break-word', textAlign: 'start', whiteSpace: 'pre' } }, _this8.successCount + ' students were imported successfully')
                        });
                        _this8.successCount = 0;
                    }, 100);
                }

                if (this.warningCount > 0) {
                    setTimeout(function () {
                        _this8.$notify.warning({
                            title: _this8.warningCount + ' Warning',
                            message: h('div', { style: { wordWrap: 'break-word', textAlign: 'start', whiteSpace: 'pre' } }, _this8.warningMessage),
                            duration: 0
                        });
                        _this8.warningCount = 0;
                        _this8.warningMessage = '';
                    }, 100);
                }

                if (this.errorCount > 0) {
                    setTimeout(function () {
                        _this8.$notify.error({
                            title: _this8.errorCount + ' Error',
                            message: h('div', { style: { wordWrap: 'break-word', textAlign: 'start', whiteSpace: 'pre' } }, _this8.errorMessage),
                            duration: 0
                        });
                        _this8.errorCount = 0;
                        _this8.errorMessage = '';
                    }, 100);
                }
                this.getusers();
            } else {
                //存在系统已有用户，则记录第一次错误几条信息
                this.existeddialog = true;
                this.existeddialog_title = importres.r.existedList.length + ' student already existed, you want ';
            }
        },
        beforeUpload: function beforeUpload(file) {
            var filetype = "xlsx";
            var filesize = 1024 * 50;
            var isLt50M = file.size / filesize < 50;
            if (file.name.toLowerCase().indexOf(filetype) != -1) {
                return true;
            } else {
                this.$message.error('Only .xlsx allowed');
                return false;
            }
            if (!isLt50M) {
                this.$message.error('The size of the PDF file should be less than 50MB.');
                return false;
            }
        },
        failUpload: function failUpload() {
            this.$message.error('File to import, Please try again later.');
        },
        importexitedAllSkip: function importexitedAllSkip() {
            var _this9 = this;

            var h = this.$createElement;
            this.existeddialog = false;
            this.getusers();
            if (this.successCount > 0) {
                setTimeout(function () {
                    _this9.$notify.success({
                        title: 'Success',
                        message: h('div', { style: { wordWrap: 'break-word', textAlign: 'start', whiteSpace: 'pre' } }, _this9.successCount + ' students were imported successfully')
                    });
                    _this9.successCount = 0;
                }, 100);
            }

            if (this.warningCount > 0) {
                setTimeout(function () {
                    _this9.$notify.warning({
                        title: _this9.warningCount + ' Warning',
                        message: h('div', { style: { wordWrap: 'break-word', textAlign: 'start', whiteSpace: 'pre' } }, _this9.warningMessage),
                        duration: 0
                    });
                    _this9.warningCount = 0;
                    _this9.warningMessage = '';
                }, 100);
            }

            if (this.errorCount > 0) {
                setTimeout(function () {
                    _this9.$notify.error({
                        title: _this9.errorCount + ' Error',
                        message: h('div', { style: { wordWrap: 'break-word', textAlign: 'start', whiteSpace: 'pre' } }, _this9.errorMessage),
                        duration: 0
                    });
                    _this9.errorCount = 0;
                    _this9.errorMessage = '';
                }, 100);
            }
        },

        //导入已存在学生
        importexitedStu: function importexitedStu() {
            var _this10 = this;

            //创建提交给后台的新数组，为空，如果操作new置为true加入新数组，如果操作update置为false加入新数组中传入
            var importList = new Array();
            for (var i = 0; i < this.ExistAction.length; i++) {
                if (this.ExistAction[i] == "New") {
                    this.existedList[i].newReport = true;
                    importList.push(this.existedList[i]);
                } else if (this.ExistAction[i] == "Update") {
                    this.existedList[i].newReport = false;
                    importList.push(this.existedList[i]);
                } else {
                    continue;
                }
            }
            this.saving = true;

            //点击提交调用接口
            this.$http.post('student/importExisted', importList).then(function (res) {
                var h = _this10.$createElement;
                //成功提示
                _this10.existeddialog = false;
                _this10.successCount += res.successCount;
                if (_this10.successCount > 0) {
                    setTimeout(function () {
                        _this10.$notify.success({
                            title: 'Success',
                            message: h('div', { style: { wordWrap: 'break-word', textAlign: 'start', whiteSpace: 'pre' } }, _this10.successCount + ' students were imported successfully')
                        });
                        _this10.successCount = 0;
                    }, 100);
                }

                //警告列表
                _this10.warningCount += res.warningList.length;
                for (var i = 0; i < res.warningList.length; i++) {
                    if (res.warningList[i].name != "") {
                        _this10.warningMessage += '(' + (i + 1) + ')' + res.warningList[i].name + ': ' + res.warningList[i].field + ' ' + res.warningList[i].type + '\n';
                    } else {
                        _this10.warningMessage += '(' + (i + 1) + ')' + res.warningList[i].email + ': ' + res.warningList[i].field + ' ' + res.warningList[i].type + '\n';
                    }
                }
                if (_this10.warningCount > 0) {
                    setTimeout(function () {
                        _this10.$notify.warning({
                            title: _this10.warningCount + ' Warning',
                            message: h('div', { style: { wordWrap: 'break-word', textAlign: 'start', whiteSpace: 'pre' } }, _this10.warningMessage),
                            duration: 0
                        });
                        _this10.warningCount = 0;
                        _this10.warningMessage = '';
                    }, 100);
                }

                //错误列表
                for (var i = 0; i < res.errorList.length; i++) {
                    _this10.errorCount++;
                    if (res.errorList[i].email != "") {
                        if (res.errorList[i].name != "") {
                            _this10.errorMessage += '(' + _this10.errorCount + ')' + res.errorList[i].name + ': ' + res.errorList[i].field + ' ' + res.errorList[i].type + '\n';
                        } else {
                            _this10.errorMessage += '(' + _this10.errorCount + ')' + res.errorList[i].email + ': ' + res.errorList[i].field + ' ' + res.errorList[i].type + '\n';
                        }
                    } else {
                        _this10.errorMessage += '(' + (j + 1) + ')' + 'Empty email or line' + '\n';
                    }
                }
                if (_this10.errorCount > 0) {
                    setTimeout(function () {
                        _this10.$notify.error({
                            title: _this10.errorCount + ' Error',
                            message: h('div', { style: { wordWrap: 'break-word', textAlign: 'start', whiteSpace: 'pre' } }, _this10.errorMessage),
                            duration: 0
                        });
                        _this10.errorCount = 0;
                        _this10.errorMessage = '';
                    }, 100);
                }
                _this10.getusers();
                _this10.saving = false;
            }).catch(function (error) {
                _this10.Creatdialog = false;
                _this10.$message.error(error.message);
            });
        }
    }
});

/***/ }),

/***/ 281:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component_md5__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__component_md5__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        var _this = this;

        //新建用户信息密码自动验证
        var NewPass = function NewPass(rule, value, callback) {
            if (value === '') {
                callback(new Error('Password Required'));
            } else {
                if (_this.Newform.NconfirmPassword !== '') {
                    _this.$refs.Newform.validateField('NconfirmPassword');
                }
                callback();
            }
        };
        var NewPass2 = function NewPass2(rule, value, callback) {
            if (value === '') {
                callback(new Error('ConfirmPassword Required'));
            } else if (value !== _this.Newform.Npassword) {
                callback(new Error('Passwords do not match!'));
            } else {
                callback();
            }
        };

        //修改用户信息密码自动验证
        var EditPass = function EditPass(rule, value, callback) {
            if (value === '') {
                callback(new Error('Password Required'));
            } else {
                if (_this.editform.EconfirmPassword !== '') {
                    _this.$refs.editform.validateField('EconfirmPassword');
                }
                callback();
            }
        };
        var EditPass2 = function EditPass2(rule, value, callback) {
            if (value === '') {
                callback(new Error('ConfirmPassword Required'));
            } else if (value !== _this.editform.Epassword) {
                callback(new Error('Passwords do not match!'));
            } else {
                callback();
            }
        };

        return {
            activeIndex2: '1',
            LoginName: 'Admin', //登录用户名

            //搜索栏
            message: '',
            selecttripvalue: '', //老师端没有这个值，但是统一借口需要传
            role: 'ta', //teacher代表未查看老师列表
            trashed: 0, //0代表未删除学生

            users: [],
            currentPage: 1,
            size: 15,
            totalPages: 1,
            // loading过渡状态变量
            loading: true,
            ntSaveBtnIsLoading: false,
            ctSaveBtnIsLoading: false,

            //新建老师
            Creatdialog: false,
            Newform: {},
            Newrules: {
                Nemail: [{ required: true, message: 'Email Adress Required', trigger: 'blur' }, { type: 'email', message: 'Email format invalid.' }],
                Npassword: [{ required: true, message: 'Password Required', trigger: 'blur' }, { validator: NewPass, trigger: 'blur' }, { min: 8, max: 20, message: 'Password should contain 8 to 20 characters.', trigger: 'blur' }, { pattern: /^\w{8,20}$/, message: "Only numbers, letters, and underscores allowed.", trigger: 'blur' }],
                NconfirmPassword: [{ required: true, message: 'ConfirmPassword Required', trigger: 'blur' }, { validator: NewPass2, trigger: 'blur' }],
                NgivenName: [{ required: true, message: 'GivenName Required', trigger: 'blur' }, { max: 30, message: 'givenName should not more than 30 characters.', trigger: 'blur' }],
                NfamilyName: [{ required: true, message: 'FamilyName Required', trigger: 'blur' }, { max: 30, message: 'familyName should not more tha 30 characters.', trigger: 'blur' }],
                NdisplayName: [{ required: true, message: 'DisplayName Required', trigger: 'blur' }, { max: 60, message: 'displayName should not more tha 60 characters.', trigger: 'blur' }],
                NmobilePhone: [{ required: true, message: 'MobilePhone Required', trigger: 'blur' }, { pattern: /^1\d{10}$/, message: 'Phone number format invalid.', trigger: 'blur' }]
            },
            //修改老师弹窗
            checked: false,
            willshow: false, //修改弹窗修密码框是否显示
            Editdialog: false,
            editform: {
                EdisplayName: '',
                EfamilyName: '',
                EgivenName: '',
                Eemail: '',
                EmobilePhone: '',
                Epassword: '',
                EconfirmPassword: ''
            },
            editrules: {
                Eemail: [{ required: true, message: 'Email Adress Required', trigger: 'blur' }, { type: 'email', message: 'Email format invalid.' }],
                Epassword: [{ required: true, message: 'Password Required', trigger: 'blur' }, { validator: EditPass, trigger: 'blur' }, { min: 8, max: 20, message: 'Password should contain 8 to 20 characters.', trigger: 'blur' }, { pattern: /^\w{8,20}$/, message: "Only numbers, letters, and underscores allowed.", trigger: 'blur' }],
                EconfirmPassword: [{ required: true, message: 'Confirm Password Required', trigger: 'blur' }, { validator: EditPass2, trigger: 'blur' }],
                EgivenName: [{ required: true, message: 'GivenName Required', trigger: 'blur' }, { max: 30, message: 'givenName should not more than 30 characters.', trigger: 'blur' }],
                EfamilyName: [{ required: true, message: 'FamilyName Required', trigger: 'blur' }, { max: 30, message: 'familyName should not more tha 30 characters.', trigger: 'blur' }],
                EdisplayName: [{ required: true, message: 'DisplayName Required', trigger: 'blur' }, { max: 60, message: 'displayName should not more tha 60 characters.', trigger: 'blur' }],
                EmobilePhone: [{ required: false }, { pattern: /^1\d{10}$/, message: 'Phone number format invalid.', trigger: 'blur' }]
            }
        };
    },

    mounted: function mounted() {
        this.$nextTick(function () {
            this.getusers();
        });
    },
    methods: {
        //输入关键字搜索
        handleIconClick: function handleIconClick(ev) {
            this.getusers();
        },


        //获取弹窗信息
        EditUser: function EditUser(user) {
            this.id = user.id;
            this.editform.EdisplayName = user.displayName;
            this.editform.EfamilyName = user.familyName;
            this.editform.EgivenName = user.givenName;
            this.editform.Eemail = user.email;
            this.editform.EmobilePhone = user.mobilePhone;
            this.Editdialog = true;
            this.checked = false;
            this.willshow = false;
            this.editform.Epassword = '';
            this.editform.EconfirmPassword = '';
        },


        //获取教师列表通用函数
        getusers: function getusers() {
            var _this2 = this;

            this.loading = true;
            this.$http.get('user?' + 'role=' + this.role + '&trashed=' + this.trashed + '&page=' + (this.currentPage - 1) + '&tripId=' + this.selecttripvalue + '&keywords=' + this.message).then(function (response) {
                //渲染数据
                _this2.users = response.list;
                _this2.totalPages = response.totalPages;
                _this2.loading = false;
            }).catch(function (error) {
                _this2.loading = false;
                _this2.$message.error(error.message);
            });
        },


        //改变当前页函数
        pageCurrentChange: function pageCurrentChange(val) {
            this.currentPage = val;
            this.getusers();
        },


        // 新建老师
        NewTeacher: function NewTeacher(formName) {
            var _this3 = this;

            this.$refs[formName].validate(function (valid) {
                if (valid) {
                    _this3.ntSaveBtnIsLoading = true;
                    var Pwd_md5 = __WEBPACK_IMPORTED_MODULE_0__component_md5___default.a.hex_md5(_this3.Newform.Npassword);
                    _this3.$http.post('teacher', {
                        user: {
                            familyName: _this3.Newform.NfamilyName,
                            givenName: _this3.Newform.NgivenName,
                            displayName: _this3.Newform.NdisplayName,
                            email: _this3.Newform.Nemail,
                            mobilePhone: _this3.Newform.NmobilePhone,
                            role: _this3.role,
                            password: Pwd_md5
                        }
                    }).then(function (response) {
                        //渲染数据
                        _this3.getusers();
                        _this3.Newform.Nemail = '';
                        _this3.Newform.Npassword = '';
                        _this3.Newform.NconfirmPassword = '';
                        _this3.Newform.NfamilyName = '';
                        _this3.Newform.NgivenName = '';
                        _this3.Newform.NdisplayName = '';
                        _this3.Newform.NmobilePhone = '';
                        _this3.Creatdialog = false;
                        _this3.ntSaveBtnIsLoading = false;
                        _this3.$message.success('New teacher created.');
                    }).catch(function (error) {
                        _this3.Creatdialog = false;
                        _this3.ntSaveBtnIsLoading = false;
                        _this3.$message.error(error.message);
                    });
                } else {
                    return false;
                }
            });
        },


        //修改老师
        changePass: function changePass() {
            if (this.checked == true) {
                this.willshow = true;
                this.isDirty = true;
            } else {
                this.willshow = false;
            }
        },
        submitedit: function submitedit(form) {
            var _this4 = this;

            this.$refs[form].validate(function (valid) {
                if (valid) {
                    _this4.ctSaveBtnIsLoading = true;
                    var api = {
                        email: _this4.editform.Eemail,
                        familyName: _this4.editform.EfamilyName,
                        givenName: _this4.editform.EgivenName,
                        displayName: _this4.editform.EdisplayName,
                        mobilePhone: _this4.editform.EmobilePhone
                    };
                    if (_this4.checked == true) {
                        var EPwd_md5 = __WEBPACK_IMPORTED_MODULE_0__component_md5___default.a.hex_md5(_this4.editform.Epassword);
                        api.password = EPwd_md5;
                    }
                    _this4.$http.put('teacher', {
                        id: _this4.id,
                        user: api
                    }).then(function (response) {
                        //渲染数据
                        _this4.getusers();
                        _this4.Editdialog = false;
                        _this4.ctSaveBtnIsLoading = false;
                    }).catch(function (error) {
                        _this4.loading = false;
                        _this4.Editdialog = false;
                        _this4.ctSaveBtnIsLoading = false;
                        _this4.$message.error(error.message);
                    });
                } else {
                    return false;
                }
            });
        },


        //删除老师
        TrashTeacher: function TrashTeacher(user) {
            var _this5 = this;

            this.deleteName = user.displayName + '-' + user.givenName + '  ' + user.familyName;
            this.email = user.email;
            this.$confirm('Are you sure you want to trash teacher: ' + this.deleteName + ' ' + this.email, 'Trash Teacher', {
                confirmButtonText: 'Trash',
                cancelButtonText: 'Cancel',
                confirmButtonClass: 'el-button--danger',
                type: 'warning',
                confirmButtonLoading: false,
                beforeClose: function beforeClose(action, instance, done) {
                    if (action === 'confirm') {
                        instance.confirmButtonLoading = true;
                        done();
                    } else {
                        instance.confirmButtonLoading = false;
                        done();
                    }
                }
            }).then(function () {
                _this5.$http.patch('user/trash/' + user.userId).then(function (response) {
                    _this5.getusers();
                }).catch(function (error) {
                    _this5.Trashdialog = false;
                    _this5.$message.error(error.message);
                });
            }).catch(function () {//弹窗点击cancel后执行的方法

            });
        }
    }
});

/***/ }),

/***/ 282:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component_md5__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__component_md5__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        var _this = this;

        //新建用户信息密码自动验证
        var NewPass = function NewPass(rule, value, callback) {
            if (value === '') {
                callback(new Error('Password Required'));
            } else {
                if (_this.Newform.NconfirmPassword !== '') {
                    _this.$refs.Newform.validateField('NconfirmPassword');
                }
                callback();
            }
        };
        var NewPass2 = function NewPass2(rule, value, callback) {
            if (value === '') {
                callback(new Error('ConfirmPassword Required'));
            } else if (value !== _this.Newform.Npassword) {
                callback(new Error('Passwords do not match!'));
            } else {
                callback();
            }
        };

        //修改用户信息密码自动验证
        var EditPass = function EditPass(rule, value, callback) {
            if (value === '') {
                callback(new Error('Password Required'));
            } else {
                if (_this.editform.EconfirmPassword !== '') {
                    _this.$refs.editform.validateField('EconfirmPassword');
                }
                callback();
            }
        };
        var EditPass2 = function EditPass2(rule, value, callback) {
            if (value === '') {
                callback(new Error('ConfirmPassword Required'));
            } else if (value !== _this.editform.Epassword) {
                callback(new Error('Passwords do not match!'));
            } else {
                callback();
            }
        };

        return {
            activeIndex2: '1',
            LoginName: 'Admin', //登录用户名

            //搜索栏
            message: '',
            selecttripvalue: '', //老师端没有这个值，但是统一借口需要传
            role: 'teacher', //teacher代表未查看老师列表
            trashed: 0, //0代表未删除学生

            users: [],
            currentPage: 1,
            size: 15,
            totalPages: 1,
            // loading过渡状态变量
            loading: true,
            ntSaveBtnIsLoading: false,
            ctSaveBtnIsLoading: false,

            //新建老师
            Creatdialog: false,
            Newform: {},
            Newrules: {
                Nemail: [{ required: true, message: 'Email Adress Required', trigger: 'blur' }, { type: 'email', message: 'Email format invalid.' }],
                Npassword: [{ required: true, message: 'Password Required', trigger: 'blur' }, { validator: NewPass, trigger: 'blur' }, { min: 8, max: 20, message: 'Password should contain 8 to 20 characters.', trigger: 'blur' }, { pattern: /^\w{8,20}$/, message: "Only numbers, letters, and underscores allowed.", trigger: 'blur' }],
                NconfirmPassword: [{ required: true, message: 'ConfirmPassword Required', trigger: 'blur' }, { validator: NewPass2, trigger: 'blur' }],
                NgivenName: [{ required: true, message: 'GivenName Required', trigger: 'blur' }, { max: 30, message: 'givenName should not more than 30 characters.', trigger: 'blur' }],
                NfamilyName: [{ required: true, message: 'FamilyName Required', trigger: 'blur' }, { max: 30, message: 'familyName should not more tha 30 characters.', trigger: 'blur' }],
                NdisplayName: [{ required: true, message: 'DisplayName Required', trigger: 'blur' }, { max: 60, message: 'displayName should not more tha 60 characters.', trigger: 'blur' }],
                NmobilePhone: [{ required: true, message: 'MobilePhone Required', trigger: 'blur' }, { pattern: /^1\d{10}$/, message: 'Phone number format invalid.', trigger: 'blur' }]
            },
            //修改老师弹窗
            checked: false,
            willshow: false, //修改弹窗修密码框是否显示
            Editdialog: false,
            editform: {
                EdisplayName: '',
                EfamilyName: '',
                EgivenName: '',
                Eemail: '',
                EmobilePhone: '',
                Epassword: '',
                EconfirmPassword: ''
            },
            editrules: {
                Eemail: [{ required: true, message: 'Email Adress Required', trigger: 'blur' }, { type: 'email', message: 'Email format invalid.' }],
                Epassword: [{ required: true, message: 'Password Required', trigger: 'blur' }, { validator: EditPass, trigger: 'blur' }, { min: 8, max: 20, message: 'Password should contain 8 to 20 characters.', trigger: 'blur' }, { pattern: /^\w{8,20}$/, message: "Only numbers, letters, and underscores allowed.", trigger: 'blur' }],
                EconfirmPassword: [{ required: true, message: 'Confirm Password Required', trigger: 'blur' }, { validator: EditPass2, trigger: 'blur' }],
                EgivenName: [{ required: true, message: 'GivenName Required', trigger: 'blur' }, { max: 30, message: 'givenName should not more than 30 characters.', trigger: 'blur' }],
                EfamilyName: [{ required: true, message: 'FamilyName Required', trigger: 'blur' }, { max: 30, message: 'familyName should not more tha 30 characters.', trigger: 'blur' }],
                EdisplayName: [{ required: true, message: 'DisplayName Required', trigger: 'blur' }, { max: 60, message: 'displayName should not more tha 60 characters.', trigger: 'blur' }],
                EmobilePhone: [{ required: false }, { pattern: /^1\d{10}$/, message: 'Phone number format invalid.', trigger: 'blur' }]
            },
            teacherEditEnabled: true,
            studentEditEnabled: true
        };
    },

    mounted: function mounted() {
        this.$nextTick(function () {
            this.getusers();
            this.getEditEnabled();
        });
    },
    methods: {
        editEnabled: function editEnabled() {
            var _this2 = this;

            this.$http.post('/common/edit/enabled?role=TEACHER' + '&editEnabled=' + this.teacherEditEnabled).catch(function (error) {
                _this2.$message.error(error.message);
            });
        },
        getEditEnabled: function getEditEnabled() {
            var _this3 = this;

            this.$http.get('/common/edit/enabled').then(function (response) {
                console.log(response);
                _this3.teacherEditEnabled = response['TEACHER'];
                _this3.studentEditEnabled = response['STUDENT'];
            }).catch(function (error) {
                _this3.$message.error(error.message);
            });
        },

        //输入关键字搜索
        handleIconClick: function handleIconClick(ev) {
            this.getusers();
        },


        //获取弹窗信息
        EditUser: function EditUser(user) {
            this.id = user.id;
            this.editform.EdisplayName = user.displayName;
            this.editform.EfamilyName = user.familyName;
            this.editform.EgivenName = user.givenName;
            this.editform.Eemail = user.email;
            this.editform.EmobilePhone = user.mobilePhone;
            this.Editdialog = true;
            this.checked = false;
            this.willshow = false;
            this.editform.Epassword = '';
            this.editform.EconfirmPassword = '';
        },


        //获取教师列表通用函数
        getusers: function getusers() {
            var _this4 = this;

            this.loading = true;
            this.$http.get('user?' + 'role=' + this.role + '&trashed=' + this.trashed + '&page=' + (this.currentPage - 1) + '&tripId=' + this.selecttripvalue + '&keywords=' + this.message).then(function (response) {
                //渲染数据
                _this4.users = response.list;
                _this4.totalPages = response.totalPages;
                _this4.loading = false;
            }).catch(function (error) {
                _this4.loading = false;
                _this4.$message.error(error.message);
            });
        },


        //改变当前页函数
        pageCurrentChange: function pageCurrentChange(val) {
            this.currentPage = val;
            this.getusers();
        },


        // 新建老师
        NewTeacher: function NewTeacher(formName) {
            var _this5 = this;

            this.$refs[formName].validate(function (valid) {
                if (valid) {
                    _this5.ntSaveBtnIsLoading = true;
                    var Pwd_md5 = __WEBPACK_IMPORTED_MODULE_0__component_md5___default.a.hex_md5(_this5.Newform.Npassword);
                    _this5.$http.post('teacher', {
                        user: {
                            familyName: _this5.Newform.NfamilyName,
                            givenName: _this5.Newform.NgivenName,
                            displayName: _this5.Newform.NdisplayName,
                            email: _this5.Newform.Nemail,
                            mobilePhone: _this5.Newform.NmobilePhone,
                            role: _this5.role,
                            password: Pwd_md5
                        }
                    }).then(function (response) {
                        //渲染数据
                        _this5.getusers();
                        _this5.Newform.Nemail = '';
                        _this5.Newform.Npassword = '';
                        _this5.Newform.NconfirmPassword = '';
                        _this5.Newform.NfamilyName = '';
                        _this5.Newform.NgivenName = '';
                        _this5.Newform.NdisplayName = '';
                        _this5.Newform.NmobilePhone = '';
                        _this5.Creatdialog = false;
                        _this5.ntSaveBtnIsLoading = false;
                        _this5.$message.success('New teacher created.');
                    }).catch(function (error) {
                        _this5.Creatdialog = false;
                        _this5.ntSaveBtnIsLoading = false;
                        _this5.$message.error(error.message);
                    });
                } else {
                    return false;
                }
            });
        },


        //修改老师
        changePass: function changePass() {
            if (this.checked == true) {
                this.willshow = true;
                this.isDirty = true;
            } else {
                this.willshow = false;
            }
        },
        submitedit: function submitedit(form) {
            var _this6 = this;

            this.$refs[form].validate(function (valid) {
                if (valid) {
                    _this6.ctSaveBtnIsLoading = true;
                    var api = {
                        email: _this6.editform.Eemail,
                        familyName: _this6.editform.EfamilyName,
                        givenName: _this6.editform.EgivenName,
                        displayName: _this6.editform.EdisplayName,
                        mobilePhone: _this6.editform.EmobilePhone
                    };
                    if (_this6.checked == true) {
                        var EPwd_md5 = __WEBPACK_IMPORTED_MODULE_0__component_md5___default.a.hex_md5(_this6.editform.Epassword);
                        api.password = EPwd_md5;
                    }
                    _this6.$http.put('teacher', {
                        id: _this6.id,
                        user: api
                    }).then(function (response) {
                        //渲染数据
                        _this6.getusers();
                        _this6.Editdialog = false;
                        _this6.ctSaveBtnIsLoading = false;
                    }).catch(function (error) {
                        _this6.loading = false;
                        _this6.Editdialog = false;
                        _this6.ctSaveBtnIsLoading = false;
                        _this6.$message.error(error.message);
                    });
                } else {
                    return false;
                }
            });
        },


        //删除老师
        TrashTeacher: function TrashTeacher(user) {
            var _this7 = this;

            this.deleteName = user.displayName + '-' + user.givenName + '  ' + user.familyName;
            this.email = user.email;
            this.$confirm('Are you sure you want to trash teacher: ' + this.deleteName + ' ' + this.email, 'Trash Teacher', {
                confirmButtonText: 'Trash',
                cancelButtonText: 'Cancel',
                confirmButtonClass: 'el-button--danger',
                type: 'warning',
                confirmButtonLoading: false,
                beforeClose: function beforeClose(action, instance, done) {
                    if (action === 'confirm') {
                        instance.confirmButtonLoading = true;
                        done();
                    } else {
                        instance.confirmButtonLoading = false;
                        done();
                    }
                }
            }).then(function () {
                _this7.$http.patch('user/trash/' + user.userId).then(function (response) {
                    _this7.getusers();
                }).catch(function (error) {
                    _this7.Trashdialog = false;
                    _this7.$message.error(error.message);
                });
            }).catch(function () {//弹窗点击cancel后执行的方法

            });
        }
    }
});

/***/ }),

/***/ 283:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            message: '', //搜索框
            role: 'teacher', //默认查看老师列表
            trashed: 1, //1代表已删除
            selecttripvalue: '', //统一接口要求传递参数，页面没有用到但不可删
            selectUsertype: 'Sa', //select框，默认查看teacher列表
            options: [{
                id: 0,
                name: 'Sa'
            }, {
                id: 1,
                name: 'Ta'
            }, {
                id: 2,
                name: 'Student'
            }],
            //列表信息
            loading: true,
            users: [],
            currentPage: 1,
            size: 15,
            totalPages: 1
        };
    },

    mounted: function mounted() {
        this.$nextTick(function () {
            this.getusers();
        });
    },
    methods: {
        //输入框搜索用户
        handleIconClick: function handleIconClick() {
            this.getusers();
        },


        //获取列表通用函数
        getusers: function getusers() {
            var _this = this;

            this.loading = true;
            this.$http.get('user?role=' + this.role + '&trashed=' + this.trashed + '&page=' + (this.currentPage - 1) + '&tripId=' + this.selecttripvalue + '&keywords=' + this.message).then(function (response) {
                //渲染数据
                _this.users = response.list;
                _this.totalPages = response.totalPages;
                _this.loading = false;
            }).catch(function (error) {
                _this.loading = false;
                _this.$message.error(error.message);
            });
        },


        //选择usertype后获取垃圾箱列表
        getselectlist: function getselectlist(ev) {
            if (ev == 0) {
                this.role = 'teacher';
                this.getusers();
            } else if (ev == 1) {
                this.role = 'ta';
                this.getusers();
            } else if (ev == 2) {
                this.role = 'student';
                this.getusers();
            }
        },


        //改变当前页函数
        pageCurrentChange: function pageCurrentChange(val) {
            this.currentPage = val;
            this.getusers();
        },


        //删除用户
        RemoveUser: function RemoveUser(user) {
            var _this2 = this;

            this.$confirm('Are you sure you want to permanently remove user: ' + user.displayName + '-' + user.givenName + ' ' + user.familyName, 'Permanently Remove User', {
                confirmButtonText: 'Yes, permanently remove it',
                cancelButtonText: 'Cancel',
                confirmButtonClass: 'el-button--danger',
                type: 'warning',
                confirmButtonLoading: false,
                beforeClose: function beforeClose(action, instance, done) {
                    if (action === 'confirm') {
                        instance.confirmButtonLoading = true;
                        done();
                    } else {
                        instance.confirmButtonLoading = false;
                        done();
                    }
                }
            }).then(function () {
                _this2.$http.delete('user/' + user.userId).then(function (response) {
                    _this2.$message.success('User deleted.');
                    _this2.getusers();
                }).catch(function (error) {
                    _this2.loading = false;
                    _this2.$message.error(error.message);
                });
            }).catch(function () {//弹窗点击cancel后执行的方法

            });
        },


        //恢复用户
        restoreUser: function restoreUser(user) {
            var _this3 = this;

            this.$http.patch('user/restore/' + user.userId).then(function (response) {
                _this3.getusers();
                _this3.$message.success('Restore user success');
            }).catch(function (error) {
                _this3.loading = false;
                _this3.Trashdialog = false;
                _this3.$message.error(error.message);
            });
        }
    }
});

/***/ }),

/***/ 284:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            TripData: [], //列表信息
            currentPage: 1,
            size: 15,
            totalPages: 1,
            loading: true,

            CreatTripdialog: false,
            EditTripdialog: false,
            Newform: {},
            Editform: {},
            //弹窗规则
            newrules: {
                NewName: [{ required: true, message: 'Trip Name Required', trigger: 'blur' }, { max: 255, message: 'Trip name cannot be longer than 255 characters', trigger: 'blur' }]
            },
            editrules: {
                EditName: [{ required: true, message: 'Trip Name Required', trigger: 'blur' }, { max: 255, message: 'Trip name cannot be longer than 255 characters', trigger: 'blur' }]
            },
            id: 0, //修改trip 传id
            deleteName: '', //删除trip
            formLabelWidth: '130px',
            saving: false,
            endPickerOptions0: {
                disabledDate: function disabledDate(time) {
                    var timeSpace = time.getTime() < Date.now() - 8.64e7;
                    return timeSpace;
                }
            }
        };
    },

    mounted: function mounted() {
        this.$nextTick(function () {
            this.getTrip();
        });
    },
    methods: {
        // editTeacherEnable(trip) {
        //   this.$http.get(`/trip/teacherEnabled/${trip.id}?enabled=${trip.teacherEditEnabled}`).catch(error=> {
        //     this.$message.error(error.message);
        //   })
        // },
        editTaEnable: function editTaEnable(trip) {
            var _this = this;

            this.$http.get('/trip/taEnabled/' + trip.id + '?enabled=' + trip.taEditEnabled).catch(function (error) {
                _this.$message.error(error.message);
            });
        },
        editSaEnable: function editSaEnable(trip) {
            var _this2 = this;

            this.$http.get('/trip/saEnabled/' + trip.id + '?enabled=' + trip.saEditEnabled).catch(function (error) {
                _this2.$message.error(error.message);
            });
        },
        editStudentEnable: function editStudentEnable(trip) {
            var _this3 = this;

            this.$http.get('/trip/studentEnabled/' + trip.id + '?enabled=' + trip.studentEditEnabled).catch(function (error) {
                _this3.$message.error(error.message);
            });
        },
        handleIconClick: function handleIconClick() {
            this.getTrip();
        },


        //新建trip
        NewTrip: function NewTrip(formName) {
            var _this4 = this;

            this.$refs[formName].validate(function (valid) {
                if (valid) {
                    _this4.saving = true;
                    console.log(_this4.Newform, "formform");
                    var param = {
                        name: _this4.Newform.NewName,
                        tips: _this4.Newform.tips || ''
                    };
                    if (_this4.Newform.date && _this4.Newform.date.length > 0) {
                        param.startDate = _this4.Newform.date[0];
                        param.endDate = _this4.Newform.date[1];
                    } else {
                        param.startDate = '';
                        param.endDate = '';
                    }
                    console.log(param, "参数");
                    _this4.$http.post('trip', param).then(function (response) {
                        //渲染数据
                        _this4.getTrip();
                        _this4.Newform = {};
                        _this4.CreatTripdialog = false;
                        _this4.loading = false;
                        _this4.saving = false;
                        _this4.$message.success('New trip created.');
                    }).catch(function (error) {
                        _this4.CreatTripdialog = false;
                        _this4.loading = false;
                        _this4.saving = false;
                        _this4.$message.error(error.message);
                    });
                }
            });
        },


        //获取弹窗信息
        EditTrip: function EditTrip(trip) {
            this.id = trip.id;
            this.deleteName = trip.name;
            this.$set(this.Editform, 'EditName', trip.name);
            this.$set(this.Editform, 'tips', trip.tips);
            var arr = [];
            if (trip.startDate && trip.startDate !== '') {
                arr.push(trip.startDate);
                arr.push(trip.endDate);
            }
            this.$set(this.Editform, 'date', arr);
            console.log(this.Editform, "编辑表单");
            console.log(this.deleteName, "编辑表单");
            this.EditTripdialog = true;
        },


        //编辑trip
        submitedit: function submitedit(formName) {
            var _this5 = this;

            // if(this.deleteName != this.Editform.EditName){
            this.$refs[formName].validate(function (valid) {
                if (valid) {
                    _this5.saving = true;
                    var param = {
                        id: _this5.id,
                        name: _this5.Editform.EditName,
                        tips: _this5.Editform.tips
                    };
                    if (_this5.Editform.date && _this5.Editform.date.length > 0) {
                        param.startDate = _this5.Editform.date[0];
                        param.endDate = _this5.Editform.date[1];
                    } else {
                        param.startDate = '';
                        param.endDate = '';
                    }
                    console.log(param, "canshu");
                    _this5.$http.put('trip', param).then(function (response) {
                        _this5.EditTripdialog = false;
                        _this5.saving = false;
                        _this5.loading = true;
                        _this5.getTrip();
                        _this5.loading = false;
                    }).catch(function (error) {
                        _this5.saving = false;
                        _this5.loading = false;
                        _this5.EditTripdialog = false;
                        _this5.$message.error(error.message);
                    });
                }
            });
            // }else {
            //     this.EditTripdialog = false;
            // }
        },


        //删除trip
        DeleteTrip: function DeleteTrip(user) {
            var _this6 = this;

            this.deleteName = user.name;
            this.$confirm('Are you sure you want to delete trip: ' + this.deleteName, 'Delete Trip', {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                confirmButtonClass: 'el-button--danger',
                type: 'warning',
                confirmButtonLoading: false,
                beforeClose: function beforeClose(action, instance, done) {
                    if (action === 'confirm') {
                        instance.confirmButtonLoading = true;
                        done();
                    } else {
                        instance.confirmButtonLoading = false;
                        done();
                    }
                }
            }).then(function () {
                _this6.$http.delete('trip/' + user.id).then(function (response) {
                    _this6.getTrip();
                }).catch(function (error) {
                    _this6.loading = false;
                    _this6.$message.error(error.message);
                });
            }).catch(function () {//弹窗点击cancel后执行的方法

            });
        },


        //获取trip列表通用函数
        getTrip: function getTrip() {
            var _this7 = this;

            this.loading = true;
            this.$http.get('trip', { params: { page: this.currentPage - 1, size: this.size } }).then(function (response) {
                //渲染数据
                _this7.loading = false;
                _this7.TripData = response.list;
                _this7.totalPages = response.totalPages;
            }).catch(function (error) {
                _this7.loading = false;
                _this7.$message.error(error.message);
            });
        },


        //改变当前页函数
        pageCurrentChange: function pageCurrentChange(val) {
            this.currentPage = val;
            console.log(this.currentPage);
            this.getTrip();
        }
    }
});

/***/ }),

/***/ 285:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component_util_js__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var templateTypeDefinition = [
//    'Witness testimony', //0
//    'Peer/Witness statement', //1
//    'Team action plan', //2
//    'Personal action plan', //3
//    'Action plan', //4
//    'PDF', //5
//    'Image', //6
//    'Video link', //7
//    'Observation checklist', //8 COPE-D
//    'Observation checklist'] //9 COPE-OP
'PDF', //0
'Image', //1
'Video link', //2
'Peer/Witness statement', //3
'Observation checklist', //4 COPE-D
'Observation checklist', //5 COPE-OP
'Observation checklist'];
/* harmony default export */ __webpack_exports__["default"] = ({
  props: [
  // userId表示当前EvidenceDialog所有者的id，通常是表示Student UserId
  'userId', 'isLineRead', 'notificationId', 'studentId'],

  data: function data() {
    return {
      // 固定的
      showCommentCount: 3,
      maxLength: 4000,
      datePickerOptions: {
        option1: {}
      },

      // 有状态的
      evidenceId: 0,
      currentCommentatorId: 0,
      templateTypeText: '',
      questions: [],
      oldQuestions: [],
      comments: [],
      hasOldQuestions: false,
      editVisible: false,
      saving: false,
      isDialogLoading: false,
      isDirty: false,

      // 上传相关
      expire: 0,
      uploadUrl: '/api/pageEvidence/upload',
      uploadFormData: {},
      dialogImageUrl: '',
      picReview: false,
      pdfPreviewUrl: '',
      imageCount: 0, // 已上传的图片数量
      clonedImageList: [],
      clonedPDFList: [],
      isUploading: false,
      isAuthorizing: false, // 是否正在获取授权中，授权过程中不允许再次点击上传

      // 仅用于教师端confirm时，会在showEvidenceDialog中传来
      confirmed: false,
      role: '',
      isAdd: false
    };
  },

  methods: {
    init: function init() {
      // 将当前userId获取下来，作为当前评论者的id，用于评论部分remove按钮的渲染，满足自己只能删自己评论的情况。
      this.currentCommentatorId = __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.get('userid');

      this.role = __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.get('role');
    },


    //POST键盘事件
    pressAction: function pressAction(question, commentList, ev) {
      if (13 == ev.keyCode && ev.ctrlKey) {
        //ctrl + enter
        if (question.content && !question.isSavingComment) {
          // 有输入值且没有正在保存。因为是代码触发，所以必须加上这个判断
          this.saveComment(question, commentList);
        }
      }
    },

    setHighlight: function setHighlight(list, id, successFn) {
      (list || []).forEach(function (items) {
        items.forEach(function (item) {
          if (item.id === id) {
            successFn && successFn(item);
          }
        });
      });
    },
    handleConfirmEvidence: function handleConfirmEvidence() {
      var _this = this;

      this.isDialogLoading = true;
      this.$http.patch('pageEvidence/confirm/' + this.evidenceId).then(function (res) {
        _this.isDialogLoading = false;
        _this.$emit('confirmed');
        _this.confirmed = true;
        _this.$message.success('confirm success');
      }).catch(function (err) {
        _this.isDialogLoading = false;
        _this.$message.error(err.message);
      });
    },
    handleDisapproveEvidence: function handleDisapproveEvidence() {
      var _this2 = this;

      this.isDialogLoading = true;
      this.$http.patch('pageEvidence/disapprove/' + this.evidenceId).then(function (res) {
        _this2.isDialogLoading = false;
        _this2.$emit('disapproved');
        _this2.confirmed = false;
        _this2.$message.success('disapprove success');
      }).catch(function (err) {
        _this2.isDialogLoading = false;
        _this2.$message.error(err.message);
      });
    },


    /*------------------- Copy自AoPE.vue -------------------*/

    //将数据渲染到模态框中
    handleQuestionList: function handleQuestionList(list, params) {
      var _this3 = this;

      //清空this.questions
      this.questions.splice(0, this.questions.length);

      var count = 0;
      for (var i = 0; i < list.length; i++) {
        var group = [];
        for (var j = 0; j < list[i].length; j++) {
          list[i][j].show = false;
          //绑定comment
          list[i][j].content = '';
          list[i][j].isSavingComment = false;
          // list[i][j].showCommentCount = this.showCommentCount;
          list[i][j].commentList = this.comments[count];
          list[i][j].showCommentCount = 3;

          var config = JSON.parse(list[i][j].config);

          // 解析config（question或answer）逻辑
          if (config != '') {
            for (var _j = 0; _j < config.list.length; _j++) {

              for (var k = 0; k < config.list[_j].length; k++) {
                if (config.list[_j][k] != undefined) {
                  if (config.list[_j][k].type === 'image') {
                    if (config.list[_j][k].answer != undefined) {
                      // 从没保存过时，初始化为空数组
                      if (config.list[_j][k].answer === '') {
                        config.list[_j][k].answer = [];
                      }

                      // Note: 这段逻辑理论上有问题，如果有多个上传组件时就是错的了
                      // 深拷贝col.answer，用于upLoad组件 file-list的数据源
                      this.clonedImageList = this.deepClone(config.list[_j][k].answer);
                      // 得到当前已经上传的文件数量
                      this.imageCount = config.list[_j][k].answer.length;
                      // 克隆后的数组里url加上缩略图后缀
                      // this.clonedImageList.forEach(file => file.url = util.resizeOSSImage.switchResizeToThumbnail(file.url))
                    }
                  } else if (config.list[_j][k].type === 'pdf') {
                    if (config.list[_j][k].answer === '') {
                      config.list[_j][k].answer = [];
                    }
                    // Note: 这段逻辑理论上有问题，如果有多个上传组件时就是错的了
                    // 深拷贝col.answer，用于upLoad组件 file-list的数据源
                    this.clonedPDFList = this.deepClone(config.list[_j][k].answer);
                  }
                }
              }
            }
          }

          list[i][j].config = config;
          group.push(list[i][j]);
          count++;
        }
        this.questions.push(group);
      }

      this.refreshOldQuestions();

      if (params !== undefined && params !== null) {
        if (params.type === 'evidence') {
          var questionId = params.questionId;
          this.setHighlight(this.questions, questionId, function (item) {
            item.highlighted = true;
          });
        }

        if (params.type === 'comment') {
          var commentId = params.commentId;
          this.setHighlight(this.comments, commentId, function (item) {
            item.highlighted = true;
          });

          // 遍历questions，判断当前评论所在位置，如果所在位置小于评论长度-3，表明当前评论被hide，需要将其展开，否则不做处理
          // forEach() => 数组源生方法，用于遍历数组项
          this.questions.forEach(function (qs) {
            // qs => question部分
            qs.forEach(function (q) {
              // q => 每一个question
              q.commentList.forEach(function (c, i) {
                // c => 每一个question的comment
                if (c.id === commentId && i < q.commentList.length - 3) {
                  q.showCommentCount = q.commentList.length;
                }
              });
            });
          });
        }
      }

      // 走到这一步所有详情对话框需要的数据都已经加载完了
      this.isDialogLoading = false;
      window.onbeforeunload = function () {
        return "你的表单有些修改尚未保存，是否确定要离开?\nSome changes aren\'t saved. Are you sure leaving the page?";
      };

      window.onunload = function () {
        return "你的表单有些修改尚未保存，是否确定要离开?\nSome changes aren\'t saved. Are you sure leaving the page?";
      };

      //因为element在给date组件赋值的之后已经触发了其change时间，进而isdirty被置为true，因此，此段代码让页面在加载完成数据之后将其置为false
      setTimeout(function () {
        _this3.isDirty = false;
        // 跳转到指定元素前
        if (params) {
          if (params.type === 'comment') {
            var commentDom = document.getElementById('comment' + params.commentId);
            commentDom && commentDom.scrollIntoView();
          } else if (params.type === 'evidence') {
            var evidenceDom = document.getElementById('question' + params.questionId);
            evidenceDom && evidenceDom.scrollIntoView();
          }
        }
      }, 0);
    },

    clone: function clone(myObj) {
      if ((typeof myObj === 'undefined' ? 'undefined' : _typeof(myObj)) != 'object') return myObj;
      if (myObj == null) return myObj;
      var myNewObj = new Object();
      for (var i in myObj) {
        myNewObj[i] = this.clone(myObj[i]);
      }return myNewObj;
    },

    checkQuestionInput: function checkQuestionInput(value) {
      this.isDirty = true;
      this.checkEmoji(value);
    },

    checkEmoji: function checkEmoji(value) {
      var regStr = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/ig;
      if (regStr.test(value)) this.$message.warning('Emoji is not supported, please remove it from your answer or comment.');
    },

    refreshOldQuestions: function refreshOldQuestions() {
      var _this4 = this;

      if (this.hasOldQuestions) {
        this.oldQuestions = [];
        this.questions.forEach(function (group) {
          var oldGroup = [];
          group.forEach(function (question) {
            var list = [];
            for (var i = 0; i < question.config.list.length; i++) {
              if (question.config.list[i] instanceof Array) {
                var temp = [];
                for (var j = 0; j < question.config.list[i].length; j++) {

                  //此处将对象序列化后在反序列化的目的是深拷贝对象，没有使用methods中的clone方法是因为
                  //element日期控件中的值发生变化时，如果使用clone方法复制对象会造成日期控件的值变成一个空的object
                  temp.push(JSON.parse(JSON.stringify(question.config.list[i][j])));
                }
                list.push(temp);
              } else {
                list.push(JSON.parse(JSON.stringify(question.config.list[i])));
              }
            }
            var oldQuestion = { config: { list: list } };
            oldGroup.push(oldQuestion);
          });
          _this4.oldQuestions.push(oldGroup);
        });
      }
    },

    //获取指定evidence的问题，当前evidence没有answer时请求加载
    getQuestion: function getQuestion(templateType, params) {
      var _this5 = this;

      this.$http.get('question/pageEvidence/' + templateType).then(function (response) {
        _this5.hasOldQuestions = false;
        _this5.handleQuestionList(response, params);
      }).catch(function (error) {
        _this5.$message.error(error);
      });
    },

    //请求当前evidence答案
    getAnswer: function getAnswer(evidenceId, templateType, params) {
      var _this6 = this;

      this.$http.get('pageEvidence/answer/' + evidenceId).then(function (response) {
        //存在则显示，不存在则请求question
        if (response.length == 0) {
          _this6.getQuestion(templateType, params);
        } else {
          _this6.hasOldQuestions = true;
          _this6.handleQuestionList(response, params);
        }
      }).catch(function (error) {
        _this6.$message.error(error);
      });
    },

    //通过此函数获得请求并显示dialog所需的所有数据
    getDialogAll: function getDialogAll(evidenceId, templateType, params) {
      var _this7 = this;

      //请求当前page评论
      this.$http.get('comment/pageEvidence/' + evidenceId).then(function (response) {
        _this7.comments = response;
        _this7.getAnswer(evidenceId, templateType, params);
      }).catch(function (error) {
        _this7.$message.error(error);
      });
    },

    isQuestionDirty: function isQuestionDirty(question, groupIndex, questionIndex) {
      if (!this.hasOldQuestions) {
        for (var i = 0; i < question.config.list.length; i++) {
          var row = question.config.list[i];
          for (var index in row) {
            var col = row[index];
            var type = col.type;
            if (type === 'input' || type === 'tableInput' || type === 'text' || type === 'radio' || type === 'date' || type === 'tableDate' || type === 'link') {
              if (question.initialEmpty === undefined || question.initialEmpty) question.initialEmpty = col.answer === '';
            }

            if (type === 'datetime') {
              if (question.initialEmpty === undefined || question.initialEmpty) question.initialEmpty = col.date === '' && col.time === '';
            }

            if (type === 'checkbox' || type === 'pdf' || type === 'image') {
              if (question.initialEmpty === undefined || question.initialEmpty) question.initialEmpty = col.answer === '' || col.answer.length === 0;
            }
          }
        }
        return true;
      }
      question.initialEmpty = false;
      var oldQuestion = this.oldQuestions[groupIndex][questionIndex];
      if (oldQuestion.config.list.length !== question.config.list.length) return true;
      for (var _i = 0; _i < question.config.list.length; _i++) {
        var _row = question.config.list[_i];
        var oldRow = oldQuestion.config.list[_i];
        for (var _index in _row) {
          var oldCol = oldRow[_index];
          var _col = _row[_index];
          var _type = _col.type;
          if (_type === 'input' || _type === 'tableInput' || _type === 'text' || _type === 'radio' || _type === 'link') {
            if (_col.answer !== oldCol.answer) return true;
          }

          if (_type === 'date' || _type === 'tableDate') {
            var oldDate = oldCol.answer === '' ? '' : Date.parse(new Date(oldCol.answer));
            var date = _col.answer === '' ? '' : Date.parse(new Date(_col.answer));
            if (oldDate !== date) return true;
          }

          if (_type === 'datetime') {
            var _oldDate = oldCol.date === '' ? '' : Date.parse(new Date(oldCol.date));
            var _date = _col.date === '' ? '' : Date.parse(new Date(_col.date));
            var oldTime = oldCol.time === '' ? '' : Date.parse(new Date(oldCol.time));
            var time = _col.time === '' ? '' : Date.parse(new Date(oldCol.time));
            if (_date !== _oldDate || time !== oldTime) {
              return true;
            }
          }

          if (_type === 'pdf' || _type === 'image') {
            var count = 0;
            var answerBoxes = [];
            for (var boxIndex in oldCol.answer) {
              answerBoxes.push(oldCol.answer[boxIndex]);
              count++;
            }
            if (_col.answer.length !== count) return true;
            for (var x = _col.answer.length - 1; x >= 0; x--) {
              // 还需要判断图片前后url是否一致，防止一增一减图片或pdf时，无法保存
              if (_col.answer[x].uid !== answerBoxes[x].uid || _col.answer[x].url !== answerBoxes[x].url) return true;
            }
          }

          if (_type === 'checkbox') {
            var _count = 0;
            var _answerBoxes = [];
            for (var _boxIndex in oldCol.answer) {
              _answerBoxes.push(oldCol.answer[_boxIndex]);
              _count++;
            }
            if (_col.answer.length !== _count) return true;
            for (var _x = 0; _x < _col.answer.length; _x++) {
              if (_col.answer[_x] !== _answerBoxes[_x]) return true;
            }
          }
        }
      }
      return false;
    },

    closeDialog: function closeDialog() {
      this.isDirty = false;
      window.onbeforeunload = null;
      window.onunload = null;
      if (!this.isLineRead) {
        this.$emit('close', { id: this.notificationId });
      }
    },

    //处理显示当前templateType的所有逻辑
    showEvidenceDialog: function showEvidenceDialog(type, evidenceId, params, confirmed, isAdd) {
      if (type == undefined) return;
      this.evidenceId = evidenceId;
      this.confirmed = confirmed; // 教师端会传此参数
      this.isAdd = isAdd;
      this.reset();
      this.isDialogLoading = true;
      this.editVisible = true;
      this.templateTypeText = templateTypeDefinition[type];
      this.getDialogAll(evidenceId, type, params);
    },
    reset: function reset() {
      this.questions = [];
      this.oldQuestions = [];
      this.saving = false;
      this.hasOldQuestions = false;
      this.isDirty = false;
      // 上传相关
      this.expire = 0;
      // this.uploadUrl = ''
      this.uploadFormData = {};
      this.dialogImageUrl = '';
      this.picReview = false;
      this.pdfPreviewUrl = '';
      this.clonedImageList = [];
      this.clonedPDFList = [];
      this.imageCount = 0;
      this.isAuthorizing = false;
      this.isUploading = false;
    },


    saveAnswer: function saveAnswer() {
      var _this8 = this;

      if (!this.isDirty) {
        this.$message({
          type: 'warning',
          message: 'Evidence hasn\'t been edited'
        });
        this.saving = false;
        return;
      }
      var postQuestionList = [];
      this.saving = true;
      this.questions.forEach(function (group, groupIndex) {
        group.forEach(function (question, questionIndex) {
          console.log('saving: ', question, questionIndex);
          if (_this8.isQuestionDirty(question, groupIndex, questionIndex)) {
            var answer = {
              id: question.answerId,
              evidenceId: _this8.evidenceId,
              evidenceQuestionId: question.id,
              answer: JSON.stringify(question.config),
              initialEmpty: question.initialEmpty
            };
            postQuestionList.push(answer);
          }
        });
      });

      if (postQuestionList.length === 0) {
        this.saving = false;
        this.$message.warning('Portfolio hasn\'t been edited, nothing saved.');
        return;
      }

      this.$http.post('pageEvidence/answer', postQuestionList).then(function (response) {
        var count = 0;
        if (!_this8.hasOldQuestions) {
          for (var i = 0; i < _this8.questions.length; i++) {
            var group = _this8.questions[i];
            for (var j = 0; j < group.length; j++) {
              group[j].answerId = response[count];
              count++;
            }
          }
        }
        _this8.hasOldQuestions = true;
        _this8.refreshOldQuestions();
        _this8.saving = false;
        _this8.isDirty = false;
        _this8.editVisible = false;
        _this8.$message({ message: 'Evidence saved successfully.', type: 'success' });

        _this8.$emit('saved');
      }).catch(function (error) {
        _this8.saving = false;
        _this8.$message.error(error.message);
      });
    },
    //提交评论
    saveComment: function saveComment(question, commentList) {
      var _this9 = this;

      question.isSavingComment = true;
      this.$http.post('comment', {
        pageEvidenceQuestionId: question.id,
        pageEvidenceId: this.evidenceId,
        content: question.content
      }).then(function (response) {
        commentList.push(response);
        _this9.$message({ message: 'Your comment is successfully posted.', type: 'success' });
        question.content = '';
        question.isSavingComment = false;
      }).catch(function (error) {
        _this9.$message.error(error.message);
        question.isSavingComment = false;
      });
    },

    //删除评论
    cancelComment: function cancelComment(comment, commentList) {
      var _this10 = this;

      this.$http.delete('comment/' + comment.id).then(function (response) {
        commentList.splice(commentList.indexOf(comment), 1);
        _this10.$message.success('Comment removed');
      }).catch(function (error) {
        _this10.$message.error(error.message);
      });
    },

    saveAlert: function saveAlert(done) {
      var _this11 = this;

      if (this.isDirty) {
        this.$confirm('Confirm to leave the page without saving?', 'Warning', {
          confirmButtonText: 'Leave',
          cancelButtonText: 'Cancel',
          confirmButtonLoading: false,
          type: 'warning'
        }).then(function (_) {
          _this11.isDirty = false;
          done();
        }).catch(function (_) {});
      } else {
        this.isDirty = false;
        done();
      }
    },

    // 上传相关
    handleUploadError: function handleUploadError(err, file, fileList) {
      console.log('handleUploadError', file, fileList, err);
      // 注意: handleUploadError和handleRemove在出错时只有一个会被element调用到

      // 上传时出錯，检查剩下的所有文件是不是都是success状态，如果是，则视为没有正在上传
      var allLeftFileSuccess = fileList.every(function (file) {
        return file.status === 'success';
      });
      if (allLeftFileSuccess) {
        this.isUploading = false;
      }

      this.$message.error('File upload failed, please try again later.');

      this.imageCount--;
    },
    handleBeforeImageUpload: function handleBeforeImageUpload(file) {
      // 进来就要设置，因为这里检查失败的话也会走handleRemove，会imageCount--
      this.imageCount++;
      console.log('handleBeforeImageUpload', this.imageCount);

      // 合法性检查
      var isImage = file.type === 'image/jpeg' || file.type === 'image/png';
      //                console.log(file.type)
      var isLt4M = file.size / 1024 / 1024 < 4;

      if (!isImage) {
        this.$message.error('Only jpg/png allowed.');
        return false;
      }
      if (!isLt4M) {
        this.$message.error('The size of the image should be less than 4MB.');
        return false;
      }

      // return this.tryGetUploadParams(file)
    },
    handleBeforePDFUpload: function handleBeforePDFUpload(file) {
      console.log('handleBeforePDFUpload entered');
      console.log(file);

      // 合法性检查
      var typeValid = file.type === 'application/pdf';
      //                console.log(file.type)
      var sizeValid = file.size / 1024 / 1024 < 10;

      if (!typeValid) {
        this.$message.error('Only PDF file allowed.');
        return false;
      }
      if (!sizeValid) {
        this.$message.error('The size of the PDF file should be less than 10MB.');
        return false;
      }

      // return this.tryGetUploadParams(file)
    },

    buildOSSUrl: function buildOSSUrl(file) {
      return 'epq/' + this.userId + '/' + file.uid + this.getSuffix(file.name);
    },
    tryGetUploadParams: function tryGetUploadParams(file) {
      var _this12 = this;

      // 走到这里就视为进入广义上的上传状态
      this.isUploading = true;

      // 这个其实不用每次都设置，放这里方便统一查看
      this.uploadFormData.success_action_status = '200';
      // 文件名利用element的基于时间戳的文件uid
      this.uploadFormData.key = this.buildOSSUrl(file);

      var now = Date.now() / 1000;

      // 判断是否过期，还剩少于3秒就认为过期
      if (this.expire - now < 3) {
        // 获取授权中
        this.isAuthorizing = true;
        var promise = this.$http.get('/common/' + this.userId).then(function (response) {
          // 授权完成
          _this12.isAuthorizing = false;

          // 地址应该不会变，但因为是请求返回的，还是每次设置一下
          _this12.uploadUrl = response.host;

          _this12.uploadFormData.OSSAccessKeyId = response.accessid;
          _this12.uploadFormData.signature = response.signature;
          _this12.uploadFormData.policy = response.policy;

          _this12.expire = response.expire;
        });

        // 分开写，不然就会返回catch的promise了
        promise.catch(function (error) {
          _this12.isAuthorizing = false;
          _this12.$message.error(error.message);
        });

        // 返回promise，上传不会立即开始；当Promise为resolve时才会上传，如果是rejected，则ElementUI会删掉文件并调用on-remove
        return promise;
      } else {
        // 没过期就直接上传，用上次的签名
        return true;
      }
    },
    handleImageRemove: function handleImageRemove(file, fileList, answerList) {
      console.log('handleImageRemove', file, fileList, answerList);
      // 只要走到这就减1，不管是手动删还是element自动调用的删除。因为上传检查的时候无条件+1了，所以这里只要走到就-1
      this.imageCount--;
      this.isDirty = true;

      // 上传一半时人为取消了，检查剩下的所有文件是不是都是success状态，如果是，则视为没有正在上传
      // 数组长度为0时every方法会返回true，所以就不判断长度为0了
      var allLeftFileSuccess = fileList.every(function (file) {
        return file.status === 'success';
      });
      if (allLeftFileSuccess) {
        this.isUploading = false;
      }

      // 断网情况下开始上传file会是空，这时会失败并且会走到handleRemove
      if (file !== null) {
        // element组件删除的文件对应的OSS URL
        var fileRemoteUrl = file.remoteUrl ? file.remoteUrl : __WEBPACK_IMPORTED_MODULE_0__component_util_js__["a" /* default */].resizeOSSImage.switchResizeToInit(file.url);

        // 根据URL查找是否此文件已经保存到将要save到db的数组中了，如果有，则同步删除；如果没有，则什么也不做，一般意味着上传一半删除或出错了等情况element自动调了删除
        var index = -1;
        for (var i = 0; i < answerList.length; i++) {
          // 一般来说，answerList里的url应该没有后缀，但存在老代码导致的数据库的既存数据已经有了后缀的情况，所以还是需要去掉逻辑
          if (fileRemoteUrl === __WEBPACK_IMPORTED_MODULE_0__component_util_js__["a" /* default */].resizeOSSImage.switchResizeToInit(answerList[i].url)) {
            index = i;
            break;
          }
        }

        if (index > -1) {
          answerList.splice(index, 1);
        }
      }
    },
    handlePDFRemove: function handlePDFRemove(file, fileList, answerList) {
      console.log('handlePDFRemove', file, fileList, answerList);
      this.isDirty = true;

      // 上传一半时人为取消了，检查剩下的所有文件是不是都是success状态，如果是，则视为没有正在上传
      // 数组长度为0时every方法会返回true，所以就不判断长度为0了
      var allLeftFileSuccess = fileList === null || fileList.every(function (file) {
        return file.status === 'success';
      });
      if (allLeftFileSuccess) {
        console.log('handlePDFRemove allLeftFileSuccess', fileList.length);
        this.isUploading = false;
      }

      // 断网情况下开始上传file会是空，这时会失败并且会走到handleRemove
      if (fileList === null || fileList.length === 0) {
        answerList.splice(0, answerList.length);
      }
    },
    handleUploadImageSuccess: function handleUploadImageSuccess(response, file, fileList, list) {
      console.log('handleUploadImageSuccess entered', file, fileList, list);

      this.isDirty = true;
      // 检查所有文件是不是都是success状态，如果是，则视为没有正在上传
      // 数组长度为0时every方法会返回true，所以就不判断长度为0了
      var allLeftFileSuccess = fileList.every(function (file) {
        return file.status === 'success';
      });
      if (allLeftFileSuccess) {
        this.isUploading = false;
      }

      // 设置file的remoteUrl
      file.remoteUrl = response.url;
      list.push({ name: file.name, url: response.key });
    },
    handleUploadPDFSuccess: function handleUploadPDFSuccess(response, file, fileList, list) {
      console.log('handleUploadPDFSuccess entered', file, fileList, list);
      this.isDirty = true;

      // 检查所有文件是不是都是success状态，如果是，则视为没有正在上传
      // 数组长度为0时every方法会返回true，所以就不判断长度为0了
      var allLeftFileSuccess = fileList.every(function (file) {
        return file.status === 'success';
      });
      if (allLeftFileSuccess) {
        this.isUploading = false;
      }

      fileList.splice(0, fileList.length, file);
      list.splice(0, list.length, { name: file.name, url: response.key });
    },
    handleFileChanged: function handleFileChanged(file, fileList) {
      console.log('handleFileChanged entered', file, fileList, file.status);
      this.isDirty = true;
    },
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      console.log('handlePictureCardPreview entered');
      console.log(file);
      // 预览时判断，url是否为blob地址，如果是不加后缀，否则加后缀。
      this.dialogImageUrl = file.url;
      this.picReview = true;
    },
    handlePDFPreview: function handlePDFPreview(file) {
      console.log('handlePDFPreview entered');
      console.log(file);

      // 微软系列浏览器如果是本地刚上传的，则弹出保存或打开对话框
      if (file.raw && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(file.raw, file.name);
      } else {
        this.$refs.pdfPreview.href = file.url;
        this.$refs.pdfPreview.click();
      }
    },
    getSuffix: function getSuffix(filename) {
      var pos = filename.lastIndexOf('.');
      var suffix = '';
      if (pos != -1) {
        suffix = filename.substring(pos);
      }
      return suffix;
    },


    // 对象深拷贝方法
    deepClone: function deepClone(data) {
      if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) !== 'object') return;
      data = JSON.parse(JSON.stringify(data));
      return data;
    }
  },
  mounted: function mounted() {
    var _this13 = this;

    this.$nextTick(function () {
      _this13.init();
    });
  }
});

/***/ }),

/***/ 286:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component_md5__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__component_md5__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    // 不加name有可能按照文件名被加载为header组件，导致和模板利用的原生header重名，被认为是递归引用
    name: 'common-header',
    data: function data() {
        return {
            LoginName: decodeURI(__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('name')), //登录用户名
            LoginId: __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('userid'), //登录用户Id
            StudentId: __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('studentId'), //学生studengId
            TeacherId: __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('teacherId'), //老师teacherId
            Role: __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('role'), //登录用户身份

            NotificationCount: 0,
            //修改用户信息弹窗

            // loading过渡状态变量
            loading: false,
            profileLoading: false,
            editSaveBtnIsLoading: false,
            changeSaveBtnIsLoading: false,

            formLabelWidth: '130px',
            editDialog: false,
            editform: {},
            editrules: {
                email: [{ required: true, message: 'Email Adress Required', trigger: 'blur' }, { type: 'email', message: 'Email format invalid.' }],
                givenName: [{ required: true, message: 'GivenName Required', trigger: 'blur' }, { max: 30, message: 'givenName should not more than 30 characters.', trigger: 'blur' }],
                familyName: [{ required: true, message: 'FamilyName Required', trigger: 'blur' }, { max: 30, message: 'familyName should not more tha 30 characters.', trigger: 'blur' }],
                displayName: [{ required: true, message: 'DisplayName Required', trigger: 'blur' }, { max: 60, message: 'displayName should not more tha 60 characters.', trigger: 'blur' }],
                school: [{ required: true, message: 'Affiliation Required', trigger: 'blur' }, { max: 100, message: 'Affiliation Name should not more tha 100 characters.', trigger: 'blur' }],
                mobilePhone: [{ required: false }, { pattern: /^1\d{10}$/, message: 'Phone number format invalid.', trigger: 'blur' }],
                motherPhone: [{ required: false }, { pattern: /^1\d{10}$/, message: 'Phone number format invalid.', trigger: 'blur' }],
                fatherPhone: [{ required: false }, { pattern: /^1\d{10}$/, message: 'Phone number format invalid.', trigger: 'blur' }]
            },
            //修改密码
            changePassDialog: false,
            passform: {},
            changePassRules: {
                oldPwd: [{ required: true, message: 'Old Password Required', trigger: 'blur' }],
                newPwd: [{ required: true, message: 'New Password Required', trigger: 'blur' }, { min: 8, max: 20, message: 'Password should contain 8 to 20 characters.', trigger: 'blur' }, { pattern: /^\w{8,20}$/, message: "Only numbers, letters, and underscores allowed.", trigger: 'blur' }]
            }
        };
    },
    mounted: function mounted() {
        var _this2 = this;

        this.$nextTick(function () {
            // 调用之前判断role是否是管理员，短路用法：&&逻辑与符号左边如果满足条件，不论右边是什么都会直接执行；反之什么也不干。
            if (_this2.Role !== 'admin') {
                _this2.getNotificationCount();
            }
        });
    },

    methods: {
        //header部分管理员dropdown操作
        handleCommand: function handleCommand(command) {
            var _this3 = this;

            if (command === 'logout') {
                //退出登录
                var _this = this;
                this.$http.get('user/logout').then(function (response) {
                    _this.$router.push('/login');
                }).catch(function (error) {
                    // TODO: 精简cookie
                    __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.remove('token');
                    __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.remove('role');
                    __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.remove('name');
                    _this3.$message.error(error.message);
                });
            } else if (command === 'edit') {
                this.editDialog = true;
                this.editStudent();
            } else if (command === 'password') {
                this.changePassDialog = true;
            }
        },


        //获取notification总数：教师端/学生端
        getNotificationCount: function getNotificationCount() {
            var _this4 = this;

            this.$http.get('notification/count').then(function (response) {
                _this4.NotificationCount = response;
            }).catch(function (error) {
                _this4.$message.error(error.message);
            });
        },


        //获取弹窗用户信息
        editStudent: function editStudent() {
            var _this5 = this;

            this.profileLoading = true;
            if (this.Role === 'student') {
                this.$http.get('student/' + this.StudentId).then(function (response) {
                    _this5.editform = response;
                    _this5.profileLoading = false;
                }).catch(function (error) {
                    _this5.$message.error(error.message);
                    _this5.profileLoading = false;
                });
            } else if (this.Role === 'teacher' || this.Role === 'ta') {
                this.$http.get('teacher/' + this.TeacherId).then(function (response) {
                    _this5.editform = response;
                    _this5.profileLoading = false;
                }).catch(function (error) {
                    _this5.$message.error(error.message);
                    _this5.profileLoading = false;
                });
            }
        },


        //编辑用户：教师／学生端
        submitedit: function submitedit(formName) {
            var _this6 = this;

            this.$refs[formName].validate(function (valid) {
                if (valid) {
                    _this6.editSaveBtnIsLoading = true;
                    if (_this6.Role === 'student') {
                        _this6.$http.put('student', {
                            id: _this6.StudentId,
                            motherPhone: _this6.editform.motherPhone,
                            fatherPhone: _this6.editform.fatherPhone,
                            school: _this6.editform.school,
                            user: {
                                email: _this6.editform.email,
                                familyName: _this6.editform.familyName,
                                givenName: _this6.editform.givenName,
                                displayName: _this6.editform.displayName,
                                mobilePhone: _this6.editform.mobilePhone
                            }
                        }).then(function (response) {
                            //渲染数据
                            _this6.editDialog = false;
                            _this6.loading = false;
                            _this6.editSaveBtnIsLoading = false;
                            _this6.$message.success('Edit success');
                        }).catch(function (error) {
                            _this6.editDialog = false;
                            _this6.loading = false;
                            _this6.editSaveBtnIsLoading = false;
                            _this6.$message.error(error.message);
                        });
                    } else {
                        _this6.$http.put('teacher', {
                            id: _this6.TeacherId,
                            user: {
                                email: _this6.editform.email,
                                familyName: _this6.editform.familyName,
                                givenName: _this6.editform.givenName,
                                displayName: _this6.editform.displayName,
                                mobilePhone: _this6.editform.mobilePhone
                            }
                        }).then(function (response) {
                            //渲染数据
                            _this6.editDialog = false;
                            _this6.loading = false;
                            _this6.editSaveBtnIsLoading = false;
                            _this6.$message.success('Edit success');
                        }).catch(function (error) {
                            _this6.editDialog = false;
                            _this6.loading = false;
                            _this6.editSaveBtnIsLoading = false;
                            _this6.$message.error(error.message);
                        });
                    }
                } else {
                    return false;
                }
            });
        },


        //修改密码：学生端
        submitPass: function submitPass(formName) {
            var _this7 = this;

            this.$refs[formName].validate(function (valid) {
                if (valid) {
                    _this7.changeSaveBtnIsLoading = true;
                    var oldPassward_md5 = __WEBPACK_IMPORTED_MODULE_1__component_md5___default.a.hex_md5(_this7.passform.oldPwd);
                    var newPassward_md5 = __WEBPACK_IMPORTED_MODULE_1__component_md5___default.a.hex_md5(_this7.passform.newPwd);
                    _this7.$http.post('user/changePwd', {
                        oldPwd: oldPassward_md5,
                        newPwd: newPassward_md5
                    }).then(function (response) {
                        console.log(_this7.passform.oldPwd);
                        _this7.changePassDialog = false;
                        _this7.$message.success('Change Password success');
                        _this7.passform.oldPwd = '';
                        _this7.passform.newPwd = '';
                        _this7.changeSaveBtnIsLoading = false;
                    }).catch(function (error) {
                        _this7.changePassDialog = false;
                        _this7.changeSaveBtnIsLoading = false;
                        _this7.$message.error(error.message);
                    });
                } else {
                    return false;
                }
            });
        }
    },
    watch: {
        $route: function $route() {
            if (this.Role !== 'admin') {
                this.getNotificationCount();
            }
        }
    }
});

/***/ }),

/***/ 287:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sortablejs__ = __webpack_require__(584);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'reportDialog',
    //props去掉report属性，防止因vue父子组件响应式更新而造成cope和aope存储答案时串掉
    props: ['isLineRead', 'notificationId'],
    data: function data() {
        return {
            report: {},
            studentId: 0,
            userId: 0,
            role: '',
            displayName: '',
            skilldialog: false,
            questions: [],
            oldQuestions: [],
            hasOldQuestions: false,
            comments: [],
            showCommentCount: 3,
            forTeacher: [],
            currentSkill: {},
            currentPage: '',
            currentPageId: 0,
            nextPage: {},
            saving: false,
            isDirty: false,
            maxLength: 4000,
            isDialogLoading: false,
            confirmAllDisabled: false,
            currentSaving: '',
            datepickerOptions: {
                option1: {}
            },
            //plan做完后面两个page才可以做
            disabledTips: '',
            pageLock: true, //是否显示lock按钮
            lock: true, //switch的状态
            //close／next弹窗
            leaveDialog: false,
            from: '', //判断点了close还是next
            skill: '',
            page: '',
            pageId: 0,
            isConfirmAllLoading: false,
            sortable: null,
            teacherEditEnabled: true,
            studentEditEnabled: true
        };
    },

    methods: {
        //行拖拽
        rowDrop: function rowDrop() {
            var _this2 = this;

            var indexList = [];
            this.questions.forEach(function (questionGroup, i) {
                questionGroup.forEach(function (question) {
                    if (question.config.type == "table") {
                        indexList.push(i);
                        var el = document.querySelector('.drag' + i + ' .el-table__body-wrapper tbody');
                        var _this = _this2;
                        __WEBPACK_IMPORTED_MODULE_2_sortablejs__["a" /* default */].create(el, {
                            onEnd: function onEnd(evt) {
                                //操作数据
                                _this.$nextTick(function () {
                                    var targetRow = question.config.list.splice(evt.oldIndex, 1)[0];
                                    console.log(targetRow, "jjjj");
                                    question.config.list.splice(evt.newIndex, 0, targetRow);
                                });
                                console.log(question.config.list, "调整后");
                            }
                        });
                    }
                });
            });
        },

        //POST键盘事件
        pressAction: function pressAction(question, commentList, ev) {
            if (13 == ev.keyCode && ev.ctrlKey) {
                //ctrl + enter
                if (question.content && !question.isSavingComment) {
                    // 有输入值且没有正在保存。因为是代码触发，所以必须加上这个判断
                    this.saveComment(question, commentList);
                }
            }
        },

        //此方法在复制对象时会将数组clone成对象，但为了兼容之前点击‘+’产生的数据，所以仍然采用此方法
        clone: function clone(myObj) {
            if ((typeof myObj === 'undefined' ? 'undefined' : _typeof(myObj)) != 'object') return myObj;
            if (myObj == null) return myObj;
            var myNewObj = new Object();
            for (var i in myObj) {
                myNewObj[i] = this.clone(myObj[i]);
            }return myNewObj;
        },
        saveAlert: function saveAlert(done) {
            if (this.isDirty) {
                this.leaveDialog = true;
                this.from = 'close';
            } else {
                this.isDirty = false;
                done();
            }
        },

        //close和next公用弹窗，三种操作执行时需先判断用户是点击了close还是leave
        unSaveAction: function unSaveAction() {
            this.leaveDialog = false;
            if (this.from === 'close') {
                this.skilldialog = false;
                this.isDirty = false;
            } else {
                this.showPage(this.skill, this.page, this.pageId); //showpage函数里有重置isDirty为false，故此处不用
            }
        },
        saveAction: function saveAction() {
            this.saving = true;
            this.leaveDialog = false;
            this.saveAnswer();
            if (this.from === 'close') {
                this.skilldialog = false;
                this.isDirty = false;
            } else {
                this.showPage(this.skill, this.page, this.pageId);
            }
        },


        getCurrentPageIndex: function getCurrentPageIndex(skill, page) {
            for (var i = 0; i < skill.pageList.length; i++) {
                if (skill.pageList[i].page == page) return i;
            }
        },

        more: function more(obj) {
            if (obj.length >= 50) {
                this.$message.error('There can be 50 answers at most.');
                return false;
            }
            var newObj = this.clone(obj[obj.length - 1]);
            newObj.id = obj.length + 1;
            for (var config in newObj.list) {
                newObj.list[config].answer = '';
            }
            console.log(newObj, "");
            obj.push(newObj);
            this.isDirty = true;
        },
        less: function less(obj) {
            var _this3 = this;

            this.$confirm('Confirm to delete the answer?', 'Warning', {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(function () {
                var msg = '';
                var type = '';
                if (obj.length > 1) {
                    obj.pop();
                    msg = 'success';
                    type = 'success';
                } else {
                    msg = 'You can\'t delete when there\'s only one answer.';
                    type = 'error';
                }
                _this3.$message({
                    type: type,
                    message: msg
                });
            }).catch(function () {
                // 用户点了取消删除
                _this3.$message.error(error.message);
            });
            this.isDirty = true;
        },

        showNextPage: function showNextPage(skill, page, pageId) {
            if (this.isDirty) {
                this.leaveDialog = true;
                this.from = 'next';
                this.skill = skill;
                this.page = page;
                this.pageId = pageId;
            } else {
                this.showPage(skill, page, pageId);
            }
        },

        //获取指定page的问题，当前page没有回答时请求加载
        getQuestion: function getQuestion(pageId, params) {
            var _this4 = this;

            this.$http.get('question/' + pageId).then(function (response) {
                _this4.hasOldQuestions = false;
                _this4.handleQuestionList(response.questionList, params);
            }).catch(function (error) {
                _this4.$message.error(error);
            });
        },

        //请求当前page答案
        getAnswer: function getAnswer(pageId, params) {
            var _this5 = this;

            this.$http.get('report/answer?reportId=' + this.report.id + '&pageId=' + pageId).then(function (response) {
                if (response.questionList.length == 0) {
                    _this5.getQuestion(pageId, params);
                } else {
                    _this5.hasOldQuestions = true;
                    _this5.handleQuestionList(response.questionList, params);
                }
            }).catch(function (error) {
                throw Error(error);
                //this.$message.error(error);
            });
        },

        //通过此函数获得请求并显示dialog所需的所有数据
        getDialogAll: function getDialogAll(pageId, params) {
            var _this6 = this;

            //请求当前page评论
            this.$http.get('comment/page?studentId=' + this.studentId + '&pageId=' + pageId).then(function (response) {
                _this6.comments = response;
                _this6.getAnswer(pageId, params);
            }).catch(function (error) {
                _this6.$message.error(error.message);
            });
        },

        closeDialog: function closeDialog() {
            this.isDirty = false;
            window.onbeforeunload = null;
            window.onunload = null;
            if (!this.isLineRead) {
                this.$emit('close', { id: this.notificationId });
            }
        },

        //处理显示当前page的所有逻辑
        showPage: function showPage(skill, page, pageId, params) {
            if (page === '' || page == undefined) return;
            this.reset();

            this.currentSkill = skill;
            this.currentPage = page;
            this.currentPageId = pageId;
            //清空this.questions,
            this.questions.splice(0, this.questions.length);
            this.getDialogAll(pageId, params);
            this.progressActiveIndex = this.getCurrentPageIndex(skill, page);
            this.isDialogLoading = true;
            this.skilldialog = true;
            for (var i = 0; i < skill.pageList.length; i++) {
                var pageObj = skill.pageList[i];
                if (pageObj.page == page) {
                    if (i == skill.pageList.length - 1) {
                        this.nextPage = '';
                    } else {
                        this.nextPage = { page: skill.pageList[i + 1].page, id: skill.pageList[i + 1].id };
                    }
                }
            }

            window.onbeforeunload = function () {
                return "你的表单有些修改尚未保存，是否确定要离开?\nSome changes aren\'t saved. Are you sure leaving the page?";
            };

            window.onunload = function () {
                return "你的表单有些修改尚未保存，是否确定要离开?\nSome changes aren\'t saved. Are you sure leaving the page?";
            };

            this.getLock(this.report.id, pageId);
        },

        showDialogFromTeacher: function showDialogFromTeacher(report, skill, page, pageId, student) {
            this.report = report;
            this.studentId = student.id;
            this.displayName = student.displayName;
            this.showPage(skill, page, pageId);
        },

        showDialogFromStu: function showDialogFromStu(report, skill, page, pageId, studentName) {
            this.report = report;
            this.displayName = studentName;
            this.showPage(skill, page, pageId);
        },

        showDialogFromNoti: function showDialogFromNoti(report, skill, page, param) {
            //if(this.role !== 'student'){
            this.report = report;
            this.studentId = param.studentId;
            this.displayName = param.studentName;
            //}
            this.showPage(skill, page.page, page.id, param);
        },

        reset: function reset() {
            this.saving = false;
            this.isDirty = false;
            this.hasOldQuestions = false;
            this.isDialogLoading = false;
            this.confirmAllDisabled = false;
            this.currentSaving = '';
        },

        //提交评论
        saveComment: function saveComment(question, commentList) {
            var _this7 = this;

            question.isSavingComment = true;
            this.$http.post('comment', { studentId: this.studentId, questionId: question.id, content: question.content }).then(function (response) {
                commentList.push(response);
                _this7.$message({ message: 'Your comment is successfully posted.', type: 'success' });
                question.content = '';
                question.isSavingComment = false;
            }).catch(function (error) {
                _this7.$message.error(error.message);
                question.isSavingComment = false;
            });
        },

        //删除评论
        cancelComment: function cancelComment(comment, commentList) {
            var _this8 = this;

            this.$http.delete('comment/' + comment.id).then(function (response) {
                commentList.splice(commentList.indexOf(comment), 1);
                _this8.$message.success('Comment removed');
            }).catch(function (error) {
                _this8.$message.error(error.message);
            });
        },

        setHighlight: function setHighlight(list, id, successFn) {
            (list || []).forEach(function (items) {
                items.forEach(function (item) {
                    if (item.id === id) {
                        successFn instanceof Function && successFn(item);
                    }
                });
            });
        },


        checkQuestionInput: function checkQuestionInput(value) {
            this.isDirty = true;
            this.checkEmoji(value);
        },

        checkEmoji: function checkEmoji(value) {
            var regStr = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/ig;
            if (regStr.test(value)) this.$message.warning('Emoji is not supported, please remove it from your answer or comment.');
        },

        //将数据渲染到模态框中
        handleQuestionList: function handleQuestionList(list, params) {
            var _this9 = this;

            //清空this.questions,
            this.questions.splice(0, this.questions.length);
            var count = 0;
            console.log(list, "list");
            for (var i = 0; i < list.length; i++) {
                //list
                var group = [];
                for (var j = 0; j < list[i].length; j++) {
                    //list内层循环
                    list[i][j].show = false;
                    list[i][j].highlighted = false;
                    //绑定comment
                    list[i][j].content = '';
                    list[i][j].isSavingComment = false;
                    list[i][j].showCommentCount = this.showCommentCount;
                    list[i][j].commentList = this.comments[count];
                    list[i][j].config = JSON.parse(list[i][j].config);
                    list[i][j].highlighted = false;
                    for (var x = 0; x < list[i][j].config.list.length; x++) {
                        //config.list循环
                        // if(list[i][j].config.type == "table"){
                        //     list[i][j].config.list[x] = {
                        //         list:list[i][j].config.list[x],
                        //         id:x + 1
                        //     }
                        // }
                        // 否则list[x]是数组，进行遍历操作
                        for (var y = 0; y < list[i][j].config.list[x].length; y++) {
                            var item = list[i][j].config.list[x][y];
                            if (item.type === 'datetime') {
                                if (item.date !== '' || item.time !== '') {
                                    list[i][j].canBeConfirm = true;
                                }
                            } else {
                                if (item.answer !== '') list[i][j].canBeConfirm = true;
                            }
                        }
                    }
                    group.push(list[i][j]);
                    count++;
                }
                this.questions.push(group);
            }
            this.refreshOldQuestions();
            // 单独处理一下拖拽所需要用的数据格式
            this.$nextTick(function () {
                _this9.questions.forEach(function (questionGroup) {
                    questionGroup.forEach(function (question) {
                        if (question.config.type == "table") {
                            question.config.list = question.config.list.map(function (item, index) {
                                return { list: item, id: index + 1 };
                            });
                        }
                    });
                });
                _this9.rowDrop();
            });
            if (params !== undefined && params !== null) {
                if (params.type === 'answer') {
                    var questionId = params.questionId;
                    this.setHighlight(this.questions, questionId, function (item) {
                        item.highlighted = true;
                    });
                }
                if (params.type === 'comment') {
                    var commentId = params.commentId;
                    this.setHighlight(this.comments, commentId, function (item) {
                        item.highlighted = true;
                    });
                    // 遍历questions，判断当前评论所在位置，如果所在位置小于评论长度-3，表明当前评论被hide，需要将其展开，否则不做处理
                    // forEach() => 数组源生方法，用于遍历数组项
                    this.questions.forEach(function (qs) {
                        // qs => question部分
                        qs.forEach(function (q) {
                            // q => 每一个question
                            q.commentList.forEach(function (c, i) {
                                // c => 每一个question的comment
                                if (c.id === commentId && i < q.commentList.length - 3) {
                                    q.showCommentCount = q.commentList.length;
                                }
                            });
                        });
                    });
                }
            }
            this.isDialogLoading = false;
            //因为element在给date组件赋值的之后已经触发了其change事件，进而isdirty被置为true，因此，此段代码让页面在加载完成数据之后将其置为false
            setTimeout(function () {
                _this9.isDirty = false;
                // 跳转到指定元素前
                if (params) {
                    if (params.type === 'comment') {
                        var commentDom = document.getElementById('comment' + params.commentId);
                        commentDom && commentDom.scrollIntoView();
                    } else if (params.type === 'answer') {
                        var answerDom = document.getElementById('question' + params.questionId);
                        answerDom && answerDom.scrollIntoView();
                    }
                }
            }, 0);
        },

        refreshOldQuestions: function refreshOldQuestions() {
            var _this10 = this;

            if (this.hasOldQuestions) {
                this.oldQuestions = [];
                this.questions.forEach(function (group) {
                    var oldGroup = [];
                    group.forEach(function (question) {
                        var list = [];
                        for (var i = 0; i < question.config.list.length; i++) {
                            if (question.config.list[i] instanceof Array) {
                                var temp = [];
                                for (var j = 0; j < question.config.list[i].length; j++) {

                                    //此处将对象序列化后在反序列化的目的是深拷贝对象，没有使用methods中的clone方法是因为
                                    //element日期控件中的值发生变化时，如果使用clone方法复制对象会造成日期控件的值变成一个空的object
                                    temp.push(JSON.parse(JSON.stringify(question.config.list[i][j])));
                                }
                                list.push(temp);
                            } else {
                                list.push(JSON.parse(JSON.stringify(question.config.list[i])));
                            }
                        }
                        var oldQuestion = { config: { list: list } };
                        oldGroup.push(oldQuestion);
                    });
                    _this10.oldQuestions.push(oldGroup);
                });
            }
        },

        // 设置当前页状态为对勾
        setPageConfirmed: function setPageConfirmed(isConfirmed) {
            for (var i = 0; i < this.currentSkill.pageList.length; i++) {
                if (this.currentSkill.pageList[i].page === this.currentPage) {
                    this.currentSkill.pageList[i].confirmed = isConfirmed;
                }
            }
        },


        // 根据signature和date值，设置confirmed的状态，并返回当前question
        setConfirmedForSignatureAndDate: function setConfirmedForSignatureAndDate(question) {
            question.confirmed = question.config.list[0][0].answer !== '';
            return question;
        },


        // 保存之前确保日期双向绑定的值不为undefined，以防日期不能选
        handleDateAnswer: function handleDateAnswer() {
            var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var type = arguments[1];

            if (type === 'date' || type === 'tableDate') {
                if (item.answer === undefined) {
                    item.answer = '';
                }
            }
            // 根据type，格式化answer数据
            if (type === 'datetime') {
                if (item.time === undefined) {
                    item.time = '';
                }
                if (item.date === undefined) {
                    item.date = '';
                }
            }
            return item;
        },
        saveAnswer: function saveAnswer() {
            var _this11 = this;

            console.log(this.role);
            console.log(this.teacherEditEnabled);
            console.log(this.studentEditEnabled);
            if (this.role === 'student' && !this.studentEditEnabled || this.role === 'teacher' && !this.teacherEditEnabled) {
                this.$message.error("You can't edit now!");
                return;
            }
            if (!this.isDirty) {
                this.$message({
                    type: 'warning',
                    message: 'Portfolio hasn\'t been edited'
                });
                this.saving = false;
                return;
            }
            this.saving = true;
            this.saveButtonDisabled = true;
            var postQuestionList = [];

            // 获取问题组的数组长度
            var groupLen = this.questions.length;
            this.questions.forEach(function (group) {
                group.forEach(function (que) {
                    if (que.config.type == "table") {
                        que.config.list = que.config.list.map(function (item) {
                            return item.list;
                        });
                    }
                });
            });
            this.questions.forEach(function (group, groupIndex) {
                group.forEach(function (question, questionIndex) {
                    // 判断当遍历到最后一组（签名&日期组）时，调用方法设置其confirmed状态
                    if (groupIndex === groupLen - 1) {}
                    // this.setConfirmedForSignatureAndDate(question)

                    // 保存answer之前，判断是否还存在未被confirmed的question，如果存在启用confirm all 按钮，否则什么也不做。
                    if (!question.confirmed) {
                        _this11.confirmAllDisabled = false;
                    }
                    if (_this11.isQuestionDirty(question, groupIndex, questionIndex)) {
                        var dateConfig = JSON.stringify(question.config);
                        dateConfig = JSON.parse(dateConfig);

                        dateConfig.list = dateConfig.list.map(function (itemGroup, itemGroupIndex) {
                            // 判断是否是数组
                            console.log(itemGroup.constructor, "constructor");
                            if (itemGroup.constructor === Array) {
                                // 遍历itemGroup
                                return itemGroup.map(function (item) {
                                    var type = item.type;
                                    return _this11.handleDateAnswer(item, type);
                                });
                            } else {
                                // itemGroup 不是数组，那么应该是使用more方法添加的对象，使用for in 循环遍历，其余同上
                                for (var key in itemGroup) {
                                    var type = itemGroup[key].type;
                                    itemGroup[key] = _this11.handleDateAnswer(itemGroup[key], type);
                                }
                                return itemGroup;
                            }
                        });
                        dateConfig = JSON.stringify(dateConfig);

                        var answer = {
                            id: question.answerId,
                            reportId: _this11.report.id,
                            questionId: question.id,
                            answer: dateConfig,
                            confirmed: question.confirmed,
                            initialEmpty: question.initialEmpty
                        };
                        postQuestionList.push(answer);
                    }
                });
            });

            if (postQuestionList.length === 0) {
                this.saving = false;
                this.$message.warning('Portfolio hasn\'t been edited, nothing saved.');
                return;
            }

            var timestamp = new Date().getTime() + '';
            this.currentSaving = timestamp;
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.instance()({ method: 'post', url: 'report/answer', data: postQuestionList, headers: { 'requestId': timestamp } }).then(function (response) {
                console.log(response);
                if (response.data.c == 1) {
                    _this11.$message.error(response.data.i);
                    _this11.saving = false;
                    return;
                }
                if (response.data.id !== _this11.currentSaving) return;
                var count = 0;
                if (!_this11.hasOldQuestions) {
                    for (var i = 0; i < _this11.questions.length; i++) {
                        var group = _this11.questions[i];
                        for (var j = 0; j < group.length; j++) {
                            group[j].answerId = response[count];
                            count++;
                        }
                    }
                }
                _this11.$message({ message: 'Portfolio saved successfully.', type: 'success' });
                // this.skilldialog = false;
                _this11.saveButtonDisabled = false;

                // 如果都已经confirmed，将页面状态更改为对勾
                var isConfirmed = true;
                _this11.questions.forEach(function (questionGroup) {
                    if (isConfirmed) {
                        isConfirmed = questionGroup.every(function (answer) {
                            return answer.confirmed;
                        });
                    }
                });
                _this11.setPageConfirmed(isConfirmed);

                var list = _this11.questions;
                for (var i = 0; i < list.length; i++) {
                    for (var j = 0; j < list[i].length; j++) {
                        for (var x = 0; x < list[i][j].config.list.length; x++) {
                            for (var y = 0; y < list[i][j].config.list[x].length; y++) {
                                var q = list[i][j].config.list[x][y];
                                if (q.type === 'datetime') {
                                    if (q.date !== '' || q.time !== '') {
                                        list[i][j].canBeConfirm = true;
                                    }
                                } else {
                                    if (q.answer !== '') list[i][j].canBeConfirm = true;
                                }
                            }
                        }
                    }
                }
                _this11.hasOldQuestions = true;
                _this11.refreshOldQuestions();
                _this11.$nextTick(function () {
                    _this11.questions.forEach(function (questionGroup) {
                        questionGroup.forEach(function (question) {
                            if (question.config.type == "table") {
                                question.config.list = question.config.list.map(function (item, index) {
                                    return { list: item, id: index + 1 };
                                });
                            }
                        });
                    });
                    _this11.rowDrop();
                });
                _this11.saving = false;
                _this11.isDirty = false;
            }).catch(function (error) {
                _this11.saving = false;
                _this11.$message.error(error.message);
            });
        },


        isQuestionDirty: function isQuestionDirty(question, groupIndex, questionIndex) {
            if (!this.hasOldQuestions) {
                console.log("走到这里了吗");
                for (var i = 0; i < question.config.list.length; i++) {
                    var row = question.config.list[i];
                    for (var index in row) {
                        var col = row[index];
                        var type = col.type;
                        if (type === 'input' || type === 'tableInput' || type === 'radio' || type === 'date' || type === 'tableDate') {
                            if (question.initialEmpty === undefined || question.initialEmpty) {
                                question.initialEmpty = col.answer === '';
                            }
                        }

                        if (type === 'datetime') {
                            if (question.initialEmpty === undefined || question.initialEmpty) question.initialEmpty = col.date === '' && col.time === '';
                        }

                        if (type === 'checkbox') {
                            if (question.initialEmpty === undefined || question.initialEmpty) question.initialEmpty = col.answer === '' || col.answer.length === 0;
                        }
                    }
                }
                if (question.config.type === 'text') {
                    question.initialEmpty = true;
                }
                return true;
            }
            question.initialEmpty = false;
            var oldQuestion = this.oldQuestions[groupIndex][questionIndex];
            console.log(oldQuestion, "olddd");
            if (oldQuestion.config.list.length !== question.config.list.length) return true;
            for (var _i = 0; _i < question.config.list.length; _i++) {
                var _row = question.config.list[_i];
                var oldRow = oldQuestion.config.list[_i];
                for (var _index in _row) {
                    var oldCol = oldRow[_index];
                    var _col = _row[_index];
                    var _type = _col.type;
                    if (_type === 'input' || _type === 'tableInput' || _type === 'text' || _type === 'radio') {
                        if (_col.answer !== oldCol.answer) return true;
                    }

                    if (_type === 'date' || _type === 'tableDate') {
                        var oldDate = oldCol.answer === '' ? '' : Date.parse(new Date(oldCol.answer));
                        var date = _col.answer === '' ? '' : Date.parse(new Date(_col.answer));
                        if (oldDate !== date) return true;
                    }

                    if (_type === 'datetime') {
                        var _oldDate = oldCol.date === '' ? '' : Date.parse(new Date(oldCol.date));
                        var _date = _col.date === '' ? '' : Date.parse(new Date(_col.date));
                        var oldTime = oldCol.time === '' ? '' : Date.parse(new Date(oldCol.time));
                        var time = _col.time === '' ? '' : Date.parse(new Date(_col.time));
                        if (_date !== _oldDate || time !== oldTime) {
                            return true;
                        }
                    }
                    if (_type === 'checkbox') {
                        var count = 0;
                        var answerBoxes = [];
                        for (var boxIndex in oldCol.answer) {
                            answerBoxes.push(oldCol.answer[boxIndex]);
                            count++;
                        }
                        if (_col.answer.length !== count) return true;
                        for (var x = 0; x < _col.answer.length; x++) {
                            if (_col.answer[x] !== answerBoxes[x]) return true;
                        }
                    }
                }
            }
            return false;
        },

        confirm: function confirm(question) {
            var _this12 = this;

            this.$set(question, 'isConfirmLoading', true);
            this.$http.patch('report/confirm/' + question.answerId).then(function (response) {
                //渲染数据
                question.confirmed = true;
                _this12.$message.success('Confirm success');
                _this12.$set(question, 'isConfirmLoading', false);
                var unConfirm = 0;
                _this12.questions.forEach(function (questionGroup) {
                    questionGroup.forEach(function (question) {
                        if (!question.config.forTeacher) {
                            if (!question.confirmed) unConfirm++;
                        }
                    });
                });

                if (unConfirm === 0) {
                    _this12.currentSkill.pageList.forEach(function (page, index) {
                        if (page.page === _this12.currentPage) page.confirmed = true;
                    });
                    //如果第一页所有问题都被confirmed，则改变后几页的状态
                    if (_this12.currentSkill.pageList[0].id === _this12.currentPageId) {
                        _this12.switchLock();
                    }
                }
            }).catch(function (error) {
                _this12.$message.error(error.message);
                _this12.$set(question, 'isConfirmLoading', false);
            });
        },


        disapprove: function disapprove(question) {
            var _this13 = this;

            this.$set(question, 'isDisapproveLoading', true);
            this.$http.patch('report/disapprove/' + question.answerId).then(function (response) {
                _this13.$message.success('Disapprove success');
                question.confirmed = false;
                _this13.$set(question, 'isDisapproveLoading', false);
                for (var i = 0; i < _this13.currentSkill.pageList.length; i++) {
                    if (_this13.currentSkill.pageList[i].page === _this13.currentPage) {
                        _this13.currentSkill.pageList[i].confirmed = false;
                    }
                }
            }).catch(function (error) {
                _this13.$message.error(error.message);
                _this13.$set(question, 'isDisapproveLoading', false);
            });
        },

        confirmAll: function confirmAll() {
            var _this14 = this;

            if (this.isDirty) {
                this.$message.warning('You must save the answers before confirming all questions.');
                return;
            }
            this.isConfirmAllLoading = true;
            var list = this.questions;
            for (var i = 0; i < list.length; i++) {
                if (i === list.length - 1) break;
                for (var j = 0; j < list[i].length; j++) {
                    var questionFlag = false;
                    for (var x = 0; x < list[i][j].config.list.length; x++) {
                        for (var y = 0; y < list[i][j].config.list[x].length; y++) {
                            var q = list[i][j].config.list[x][y];
                            if (q.type === 'datetime') {
                                if (q.date !== '' || q.time !== '') {
                                    questionFlag = true;
                                }
                            } else {
                                if (q.answer !== '') questionFlag = true;
                            }
                        }
                        if (!questionFlag) {
                            this.$message.error('Some questions aren\'t filled with answer');
                            this.isConfirmAllLoading = false;
                            return;
                        }
                    }
                }
            }
            this.$http.patch('report/confirm', {}, { params: { reportId: this.report.id, pageId: this.currentPageId } }).then(function (response) {
                var isPageConfirmed = true;
                list[list.length - 1][0].config.list[0][0].answer = response.name;
                list.forEach(function (questionGroup, questionGroupIndex) {
                    // questionGroup => 问题组
                    questionGroup.forEach(function (question, questionIndex) {
                        if (questionGroupIndex === list.length - 1) {
                            // this.setConfirmedForSignatureAndDate(question);
                            if (isPageConfirmed) isPageConfirmed = question.confirmed;
                        } else {
                            // 将所有question的confirm都设为true
                            question.confirmed = true;
                        }
                    });
                });
                // 封装方法，confirm all and sign后，将页面状态设为对勾
                _this14.setPageConfirmed(isPageConfirmed);
                _this14.isConfirmAllLoading = false;
                _this14.$message.success('Confirm all and sign success');

                //如果第一页all confirmed，则改变后几页的状态
                if (_this14.currentSkill.pageList[0].id === _this14.currentPageId) {
                    _this14.switchLock();
                }
            }).catch(function (error) {
                _this14.isConfirmAllLoading = false;
                _this14.$message.error(error.message);
            });
        },


        //            改变lock状态
        switchLock: function switchLock(lock) {
            var _this15 = this;

            var otherPageID = []; //手动改变某page的状态时同步改变其他page的lock状态
            this.currentSkill.pageList.forEach(function (page, index) {
                if (index !== 0) {
                    otherPageID.push(_this15.currentSkill.pageList[index].id);
                }
            });
            var parms = {
                reportId: this.report.id,
                pageList: otherPageID,
                lock: !!lock
            };
            this.$http.post('report/lockSwitch/', parms).then(function (response) {
                _this15.getLock(_this15.report.id, _this15.currentPageId);
            }).catch(function (error) {
                _this15.$message.error(error.message);
            });
        },


        //            获取lock状态
        getLock: function getLock(reportId, pageId) {
            var _this16 = this;

            this.$http.get('report/lockStatus?reportId=' + reportId + '&pageId=' + pageId).then(function (response) {
                _this16.pageLock = response.pageLock;
                _this16.lock = response.lock;
                _this16.disabledTips = response.lock ? 'Cannot be editable until all the questions under ' + _this16.currentSkill.pageList[0].page + ' part are confirmed' : '';
            }).catch(function (error) {
                _this16.$message.error(error.message);
            });
        },
        getEditEnabled: function getEditEnabled() {
            var _this17 = this;

            this.$http.get('/common/edit/enabled').then(function (response) {
                console.log(response);
                _this17.teacherEditEnabled = response['TEACHER'];
                _this17.studentEditEnabled = response['STUDENT'];
            }).catch(function (error) {
                _this17.$message.error(error.message);
            });
        },


        init: function init() {
            this.role = __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('role');
            this.userId = __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('userid');
            this.displayName = decodeURI(__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('name'));
            if (this.role === 'student') {
                this.studentId = __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('studentId');
            }
            if (this.role === 'teacher') {
                this.teacherId = __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('teacherId');
            }
            this.getEditEnabled();
        }
    },
    mounted: function mounted() {
        this.$nextTick(function () {
            this.init();
            document.body.ondrop = function (event) {
                event.preventDefault();
                event.stopPropagation();
            };
        });
    }
});

/***/ }),

/***/ 288:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['selecttripvalue', 'tId'],
    watch: {
        selecttripvalue: function selecttripvalue() {
            this.teacherId && this.getselectlist();
        },
        tId: function tId() {
            this.teacherId && this.getselectlist();
        }
    },
    data: function data() {
        return {
            searchPlaceHolder: 'Search anything about student',

            keywordsL: '',
            keywordsR: '',
            exceptL: true,
            exceptR: false,

            loadingL: false,
            loadingR: false,
            AllStudents: [],
            MyStudents: [],
            Addlist: [], //从左向右选中list
            Removelist: [], //从右向左选中list
            currentPageL: 1, //分页信息分左右
            currentPageR: 1,
            totalPagesL: 1,
            totalPagesR: 1,
            size: 15,
            role: '',

            // loading变量
            addBtnIsLoading: false,
            removeBtnIsLoading: false
        };
    },

    computed: {
        teacherId: function teacherId() {
            var cookieId = __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('teacherId');
            return this.tId || cookieId;
        }
    },
    methods: {
        //选trip搜学生
        getselectlist: function getselectlist() {
            this.getAllStudents();
            this.getMyStudents();
        },


        //多选选中的数组
        AddSelection: function AddSelection(val) {
            this.Addlist = val;
        },
        RemoveSelection: function RemoveSelection(val) {
            this.Removelist = val;
        },


        //搜索学生信息
        handleIconClickL: function handleIconClickL() {
            this.getAllStudents();
        },
        handleIconClickR: function handleIconClickR() {
            this.getMyStudents();
        },


        //改变当前页函数
        pageCurrentChangeL: function pageCurrentChangeL(val) {
            this.currentPageL = val;
            this.getAllStudents();
        },


        //添加relation
        addRelation: function addRelation() {
            var _this = this;

            var whichBtn = 'add';
            this.loadingL = true;
            this.loadingR = true;
            this.addBtnIsLoading = true;
            this.$http.post('relation', { id: this.teacherId, studentList: this.Addlist }).then(function (res) {
                // 此时获取所有学生，会重新更新AllStudents
                _this.getAllStudents(whichBtn);
                _this.getMyStudents(whichBtn);
            }).catch(function (error) {
                _this.$message.error(error.message), _this.loadingL = false;
                _this.loadingR = false;
                _this.addBtnIsLoading = false;
            });
        },

        //移除relation
        removeRelation: function removeRelation() {
            var _this2 = this;

            var whichBtn = 'remove';
            this.loadingL = true;
            this.loadingR = true;
            this.removeBtnIsLoading = true;
            this.$http.delete('relation', { data: { id: this.teacherId, studentList: this.Removelist } }).then(function (res) {
                _this2.getAllStudents(whichBtn);
                _this2.getMyStudents(whichBtn);
            }).catch(function (error) {
                _this2.$message.error(error.message), _this2.loadingL = false;
                _this2.loadingR = false;
                _this2.removeBtnIsLoading = false;
            });
        },


        // 根据trip过滤数组数据并返回
        filterDataByTrip: function filterDataByTrip(list) {
            var _this3 = this;

            var list = list || [];
            return list.filter(function (value) {
                return value.tripId === _this3.selecttripvalue;
            });
        },

        // 根据关键字过滤数组数据并返回
        filterDataByKeyWords: function filterDataByKeyWords(list, keyWords) {
            var list = list || [];
            var keyWords = keyWords.toLowerCase() || '';
            return list.filter(function (value) {
                var info = value.text.toLowerCase();
                return info.indexOf(keyWords) > -1;
            });
        },


        // 根据参数控制按钮loading的初始状态
        setLoadingStartByWhichBtn: function setLoadingStartByWhichBtn(whichBtn) {
            whichBtn === 'add' ? this.addBtnIsLoading = true : whichBtn === 'remove' ? this.removeBtnIsLoading = true : '';
            this.Removelist = [];
            this.Addlist = [];
        },


        // 根据参数控制按钮loading的结束状态
        setLoadingEndByWhichBtn: function setLoadingEndByWhichBtn(whichBtn) {
            whichBtn === 'add' ? this.addBtnIsLoading = false : whichBtn === 'remove' ? this.removeBtnIsLoading = false : '';
        },


        //穿梭框-获取左边全部学生数据
        getAllStudents: function getAllStudents(whichBtn) {
            var _this4 = this;

            this.setLoadingStartByWhichBtn(whichBtn);
            this.loadingL = true;
            var allStudents = [];
            // 穿梭框-左-query数据
            var leftQuery = {
                teacherId: this.teacherId,
                size: this.size,
                page: this.currentPageL - 1,
                tripId: this.selecttripvalue,
                keywords: this.keywordsL,
                except: this.exceptL
            };
            this.$http.get('relation', {
                params: leftQuery
            }).then(function (response) {
                allStudents = response.list;
                _this4.AllStudents = allStudents;
                _this4.totalPagesL = response.totalPages;
                _this4.loadingL = false;
                _this4.setLoadingEndByWhichBtn(whichBtn);
            }).catch(function (error) {
                _this4.loadingL = false;
                _this4.setLoadingEndByWhichBtn(whichBtn);
                _this4.$message.error(error.message);
            });
        },

        //穿梭框－获取右边已添加学生数据
        getMyStudents: function getMyStudents(whichBtn) {
            var _this5 = this;

            this.setLoadingStartByWhichBtn(whichBtn);
            this.loadingR = true;
            var myStudent = [];
            this.$http.get('relation/' + this.teacherId).then(function (response) {
                myStudent = response;
                if (_this5.selecttripvalue !== '') {
                    myStudent = _this5.filterDataByTrip(response);
                    if (_this5.keywordsR !== '') {
                        myStudent = _this5.filterDataByKeyWords(myStudent, _this5.keywordsR);
                    }
                } else {
                    if (_this5.keywordsR !== '') {
                        myStudent = _this5.filterDataByKeyWords(myStudent, _this5.keywordsR);
                    }
                }
                _this5.MyStudents = myStudent;
                // this.totalPagesR = response.totalPages;
                _this5.loadingR = false;
                _this5.setLoadingEndByWhichBtn(whichBtn);
            }).catch(function (error) {
                _this5.loadingR = false;
                _this5.setLoadingEndByWhichBtn(whichBtn);
                _this5.$message.error(error.message);
                throw new Error(error);
            });
        }
    },
    mounted: function mounted() {
        this.role = __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('role');
        this.teacherId && this.getselectlist();
    }
});

/***/ }),

/***/ 289:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component_util_js__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_EvidenceDialog_vue__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_EvidenceDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_EvidenceDialog_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var templateTypeDefinition = [
//        'Witness testimony', //0
//        'Peer/Witness statement', //1
//        'Team action plan', //2
//        'Personal action plan', //3
//        'Action plan', //4
//        'PDF', //5
//        'Image', //6
//        'Video link', //7
//        'Observation checklist', //8 COPE-D
//        'Observation checklist'] //9 COPE-OP
'PDF', //0
'Image', //1
'Video link', //2
'Peer/Witness statement', //3
'Observation checklist', //4 COPE-D
'Observation checklist', //5 COPE-OP
'Observation checklist'];
/* harmony default export */ __webpack_exports__["default"] = ({

    components: {
        'evidence-dialog': __WEBPACK_IMPORTED_MODULE_2__common_EvidenceDialog_vue___default.a
    },
    computed: {
        title: function title() {
            return this.reportName + ' - ' + this.skillName + ' - ' + this.pageName + ' - Evidence';
        }
    },

    data: function data() {
        return {
            userId: '',
            // 路由参数
            studentId: '',
            studentName: '',
            pageId: '',
            skillAbbr: '',
            reportName: '',
            reportId: 0,
            skillName: '',
            pageName: '',
            role: '',

            // 列表数据
            evidences: [],
            isLoading: false,

            dialogImageUrl: '',
            picReview: false,

            isBtnClick: false,

            //evidence 下载模板按钮所用
            templateName: '',
            templateName1: '',
            templateHref: '',
            templateHref1: '',
            //判断是否已经存在了Peer/Witness statement 或 Observation checklist
            isHavingPS: false

        };
    },

    methods: {
        // 列表相关
        getEvidences: function getEvidences() {
            var _this2 = this;

            this.isLoading = true;
            this.$http.get('/pageEvidence', { params: { studentId: this.studentId, pageId: this.pageId } }).then(function (response) {
                _this2.evidences = _this2.parseEvidences(response);
                _this2.isLoading = false;
            }).catch(function (error) {
                _this2.isLoading = false;
                _this2.$message.error(error.message);
            });
        },

        // 解析Evidence，拿出里面复杂的answer数据结构直接放到evidence下
        parseEvidences: function parseEvidences(rawArray) {
            var results = [];
            for (var i = 0; i < rawArray.length; i++) {
                var raw = rawArray[i];
                var evi = Object.assign(raw);
                results.push(evi);

                var answerList = [];
                if (raw.answerList != undefined && raw.answerList.length > 0) {

                    var first = JSON.parse(raw.answerList[0]);
                    // 解析JSON，把里面的answer数组拿出来，直接赋到evidence上
                    if (first.list != undefined) {
                        //TODO: 临时的代码，定下来需求后重构，放到服务器端
                        if (first.list.length > 0) {
                            if (first.list[0].length > 0) {
                                if (first.list[0][0].type === 'input' || first.list[0][0].type === 'text') {
                                    // 如果有answer，强行取第一条为输入框的answer作为description
                                    evi.description = first.list[0][0].answer;
                                }
                            }
                        }

                        // 循环多条evidenceAnswer记录，找到有图片或pdf的answer
                        for (var l = 1; l < raw.answerList.length; l++) {
                            // 每一条是个JSON
                            var rawAnswers = JSON.parse(raw.answerList[l]);
                            // 解析JSON，把里面的answer数组拿出来，直接赋到evidence上
                            if (rawAnswers.list != undefined) {
                                for (var j = 0; j < rawAnswers.list.length; j++) {
                                    for (var k = 0; k < rawAnswers.list[j].length; k++) {
                                        if (rawAnswers.list[j][k] != undefined) {
                                            if (rawAnswers.list[j][k].type === 'image' || rawAnswers.list[j][k].type === 'pdf' || rawAnswers.list[j][k].type === 'link') {
                                                answerList = rawAnswers.list[j][k].answer;
                                                if (rawAnswers.list[j][k].type === 'image' && answerList !== '') {
                                                    // answerList.forEach(file => file.url = util.resizeOSSImage.switchResizeToThumbnail(file.url))
                                                }
                                                break;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                evi.answerList = answerList;
            }
            return results;
        },
        getTemplateText: function getTemplateText(row, colunm) {
            return templateTypeDefinition[row.templateType];
        },
        templateAddr: function templateAddr(skillAbbr, pageName) {
            var trimPageName = pageName.trim();
            var addr = '';
            var addr1 = '';
            var name = '';
            var name1 = '';
            this.templateName = name;
            this.templateName1 = name1;
            this.templateHref1 = addr1;
            this.templateHref = addr;
        },
        confirmAll: function confirmAll() {
            var _this3 = this;

            this.$http.patch('pageEvidence/confirmAll?studentId=' + this.studentId + '&pageId=' + this.pageId).then(function (res) {
                _this3.evidences.forEach(function (item) {
                    return item.confirmed = true;
                });
                _this3.$message.success('confirm success');
            }).catch(function (err) {
                _this3.$message.error(err.message);
            });
        },


        // 删除
        handleDeleteEvidence: function handleDeleteEvidence(index, row) {
            var _this4 = this;

            this.$confirm('Are you sure to delete?', 'Confirm', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning',
                confirmButtonLoading: false,
                beforeClose: function beforeClose(action, instance, done) {
                    if (action === 'confirm') {
                        instance.confirmButtonLoading = true;
                        done();
                    } else {
                        instance.confirmButtonLoading = false;
                        done();
                    }
                }
            }).then(function () {
                _this4.$http.delete('pageEvidence/' + _this4.evidences[index].id).then(function (response) {
                    //                        this.evidences.splice(index, 1)
                    _this4.getEvidences();
                    _this4.$message({
                        type: 'success',
                        message: 'Evidence deleted.'
                    });
                }).catch(function (error) {
                    _this4.$message.error(error.message);
                });
            }).catch(function () {
                // 用户点了取消删除
            });
        },


        addEvidence: function addEvidence(templateType) {
            //判断evidence是否已经含有'Peer/Witness statement',//'Observation checklist'
            this.isHavingPS = false;
            for (var i = 0; i < this.evidences.length; i++) {
                if (this.evidences[i].templateType == 3 || this.evidences[i].templateType == 4 || this.evidences[i].templateType == 5 || this.evidences[i].templateType == 6) {
                    this.isHavingPS = true;
                }
            }

            if (this.isHavingPS && (templateType == 3 || templateType == 4 || templateType == 5 || templateType == 6)) {
                this.$message.warning('You can only add one evidence of this type.');
            } else {
                var _this = this;
                _this.isBtnClick = true;
                var evidence = { report: { id: this.reportId }, page: { id: this.pageId }, templateType: templateType };
                this.requestApi('pageEvidence', 'post', evidence, function (response) {
                    evidence.id = response.id;
                    evidence.time = response.time;
                    evidence.sequence = _this.evidences.length + 1;
                    _this.evidences.push(evidence);
                    _this.showDialog(templateType, _this.evidences.length - 1, null, true);
                    _this.isBtnClick = false;
                });
            }
        },

        handleMoveOrder: function handleMoveOrder(offset, seq, evidence) {
            var _this5 = this;

            this.$http.put('pageEvidence/sequence', {}, { params: { evidenceId: evidence.id, sequence: seq + offset } }).then(function (response) {
                //                    this.evidences.splice(seq - 1, 1)
                //                    this.evidences.splice(seq - 1 + offset, 0, evidence)

                _this5.getEvidences();
            }).catch(function (error) {
                _this5.$message.error(error.message);
            });
        },


        requestApi: function requestApi(url, method, params, successFunc) {
            var _this6 = this;

            this.$http({
                method: method,
                url: url,
                data: params
            }).then(function (response) {
                successFunc(response);
            }).catch(function (error) {
                _this6.$message.error(error.message);
            });
        },

        //处理显示当前templateType的所有逻辑
        showDialog: function showDialog(type, index, confirmed, isAdd) {
            this.$refs.evidenceDialog.showEvidenceDialog(type, this.evidences[index].id, null, confirmed, isAdd);
        },

        handlePictureCardPreview: function handlePictureCardPreview(file) {
            console.log('handlePictureCardPreview entered');
            console.log(file);
            this.dialogImageUrl = file.url;
            this.picReview = true;
        },
        handlePDFPreview: function handlePDFPreview(file) {
            console.log('handlePDFPreview entered');
            console.log(file);

            //                this.$refs.pdfPreview.href = URL.createObjectURL(file.raw)
            this.$refs.pdfPreview.href = file.url;
            this.$refs.pdfPreview.click();
            //                URL.revokeObjectURL(file.raw)
        },
        tryAddProtocol: function tryAddProtocol(url) {
            url = url.trim();
            if (!/^(ftp|https?|\/|file)/.test(url)) {
                url = 'http://' + url;
            }
            return url;
        },
        init: function init() {
            console.log('init');
            this.userId = __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.get('userid');
            this.role = __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.get('role');

            var query = this.$route.query;
            if (query) {
                this.reportName = query.reportName.toUpperCase();
                // 不知道为什么赋值了就不好用了，先去掉这个吧
                //                    this.reportIndex = query.reportIndex
                this.pageId = query.pageId;
                this.skillName = query.skillName;
                this.pageName = query.pageName.replace(/(^\s*)|(\s*$)/g, "");
                this.skillAbbr = query.skillAbbr;
                this.studentId = query.studentId;
                this.reportId = query.reportId;
                this.studentName = query.studentName;
            } else {
                this.$message.error('Cannot get evidence');
            }

            this.getEvidences();
        }
    },
    mounted: function mounted() {
        this.init();
        this.templateAddr(this.skillAbbr, this.pageName);
    },

    watch: {
        '$route': 'init'
    }
});

/***/ }),

/***/ 290:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_ReportDialog_vue__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_ReportDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_ReportDialog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({

    components: {
        'skill-dialog': __WEBPACK_IMPORTED_MODULE_1__common_ReportDialog_vue___default.a
    },

    data: function data() {
        return {
            report: {},
            studentId: 0,
            userId: 0,
            role: 'student',
            displayName: '',
            displayName2: '',
            category: 'cope',
            active: 0,
            loading: false,
            loadingText: 'loading...',
            generateReportLoading: false,
            progressActiveIndex: 0,

            //aope技能顺序
            aopeItems: ['TW', 'PRL', 'TP', 'RS', 'ISP', 'LWE', 'CE']

        };
    },

    methods: {

        showPageDialog: function showPageDialog(skill, page) {
            this.$refs.reportDialog.showDialogFromStu(this.report, skill, page.page, page.id, this.displayName);
        },

        clone: function clone(myObj) {
            if ((typeof myObj === 'undefined' ? 'undefined' : _typeof(myObj)) != 'object') return myObj;
            if (myObj == null) return myObj;
            var myNewObj = new Object();
            for (var i in myObj) {
                myNewObj[i] = this.clone(myObj[i]);
            }return myNewObj;
        },
        next: function next() {
            if (this.active++ > 2) this.active = 0;
        },


        saveAlert: function saveAlert(done) {
            var _this2 = this;

            if (this.isDirty) {
                this.$confirm('Confirm to leave the page without saving?', 'Warning', {
                    confirmButtonText: 'Leave',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(function (_) {
                    _this2.isDirty = false;
                    done();
                }).catch(function (_) {});
            } else {
                this.isDirty = false;
                done();
            }
        },

        getCurrentPageIndex: function getCurrentPageIndex(skill, page) {
            for (var i = 0; i < skill.pageList.length; i++) {
                if (skill.pageList[i].page == page) return i;
            }
        },

        downloadFile: function downloadFile(blob, fileName, aLinkId) {
            // 能力检测
            // IE独家秘笈 => navigator.msSaveBlob
            if (window.navigator.msSaveBlob) {
                // for ie 10 and later
                try {
                    window.navigator.msSaveBlob(blob, fileName);
                } catch (e) {
                    console.log(e);
                }
            } else {
                try {
                    var aLink = document.getElementById(aLinkId);
                    aLink.download = fileName;
                    aLink.href = window.URL.createObjectURL(blob);
                    aLink.click();
                    window.URL.revokeObjectURL(blob);
                } catch (e) {
                    console.log(e);
                }
            }
        },


        downloadReport: function downloadReport(event) {
            var _this3 = this;

            this.loading = true;
            var category = this.category === 'cope' ? 'CoPE' : this.category === 'aope' ? 'AoPE' : '',
                fileName = this.displayName2 + '_' + category + '.pdf',
                aLinkId = 'generate-link';
            this.loadingText = 'Generating, please wait...';
            __WEBPACK_IMPORTED_MODULE_2_axios___default.a.instance().get('report/download', { params: { studentId: this.studentId, category: this.category }, responseType: 'blob' }).then(function (response) {
                var blob = response.data;
                _this3.downloadFile(blob, fileName, aLinkId);
                _this3.loading = false;
                _this3.loadingText = 'loading...';
            }).catch(function (error) {
                console.log(error);
                _this3.loading = false;
                _this3.loadingText = 'loading...';
                _this3.$message.error('Service unavailable, please try again later.');
            });
        },

        // 将aope数据排序
        customSort: function customSort(list, items) {
            var newSkillList = [];
            list.forEach(function (value) {
                var abbr = value['abbr'];
                items.forEach(function (item, itemIndex) {
                    abbr === item ? newSkillList[itemIndex] = value : '';
                });
            });
            return newSkillList;
        },


        getReport: function getReport() {
            this.loading = true;
            var _this = this;
            this.requestApi('report?studentId=' + this.studentId + '&category=' + this.category, 'get', {}, function (response) {
                if (_this.category == 'aope') {
                    response.skillList = _this.customSort(response.skillList, _this.aopeItems);
                }
                _this.report = response;
                _this.loading = false;
            }, function () {
                _this.loading = false;
            });
        },
        more: function more(obj) {
            var newObj = this.clone(obj[obj.length - 1]);
            for (var config in newObj) {
                newObj[config].answer = '';
            }
            obj.push(newObj);
            this.isDirty = true;
        },
        less: function less(obj) {
            var _this4 = this;

            this.$confirm('Confirm to delete the answer?', 'Warning', {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(function () {
                var msg = '';
                var type = '';
                if (obj.length > 1) {
                    obj.pop();
                    msg = 'success';
                    type = 'success';
                } else {
                    msg = 'You can\'t delete when there\'s only one answer';
                    type = 'error';
                }
                _this4.$message({
                    type: type,
                    message: msg
                });
            });
            this.isDirty = true;
        },

        showNextPage: function showNextPage(skill, page, pageId) {
            var _this5 = this;

            if (this.isDirty) {
                this.$confirm('Confirm to go to other page without saving?', 'Warning', {
                    confirmButtonText: 'Go',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(function (_) {
                    _this5.showPage(skill, page, pageId);
                    _this5.isDirty = false;
                }).catch(function (_) {});
            } else {
                this.showPage(skill, page, pageId);
                this.isDirty = false;
            }
        },

        //请求获取指定page的所有问题的评论(按问题顺序排列的二维数组)
        getComment: function getComment(pageId) {
            var _this = this;
            this.requestApi('comment/page?studentId=' + this.studentId + '&pageId=' + pageId, 'get', {}, function (response) {
                _this.comments = response;
            });
        },

        //将数据渲染到模态框中
        handleQuestionList: function handleQuestionList(list) {
            var count = 0;
            for (var i = 0; i < list.length; i++) {
                var group = [];
                for (var j = 0; j < list[i].length; j++) {
                    list[i][j].show = false;
                    //绑定comment
                    list[i][j].content = '';
                    list[i][j].isDisabled = false;
                    list[i][j].showCommentCount = this.showCommentCount;
                    list[i][j].commentList = this.comments[count];
                    list[i][j].config = JSON.parse(list[i][j].config);
                    group.push(list[i][j]);
                    count++;
                }
                this.questions.push(group);
            }
            this.isDialogLoading = false;
        },

        //获取指定page的问题，当前page没有回答时请求加载
        getQuesion: function getQuesion(pageId) {
            var _this = this;
            this.requestApi('question/' + pageId, 'get', {}, function (response) {
                _this.handleQuestionList(response);
            });
        },

        //请求当前page答案
        getAnswer: function getAnswer(pageId) {
            var _this = this;
            this.requestApi('report/answer?reportId=' + this.report.id + '&pageId=' + pageId, 'get', {}, function (response) {
                _this.getComment(pageId);
                //存在则显示，不存在则请求question
                if (response.questionList.length == 0) {
                    _this.getQuesion(pageId);
                } else {
                    _this.handleQuestionList(response.questionList);
                }
            });
        },

        //通过此函数获得请求并显示dialog所需的所有数据
        getDialogAll: function getDialogAll(pageId) {
            //请求当前page评论
            var _this = this;
            this.requestApi('comment/page?studentId=' + this.studentId + '&pageId=' + pageId, 'get', {}, function (response) {
                _this.comments = response;
                _this.getAnswer(pageId);
            });
        },

        closeDialog: function closeDialog() {
            window.onbeforeunload = null;
            window.onunload = null;
        },

        //处理显示当前page的所有逻辑
        showPage: function showPage(skill, page, pageId) {
            if (page == '' || page == undefined) return;
            this.currentSkill = skill;
            this.currentPage = page;
            //清空this.questions,
            this.questions.splice(0, this.questions.length);
            this.getDialogAll(pageId);
            this.progressActiveIndex = this.getCurrentPageIndex(skill, page);
            this.isDialogLoading = true;
            this.skilldialog = true;
            for (var i = 0; i < skill.pageList.length; i++) {
                var pageObj = skill.pageList[i];
                if (pageObj.page == page) {
                    if (i == skill.pageList.length - 1) {
                        this.nextPage = '';
                    } else {
                        this.nextPage = { page: skill.pageList[i + 1].page, id: skill.pageList[i + 1].id };
                    }
                }
            }

            window.onbeforeunload = function () {
                return "quit?";
            };

            window.onunload = function () {
                return "reload?";
            };
        },

        //提交评论
        saveComment: function saveComment(question, commentList) {
            var _this6 = this;

            if (question.content == null || question.content == '' || question.content != null && question.content.trim().length == 0) {
                this.$message.error('Comment cant\'t be empty');
                return;
            }
            question.isDisabled = true;
            var _this = this;
            this.$http.post('comment', { studentId: this.studentId, questionId: question.id, content: question.content }).then(function (response) {
                commentList.push(response);
                _this6.$message({ message: 'Your comment is successfully posted.', type: 'success' });
                question.content = '';
                question.isDisabled = false;
            }).catch(function (error) {
                _this6.$message.error(error.message);
                question.isDisabled = false;
            });
        },

        //删除评论
        cancelComment: function cancelComment(comment, commentList) {
            var _this7 = this;

            this.$http.delete('comment/' + comment.id).then(function (response) {
                commentList.splice(commentList.indexOf(comment), 1);
                _this7.$message.success('Success');
            }).catch(function (error) {
                _this7.$message.error(error.message);
            });
        },

        saveAnswer: function saveAnswer() {
            var _this8 = this;

            if (!this.isDirty) {
                this.$message({
                    type: 'warning',
                    message: 'Portfolio hasn\'t been edited'
                });
                return;
            }
            var postQuestionList = [];
            var _this = this;
            this.saving = true;
            this.questions.forEach(function (group) {
                group.forEach(function (question) {
                    var answer = {
                        id: question.answerId,
                        report: { id: _this.report.id },
                        question: { id: question.id },
                        answer: JSON.stringify(question.config)
                    };
                    postQuestionList.push(answer);
                });
            });
            var _this = this;
            this.$http.post('report/answer', postQuestionList).then(function (response) {
                var count = 0;
                for (var i = 0; i < _this.questions.length; i++) {
                    var group = _this.questions[i];
                    for (var j = 0; j < group.length; j++) {
                        group[j].answerId = response[count];
                        count++;
                    }
                }
                _this8.$message({ message: 'Portfolio saved successfully.', type: 'success' });
                _this8.saving = false;
            }).catch(function (error) {
                _this8.saving = false;
                _this8.$message.error(error.message);
            });
            this.isDirty = false;
        },

        requestApi: function requestApi(url, method, params, successFunc) {
            var _this9 = this;

            this.$http({
                method: method,
                url: url,
                data: params
            }).then(function (response) {
                successFunc(response);
            }).catch(function (error) {
                _this9.isDialogLoading = false;
                _this9.$message.error(error.message);
            });
        },
        init: function init() {
            this.role = __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('role');
            this.userId = __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('userid');
            //                this.displayName = decodeURI(Cookies.get('name'));
            if (this.role == 'student') {
                this.studentId = __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('studentId');
            }
            this.category = this.$route.name.toLowerCase();
            this.getReport();
        },

        //获取学生个人信息（拼音）
        getProfile: function getProfile() {
            var _this10 = this;

            this.$http.get('student/' + this.studentId).then(function (response) {
                _this10.displayName = response.displayName + ' - ' + response.givenName + '  ' + response.familyName;
                _this10.displayName2 = response.displayName + '_' + response.givenName + '_' + response.familyName;
                var tipsMsg = '';
                if (response.tips && response.tips !== null) {
                    tipsMsg = response.tips;
                } else {
                    tipsMsg = '';
                }
                _this10.$emit('setTips', tipsMsg);
            }).catch(function (error) {
                _this10.$message.error(error.message);
            });
        }
    },
    mounted: function mounted() {
        this.$nextTick(function () {
            this.init();
            this.getProfile();
        });
    },

    watch: {
        // 如果路由有变化，会再次执行该方法
        '$route': 'init'

    }
});

/***/ }),

/***/ 291:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component_md5__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__component_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_ReportDialog_vue__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_ReportDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_ReportDialog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({

    components: {
        'skill-dialog': __WEBPACK_IMPORTED_MODULE_2__common_ReportDialog_vue___default.a
    },

    data: function data() {
        var _this2 = this;

        //修改用户信息密码自动验证
        var validatePass = function validatePass(rule, value, callback) {
            if (value === '') {
                callback(new Error('Password Required'));
            } else {
                if (_this2.editform.EconfirmPassword !== '') {
                    _this2.$refs.editform.validateField('EconfirmPassword');
                }
                callback();
            }
        };
        var validatePass2 = function validatePass2(rule, value, callback) {
            if (value === '') {
                callback(new Error('ConfirmPassword Required'));
            } else if (value !== _this2.editform.Epassword) {
                callback(new Error('Passwords do not match!'));
            } else {
                callback();
            }
        };
        return {
            teacherId: 0,
            teacherName: '',
            studentId: 0,
            loading: false,
            loadingText: 'loading...',
            // Dialog 保存按钮loading变量
            saveBtnIsLoading: false,

            //表格信息
            MyStudents: [],
            stuCountList: [],

            //分页信息
            currentPageTable: 1,
            totalPages: 1,
            size: 15,
            //搜索栏
            selectTripValue: '',
            dialogtripid: '',
            options: [{
                id: 0,
                name: ''
            }],
            keywords: '',

            //修改信息弹窗
            Editdialog: false,
            editform: {
                EDeadline2: '',
                EDeadline1: ''
            },
            isDirty: false, //判断有无修改弹窗
            isTripDirty: false,
            dialogtripvalue: '',
            checked: false, //修改弹窗修密码框是否显示
            willshow: false, //修改弹窗修密码框是否显示
            pickerOptions: {
                //修改弹窗deadline
                disabledDate: function disabledDate(time) {
                    return time.getTime() < Date.now() - 8.64e7;
                }
            },
            editrules: {
                Eemail: [{ required: true, message: 'Email Adress Required', trigger: 'blur' }, { type: 'email', message: 'Email format invalid.' }],
                Epassword: [{ required: true, message: 'Password Required', trigger: 'blur' }, { validator: validatePass, trigger: 'blur' }, { min: 8, max: 20, message: 'Password should contain 8 to 20 characters.', trigger: 'blur' }, { pattern: /^\w{8,20}$/, message: "Only numbers, letters, and underscores allowed.", trigger: 'blur' }],
                EconfirmPassword: [{ required: true, message: 'Confirm Password Required', trigger: 'blur' }, { validator: validatePass2, trigger: 'blur' }],
                EgivenName: [{ required: true, message: 'GivenName Required', trigger: 'blur' }, { max: 30, message: 'givenName should not more than 30 characters.', trigger: 'blur' }],
                EfamilyName: [{ required: true, message: 'FamilyName Required', trigger: 'blur' }, { max: 30, message: 'familyName should not more tha 30 characters.', trigger: 'blur' }],
                EdisplayName: [{ required: true, message: 'DisplayName Required', trigger: 'blur' }, { max: 60, message: 'displayName should not more tha 60 characters.', trigger: 'blur' }],
                Eschool: [{ required: true, message: 'Affiliation Required', trigger: 'blur' }, { max: 100, message: 'Affiliation Name should not more tha 100 characters.', trigger: 'blur' }],
                EmobilePhone: [{ required: false }, { pattern: /^1\d{10}$/, message: 'Phone number format invalid.', trigger: 'blur' }],
                EmotherPhone: [{ required: false }, { pattern: /^1\d{10}$/, message: 'Phone number format invalid.', trigger: 'blur' }],
                EfatherPhone: [{ required: false }, { pattern: /^1\d{10}$/, message: 'Phone number format invalid.', trigger: 'blur' }]
            },

            //显示报告详情
            report: {},
            reportId: 0, //传递参数用
            userId: 0,

            // cope、aope技能顺序
            copeItems: ['IOLP', 'WWO', 'PS', 'D', 'R', 'OP'],
            aopeItems: ['PRL', 'TW', 'TP', 'RS', 'ISP', 'LWE', 'CE'],

            //下载报告弹窗dialog用
            student: {},
            showReportDialog: false,
            reportDialogParam: { assessor: '', moderator: '', filled: false, category: '' },

            //配置学生AOPE技能弹窗
            submitAopeSkillLoading: false,
            configSkillDialogLoading: false,
            configSkillDialog: false,
            configSkillTitle: '',
            checkedSkillsId: [],
            checkedSkillsName: [],
            allAopeSkills: [],
            expandRowKeys: [],
            queryStudentId: ''
        };
    },

    mounted: function mounted() {
        this.$nextTick(function () {
            this.init();
            this.getTeacherInfo();
            this.getTrip();
            this.getMyStudents();
        });
    },
    methods: {
        init: function init() {
            this.teacherId = __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('teacherId');
            this.role = __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('role');
            this.userId = __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('userid');
            if (this.$route.query.studentId !== undefined) {
                this.queryStudentId = this.$route.query.studentId;
            }
        },

        //获取trip列表
        getTrip: function getTrip() {
            var _this3 = this;

            this.$http.get('trip/list').then(function (response) {
                _this3.options = response;
            }).catch(function (error) {
                _this3.$message.error(error.message);
            });
        },
        showTripList: function showTripList() {
            this.getTrip();
        },


        //获取老师信息
        getTeacherInfo: function getTeacherInfo() {
            var _this4 = this;

            this.$http.get('teacher/' + this.teacherId).then(function (res) {
                _this4.teacherName = res.familyName + ' ' + res.givenName;
            }).catch(function (error) {
                _this4.$message.error(error.message);
            });
        },

        //获取我的所有学生列表
        getMyStudents: function getMyStudents() {
            var _this5 = this;

            this.loading = true;
            this.$http.get('relation', { params: {
                    teacherId: this.teacherId,
                    size: this.size,
                    page: this.currentPageTable - 1,
                    tripId: this.selectTripValue,
                    keywords: this.keywords,
                    except: false
                }
            }).then(function (response) {
                _this5.MyStudents = response.list;
                var stuCountList = new Array();
                for (var i = 0; i < response.list.length; i++) {
                    _this5.MyStudents[i].report = {
                        id: 0,
                        skillList: [{
                            abbr: '',
                            enabled: false,
                            id: 0,
                            pageList: [{
                                confirmed: false,
                                page: '',
                                id: 0
                            }]
                        }]
                    };
                    _this5.MyStudents[i].reportC = {
                        id: 0,
                        skillList: [{
                            abbr: '',
                            enabled: false,
                            id: 0,
                            pageList: [{
                                confirmed: false,
                                page: '',
                                id: 0
                            }]
                        }]
                    };
                    _this5.$set(_this5.MyStudents[i], 'loadingReport', true);
                    stuCountList.push(_this5.MyStudents[i].userId);
                }

                _this5.totalPages = response.totalPages;
                _this5.loading = false;
                //获取各学生未读notification数
                if (_this5.role === 'teacher' || _this5.role === 'ta') {
                    _this5.$http.post('notification/count/list', stuCountList).then(function (response) {
                        for (var i = 0; i < response.length; i++) {
                            _this5.$set(_this5.MyStudents[i], 'notificationCount', response[i]);
                        }
                    }).catch(function (error) {
                        _this5.$message.error(error.message);
                    });
                }
                if (_this5.queryStudentId !== '') {
                    var studentIndex = 0;
                    _this5.MyStudents.forEach(function (student, index) {
                        if (student.id == _this5.queryStudentId) {
                            studentIndex = index;
                        }
                    });
                    _this5.expandRowKeys.push(_this5.queryStudentId);
                    _this5.getStuReport({ index: '0' }, studentIndex, { id: _this5.queryStudentId });
                }
            }).catch(function (error) {
                _this5.$message.error(error.message), _this5.loading = false;
            });
        },
        downloadFile: function downloadFile(blob, fileName, aLinkId) {
            // 能力检测
            // IE独家秘笈 => navigator.msSaveBlob
            if (window.navigator.msSaveBlob) {
                // for ie 10 and later
                try {
                    window.navigator.msSaveBlob(blob, fileName);
                } catch (e) {
                    console.log(e);
                }
            } else {
                try {
                    var aLink = document.getElementById(aLinkId);
                    aLink.download = fileName;
                    aLink.href = window.URL.createObjectURL(blob);
                    aLink.click();
                    window.URL.revokeObjectURL(blob);
                } catch (e) {
                    console.log(e);
                }
            }
        },


        download: function download(student) {
            var _this6 = this;

            this.loading = true;
            var fileName = student.displayName + '_' + student.givenName + '_' + student.familyName + '.pdf';
            __WEBPACK_IMPORTED_MODULE_3_axios___default.a.instance().get('report/download', { params: { studentId: student.id }, responseType: 'blob' }).then(function (response) {
                var blob = response.data;
                var aLinkId = 'generate-link';
                // 下载文件，传递三个参数，blob对象，文件名，a标签id
                _this6.downloadFile(blob, fileName, aLinkId);
                _this6.loading = false;
                _this6.loadingText = 'loading...';
            }).catch(function (error) {
                _this6.loading = false;
                _this6.loadingText = 'loading...';
                console.log(error);
                _this6.$message.error('Service unavailable, please try again later.');
            });
        },

        downloadDocx: function downloadDocx(student) {
            var _this7 = this;

            this.loading = true;
            var fileName = student.displayName + '_' + student.givenName + '_' + student.familyName + '.docx';
            __WEBPACK_IMPORTED_MODULE_3_axios___default.a.instance().get('report/downloadDocx', { params: { studentId: student.id }, responseType: 'blob' }).then(function (response) {
                var blob = response.data;
                var aLinkId = 'generate-link';
                // 下载文件，传递三个参数，blob对象，文件名，a标签id
                _this7.downloadFile(blob, fileName, aLinkId);
                _this7.loading = false;
                _this7.loadingText = 'loading...';
            }).catch(function (error) {
                _this7.loading = false;
                _this7.loadingText = 'loading...';
                console.log(error);
                _this7.$message.error('Service unavailable, please try again later.');
            });
        },
        preview: function preview(student) {
            window.open('/api/report/html?category=epq&studentId=' + student.id);
        },


        //改变当前页函数
        pageCurrentChange: function pageCurrentChange(val) {
            this.currentPageTable = val;
            this.getMyStudents();
        },


        //输关键字搜索
        handleIconClick: function handleIconClick() {
            this.loading = true;
            this.getMyStudents();
        },


        //选trip搜索
        tripSelectList: function tripSelectList() {
            this.getMyStudents();
        },


        //获取弹窗信息
        Editstudent: function Editstudent(user) {
            this.id = user.id;
            this.$set(this.editform, 'EmotherPhone', user.motherPhone);
            this.$set(this.editform, 'EfatherPhone', user.fatherPhone);
            this.$set(this.editform, 'Eschool', user.school);
            this.dialogtripid = user.tripId;
            this.$set(this.editform, 'EdisplayName', user.displayName);
            this.$set(this.editform, 'EfamilyName', user.familyName);
            this.$set(this.editform, 'EgivenName', user.givenName);
            this.$set(this.editform, 'Eemail', user.email);
            this.$set(this.editform, 'EmobilePhone', user.mobilePhone);
            this.$set(this.editform, 'EDeadline1', user.deadline1);
            this.$set(this.editform, 'EDeadline2', user.deadline2);
            this.Editdialog = true;
            this.Editdialog = true;
            this.checked = false;
            this.willshow = false;
        },


        //给学生修改trip
        ChangeTrip: function ChangeTrip() {
            var _this8 = this;

            //                console.log('TripDirty:'+ this.isTripDirty)
            if (this.isTripDirty) {
                this.$http.put('trip/choose?studentId=' + this.id + '&tripId=' + this.dialogtripid).then(function (response) {
                    _this8.getMyStudents();
                    _this8.Editdialog = false;
                }).catch(function (error) {
                    _this8.$message.error(error.message);
                    _this8.getMyStudents();
                    _this8.Editdialog = false;
                });
            } else {
                this.getMyStudents();
                this.Editdialog = false;
            }

            this.isTripDirty = false;
        },


        //编辑学生
        changePass: function changePass() {
            if (this.checked == true) {
                this.willshow = true;
                this.isDirty = true;
            } else {
                this.willshow = false;
            }
        },
        submitedit: function submitedit(formName) {
            var _this9 = this;

            //                console.log('TripDirty:'+ this.isTripDirty)
            //                console.log('Dirty:'+ this.isDirty)
            if (!this.isDirty && !this.isTripDirty) {
                this.Editdialog = false;
                return;
            }
            this.$refs[formName].validate(function (valid) {
                if (valid) {
                    // 触发save按钮事件，按钮进入loading状态
                    _this9.saveBtnIsLoading = true;
                    var api = {
                        email: _this9.editform.Eemail,
                        familyName: _this9.editform.EfamilyName,
                        givenName: _this9.editform.EgivenName,
                        displayName: _this9.editform.EdisplayName,
                        mobilePhone: _this9.editform.EmobilePhone
                    };
                    if (_this9.checked == true) {
                        var EPwd_md5 = __WEBPACK_IMPORTED_MODULE_1__component_md5___default.a.hex_md5(_this9.editform.Epassword);
                        api.password = EPwd_md5;
                    }
                    _this9.$http.put('student', {
                        id: _this9.id,
                        motherPhone: _this9.editform.EmotherPhone,
                        fatherPhone: _this9.editform.EfatherPhone,
                        school: _this9.editform.Eschool,
                        deadline1: _this9.editform.EDeadline1,
                        deadline2: _this9.editform.EDeadline2,
                        user: api
                    }).then(function (response) {
                        _this9.ChangeTrip();
                        _this9.loading = true;
                        api.password = undefined;
                        //                            this.getMyStudents();
                        _this9.saveBtnIsLoading = false;
                    }).catch(function (error) {
                        _this9.loading = false;
                        _this9.Editdialog = false;
                        _this9.saveBtnIsLoading = false;
                        _this9.$message.error(error.message);
                    });
                } else {
                    return false;
                }
            });
            this.isDirty = false;
        },


        // 将copo和aope数据排序
        customSort: function customSort(list, items) {
            var newSkillList = [];
            list.forEach(function (value) {
                var abbr = value['abbr'];
                /*abbr === 'IOLP' ? newSkillList[0] = value :
                 (abbr === 'WWO' ? newSkillList[1] = value :
                 (abbr === 'PS' ? newSkillList[2] = value :
                 (abbr === 'D' ? newSkillList[3] = value :
                 (abbr === 'R' ? newSkillList[4] = value :
                 (abbr === 'OP' ? newSkillList[5] = value : '')))));*/
                items.forEach(function (item, itemIndex) {
                    abbr === item ? newSkillList[itemIndex] = value : '';
                });
            });
            return newSkillList;
        },


        //获取学生报告信息
        getPortfolio: function getPortfolio(index, studentId, category) {
            var _this10 = this;

            this.$set(this.MyStudents[index], 'loadingReport', true);
            this.$http.get('report', { params: {
                    studentId: studentId,
                    category: category
                }
            }).then(function (response) {
                if (category === 'epq') {
                    // response.skillList = this.customSort(response.skillList, this.copeItems);
                    _this10.MyStudents[index].reportC = response;
                } else {
                    // response.skillList = this.customSort(response.skillList, this.aopeItems);
                    _this10.MyStudents[index].report = response;
                }
                _this10.$set(_this10.MyStudents[index], 'loadingReport', false);
                _this10.studentId = studentId;
            }).catch(function (error) {
                _this10.$message.error(error.message);
            });
        },


        //展开行
        getExpand: function getExpand(row, expandedRows) {
            var _this = this;
            expandedRows.forEach(function (pro) {
                if (row.id === pro.id) {
                    //判断当前点击的行是否在expendedRows中，即当前行点击是展开还是关闭，如果展开则往下走
                    var myStudents = _this.MyStudents;
                    myStudents.forEach(function (p, index) {
                        if (p.id === row.id) {
                            _this.getPortfolio(index, row.id, 'epq');
                        }
                    });
                }
            });
        },
        getStuReport: function getStuReport(ev, index, student) {
            //点击不同tab(tab实例，行数，studentid)
            if (ev.index === '1') {
                this.getPortfolio(index, student.id, 'log');
            } else {
                this.getPortfolio(index, student.id, 'epq');
            }
        },


        /*表格点击时需要传递四个参数，用index来获取reportid，故调用*/
        showPage: function showPage(skill, page, pageId, index, category) {
            if (category === 'log') {
                this.report.id = this.MyStudents[index].report.id;
            } else {
                this.report.id = this.MyStudents[index].reportC.id;
            }
            this.$refs.reportDialog.showDialogFromTeacher(this.report, skill, page, pageId, { id: this.MyStudents[index].id, displayName: this.MyStudents[index].displayName + ' - ' + this.MyStudents[index].givenName + '  ' + this.MyStudents[index].familyName });
        },

        /* 下载报告dialog用 */

        //将Assessor填充为老师的英文名
        getCurrentUserName: function getCurrentUserName() {
            this.reportDialogParam.assessor = this.teacherName;
        },

        showDownloadReportDialog: function showDownloadReportDialog(event, student, category) {
            this.student = student;
            this.reportDialogParam = { assessor: '', moderator: '', filled: false, category: category };
            this.reportDialogParam = { assessor: '', moderator: '', filled: false, category: category };
            this.showReportDialog = true;
        },

        //配置AOPE skill技能
        editAopeSkill: function editAopeSkill(user, index) {
            var _this11 = this;

            this.configSkillTitle = 'Edit AoPE Skills For ' + user.displayName + user.givenName + ' ' + user.familyName;
            this.configSkillDialog = true;
            this.configSkillDialogLoading = true;
            this.$http.get('report', { params: {
                    studentId: user.id,
                    category: 'aope'
                }
            }).then(function (response) {
                response.skillList = _this11.customSort(response.skillList, _this11.aopeItems);
                _this11.MyStudents[index].report = response; //拿到aope所有技能
                var checkedSkillsName = [];
                var checkedSkillsId = [];
                //拿到已选择的aope技能
                _this11.MyStudents[index].report.skillList.forEach(function (ckeckedSkill) {
                    if (ckeckedSkill.enabled) {
                        checkedSkillsName.push(ckeckedSkill.name);
                        checkedSkillsId.push({ id: ckeckedSkill.id });
                    }
                });
                _this11.reportId = response.id;
                _this11.allAopeSkills = response.skillList;
                _this11.checkedSkillsName = checkedSkillsName;
                _this11.checkedSkillsId = checkedSkillsId;
                _this11.configSkillDialogLoading = false;
            }).catch(function (error) {
                _this11.$message.error(error.message);
            });
        },
        changeCheckedSkill: function changeCheckedSkill(el) {
            var p = [];
            var allSkills = this.allAopeSkills;
            el.forEach(function (val) {
                allSkills.forEach(function (pro) {
                    if (val === pro.name) {
                        p.push({ id: pro.id });
                    }
                });
            });
            this.checkedSkillsId = p;
        },
        submitAopeSkill: function submitAopeSkill() {
            var _this12 = this;

            if (this.checkedSkillsId.length > 3) {
                this.$message.warning('You can only choose 3 skills.');
            } else if (this.checkedSkillsId.length < 3) {
                this.$message.warning('Please choose 3 skills.');
            } else {
                this.submitAopeSkillLoading = true;
                var parms = {
                    id: this.reportId,
                    skillList: this.checkedSkillsId
                };
                this.$http.post('report/assignSkill', parms).then(function (response) {
                    _this12.submitAopeSkillLoading = false;
                    _this12.configSkillDialog = false;
                    _this12.getMyStudents();
                }).catch(function (error) {
                    _this12.$message.error(error.message);
                });
            }
        },

        getRowKey: function getRowKey(row) {
            return row.id;
        }

    }

});

/***/ }),

/***/ 292:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_TransferBox_vue__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_TransferBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_TransferBox_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



//import ElRow from "../../../node_modules/element-ui/packages/row/src/row";
/* harmony default export */ __webpack_exports__["default"] = ({
    //components: {ElRow},
    components: {
        "transfer-box": __WEBPACK_IMPORTED_MODULE_1__common_TransferBox_vue___default.a
    },
    data: function data() {
        return {
            //获取trip列表
            selecttripvalue: '',
            options: []
        };
    },

    mounted: function mounted() {
        this.$nextTick(function () {
            this.getTrip();
        });
    },
    methods: {
        //获取trip列表
        getTrip: function getTrip() {
            var _this = this;

            this.$http.get('trip/list').then(function (response) {
                _this.options = response;
            }).catch(function (error) {
                _this.$message.error(error.message);
            });
        }
    }
});

/***/ }),

/***/ 293:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_raven_js__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raven_js_plugins_vue__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raven_js_plugins_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_raven_js_plugins_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_router__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App_vue__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__routes__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_js_cookie__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api_api__ = __webpack_require__(230);




if (true) {
    __WEBPACK_IMPORTED_MODULE_1_raven_js___default.a.config('https://6315866689b745e88bebc9c90ac2458f@sentry.io/174849').addPlugin(__WEBPACK_IMPORTED_MODULE_2_raven_js_plugins_vue___default.a, __WEBPACK_IMPORTED_MODULE_0_vue__["default"]).install();
}












__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_router__["default"]);

// 保持和Vue-Resource一样的调用方法
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$http = __WEBPACK_IMPORTED_MODULE_9__api_api__["a" /* default */];

var router = new __WEBPACK_IMPORTED_MODULE_5_vue_router__["default"]({
    mode: !!(window.history && history.pushState) ? 'history' : 'hash',
    routes: __WEBPACK_IMPORTED_MODULE_7__routes__["a" /* default */]
});

router.beforeEach(function (to, from, next) {

    // console.log('from: %s, to: %s', from.path, to.path)
    // console.log('to: %s', JSON.stringify(to))
    var role = __WEBPACK_IMPORTED_MODULE_8_js_cookie___default.a.get('role');

    if (to.path === '/login' || to.path === '/') {
        switch (role) {
            case 'admin':
                next({ path: '/admin/student' });
                break;
            case 'student':
                next({ path: '/student/cope' });
                break;
            case 'teacher':
                next({ path: '/teacher/progress' });
                break;
            default:
                next();
                break;
        }
    } else {
        // 未定义role或role和当前cookie里role相同则允许访问，否则
        if (to.matched.every(function (record) {
            return typeof record.meta.role === 'undefined' || record.meta.role === role;
        })) {
            // if (to.matched.every(record => {
            //
            //         console.log('role',role);
            //         console.log('record.meta.role',record.meta.role);
            //     return typeof(record.meta.role) === 'undefined' || record.meta.role === role
            //     })) {
            //     console.log('next')
            next();
        } else {
            // console.log('next login')
            next({ path: '/login' });
        }
    }
});

// api层鉴权失败统一处理
__WEBPACK_IMPORTED_MODULE_9__api_api__["a" /* default */].interceptors.response.use(function (response) {
    return response;
}, function (error) {
    // 返回code是2的情况下，跳转到login页
    if (error.code === 2) {
        router.push('/login');
    }
    return Promise.reject(error);
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    router: router,
    render: function render(h) {
        return h(__WEBPACK_IMPORTED_MODULE_6__App_vue___default.a);
    }
}).$mount('#app');

/***/ }),

/***/ 297:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ 298:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(297)
var ieee754 = __webpack_require__(569)
var isArray = __webpack_require__(570)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),

/***/ 528:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(undefined);
// imports


// module
exports.push([module.i, ".radius-10[data-v-1b608816]{border-radius:10px}.content .border-b[data-v-1b608816]{border-bottom:1px solid #eef1f6}.content .border-b-2[data-v-1b608816]{border-bottom:2px solid #eef1f6}.content .skillListTitle[data-v-1b608816]{height:36px;background:#eef1f6;border-top-left-radius:9px;border-top-right-radius:9px}.content .skillListTitle h2[data-v-1b608816]{display:block;float:left;margin-top:7px!important}.content .skillListTitle button[data-v-1b608816]{float:right;margin-left:5px}.content .line-right button[data-v-1b608816]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;width:100%}.content .line-right i[data-v-1b608816]:hover{color:#20a0ff}@-moz-document url-prefix(){.line-right button{text-align:left}}.question-title[data-v-1b608816]{display:table}.owner[data-v-1b608816]{position:absolute;top:-68px;right:40px}", ""]);

// exports


/***/ }),

/***/ 529:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(undefined);
// imports


// module
exports.push([module.i, ".border-hearder[data-v-1b85e906]{border-color:#dfe6ec!important;margin-top:-1px}.pdfIcon[data-v-1b85e906]{width:50px;height:50px}.evidence-Dropdown[data-v-1b85e906]{width:172px}.commentContent[data-v-1b85e906]{white-space:pre;-ms-word-wrap:break-word;white-space:pre-wrap;white-space:-moz-pre-wrap;white-space:-o-pre-wrap;word-wrap:break-word}", ""]);

// exports


/***/ }),

/***/ 530:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(undefined);
// imports


// module
exports.push([module.i, ".bg-coclor{background:#edf7ff}.table-pointer thead{cursor:pointer}.td-padding-small td{padding:0}.toDialog:hover{text-decoration:underline;cursor:pointer}.toDialog:hover,.toDialog:hover .dark{color:#13ce66!important}", ""]);

// exports


/***/ }),

/***/ 531:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ 532:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ 533:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(undefined);
// imports


// module
exports.push([module.i, ".border-hearder[data-v-35d65550]{border-color:#dfe6ec!important;margin-top:-1px}.pdfIcon[data-v-35d65550]{width:50px;height:50px}.evidence-Dropdown[data-v-35d65550]{width:192px}.bg-lightgary[data-v-35d65550]{background:#eef1f6;border:1px solid #e6e6e6}.bg-lightgary table tr td[data-v-35d65550]:first-child{display:list-item;margin-left:15px;margin-top:4px}.bg-lightgary table td[data-v-35d65550]{color:#000}.bg-lightgary table td span[data-v-35d65550]{background:#e6e6e6;display:inline-block;padding:2px 5px;margin:2px 10px 0 0;color:#324157;font-weight:400!important}.bg-lightgary table td span span[data-v-35d65550]{color:#ff4949;margin:0;padding:0}.p-5[data-v-35d65550]{padding:5px}", ""]);

// exports


/***/ }),

/***/ 534:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ 535:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(undefined);
// imports


// module
exports.push([module.i, ".page-container[data-v-427f8d8a]{text-align:center}.page-container .info[data-v-427f8d8a]{width:600px;border-radius:2px;background:#fff;text-align:center;position:absolute;left:50%;top:150px;margin-left:-340px;color:#333;-webkit-box-shadow:inset 0 0 10px #ccc;box-shadow:inset 0 0 10px #ccc}.page-container .info i[data-v-427f8d8a]{font-size:68px}.page-container .info h1[data-v-427f8d8a]{font-size:26px!important}", ""]);

// exports


/***/ }),

/***/ 536:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(undefined);
// imports


// module
exports.push([module.i, ".m-none{margin:0!important}.m--4{margin:-4px!important}.m-2{margin:2px!important}.m-5{margin:5px!important}.m-10{margin:10px!important}.m-15{margin:15px!important}.m-20{margin:20px!important}.m-30{margin:30px!important}.m-40{margin:40px!important}.m-50{margin:50px!important}.mt-none{margin-top:0!important}.mt--4{margin-top:-4px!important}.mt-2{margin-top:2px!important}.mt-5{margin-top:5px!important}.mt-10{margin-top:10px!important}.mt-15{margin-top:15px!important}.mt-20{margin-top:20px!important}.mt-30{margin-top:30px!important}.mt-40{margin-top:40px!important}.mt-50{margin-top:50px!important}.mb-none{margin-bottom:0!important}.mb--4{margin-bottom:-4px!important}.mb-2{margin-bottom:2px!important}.mb-5{margin-bottom:5px!important}.mb-10{margin-bottom:10px!important}.mb-15{margin-bottom:15px!important}.mb-20{margin-bottom:20px!important}.mb-30{margin-bottom:30px!important}.mb-40{margin-bottom:40px!important}.mb-50{margin-bottom:50px!important}.ml-none{margin-left:0!important}.ml--4{margin-left:-4px!important}.ml-2{margin-left:2px!important}.ml-5{margin-left:5px!important}.ml-10{margin-left:10px!important}.ml-15{margin-left:15px!important}.ml-20{margin-left:20px!important}.ml-30{margin-left:30px!important}.ml-40{margin-left:40px!important}.ml-50{margin-left:50px!important}.mr-none{margin-right:0!important}.mr--4{margin-right:-4px!important}.mr-2{margin-right:2px!important}.mr-5{margin-right:5px!important}.mr-10{margin-right:10px!important}.mr-15{margin-right:15px!important}.mr-20{margin-right:20px!important}.mr-30{margin-right:30px!important}.mr-40{margin-right:40px!important}.mr-50{margin-right:50px!important}.p-none{padding:0!important}.p--4{padding:-4px!important}.p-2{padding:2px!important}.p-5{padding:5px!important}.p-10{padding:10px!important}.p-15{padding:15px!important}.p-20{padding:20px!important}.p-30{padding:30px!important}.p-40{padding:40px!important}.p-50{padding:50px!important}.pt-none{padding-top:0!important}.pt--4{padding-top:-4px!important}.pt-2{padding-top:2px!important}.pt-5{padding-top:5px!important}.pt-10{padding-top:10px!important}.pt-15{padding-top:15px!important}.pt-20{padding-top:20px!important}.pt-30{padding-top:30px!important}.pt-40{padding-top:40px!important}.pt-50{padding-top:50px!important}.pb-none{padding-bottom:0!important}.pb--4{padding-bottom:-4px!important}.pb-2{padding-bottom:2px!important}.pb-5{padding-bottom:5px!important}.pb-10{padding-bottom:10px!important}.pb-15{padding-bottom:15px!important}.pb-20{padding-bottom:20px!important}.pb-30{padding-bottom:30px!important}.pb-40{padding-bottom:40px!important}.pb-50{padding-bottom:50px!important}.pl-none{padding-left:0!important}.pl--4{padding-left:-4px!important}.pl-2{padding-left:2px!important}.pl-5{padding-left:5px!important}.pl-10{padding-left:10px!important}.pl-15{padding-left:15px!important}.pl-20{padding-left:20px!important}.pl-30{padding-left:30px!important}.pl-40{padding-left:40px!important}.pl-50{padding-left:50px!important}.pr-none{padding-right:0!important}.pr--4{padding-right:-4px!important}.pr-2{padding-right:2px!important}.pr-5{padding-right:5px!important}.pr-10{padding-right:10px!important}.pr-15{padding-right:15px!important}.pr-20{padding-right:20px!important}.pr-30{padding-right:30px!important}.pr-40{padding-right:40px!important}.pr-50{padding-right:50px!important}body,html{height:100%}body{background:#eef1f6;font-size:14px;color:#657180;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}#app{position:absolute;top:0;bottom:0;width:100%;height:auto!important}.el-menu{background:#fff}.el-menu .is-active{color:#ff4949}.el-menu--horizontal .el-submenu>.el-menu{left:auto!important;right:0!important}.el-dropdown{cursor:pointer}header{background:#fff;border-bottom:1px solid #ccc;-webkit-box-shadow:0 0 4px rgba(33,33,33,.2);box-shadow:0 0 4px rgba(33,33,33,.2)}header img{width:160px;padding:12px 0 8px}header .el-badge{cursor:pointer}header .el-badge .el-badge__content.is-fixed{top:-2px;right:0}.main{width:100%;background:#eef1f6;margin-top:3px}.main,.main .main-content{display:-webkit-box;display:-ms-flexbox;display:flex}.main .main-content{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row;flex-flow:row;background-color:#fff;border-radius:10px}.main .main-left{width:18%;max-width:200px;border-right:1px solid #eef1f6}.main .main-right{width:82%;height:auto;-webkit-box-flex:1;-ms-flex:1;flex:1;box-sizing:border-box;-moz-box-sizing:border-box;-webkit-box-sizing:border-box}.breadcrumb{font-weight:700;font-size:12px;color:#ccc}.breadcrumb .el-breadcrumb__item__inner{color:#ff4949;font-weight:400}.copyright{width:100%;text-align:center;background:#eef1f6;bottom:0}@media screen and (min-width:1280px){.dialogWidth-1000{width:1000px!important}}.full-width{width:100%!important}", ""]);

// exports


/***/ }),

/***/ 537:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(undefined);
// imports


// module
exports.push([module.i, "*{margin:0;padding:0;font-family:Helvetica Neue,Helvetica,PingFang SC,Hiragino Sans GB,Microsoft YaHei,\\\\5FAE\\8F6F\\96C5\\9ED1,Arial,sans-serif}a{color:#20a0ff}a,a:hover{text-decoration:none}a:hover{color:#4db3ff}.right{float:right!important}.left{float:left!important}.text-center{text-align:center}.text-right{text-align:right}.text-right .el-dialog{text-align:left}.bg-lightgarg{background:#eef1f6!important}.el-dialog__header{padding-bottom:15px!important}.el-dialog__body{border-top:1px solid #eef1f6!important}.gary{color:#ccc}.dark{color:#657180}.white,.white:hover{color:#fff}.success{color:#13ce66}.primary{color:#20a0ff}.upload{display:initial}.dialogStyle .el-dialog__body .el-input,.dialogStyle .el-dialog__body .el-select{width:70%}.dialogStyle .el-dialog__body .el-select .el-input{width:100%}@media screen and (max-width:1000px){.dialogStyle .el-dialog__body .el-input,.dialogStyle .el-dialog__body .el-select{width:85%}.dialogStyle .el-dialog__body .el-select .el-input{width:100%}}.border{border:1px solid #ccc}h1{font-size:20px!important}h2{font-size:18px!important}h3{font-size:16px!important}h4{font-size:14px!important}.font-eeSmall,h5{font-size:12px!important}.input-setMaxWidth{max-width:285px}.form-item-default .el-form-item__content{line-height:36px}@-moz-document url-prefix(){.el-form-item__content{line-height:normal}}.post-textarea textarea{height:74px}@media (-ms-high-contrast:none),screen and (-ms-high-contrast:active){.el-form-item__content{line-height:normal}.upload{display:inline-block}header .router-link-active>img{border-color:transparent;width:160px;height:37px}}", ""]);

// exports


/***/ }),

/***/ 538:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ 539:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(undefined);
// imports


// module
exports.push([module.i, ".radius-10[data-v-46d17f63]{border-radius:10px}.content .border-b[data-v-46d17f63]{border-bottom:1px solid #eef1f6}.content .skillListTitle[data-v-46d17f63]{height:36px;background:#eef1f6;border-top-left-radius:8px;border-top-right-radius:8px}.content .skillListTitle h2[data-v-46d17f63]{display:block;float:left}.content .skillListTitle button[data-v-46d17f63]{float:right}.content .line-right button[data-v-46d17f63]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;width:100%}@-moz-document url-prefix(){.line-right button{text-align:left}}.inlineBlock[data-v-46d17f63]{display:inline-block}.owner[data-v-46d17f63]{position:absolute;top:-68px;right:40px}.fixedFooter[data-v-46d17f63]{z-index:20005;position:fixed;bottom:0;left:0;width:100%;height:60px;line-height:60px;text-align:center;background:#fff;-webkit-box-shadow:0 0 10px rgba(0,0,0,.3);box-shadow:0 0 10px rgba(0,0,0,.3)}.commentContent[data-v-46d17f63]{white-space:pre;-ms-word-wrap:break-word;white-space:pre-wrap;white-space:-moz-pre-wrap;white-space:-o-pre-wrap;word-wrap:break-word}.el-checkbox[data-v-46d17f63],.el-checkbox__input [data-v-46d17f63]{vertical-align:top;display:inline-block}", ""]);

// exports


/***/ }),

/***/ 540:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ 541:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(undefined);
// imports


// module
exports.push([module.i, ".actionIntro[data-v-5d7eb81e]{background:#fafafa;border:1px solid #eef1f6;list-style:inside disc}.actionIntro li[data-v-5d7eb81e]{line-height:24px}", ""]);

// exports


/***/ }),

/***/ 542:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(undefined);
// imports


// module
exports.push([module.i, ".actions{padding-top:293px;text-align:center}", ""]);

// exports


/***/ }),

/***/ 543:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(undefined);
// imports


// module
exports.push([module.i, ".demo-table-expand{font-size:0}.demo-table-expand label{width:65px;color:#99a9bf}.demo-table-expand .log label{width:160px;color:#99a9bf}.demo-table-expand .el-form-item{margin-right:0;margin-bottom:0;width:50%}.el-badge__content.is-fixed{top:8px;right:0;cursor:pointer}.el-form-item i{font-size:16px}.el-form-item i:hover{cursor:pointer}.el-form-item i.icon-folder{font-size:18px}.el-form-item i.ion-shuffle{font-size:12px}.el-form-item .p-evidence{padding:3.5px 5px!important}.el-form-item .pt-7{padding-top:7px}.question-title{display:table}.owner{position:absolute;top:-68px;right:40px}.configAope{display:table-caption}.configAope .el-checkbox:first-child{margin-left:30px}", ""]);

// exports


/***/ }),

/***/ 544:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ 545:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(undefined);
// imports


// module
exports.push([module.i, "@media screen and (min-width:768px){.content[data-v-d7335fe8]{width:500px;position:absolute;left:50%;margin-left:-250px}}header[data-v-d7335fe8]{padding-top:12px;height:48px;background:#fff;overflow:hidden}header img[data-v-d7335fe8]{width:160px;padding:0!important}header .app[data-v-d7335fe8]{margin-right:0!important}.asdan-background .asdan-background-image[data-v-d7335fe8]{position:fixed;top:0;left:0;min-width:100%;min-height:100%;z-index:-1000}.asdan-background .asdan-background-mask[data-v-d7335fe8]{position:fixed;top:0;left:0;min-width:100%;min-height:100%;z-index:-900;background-color:hsla(0,0%,100%,.9)}.content .asdan-login[data-v-d7335fe8]{margin:20% auto 30%;background:#324157;height:260px;border-radius:10px;border:2px solid #324157;-webkit-box-sizing:border-box;-o-box-sizing:border-box;-ms-box-sizing:border-box;box-sizing:border-box}.content .asdan-login span.label[data-v-d7335fe8]{display:block;text-align:left}.content .asdan-login .panel-title[data-v-d7335fe8]{font-size:18px;line-height:36px;color:#fff}.content .asdan-login .panel-body[data-v-d7335fe8]{background:#fff;height:215px;border-bottom-left-radius:10px;border-bottom-right-radius:10px}.content .asdan-login .panel-body .dialog-footer button[data-v-d7335fe8]{width:100%}.el-input[data-v-d7335fe8]{max-width:none}", ""]);

// exports


/***/ }),

/***/ 546:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ 547:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ 568:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "user-template.xlsx";

/***/ }),

/***/ 569:
/***/ (function(module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ 570:
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),

/***/ 58:
/***/ (function(module, exports) {

/*
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.1 Copyright (C) Paul Johnston 1999 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */

/*
 * Configurable variables. You may need to tweak these to be compatible with
 * the server-side, but the defaults work in most cases.
 */
var hexcase = 0; /* hex output format. 0 - lowercase; 1 - uppercase        */
var b64pad = ""; /* base-64 pad character. "=" for strict RFC compliance   */
var chrsz = 8; /* bits per input character. 8 - ASCII; 16 - Unicode      */

/*
 * These are the functions you'll usually want to call
 * They take string arguments and return either hex or base-64 encoded strings
 */
exports.hex_md5 = function hex_md5(s) {
  return binl2hex(core_md5(str2binl(s), s.length * chrsz));
};
function b64_md5(s) {
  return binl2b64(core_md5(str2binl(s), s.length * chrsz));
}
function str_md5(s) {
  return binl2str(core_md5(str2binl(s), s.length * chrsz));
}
function hex_hmac_md5(key, data) {
  return binl2hex(core_hmac_md5(key, data));
}
function b64_hmac_md5(key, data) {
  return binl2b64(core_hmac_md5(key, data));
}
function str_hmac_md5(key, data) {
  return binl2str(core_hmac_md5(key, data));
}

/*
 * Perform a simple self-test to see if the VM is working
 */
function md5_vm_test() {
  return hex_md5("abc") == "900150983cd24fb0d6963f7d28e17f72";
}

/*
 * Calculate the MD5 of an array of little-endian words, and a bit length
 */
function core_md5(x, len) {
  /* append padding */
  x[len >> 5] |= 0x80 << len % 32;
  x[(len + 64 >>> 9 << 4) + 14] = len;

  var a = 1732584193;
  var b = -271733879;
  var c = -1732584194;
  var d = 271733878;

  for (var i = 0; i < x.length; i += 16) {
    var olda = a;
    var oldb = b;
    var oldc = c;
    var oldd = d;

    a = md5_ff(a, b, c, d, x[i + 0], 7, -680876936);
    d = md5_ff(d, a, b, c, x[i + 1], 12, -389564586);
    c = md5_ff(c, d, a, b, x[i + 2], 17, 606105819);
    b = md5_ff(b, c, d, a, x[i + 3], 22, -1044525330);
    a = md5_ff(a, b, c, d, x[i + 4], 7, -176418897);
    d = md5_ff(d, a, b, c, x[i + 5], 12, 1200080426);
    c = md5_ff(c, d, a, b, x[i + 6], 17, -1473231341);
    b = md5_ff(b, c, d, a, x[i + 7], 22, -45705983);
    a = md5_ff(a, b, c, d, x[i + 8], 7, 1770035416);
    d = md5_ff(d, a, b, c, x[i + 9], 12, -1958414417);
    c = md5_ff(c, d, a, b, x[i + 10], 17, -42063);
    b = md5_ff(b, c, d, a, x[i + 11], 22, -1990404162);
    a = md5_ff(a, b, c, d, x[i + 12], 7, 1804603682);
    d = md5_ff(d, a, b, c, x[i + 13], 12, -40341101);
    c = md5_ff(c, d, a, b, x[i + 14], 17, -1502002290);
    b = md5_ff(b, c, d, a, x[i + 15], 22, 1236535329);

    a = md5_gg(a, b, c, d, x[i + 1], 5, -165796510);
    d = md5_gg(d, a, b, c, x[i + 6], 9, -1069501632);
    c = md5_gg(c, d, a, b, x[i + 11], 14, 643717713);
    b = md5_gg(b, c, d, a, x[i + 0], 20, -373897302);
    a = md5_gg(a, b, c, d, x[i + 5], 5, -701558691);
    d = md5_gg(d, a, b, c, x[i + 10], 9, 38016083);
    c = md5_gg(c, d, a, b, x[i + 15], 14, -660478335);
    b = md5_gg(b, c, d, a, x[i + 4], 20, -405537848);
    a = md5_gg(a, b, c, d, x[i + 9], 5, 568446438);
    d = md5_gg(d, a, b, c, x[i + 14], 9, -1019803690);
    c = md5_gg(c, d, a, b, x[i + 3], 14, -187363961);
    b = md5_gg(b, c, d, a, x[i + 8], 20, 1163531501);
    a = md5_gg(a, b, c, d, x[i + 13], 5, -1444681467);
    d = md5_gg(d, a, b, c, x[i + 2], 9, -51403784);
    c = md5_gg(c, d, a, b, x[i + 7], 14, 1735328473);
    b = md5_gg(b, c, d, a, x[i + 12], 20, -1926607734);

    a = md5_hh(a, b, c, d, x[i + 5], 4, -378558);
    d = md5_hh(d, a, b, c, x[i + 8], 11, -2022574463);
    c = md5_hh(c, d, a, b, x[i + 11], 16, 1839030562);
    b = md5_hh(b, c, d, a, x[i + 14], 23, -35309556);
    a = md5_hh(a, b, c, d, x[i + 1], 4, -1530992060);
    d = md5_hh(d, a, b, c, x[i + 4], 11, 1272893353);
    c = md5_hh(c, d, a, b, x[i + 7], 16, -155497632);
    b = md5_hh(b, c, d, a, x[i + 10], 23, -1094730640);
    a = md5_hh(a, b, c, d, x[i + 13], 4, 681279174);
    d = md5_hh(d, a, b, c, x[i + 0], 11, -358537222);
    c = md5_hh(c, d, a, b, x[i + 3], 16, -722521979);
    b = md5_hh(b, c, d, a, x[i + 6], 23, 76029189);
    a = md5_hh(a, b, c, d, x[i + 9], 4, -640364487);
    d = md5_hh(d, a, b, c, x[i + 12], 11, -421815835);
    c = md5_hh(c, d, a, b, x[i + 15], 16, 530742520);
    b = md5_hh(b, c, d, a, x[i + 2], 23, -995338651);

    a = md5_ii(a, b, c, d, x[i + 0], 6, -198630844);
    d = md5_ii(d, a, b, c, x[i + 7], 10, 1126891415);
    c = md5_ii(c, d, a, b, x[i + 14], 15, -1416354905);
    b = md5_ii(b, c, d, a, x[i + 5], 21, -57434055);
    a = md5_ii(a, b, c, d, x[i + 12], 6, 1700485571);
    d = md5_ii(d, a, b, c, x[i + 3], 10, -1894986606);
    c = md5_ii(c, d, a, b, x[i + 10], 15, -1051523);
    b = md5_ii(b, c, d, a, x[i + 1], 21, -2054922799);
    a = md5_ii(a, b, c, d, x[i + 8], 6, 1873313359);
    d = md5_ii(d, a, b, c, x[i + 15], 10, -30611744);
    c = md5_ii(c, d, a, b, x[i + 6], 15, -1560198380);
    b = md5_ii(b, c, d, a, x[i + 13], 21, 1309151649);
    a = md5_ii(a, b, c, d, x[i + 4], 6, -145523070);
    d = md5_ii(d, a, b, c, x[i + 11], 10, -1120210379);
    c = md5_ii(c, d, a, b, x[i + 2], 15, 718787259);
    b = md5_ii(b, c, d, a, x[i + 9], 21, -343485551);

    a = safe_add(a, olda);
    b = safe_add(b, oldb);
    c = safe_add(c, oldc);
    d = safe_add(d, oldd);
  }
  return Array(a, b, c, d);
}

/*
 * These functions implement the four basic operations the algorithm uses.
 */
function md5_cmn(q, a, b, x, s, t) {
  return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s), b);
}
function md5_ff(a, b, c, d, x, s, t) {
  return md5_cmn(b & c | ~b & d, a, b, x, s, t);
}
function md5_gg(a, b, c, d, x, s, t) {
  return md5_cmn(b & d | c & ~d, a, b, x, s, t);
}
function md5_hh(a, b, c, d, x, s, t) {
  return md5_cmn(b ^ c ^ d, a, b, x, s, t);
}
function md5_ii(a, b, c, d, x, s, t) {
  return md5_cmn(c ^ (b | ~d), a, b, x, s, t);
}

/*
 * Calculate the HMAC-MD5, of a key and some data
 */
function core_hmac_md5(key, data) {
  var bkey = str2binl(key);
  if (bkey.length > 16) bkey = core_md5(bkey, key.length * chrsz);

  var ipad = Array(16),
      opad = Array(16);
  for (var i = 0; i < 16; i++) {
    ipad[i] = bkey[i] ^ 0x36363636;
    opad[i] = bkey[i] ^ 0x5C5C5C5C;
  }

  var hash = core_md5(ipad.concat(str2binl(data)), 512 + data.length * chrsz);
  return core_md5(opad.concat(hash), 512 + 128);
}

/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */
function safe_add(x, y) {
  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return msw << 16 | lsw & 0xFFFF;
}

/*
 * Bitwise rotate a 32-bit number to the left.
 */
function bit_rol(num, cnt) {
  return num << cnt | num >>> 32 - cnt;
}

/*
 * Convert a string to an array of little-endian words
 * If chrsz is ASCII, characters >255 have their hi-byte silently ignored.
 */
function str2binl(str) {
  var bin = Array();
  var mask = (1 << chrsz) - 1;
  for (var i = 0; i < str.length * chrsz; i += chrsz) {
    bin[i >> 5] |= (str.charCodeAt(i / chrsz) & mask) << i % 32;
  }return bin;
}

/*
 * Convert an array of little-endian words to a string
 */
function binl2str(bin) {
  var str = "";
  var mask = (1 << chrsz) - 1;
  for (var i = 0; i < bin.length * 32; i += chrsz) {
    str += String.fromCharCode(bin[i >> 5] >>> i % 32 & mask);
  }return str;
}

/*
 * Convert an array of little-endian words to a hex string.
 */
function binl2hex(binarray) {
  var hex_tab = hexcase ? "0123456789ABCDEF" : "0123456789abcdef";
  var str = "";
  for (var i = 0; i < binarray.length * 4; i++) {
    str += hex_tab.charAt(binarray[i >> 2] >> i % 4 * 8 + 4 & 0xF) + hex_tab.charAt(binarray[i >> 2] >> i % 4 * 8 & 0xF);
  }
  return str;
}

/*
 * Convert an array of little-endian words to a base-64 string
 */
function binl2b64(binarray) {
  var tab = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
  var str = "";
  for (var i = 0; i < binarray.length * 4; i += 3) {
    var triplet = (binarray[i >> 2] >> 8 * (i % 4) & 0xFF) << 16 | (binarray[i + 1 >> 2] >> 8 * ((i + 1) % 4) & 0xFF) << 8 | binarray[i + 2 >> 2] >> 8 * ((i + 2) % 4) & 0xFF;
    for (var j = 0; j < 4; j++) {
      if (i * 8 + j * 6 > binarray.length * 32) str += b64pad;else str += tab.charAt(triplet >> 6 * (3 - j) & 0x3F);
    }
  }
  return str;
}

/***/ }),

/***/ 584:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MultiDrag */
/* unused harmony export Sortable */
/* unused harmony export Swap */
/**!
 * Sortable 1.14.0
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var version = "1.14.0";

function userAgent(pattern) {
  if (typeof window !== 'undefined' && window.navigator) {
    return !! /*@__PURE__*/navigator.userAgent.match(pattern);
  }
}

var IE11OrLess = userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
var Edge = userAgent(/Edge/i);
var FireFox = userAgent(/firefox/i);
var Safari = userAgent(/safari/i) && !userAgent(/chrome/i) && !userAgent(/android/i);
var IOS = userAgent(/iP(ad|od|hone)/i);
var ChromeForAndroid = userAgent(/chrome/i) && userAgent(/android/i);

var captureMode = {
  capture: false,
  passive: false
};

function on(el, event, fn) {
  el.addEventListener(event, fn, !IE11OrLess && captureMode);
}

function off(el, event, fn) {
  el.removeEventListener(event, fn, !IE11OrLess && captureMode);
}

function matches(
/**HTMLElement*/
el,
/**String*/
selector) {
  if (!selector) return;
  selector[0] === '>' && (selector = selector.substring(1));

  if (el) {
    try {
      if (el.matches) {
        return el.matches(selector);
      } else if (el.msMatchesSelector) {
        return el.msMatchesSelector(selector);
      } else if (el.webkitMatchesSelector) {
        return el.webkitMatchesSelector(selector);
      }
    } catch (_) {
      return false;
    }
  }

  return false;
}

function getParentOrHost(el) {
  return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
}

function closest(
/**HTMLElement*/
el,
/**String*/
selector,
/**HTMLElement*/
ctx, includeCTX) {
  if (el) {
    ctx = ctx || document;

    do {
      if (selector != null && (selector[0] === '>' ? el.parentNode === ctx && matches(el, selector) : matches(el, selector)) || includeCTX && el === ctx) {
        return el;
      }

      if (el === ctx) break;
      /* jshint boss:true */
    } while (el = getParentOrHost(el));
  }

  return null;
}

var R_SPACE = /\s+/g;

function toggleClass(el, name, state) {
  if (el && name) {
    if (el.classList) {
      el.classList[state ? 'add' : 'remove'](name);
    } else {
      var className = (' ' + el.className + ' ').replace(R_SPACE, ' ').replace(' ' + name + ' ', ' ');
      el.className = (className + (state ? ' ' + name : '')).replace(R_SPACE, ' ');
    }
  }
}

function css(el, prop, val) {
  var style = el && el.style;

  if (style) {
    if (val === void 0) {
      if (document.defaultView && document.defaultView.getComputedStyle) {
        val = document.defaultView.getComputedStyle(el, '');
      } else if (el.currentStyle) {
        val = el.currentStyle;
      }

      return prop === void 0 ? val : val[prop];
    } else {
      if (!(prop in style) && prop.indexOf('webkit') === -1) {
        prop = '-webkit-' + prop;
      }

      style[prop] = val + (typeof val === 'string' ? '' : 'px');
    }
  }
}

function matrix(el, selfOnly) {
  var appliedTransforms = '';

  if (typeof el === 'string') {
    appliedTransforms = el;
  } else {
    do {
      var transform = css(el, 'transform');

      if (transform && transform !== 'none') {
        appliedTransforms = transform + ' ' + appliedTransforms;
      }
      /* jshint boss:true */

    } while (!selfOnly && (el = el.parentNode));
  }

  var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
  /*jshint -W056 */

  return matrixFn && new matrixFn(appliedTransforms);
}

function find(ctx, tagName, iterator) {
  if (ctx) {
    var list = ctx.getElementsByTagName(tagName),
        i = 0,
        n = list.length;

    if (iterator) {
      for (; i < n; i++) {
        iterator(list[i], i);
      }
    }

    return list;
  }

  return [];
}

function getWindowScrollingElement() {
  var scrollingElement = document.scrollingElement;

  if (scrollingElement) {
    return scrollingElement;
  } else {
    return document.documentElement;
  }
}
/**
 * Returns the "bounding client rect" of given element
 * @param  {HTMLElement} el                       The element whose boundingClientRect is wanted
 * @param  {[Boolean]} relativeToContainingBlock  Whether the rect should be relative to the containing block of (including) the container
 * @param  {[Boolean]} relativeToNonStaticParent  Whether the rect should be relative to the relative parent of (including) the contaienr
 * @param  {[Boolean]} undoScale                  Whether the container's scale() should be undone
 * @param  {[HTMLElement]} container              The parent the element will be placed in
 * @return {Object}                               The boundingClientRect of el, with specified adjustments
 */


function getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
  if (!el.getBoundingClientRect && el !== window) return;
  var elRect, top, left, bottom, right, height, width;

  if (el !== window && el.parentNode && el !== getWindowScrollingElement()) {
    elRect = el.getBoundingClientRect();
    top = elRect.top;
    left = elRect.left;
    bottom = elRect.bottom;
    right = elRect.right;
    height = elRect.height;
    width = elRect.width;
  } else {
    top = 0;
    left = 0;
    bottom = window.innerHeight;
    right = window.innerWidth;
    height = window.innerHeight;
    width = window.innerWidth;
  }

  if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
    // Adjust for translate()
    container = container || el.parentNode; // solves #1123 (see: https://stackoverflow.com/a/37953806/6088312)
    // Not needed on <= IE11

    if (!IE11OrLess) {
      do {
        if (container && container.getBoundingClientRect && (css(container, 'transform') !== 'none' || relativeToNonStaticParent && css(container, 'position') !== 'static')) {
          var containerRect = container.getBoundingClientRect(); // Set relative to edges of padding box of container

          top -= containerRect.top + parseInt(css(container, 'border-top-width'));
          left -= containerRect.left + parseInt(css(container, 'border-left-width'));
          bottom = top + elRect.height;
          right = left + elRect.width;
          break;
        }
        /* jshint boss:true */

      } while (container = container.parentNode);
    }
  }

  if (undoScale && el !== window) {
    // Adjust for scale()
    var elMatrix = matrix(container || el),
        scaleX = elMatrix && elMatrix.a,
        scaleY = elMatrix && elMatrix.d;

    if (elMatrix) {
      top /= scaleY;
      left /= scaleX;
      width /= scaleX;
      height /= scaleY;
      bottom = top + height;
      right = left + width;
    }
  }

  return {
    top: top,
    left: left,
    bottom: bottom,
    right: right,
    width: width,
    height: height
  };
}
/**
 * Checks if a side of an element is scrolled past a side of its parents
 * @param  {HTMLElement}  el           The element who's side being scrolled out of view is in question
 * @param  {String}       elSide       Side of the element in question ('top', 'left', 'right', 'bottom')
 * @param  {String}       parentSide   Side of the parent in question ('top', 'left', 'right', 'bottom')
 * @return {HTMLElement}               The parent scroll element that the el's side is scrolled past, or null if there is no such element
 */


function isScrolledPast(el, elSide, parentSide) {
  var parent = getParentAutoScrollElement(el, true),
      elSideVal = getRect(el)[elSide];
  /* jshint boss:true */

  while (parent) {
    var parentSideVal = getRect(parent)[parentSide],
        visible = void 0;

    if (parentSide === 'top' || parentSide === 'left') {
      visible = elSideVal >= parentSideVal;
    } else {
      visible = elSideVal <= parentSideVal;
    }

    if (!visible) return parent;
    if (parent === getWindowScrollingElement()) break;
    parent = getParentAutoScrollElement(parent, false);
  }

  return false;
}
/**
 * Gets nth child of el, ignoring hidden children, sortable's elements (does not ignore clone if it's visible)
 * and non-draggable elements
 * @param  {HTMLElement} el       The parent element
 * @param  {Number} childNum      The index of the child
 * @param  {Object} options       Parent Sortable's options
 * @return {HTMLElement}          The child at index childNum, or null if not found
 */


function getChild(el, childNum, options, includeDragEl) {
  var currentChild = 0,
      i = 0,
      children = el.children;

  while (i < children.length) {
    if (children[i].style.display !== 'none' && children[i] !== Sortable.ghost && (includeDragEl || children[i] !== Sortable.dragged) && closest(children[i], options.draggable, el, false)) {
      if (currentChild === childNum) {
        return children[i];
      }

      currentChild++;
    }

    i++;
  }

  return null;
}
/**
 * Gets the last child in the el, ignoring ghostEl or invisible elements (clones)
 * @param  {HTMLElement} el       Parent element
 * @param  {selector} selector    Any other elements that should be ignored
 * @return {HTMLElement}          The last child, ignoring ghostEl
 */


function lastChild(el, selector) {
  var last = el.lastElementChild;

  while (last && (last === Sortable.ghost || css(last, 'display') === 'none' || selector && !matches(last, selector))) {
    last = last.previousElementSibling;
  }

  return last || null;
}
/**
 * Returns the index of an element within its parent for a selected set of
 * elements
 * @param  {HTMLElement} el
 * @param  {selector} selector
 * @return {number}
 */


function index(el, selector) {
  var index = 0;

  if (!el || !el.parentNode) {
    return -1;
  }
  /* jshint boss:true */


  while (el = el.previousElementSibling) {
    if (el.nodeName.toUpperCase() !== 'TEMPLATE' && el !== Sortable.clone && (!selector || matches(el, selector))) {
      index++;
    }
  }

  return index;
}
/**
 * Returns the scroll offset of the given element, added with all the scroll offsets of parent elements.
 * The value is returned in real pixels.
 * @param  {HTMLElement} el
 * @return {Array}             Offsets in the format of [left, top]
 */


function getRelativeScrollOffset(el) {
  var offsetLeft = 0,
      offsetTop = 0,
      winScroller = getWindowScrollingElement();

  if (el) {
    do {
      var elMatrix = matrix(el),
          scaleX = elMatrix.a,
          scaleY = elMatrix.d;
      offsetLeft += el.scrollLeft * scaleX;
      offsetTop += el.scrollTop * scaleY;
    } while (el !== winScroller && (el = el.parentNode));
  }

  return [offsetLeft, offsetTop];
}
/**
 * Returns the index of the object within the given array
 * @param  {Array} arr   Array that may or may not hold the object
 * @param  {Object} obj  An object that has a key-value pair unique to and identical to a key-value pair in the object you want to find
 * @return {Number}      The index of the object in the array, or -1
 */


function indexOfObject(arr, obj) {
  for (var i in arr) {
    if (!arr.hasOwnProperty(i)) continue;

    for (var key in obj) {
      if (obj.hasOwnProperty(key) && obj[key] === arr[i][key]) return Number(i);
    }
  }

  return -1;
}

function getParentAutoScrollElement(el, includeSelf) {
  // skip to window
  if (!el || !el.getBoundingClientRect) return getWindowScrollingElement();
  var elem = el;
  var gotSelf = false;

  do {
    // we don't need to get elem css if it isn't even overflowing in the first place (performance)
    if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
      var elemCSS = css(elem);

      if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == 'auto' || elemCSS.overflowX == 'scroll') || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == 'auto' || elemCSS.overflowY == 'scroll')) {
        if (!elem.getBoundingClientRect || elem === document.body) return getWindowScrollingElement();
        if (gotSelf || includeSelf) return elem;
        gotSelf = true;
      }
    }
    /* jshint boss:true */

  } while (elem = elem.parentNode);

  return getWindowScrollingElement();
}

function extend(dst, src) {
  if (dst && src) {
    for (var key in src) {
      if (src.hasOwnProperty(key)) {
        dst[key] = src[key];
      }
    }
  }

  return dst;
}

function isRectEqual(rect1, rect2) {
  return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
}

var _throttleTimeout;

function throttle(callback, ms) {
  return function () {
    if (!_throttleTimeout) {
      var args = arguments,
          _this = this;

      if (args.length === 1) {
        callback.call(_this, args[0]);
      } else {
        callback.apply(_this, args);
      }

      _throttleTimeout = setTimeout(function () {
        _throttleTimeout = void 0;
      }, ms);
    }
  };
}

function cancelThrottle() {
  clearTimeout(_throttleTimeout);
  _throttleTimeout = void 0;
}

function scrollBy(el, x, y) {
  el.scrollLeft += x;
  el.scrollTop += y;
}

function clone(el) {
  var Polymer = window.Polymer;
  var $ = window.jQuery || window.Zepto;

  if (Polymer && Polymer.dom) {
    return Polymer.dom(el).cloneNode(true);
  } else if ($) {
    return $(el).clone(true)[0];
  } else {
    return el.cloneNode(true);
  }
}

function setRect(el, rect) {
  css(el, 'position', 'absolute');
  css(el, 'top', rect.top);
  css(el, 'left', rect.left);
  css(el, 'width', rect.width);
  css(el, 'height', rect.height);
}

function unsetRect(el) {
  css(el, 'position', '');
  css(el, 'top', '');
  css(el, 'left', '');
  css(el, 'width', '');
  css(el, 'height', '');
}

var expando = 'Sortable' + new Date().getTime();

function AnimationStateManager() {
  var animationStates = [],
      animationCallbackId;
  return {
    captureAnimationState: function captureAnimationState() {
      animationStates = [];
      if (!this.options.animation) return;
      var children = [].slice.call(this.el.children);
      children.forEach(function (child) {
        if (css(child, 'display') === 'none' || child === Sortable.ghost) return;
        animationStates.push({
          target: child,
          rect: getRect(child)
        });

        var fromRect = _objectSpread2({}, animationStates[animationStates.length - 1].rect); // If animating: compensate for current animation


        if (child.thisAnimationDuration) {
          var childMatrix = matrix(child, true);

          if (childMatrix) {
            fromRect.top -= childMatrix.f;
            fromRect.left -= childMatrix.e;
          }
        }

        child.fromRect = fromRect;
      });
    },
    addAnimationState: function addAnimationState(state) {
      animationStates.push(state);
    },
    removeAnimationState: function removeAnimationState(target) {
      animationStates.splice(indexOfObject(animationStates, {
        target: target
      }), 1);
    },
    animateAll: function animateAll(callback) {
      var _this = this;

      if (!this.options.animation) {
        clearTimeout(animationCallbackId);
        if (typeof callback === 'function') callback();
        return;
      }

      var animating = false,
          animationTime = 0;
      animationStates.forEach(function (state) {
        var time = 0,
            target = state.target,
            fromRect = target.fromRect,
            toRect = getRect(target),
            prevFromRect = target.prevFromRect,
            prevToRect = target.prevToRect,
            animatingRect = state.rect,
            targetMatrix = matrix(target, true);

        if (targetMatrix) {
          // Compensate for current animation
          toRect.top -= targetMatrix.f;
          toRect.left -= targetMatrix.e;
        }

        target.toRect = toRect;

        if (target.thisAnimationDuration) {
          // Could also check if animatingRect is between fromRect and toRect
          if (isRectEqual(prevFromRect, toRect) && !isRectEqual(fromRect, toRect) && // Make sure animatingRect is on line between toRect & fromRect
          (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) {
            // If returning to same place as started from animation and on same axis
            time = calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
          }
        } // if fromRect != toRect: animate


        if (!isRectEqual(toRect, fromRect)) {
          target.prevFromRect = fromRect;
          target.prevToRect = toRect;

          if (!time) {
            time = _this.options.animation;
          }

          _this.animate(target, animatingRect, toRect, time);
        }

        if (time) {
          animating = true;
          animationTime = Math.max(animationTime, time);
          clearTimeout(target.animationResetTimer);
          target.animationResetTimer = setTimeout(function () {
            target.animationTime = 0;
            target.prevFromRect = null;
            target.fromRect = null;
            target.prevToRect = null;
            target.thisAnimationDuration = null;
          }, time);
          target.thisAnimationDuration = time;
        }
      });
      clearTimeout(animationCallbackId);

      if (!animating) {
        if (typeof callback === 'function') callback();
      } else {
        animationCallbackId = setTimeout(function () {
          if (typeof callback === 'function') callback();
        }, animationTime);
      }

      animationStates = [];
    },
    animate: function animate(target, currentRect, toRect, duration) {
      if (duration) {
        css(target, 'transition', '');
        css(target, 'transform', '');
        var elMatrix = matrix(this.el),
            scaleX = elMatrix && elMatrix.a,
            scaleY = elMatrix && elMatrix.d,
            translateX = (currentRect.left - toRect.left) / (scaleX || 1),
            translateY = (currentRect.top - toRect.top) / (scaleY || 1);
        target.animatingX = !!translateX;
        target.animatingY = !!translateY;
        css(target, 'transform', 'translate3d(' + translateX + 'px,' + translateY + 'px,0)');
        this.forRepaintDummy = repaint(target); // repaint

        css(target, 'transition', 'transform ' + duration + 'ms' + (this.options.easing ? ' ' + this.options.easing : ''));
        css(target, 'transform', 'translate3d(0,0,0)');
        typeof target.animated === 'number' && clearTimeout(target.animated);
        target.animated = setTimeout(function () {
          css(target, 'transition', '');
          css(target, 'transform', '');
          target.animated = false;
          target.animatingX = false;
          target.animatingY = false;
        }, duration);
      }
    }
  };
}

function repaint(target) {
  return target.offsetWidth;
}

function calculateRealTime(animatingRect, fromRect, toRect, options) {
  return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
}

var plugins = [];
var defaults = {
  initializeByDefault: true
};
var PluginManager = {
  mount: function mount(plugin) {
    // Set default static properties
    for (var option in defaults) {
      if (defaults.hasOwnProperty(option) && !(option in plugin)) {
        plugin[option] = defaults[option];
      }
    }

    plugins.forEach(function (p) {
      if (p.pluginName === plugin.pluginName) {
        throw "Sortable: Cannot mount plugin ".concat(plugin.pluginName, " more than once");
      }
    });
    plugins.push(plugin);
  },
  pluginEvent: function pluginEvent(eventName, sortable, evt) {
    var _this = this;

    this.eventCanceled = false;

    evt.cancel = function () {
      _this.eventCanceled = true;
    };

    var eventNameGlobal = eventName + 'Global';
    plugins.forEach(function (plugin) {
      if (!sortable[plugin.pluginName]) return; // Fire global events if it exists in this sortable

      if (sortable[plugin.pluginName][eventNameGlobal]) {
        sortable[plugin.pluginName][eventNameGlobal](_objectSpread2({
          sortable: sortable
        }, evt));
      } // Only fire plugin event if plugin is enabled in this sortable,
      // and plugin has event defined


      if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) {
        sortable[plugin.pluginName][eventName](_objectSpread2({
          sortable: sortable
        }, evt));
      }
    });
  },
  initializePlugins: function initializePlugins(sortable, el, defaults, options) {
    plugins.forEach(function (plugin) {
      var pluginName = plugin.pluginName;
      if (!sortable.options[pluginName] && !plugin.initializeByDefault) return;
      var initialized = new plugin(sortable, el, sortable.options);
      initialized.sortable = sortable;
      initialized.options = sortable.options;
      sortable[pluginName] = initialized; // Add default options from plugin

      _extends(defaults, initialized.defaults);
    });

    for (var option in sortable.options) {
      if (!sortable.options.hasOwnProperty(option)) continue;
      var modified = this.modifyOption(sortable, option, sortable.options[option]);

      if (typeof modified !== 'undefined') {
        sortable.options[option] = modified;
      }
    }
  },
  getEventProperties: function getEventProperties(name, sortable) {
    var eventProperties = {};
    plugins.forEach(function (plugin) {
      if (typeof plugin.eventProperties !== 'function') return;

      _extends(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name));
    });
    return eventProperties;
  },
  modifyOption: function modifyOption(sortable, name, value) {
    var modifiedValue;
    plugins.forEach(function (plugin) {
      // Plugin must exist on the Sortable
      if (!sortable[plugin.pluginName]) return; // If static option listener exists for this option, call in the context of the Sortable's instance of this plugin

      if (plugin.optionListeners && typeof plugin.optionListeners[name] === 'function') {
        modifiedValue = plugin.optionListeners[name].call(sortable[plugin.pluginName], value);
      }
    });
    return modifiedValue;
  }
};

function dispatchEvent(_ref) {
  var sortable = _ref.sortable,
      rootEl = _ref.rootEl,
      name = _ref.name,
      targetEl = _ref.targetEl,
      cloneEl = _ref.cloneEl,
      toEl = _ref.toEl,
      fromEl = _ref.fromEl,
      oldIndex = _ref.oldIndex,
      newIndex = _ref.newIndex,
      oldDraggableIndex = _ref.oldDraggableIndex,
      newDraggableIndex = _ref.newDraggableIndex,
      originalEvent = _ref.originalEvent,
      putSortable = _ref.putSortable,
      extraEventProperties = _ref.extraEventProperties;
  sortable = sortable || rootEl && rootEl[expando];
  if (!sortable) return;
  var evt,
      options = sortable.options,
      onName = 'on' + name.charAt(0).toUpperCase() + name.substr(1); // Support for new CustomEvent feature

  if (window.CustomEvent && !IE11OrLess && !Edge) {
    evt = new CustomEvent(name, {
      bubbles: true,
      cancelable: true
    });
  } else {
    evt = document.createEvent('Event');
    evt.initEvent(name, true, true);
  }

  evt.to = toEl || rootEl;
  evt.from = fromEl || rootEl;
  evt.item = targetEl || rootEl;
  evt.clone = cloneEl;
  evt.oldIndex = oldIndex;
  evt.newIndex = newIndex;
  evt.oldDraggableIndex = oldDraggableIndex;
  evt.newDraggableIndex = newDraggableIndex;
  evt.originalEvent = originalEvent;
  evt.pullMode = putSortable ? putSortable.lastPutMode : undefined;

  var allEventProperties = _objectSpread2(_objectSpread2({}, extraEventProperties), PluginManager.getEventProperties(name, sortable));

  for (var option in allEventProperties) {
    evt[option] = allEventProperties[option];
  }

  if (rootEl) {
    rootEl.dispatchEvent(evt);
  }

  if (options[onName]) {
    options[onName].call(sortable, evt);
  }
}

var _excluded = ["evt"];

var pluginEvent = function pluginEvent(eventName, sortable) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      originalEvent = _ref.evt,
      data = _objectWithoutProperties(_ref, _excluded);

  PluginManager.pluginEvent.bind(Sortable)(eventName, sortable, _objectSpread2({
    dragEl: dragEl,
    parentEl: parentEl,
    ghostEl: ghostEl,
    rootEl: rootEl,
    nextEl: nextEl,
    lastDownEl: lastDownEl,
    cloneEl: cloneEl,
    cloneHidden: cloneHidden,
    dragStarted: moved,
    putSortable: putSortable,
    activeSortable: Sortable.active,
    originalEvent: originalEvent,
    oldIndex: oldIndex,
    oldDraggableIndex: oldDraggableIndex,
    newIndex: newIndex,
    newDraggableIndex: newDraggableIndex,
    hideGhostForTarget: _hideGhostForTarget,
    unhideGhostForTarget: _unhideGhostForTarget,
    cloneNowHidden: function cloneNowHidden() {
      cloneHidden = true;
    },
    cloneNowShown: function cloneNowShown() {
      cloneHidden = false;
    },
    dispatchSortableEvent: function dispatchSortableEvent(name) {
      _dispatchEvent({
        sortable: sortable,
        name: name,
        originalEvent: originalEvent
      });
    }
  }, data));
};

function _dispatchEvent(info) {
  dispatchEvent(_objectSpread2({
    putSortable: putSortable,
    cloneEl: cloneEl,
    targetEl: dragEl,
    rootEl: rootEl,
    oldIndex: oldIndex,
    oldDraggableIndex: oldDraggableIndex,
    newIndex: newIndex,
    newDraggableIndex: newDraggableIndex
  }, info));
}

var dragEl,
    parentEl,
    ghostEl,
    rootEl,
    nextEl,
    lastDownEl,
    cloneEl,
    cloneHidden,
    oldIndex,
    newIndex,
    oldDraggableIndex,
    newDraggableIndex,
    activeGroup,
    putSortable,
    awaitingDragStarted = false,
    ignoreNextClick = false,
    sortables = [],
    tapEvt,
    touchEvt,
    lastDx,
    lastDy,
    tapDistanceLeft,
    tapDistanceTop,
    moved,
    lastTarget,
    lastDirection,
    pastFirstInvertThresh = false,
    isCircumstantialInvert = false,
    targetMoveDistance,
    // For positioning ghost absolutely
ghostRelativeParent,
    ghostRelativeParentInitialScroll = [],
    // (left, top)
_silent = false,
    savedInputChecked = [];
/** @const */

var documentExists = typeof document !== 'undefined',
    PositionGhostAbsolutely = IOS,
    CSSFloatProperty = Edge || IE11OrLess ? 'cssFloat' : 'float',
    // This will not pass for IE9, because IE9 DnD only works on anchors
supportDraggable = documentExists && !ChromeForAndroid && !IOS && 'draggable' in document.createElement('div'),
    supportCssPointerEvents = function () {
  if (!documentExists) return; // false when <= IE11

  if (IE11OrLess) {
    return false;
  }

  var el = document.createElement('x');
  el.style.cssText = 'pointer-events:auto';
  return el.style.pointerEvents === 'auto';
}(),
    _detectDirection = function _detectDirection(el, options) {
  var elCSS = css(el),
      elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth),
      child1 = getChild(el, 0, options),
      child2 = getChild(el, 1, options),
      firstChildCSS = child1 && css(child1),
      secondChildCSS = child2 && css(child2),
      firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + getRect(child1).width,
      secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + getRect(child2).width;

  if (elCSS.display === 'flex') {
    return elCSS.flexDirection === 'column' || elCSS.flexDirection === 'column-reverse' ? 'vertical' : 'horizontal';
  }

  if (elCSS.display === 'grid') {
    return elCSS.gridTemplateColumns.split(' ').length <= 1 ? 'vertical' : 'horizontal';
  }

  if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== 'none') {
    var touchingSideChild2 = firstChildCSS["float"] === 'left' ? 'left' : 'right';
    return child2 && (secondChildCSS.clear === 'both' || secondChildCSS.clear === touchingSideChild2) ? 'vertical' : 'horizontal';
  }

  return child1 && (firstChildCSS.display === 'block' || firstChildCSS.display === 'flex' || firstChildCSS.display === 'table' || firstChildCSS.display === 'grid' || firstChildWidth >= elWidth && elCSS[CSSFloatProperty] === 'none' || child2 && elCSS[CSSFloatProperty] === 'none' && firstChildWidth + secondChildWidth > elWidth) ? 'vertical' : 'horizontal';
},
    _dragElInRowColumn = function _dragElInRowColumn(dragRect, targetRect, vertical) {
  var dragElS1Opp = vertical ? dragRect.left : dragRect.top,
      dragElS2Opp = vertical ? dragRect.right : dragRect.bottom,
      dragElOppLength = vertical ? dragRect.width : dragRect.height,
      targetS1Opp = vertical ? targetRect.left : targetRect.top,
      targetS2Opp = vertical ? targetRect.right : targetRect.bottom,
      targetOppLength = vertical ? targetRect.width : targetRect.height;
  return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
},

/**
 * Detects first nearest empty sortable to X and Y position using emptyInsertThreshold.
 * @param  {Number} x      X position
 * @param  {Number} y      Y position
 * @return {HTMLElement}   Element of the first found nearest Sortable
 */
_detectNearestEmptySortable = function _detectNearestEmptySortable(x, y) {
  var ret;
  sortables.some(function (sortable) {
    var threshold = sortable[expando].options.emptyInsertThreshold;
    if (!threshold || lastChild(sortable)) return;
    var rect = getRect(sortable),
        insideHorizontally = x >= rect.left - threshold && x <= rect.right + threshold,
        insideVertically = y >= rect.top - threshold && y <= rect.bottom + threshold;

    if (insideHorizontally && insideVertically) {
      return ret = sortable;
    }
  });
  return ret;
},
    _prepareGroup = function _prepareGroup(options) {
  function toFn(value, pull) {
    return function (to, from, dragEl, evt) {
      var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;

      if (value == null && (pull || sameGroup)) {
        // Default pull value
        // Default pull and put value if same group
        return true;
      } else if (value == null || value === false) {
        return false;
      } else if (pull && value === 'clone') {
        return value;
      } else if (typeof value === 'function') {
        return toFn(value(to, from, dragEl, evt), pull)(to, from, dragEl, evt);
      } else {
        var otherGroup = (pull ? to : from).options.group.name;
        return value === true || typeof value === 'string' && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
      }
    };
  }

  var group = {};
  var originalGroup = options.group;

  if (!originalGroup || _typeof(originalGroup) != 'object') {
    originalGroup = {
      name: originalGroup
    };
  }

  group.name = originalGroup.name;
  group.checkPull = toFn(originalGroup.pull, true);
  group.checkPut = toFn(originalGroup.put);
  group.revertClone = originalGroup.revertClone;
  options.group = group;
},
    _hideGhostForTarget = function _hideGhostForTarget() {
  if (!supportCssPointerEvents && ghostEl) {
    css(ghostEl, 'display', 'none');
  }
},
    _unhideGhostForTarget = function _unhideGhostForTarget() {
  if (!supportCssPointerEvents && ghostEl) {
    css(ghostEl, 'display', '');
  }
}; // #1184 fix - Prevent click event on fallback if dragged but item not changed position


if (documentExists) {
  document.addEventListener('click', function (evt) {
    if (ignoreNextClick) {
      evt.preventDefault();
      evt.stopPropagation && evt.stopPropagation();
      evt.stopImmediatePropagation && evt.stopImmediatePropagation();
      ignoreNextClick = false;
      return false;
    }
  }, true);
}

var nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent(evt) {
  if (dragEl) {
    evt = evt.touches ? evt.touches[0] : evt;

    var nearest = _detectNearestEmptySortable(evt.clientX, evt.clientY);

    if (nearest) {
      // Create imitation event
      var event = {};

      for (var i in evt) {
        if (evt.hasOwnProperty(i)) {
          event[i] = evt[i];
        }
      }

      event.target = event.rootEl = nearest;
      event.preventDefault = void 0;
      event.stopPropagation = void 0;

      nearest[expando]._onDragOver(event);
    }
  }
};

var _checkOutsideTargetEl = function _checkOutsideTargetEl(evt) {
  if (dragEl) {
    dragEl.parentNode[expando]._isOutsideThisEl(evt.target);
  }
};
/**
 * @class  Sortable
 * @param  {HTMLElement}  el
 * @param  {Object}       [options]
 */


function Sortable(el, options) {
  if (!(el && el.nodeType && el.nodeType === 1)) {
    throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(el));
  }

  this.el = el; // root element

  this.options = options = _extends({}, options); // Export instance

  el[expando] = this;
  var defaults = {
    group: null,
    sort: true,
    disabled: false,
    store: null,
    handle: null,
    draggable: /^[uo]l$/i.test(el.nodeName) ? '>li' : '>*',
    swapThreshold: 1,
    // percentage; 0 <= x <= 1
    invertSwap: false,
    // invert always
    invertedSwapThreshold: null,
    // will be set to same as swapThreshold if default
    removeCloneOnHide: true,
    direction: function direction() {
      return _detectDirection(el, this.options);
    },
    ghostClass: 'sortable-ghost',
    chosenClass: 'sortable-chosen',
    dragClass: 'sortable-drag',
    ignore: 'a, img',
    filter: null,
    preventOnFilter: true,
    animation: 0,
    easing: null,
    setData: function setData(dataTransfer, dragEl) {
      dataTransfer.setData('Text', dragEl.textContent);
    },
    dropBubble: false,
    dragoverBubble: false,
    dataIdAttr: 'data-id',
    delay: 0,
    delayOnTouchOnly: false,
    touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
    forceFallback: false,
    fallbackClass: 'sortable-fallback',
    fallbackOnBody: false,
    fallbackTolerance: 0,
    fallbackOffset: {
      x: 0,
      y: 0
    },
    supportPointer: Sortable.supportPointer !== false && 'PointerEvent' in window && !Safari,
    emptyInsertThreshold: 5
  };
  PluginManager.initializePlugins(this, el, defaults); // Set default options

  for (var name in defaults) {
    !(name in options) && (options[name] = defaults[name]);
  }

  _prepareGroup(options); // Bind all private methods


  for (var fn in this) {
    if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
      this[fn] = this[fn].bind(this);
    }
  } // Setup drag mode


  this.nativeDraggable = options.forceFallback ? false : supportDraggable;

  if (this.nativeDraggable) {
    // Touch start threshold cannot be greater than the native dragstart threshold
    this.options.touchStartThreshold = 1;
  } // Bind events


  if (options.supportPointer) {
    on(el, 'pointerdown', this._onTapStart);
  } else {
    on(el, 'mousedown', this._onTapStart);
    on(el, 'touchstart', this._onTapStart);
  }

  if (this.nativeDraggable) {
    on(el, 'dragover', this);
    on(el, 'dragenter', this);
  }

  sortables.push(this.el); // Restore sorting

  options.store && options.store.get && this.sort(options.store.get(this) || []); // Add animation state manager

  _extends(this, AnimationStateManager());
}

Sortable.prototype =
/** @lends Sortable.prototype */
{
  constructor: Sortable,
  _isOutsideThisEl: function _isOutsideThisEl(target) {
    if (!this.el.contains(target) && target !== this.el) {
      lastTarget = null;
    }
  },
  _getDirection: function _getDirection(evt, target) {
    return typeof this.options.direction === 'function' ? this.options.direction.call(this, evt, target, dragEl) : this.options.direction;
  },
  _onTapStart: function _onTapStart(
  /** Event|TouchEvent */
  evt) {
    if (!evt.cancelable) return;

    var _this = this,
        el = this.el,
        options = this.options,
        preventOnFilter = options.preventOnFilter,
        type = evt.type,
        touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === 'touch' && evt,
        target = (touch || evt).target,
        originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target,
        filter = options.filter;

    _saveInputCheckedState(el); // Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.


    if (dragEl) {
      return;
    }

    if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) {
      return; // only left button and enabled
    } // cancel dnd if original target is content editable


    if (originalTarget.isContentEditable) {
      return;
    } // Safari ignores further event handling after mousedown


    if (!this.nativeDraggable && Safari && target && target.tagName.toUpperCase() === 'SELECT') {
      return;
    }

    target = closest(target, options.draggable, el, false);

    if (target && target.animated) {
      return;
    }

    if (lastDownEl === target) {
      // Ignoring duplicate `down`
      return;
    } // Get the index of the dragged element within its parent


    oldIndex = index(target);
    oldDraggableIndex = index(target, options.draggable); // Check filter

    if (typeof filter === 'function') {
      if (filter.call(this, evt, target, this)) {
        _dispatchEvent({
          sortable: _this,
          rootEl: originalTarget,
          name: 'filter',
          targetEl: target,
          toEl: el,
          fromEl: el
        });

        pluginEvent('filter', _this, {
          evt: evt
        });
        preventOnFilter && evt.cancelable && evt.preventDefault();
        return; // cancel dnd
      }
    } else if (filter) {
      filter = filter.split(',').some(function (criteria) {
        criteria = closest(originalTarget, criteria.trim(), el, false);

        if (criteria) {
          _dispatchEvent({
            sortable: _this,
            rootEl: criteria,
            name: 'filter',
            targetEl: target,
            fromEl: el,
            toEl: el
          });

          pluginEvent('filter', _this, {
            evt: evt
          });
          return true;
        }
      });

      if (filter) {
        preventOnFilter && evt.cancelable && evt.preventDefault();
        return; // cancel dnd
      }
    }

    if (options.handle && !closest(originalTarget, options.handle, el, false)) {
      return;
    } // Prepare `dragstart`


    this._prepareDragStart(evt, touch, target);
  },
  _prepareDragStart: function _prepareDragStart(
  /** Event */
  evt,
  /** Touch */
  touch,
  /** HTMLElement */
  target) {
    var _this = this,
        el = _this.el,
        options = _this.options,
        ownerDocument = el.ownerDocument,
        dragStartFn;

    if (target && !dragEl && target.parentNode === el) {
      var dragRect = getRect(target);
      rootEl = el;
      dragEl = target;
      parentEl = dragEl.parentNode;
      nextEl = dragEl.nextSibling;
      lastDownEl = target;
      activeGroup = options.group;
      Sortable.dragged = dragEl;
      tapEvt = {
        target: dragEl,
        clientX: (touch || evt).clientX,
        clientY: (touch || evt).clientY
      };
      tapDistanceLeft = tapEvt.clientX - dragRect.left;
      tapDistanceTop = tapEvt.clientY - dragRect.top;
      this._lastX = (touch || evt).clientX;
      this._lastY = (touch || evt).clientY;
      dragEl.style['will-change'] = 'all';

      dragStartFn = function dragStartFn() {
        pluginEvent('delayEnded', _this, {
          evt: evt
        });

        if (Sortable.eventCanceled) {
          _this._onDrop();

          return;
        } // Delayed drag has been triggered
        // we can re-enable the events: touchmove/mousemove


        _this._disableDelayedDragEvents();

        if (!FireFox && _this.nativeDraggable) {
          dragEl.draggable = true;
        } // Bind the events: dragstart/dragend


        _this._triggerDragStart(evt, touch); // Drag start event


        _dispatchEvent({
          sortable: _this,
          name: 'choose',
          originalEvent: evt
        }); // Chosen item


        toggleClass(dragEl, options.chosenClass, true);
      }; // Disable "draggable"


      options.ignore.split(',').forEach(function (criteria) {
        find(dragEl, criteria.trim(), _disableDraggable);
      });
      on(ownerDocument, 'dragover', nearestEmptyInsertDetectEvent);
      on(ownerDocument, 'mousemove', nearestEmptyInsertDetectEvent);
      on(ownerDocument, 'touchmove', nearestEmptyInsertDetectEvent);
      on(ownerDocument, 'mouseup', _this._onDrop);
      on(ownerDocument, 'touchend', _this._onDrop);
      on(ownerDocument, 'touchcancel', _this._onDrop); // Make dragEl draggable (must be before delay for FireFox)

      if (FireFox && this.nativeDraggable) {
        this.options.touchStartThreshold = 4;
        dragEl.draggable = true;
      }

      pluginEvent('delayStart', this, {
        evt: evt
      }); // Delay is impossible for native DnD in Edge or IE

      if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !(Edge || IE11OrLess))) {
        if (Sortable.eventCanceled) {
          this._onDrop();

          return;
        } // If the user moves the pointer or let go the click or touch
        // before the delay has been reached:
        // disable the delayed drag


        on(ownerDocument, 'mouseup', _this._disableDelayedDrag);
        on(ownerDocument, 'touchend', _this._disableDelayedDrag);
        on(ownerDocument, 'touchcancel', _this._disableDelayedDrag);
        on(ownerDocument, 'mousemove', _this._delayedDragTouchMoveHandler);
        on(ownerDocument, 'touchmove', _this._delayedDragTouchMoveHandler);
        options.supportPointer && on(ownerDocument, 'pointermove', _this._delayedDragTouchMoveHandler);
        _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
      } else {
        dragStartFn();
      }
    }
  },
  _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(
  /** TouchEvent|PointerEvent **/
  e) {
    var touch = e.touches ? e.touches[0] : e;

    if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) {
      this._disableDelayedDrag();
    }
  },
  _disableDelayedDrag: function _disableDelayedDrag() {
    dragEl && _disableDraggable(dragEl);
    clearTimeout(this._dragStartTimer);

    this._disableDelayedDragEvents();
  },
  _disableDelayedDragEvents: function _disableDelayedDragEvents() {
    var ownerDocument = this.el.ownerDocument;
    off(ownerDocument, 'mouseup', this._disableDelayedDrag);
    off(ownerDocument, 'touchend', this._disableDelayedDrag);
    off(ownerDocument, 'touchcancel', this._disableDelayedDrag);
    off(ownerDocument, 'mousemove', this._delayedDragTouchMoveHandler);
    off(ownerDocument, 'touchmove', this._delayedDragTouchMoveHandler);
    off(ownerDocument, 'pointermove', this._delayedDragTouchMoveHandler);
  },
  _triggerDragStart: function _triggerDragStart(
  /** Event */
  evt,
  /** Touch */
  touch) {
    touch = touch || evt.pointerType == 'touch' && evt;

    if (!this.nativeDraggable || touch) {
      if (this.options.supportPointer) {
        on(document, 'pointermove', this._onTouchMove);
      } else if (touch) {
        on(document, 'touchmove', this._onTouchMove);
      } else {
        on(document, 'mousemove', this._onTouchMove);
      }
    } else {
      on(dragEl, 'dragend', this);
      on(rootEl, 'dragstart', this._onDragStart);
    }

    try {
      if (document.selection) {
        // Timeout neccessary for IE9
        _nextTick(function () {
          document.selection.empty();
        });
      } else {
        window.getSelection().removeAllRanges();
      }
    } catch (err) {}
  },
  _dragStarted: function _dragStarted(fallback, evt) {

    awaitingDragStarted = false;

    if (rootEl && dragEl) {
      pluginEvent('dragStarted', this, {
        evt: evt
      });

      if (this.nativeDraggable) {
        on(document, 'dragover', _checkOutsideTargetEl);
      }

      var options = this.options; // Apply effect

      !fallback && toggleClass(dragEl, options.dragClass, false);
      toggleClass(dragEl, options.ghostClass, true);
      Sortable.active = this;
      fallback && this._appendGhost(); // Drag start event

      _dispatchEvent({
        sortable: this,
        name: 'start',
        originalEvent: evt
      });
    } else {
      this._nulling();
    }
  },
  _emulateDragOver: function _emulateDragOver() {
    if (touchEvt) {
      this._lastX = touchEvt.clientX;
      this._lastY = touchEvt.clientY;

      _hideGhostForTarget();

      var target = document.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
      var parent = target;

      while (target && target.shadowRoot) {
        target = target.shadowRoot.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
        if (target === parent) break;
        parent = target;
      }

      dragEl.parentNode[expando]._isOutsideThisEl(target);

      if (parent) {
        do {
          if (parent[expando]) {
            var inserted = void 0;
            inserted = parent[expando]._onDragOver({
              clientX: touchEvt.clientX,
              clientY: touchEvt.clientY,
              target: target,
              rootEl: parent
            });

            if (inserted && !this.options.dragoverBubble) {
              break;
            }
          }

          target = parent; // store last element
        }
        /* jshint boss:true */
        while (parent = parent.parentNode);
      }

      _unhideGhostForTarget();
    }
  },
  _onTouchMove: function _onTouchMove(
  /**TouchEvent*/
  evt) {
    if (tapEvt) {
      var options = this.options,
          fallbackTolerance = options.fallbackTolerance,
          fallbackOffset = options.fallbackOffset,
          touch = evt.touches ? evt.touches[0] : evt,
          ghostMatrix = ghostEl && matrix(ghostEl, true),
          scaleX = ghostEl && ghostMatrix && ghostMatrix.a,
          scaleY = ghostEl && ghostMatrix && ghostMatrix.d,
          relativeScrollOffset = PositionGhostAbsolutely && ghostRelativeParent && getRelativeScrollOffset(ghostRelativeParent),
          dx = (touch.clientX - tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1),
          dy = (touch.clientY - tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1); // only set the status to dragging, when we are actually dragging

      if (!Sortable.active && !awaitingDragStarted) {
        if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) {
          return;
        }

        this._onDragStart(evt, true);
      }

      if (ghostEl) {
        if (ghostMatrix) {
          ghostMatrix.e += dx - (lastDx || 0);
          ghostMatrix.f += dy - (lastDy || 0);
        } else {
          ghostMatrix = {
            a: 1,
            b: 0,
            c: 0,
            d: 1,
            e: dx,
            f: dy
          };
        }

        var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
        css(ghostEl, 'webkitTransform', cssMatrix);
        css(ghostEl, 'mozTransform', cssMatrix);
        css(ghostEl, 'msTransform', cssMatrix);
        css(ghostEl, 'transform', cssMatrix);
        lastDx = dx;
        lastDy = dy;
        touchEvt = touch;
      }

      evt.cancelable && evt.preventDefault();
    }
  },
  _appendGhost: function _appendGhost() {
    // Bug if using scale(): https://stackoverflow.com/questions/2637058
    // Not being adjusted for
    if (!ghostEl) {
      var container = this.options.fallbackOnBody ? document.body : rootEl,
          rect = getRect(dragEl, true, PositionGhostAbsolutely, true, container),
          options = this.options; // Position absolutely

      if (PositionGhostAbsolutely) {
        // Get relatively positioned parent
        ghostRelativeParent = container;

        while (css(ghostRelativeParent, 'position') === 'static' && css(ghostRelativeParent, 'transform') === 'none' && ghostRelativeParent !== document) {
          ghostRelativeParent = ghostRelativeParent.parentNode;
        }

        if (ghostRelativeParent !== document.body && ghostRelativeParent !== document.documentElement) {
          if (ghostRelativeParent === document) ghostRelativeParent = getWindowScrollingElement();
          rect.top += ghostRelativeParent.scrollTop;
          rect.left += ghostRelativeParent.scrollLeft;
        } else {
          ghostRelativeParent = getWindowScrollingElement();
        }

        ghostRelativeParentInitialScroll = getRelativeScrollOffset(ghostRelativeParent);
      }

      ghostEl = dragEl.cloneNode(true);
      toggleClass(ghostEl, options.ghostClass, false);
      toggleClass(ghostEl, options.fallbackClass, true);
      toggleClass(ghostEl, options.dragClass, true);
      css(ghostEl, 'transition', '');
      css(ghostEl, 'transform', '');
      css(ghostEl, 'box-sizing', 'border-box');
      css(ghostEl, 'margin', 0);
      css(ghostEl, 'top', rect.top);
      css(ghostEl, 'left', rect.left);
      css(ghostEl, 'width', rect.width);
      css(ghostEl, 'height', rect.height);
      css(ghostEl, 'opacity', '0.8');
      css(ghostEl, 'position', PositionGhostAbsolutely ? 'absolute' : 'fixed');
      css(ghostEl, 'zIndex', '100000');
      css(ghostEl, 'pointerEvents', 'none');
      Sortable.ghost = ghostEl;
      container.appendChild(ghostEl); // Set transform-origin

      css(ghostEl, 'transform-origin', tapDistanceLeft / parseInt(ghostEl.style.width) * 100 + '% ' + tapDistanceTop / parseInt(ghostEl.style.height) * 100 + '%');
    }
  },
  _onDragStart: function _onDragStart(
  /**Event*/
  evt,
  /**boolean*/
  fallback) {
    var _this = this;

    var dataTransfer = evt.dataTransfer;
    var options = _this.options;
    pluginEvent('dragStart', this, {
      evt: evt
    });

    if (Sortable.eventCanceled) {
      this._onDrop();

      return;
    }

    pluginEvent('setupClone', this);

    if (!Sortable.eventCanceled) {
      cloneEl = clone(dragEl);
      cloneEl.draggable = false;
      cloneEl.style['will-change'] = '';

      this._hideClone();

      toggleClass(cloneEl, this.options.chosenClass, false);
      Sortable.clone = cloneEl;
    } // #1143: IFrame support workaround


    _this.cloneId = _nextTick(function () {
      pluginEvent('clone', _this);
      if (Sortable.eventCanceled) return;

      if (!_this.options.removeCloneOnHide) {
        rootEl.insertBefore(cloneEl, dragEl);
      }

      _this._hideClone();

      _dispatchEvent({
        sortable: _this,
        name: 'clone'
      });
    });
    !fallback && toggleClass(dragEl, options.dragClass, true); // Set proper drop events

    if (fallback) {
      ignoreNextClick = true;
      _this._loopId = setInterval(_this._emulateDragOver, 50);
    } else {
      // Undo what was set in _prepareDragStart before drag started
      off(document, 'mouseup', _this._onDrop);
      off(document, 'touchend', _this._onDrop);
      off(document, 'touchcancel', _this._onDrop);

      if (dataTransfer) {
        dataTransfer.effectAllowed = 'move';
        options.setData && options.setData.call(_this, dataTransfer, dragEl);
      }

      on(document, 'drop', _this); // #1276 fix:

      css(dragEl, 'transform', 'translateZ(0)');
    }

    awaitingDragStarted = true;
    _this._dragStartId = _nextTick(_this._dragStarted.bind(_this, fallback, evt));
    on(document, 'selectstart', _this);
    moved = true;

    if (Safari) {
      css(document.body, 'user-select', 'none');
    }
  },
  // Returns true - if no further action is needed (either inserted or another condition)
  _onDragOver: function _onDragOver(
  /**Event*/
  evt) {
    var el = this.el,
        target = evt.target,
        dragRect,
        targetRect,
        revert,
        options = this.options,
        group = options.group,
        activeSortable = Sortable.active,
        isOwner = activeGroup === group,
        canSort = options.sort,
        fromSortable = putSortable || activeSortable,
        vertical,
        _this = this,
        completedFired = false;

    if (_silent) return;

    function dragOverEvent(name, extra) {
      pluginEvent(name, _this, _objectSpread2({
        evt: evt,
        isOwner: isOwner,
        axis: vertical ? 'vertical' : 'horizontal',
        revert: revert,
        dragRect: dragRect,
        targetRect: targetRect,
        canSort: canSort,
        fromSortable: fromSortable,
        target: target,
        completed: completed,
        onMove: function onMove(target, after) {
          return _onMove(rootEl, el, dragEl, dragRect, target, getRect(target), evt, after);
        },
        changed: changed
      }, extra));
    } // Capture animation state


    function capture() {
      dragOverEvent('dragOverAnimationCapture');

      _this.captureAnimationState();

      if (_this !== fromSortable) {
        fromSortable.captureAnimationState();
      }
    } // Return invocation when dragEl is inserted (or completed)


    function completed(insertion) {
      dragOverEvent('dragOverCompleted', {
        insertion: insertion
      });

      if (insertion) {
        // Clones must be hidden before folding animation to capture dragRectAbsolute properly
        if (isOwner) {
          activeSortable._hideClone();
        } else {
          activeSortable._showClone(_this);
        }

        if (_this !== fromSortable) {
          // Set ghost class to new sortable's ghost class
          toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
          toggleClass(dragEl, options.ghostClass, true);
        }

        if (putSortable !== _this && _this !== Sortable.active) {
          putSortable = _this;
        } else if (_this === Sortable.active && putSortable) {
          putSortable = null;
        } // Animation


        if (fromSortable === _this) {
          _this._ignoreWhileAnimating = target;
        }

        _this.animateAll(function () {
          dragOverEvent('dragOverAnimationComplete');
          _this._ignoreWhileAnimating = null;
        });

        if (_this !== fromSortable) {
          fromSortable.animateAll();
          fromSortable._ignoreWhileAnimating = null;
        }
      } // Null lastTarget if it is not inside a previously swapped element


      if (target === dragEl && !dragEl.animated || target === el && !target.animated) {
        lastTarget = null;
      } // no bubbling and not fallback


      if (!options.dragoverBubble && !evt.rootEl && target !== document) {
        dragEl.parentNode[expando]._isOutsideThisEl(evt.target); // Do not detect for empty insert if already inserted


        !insertion && nearestEmptyInsertDetectEvent(evt);
      }

      !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
      return completedFired = true;
    } // Call when dragEl has been inserted


    function changed() {
      newIndex = index(dragEl);
      newDraggableIndex = index(dragEl, options.draggable);

      _dispatchEvent({
        sortable: _this,
        name: 'change',
        toEl: el,
        newIndex: newIndex,
        newDraggableIndex: newDraggableIndex,
        originalEvent: evt
      });
    }

    if (evt.preventDefault !== void 0) {
      evt.cancelable && evt.preventDefault();
    }

    target = closest(target, options.draggable, el, true);
    dragOverEvent('dragOver');
    if (Sortable.eventCanceled) return completedFired;

    if (dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) {
      return completed(false);
    }

    ignoreNextClick = false;

    if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = parentEl !== rootEl) // Reverting item into the original list
    : putSortable === this || (this.lastPutMode = activeGroup.checkPull(this, activeSortable, dragEl, evt)) && group.checkPut(this, activeSortable, dragEl, evt))) {
      vertical = this._getDirection(evt, target) === 'vertical';
      dragRect = getRect(dragEl);
      dragOverEvent('dragOverValid');
      if (Sortable.eventCanceled) return completedFired;

      if (revert) {
        parentEl = rootEl; // actualization

        capture();

        this._hideClone();

        dragOverEvent('revert');

        if (!Sortable.eventCanceled) {
          if (nextEl) {
            rootEl.insertBefore(dragEl, nextEl);
          } else {
            rootEl.appendChild(dragEl);
          }
        }

        return completed(true);
      }

      var elLastChild = lastChild(el, options.draggable);

      if (!elLastChild || _ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
        // Insert to end of list
        // If already at end of list: Do not insert
        if (elLastChild === dragEl) {
          return completed(false);
        } // if there is a last element, it is the target


        if (elLastChild && el === evt.target) {
          target = elLastChild;
        }

        if (target) {
          targetRect = getRect(target);
        }

        if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
          capture();
          el.appendChild(dragEl);
          parentEl = el; // actualization

          changed();
          return completed(true);
        }
      } else if (elLastChild && _ghostIsFirst(evt, vertical, this)) {
        // Insert to start of list
        var firstChild = getChild(el, 0, options, true);

        if (firstChild === dragEl) {
          return completed(false);
        }

        target = firstChild;
        targetRect = getRect(target);

        if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, false) !== false) {
          capture();
          el.insertBefore(dragEl, firstChild);
          parentEl = el; // actualization

          changed();
          return completed(true);
        }
      } else if (target.parentNode === el) {
        targetRect = getRect(target);
        var direction = 0,
            targetBeforeFirstSwap,
            differentLevel = dragEl.parentNode !== el,
            differentRowCol = !_dragElInRowColumn(dragEl.animated && dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical),
            side1 = vertical ? 'top' : 'left',
            scrolledPastTop = isScrolledPast(target, 'top', 'top') || isScrolledPast(dragEl, 'top', 'top'),
            scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;

        if (lastTarget !== target) {
          targetBeforeFirstSwap = targetRect[side1];
          pastFirstInvertThresh = false;
          isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
        }

        direction = _getSwapDirection(evt, target, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, isCircumstantialInvert, lastTarget === target);
        var sibling;

        if (direction !== 0) {
          // Check if target is beside dragEl in respective direction (ignoring hidden elements)
          var dragIndex = index(dragEl);

          do {
            dragIndex -= direction;
            sibling = parentEl.children[dragIndex];
          } while (sibling && (css(sibling, 'display') === 'none' || sibling === ghostEl));
        } // If dragEl is already beside target: Do not insert


        if (direction === 0 || sibling === target) {
          return completed(false);
        }

        lastTarget = target;
        lastDirection = direction;
        var nextSibling = target.nextElementSibling,
            after = false;
        after = direction === 1;

        var moveVector = _onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, after);

        if (moveVector !== false) {
          if (moveVector === 1 || moveVector === -1) {
            after = moveVector === 1;
          }

          _silent = true;
          setTimeout(_unsilent, 30);
          capture();

          if (after && !nextSibling) {
            el.appendChild(dragEl);
          } else {
            target.parentNode.insertBefore(dragEl, after ? nextSibling : target);
          } // Undo chrome's scroll adjustment (has no effect on other browsers)


          if (scrolledPastTop) {
            scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
          }

          parentEl = dragEl.parentNode; // actualization
          // must be done before animation

          if (targetBeforeFirstSwap !== undefined && !isCircumstantialInvert) {
            targetMoveDistance = Math.abs(targetBeforeFirstSwap - getRect(target)[side1]);
          }

          changed();
          return completed(true);
        }
      }

      if (el.contains(dragEl)) {
        return completed(false);
      }
    }

    return false;
  },
  _ignoreWhileAnimating: null,
  _offMoveEvents: function _offMoveEvents() {
    off(document, 'mousemove', this._onTouchMove);
    off(document, 'touchmove', this._onTouchMove);
    off(document, 'pointermove', this._onTouchMove);
    off(document, 'dragover', nearestEmptyInsertDetectEvent);
    off(document, 'mousemove', nearestEmptyInsertDetectEvent);
    off(document, 'touchmove', nearestEmptyInsertDetectEvent);
  },
  _offUpEvents: function _offUpEvents() {
    var ownerDocument = this.el.ownerDocument;
    off(ownerDocument, 'mouseup', this._onDrop);
    off(ownerDocument, 'touchend', this._onDrop);
    off(ownerDocument, 'pointerup', this._onDrop);
    off(ownerDocument, 'touchcancel', this._onDrop);
    off(document, 'selectstart', this);
  },
  _onDrop: function _onDrop(
  /**Event*/
  evt) {
    var el = this.el,
        options = this.options; // Get the index of the dragged element within its parent

    newIndex = index(dragEl);
    newDraggableIndex = index(dragEl, options.draggable);
    pluginEvent('drop', this, {
      evt: evt
    });
    parentEl = dragEl && dragEl.parentNode; // Get again after plugin event

    newIndex = index(dragEl);
    newDraggableIndex = index(dragEl, options.draggable);

    if (Sortable.eventCanceled) {
      this._nulling();

      return;
    }

    awaitingDragStarted = false;
    isCircumstantialInvert = false;
    pastFirstInvertThresh = false;
    clearInterval(this._loopId);
    clearTimeout(this._dragStartTimer);

    _cancelNextTick(this.cloneId);

    _cancelNextTick(this._dragStartId); // Unbind events


    if (this.nativeDraggable) {
      off(document, 'drop', this);
      off(el, 'dragstart', this._onDragStart);
    }

    this._offMoveEvents();

    this._offUpEvents();

    if (Safari) {
      css(document.body, 'user-select', '');
    }

    css(dragEl, 'transform', '');

    if (evt) {
      if (moved) {
        evt.cancelable && evt.preventDefault();
        !options.dropBubble && evt.stopPropagation();
      }

      ghostEl && ghostEl.parentNode && ghostEl.parentNode.removeChild(ghostEl);

      if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') {
        // Remove clone(s)
        cloneEl && cloneEl.parentNode && cloneEl.parentNode.removeChild(cloneEl);
      }

      if (dragEl) {
        if (this.nativeDraggable) {
          off(dragEl, 'dragend', this);
        }

        _disableDraggable(dragEl);

        dragEl.style['will-change'] = ''; // Remove classes
        // ghostClass is added in dragStarted

        if (moved && !awaitingDragStarted) {
          toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : this.options.ghostClass, false);
        }

        toggleClass(dragEl, this.options.chosenClass, false); // Drag stop event

        _dispatchEvent({
          sortable: this,
          name: 'unchoose',
          toEl: parentEl,
          newIndex: null,
          newDraggableIndex: null,
          originalEvent: evt
        });

        if (rootEl !== parentEl) {
          if (newIndex >= 0) {
            // Add event
            _dispatchEvent({
              rootEl: parentEl,
              name: 'add',
              toEl: parentEl,
              fromEl: rootEl,
              originalEvent: evt
            }); // Remove event


            _dispatchEvent({
              sortable: this,
              name: 'remove',
              toEl: parentEl,
              originalEvent: evt
            }); // drag from one list and drop into another


            _dispatchEvent({
              rootEl: parentEl,
              name: 'sort',
              toEl: parentEl,
              fromEl: rootEl,
              originalEvent: evt
            });

            _dispatchEvent({
              sortable: this,
              name: 'sort',
              toEl: parentEl,
              originalEvent: evt
            });
          }

          putSortable && putSortable.save();
        } else {
          if (newIndex !== oldIndex) {
            if (newIndex >= 0) {
              // drag & drop within the same list
              _dispatchEvent({
                sortable: this,
                name: 'update',
                toEl: parentEl,
                originalEvent: evt
              });

              _dispatchEvent({
                sortable: this,
                name: 'sort',
                toEl: parentEl,
                originalEvent: evt
              });
            }
          }
        }

        if (Sortable.active) {
          /* jshint eqnull:true */
          if (newIndex == null || newIndex === -1) {
            newIndex = oldIndex;
            newDraggableIndex = oldDraggableIndex;
          }

          _dispatchEvent({
            sortable: this,
            name: 'end',
            toEl: parentEl,
            originalEvent: evt
          }); // Save sorting


          this.save();
        }
      }
    }

    this._nulling();
  },
  _nulling: function _nulling() {
    pluginEvent('nulling', this);
    rootEl = dragEl = parentEl = ghostEl = nextEl = cloneEl = lastDownEl = cloneHidden = tapEvt = touchEvt = moved = newIndex = newDraggableIndex = oldIndex = oldDraggableIndex = lastTarget = lastDirection = putSortable = activeGroup = Sortable.dragged = Sortable.ghost = Sortable.clone = Sortable.active = null;
    savedInputChecked.forEach(function (el) {
      el.checked = true;
    });
    savedInputChecked.length = lastDx = lastDy = 0;
  },
  handleEvent: function handleEvent(
  /**Event*/
  evt) {
    switch (evt.type) {
      case 'drop':
      case 'dragend':
        this._onDrop(evt);

        break;

      case 'dragenter':
      case 'dragover':
        if (dragEl) {
          this._onDragOver(evt);

          _globalDragOver(evt);
        }

        break;

      case 'selectstart':
        evt.preventDefault();
        break;
    }
  },

  /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */
  toArray: function toArray() {
    var order = [],
        el,
        children = this.el.children,
        i = 0,
        n = children.length,
        options = this.options;

    for (; i < n; i++) {
      el = children[i];

      if (closest(el, options.draggable, this.el, false)) {
        order.push(el.getAttribute(options.dataIdAttr) || _generateId(el));
      }
    }

    return order;
  },

  /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */
  sort: function sort(order, useAnimation) {
    var items = {},
        rootEl = this.el;
    this.toArray().forEach(function (id, i) {
      var el = rootEl.children[i];

      if (closest(el, this.options.draggable, rootEl, false)) {
        items[id] = el;
      }
    }, this);
    useAnimation && this.captureAnimationState();
    order.forEach(function (id) {
      if (items[id]) {
        rootEl.removeChild(items[id]);
        rootEl.appendChild(items[id]);
      }
    });
    useAnimation && this.animateAll();
  },

  /**
   * Save the current sorting
   */
  save: function save() {
    var store = this.options.store;
    store && store.set && store.set(this);
  },

  /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */
  closest: function closest$1(el, selector) {
    return closest(el, selector || this.options.draggable, this.el, false);
  },

  /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */
  option: function option(name, value) {
    var options = this.options;

    if (value === void 0) {
      return options[name];
    } else {
      var modifiedValue = PluginManager.modifyOption(this, name, value);

      if (typeof modifiedValue !== 'undefined') {
        options[name] = modifiedValue;
      } else {
        options[name] = value;
      }

      if (name === 'group') {
        _prepareGroup(options);
      }
    }
  },

  /**
   * Destroy
   */
  destroy: function destroy() {
    pluginEvent('destroy', this);
    var el = this.el;
    el[expando] = null;
    off(el, 'mousedown', this._onTapStart);
    off(el, 'touchstart', this._onTapStart);
    off(el, 'pointerdown', this._onTapStart);

    if (this.nativeDraggable) {
      off(el, 'dragover', this);
      off(el, 'dragenter', this);
    } // Remove draggable attributes


    Array.prototype.forEach.call(el.querySelectorAll('[draggable]'), function (el) {
      el.removeAttribute('draggable');
    });

    this._onDrop();

    this._disableDelayedDragEvents();

    sortables.splice(sortables.indexOf(this.el), 1);
    this.el = el = null;
  },
  _hideClone: function _hideClone() {
    if (!cloneHidden) {
      pluginEvent('hideClone', this);
      if (Sortable.eventCanceled) return;
      css(cloneEl, 'display', 'none');

      if (this.options.removeCloneOnHide && cloneEl.parentNode) {
        cloneEl.parentNode.removeChild(cloneEl);
      }

      cloneHidden = true;
    }
  },
  _showClone: function _showClone(putSortable) {
    if (putSortable.lastPutMode !== 'clone') {
      this._hideClone();

      return;
    }

    if (cloneHidden) {
      pluginEvent('showClone', this);
      if (Sortable.eventCanceled) return; // show clone at dragEl or original position

      if (dragEl.parentNode == rootEl && !this.options.group.revertClone) {
        rootEl.insertBefore(cloneEl, dragEl);
      } else if (nextEl) {
        rootEl.insertBefore(cloneEl, nextEl);
      } else {
        rootEl.appendChild(cloneEl);
      }

      if (this.options.group.revertClone) {
        this.animate(dragEl, cloneEl);
      }

      css(cloneEl, 'display', '');
      cloneHidden = false;
    }
  }
};

function _globalDragOver(
/**Event*/
evt) {
  if (evt.dataTransfer) {
    evt.dataTransfer.dropEffect = 'move';
  }

  evt.cancelable && evt.preventDefault();
}

function _onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
  var evt,
      sortable = fromEl[expando],
      onMoveFn = sortable.options.onMove,
      retVal; // Support for new CustomEvent feature

  if (window.CustomEvent && !IE11OrLess && !Edge) {
    evt = new CustomEvent('move', {
      bubbles: true,
      cancelable: true
    });
  } else {
    evt = document.createEvent('Event');
    evt.initEvent('move', true, true);
  }

  evt.to = toEl;
  evt.from = fromEl;
  evt.dragged = dragEl;
  evt.draggedRect = dragRect;
  evt.related = targetEl || toEl;
  evt.relatedRect = targetRect || getRect(toEl);
  evt.willInsertAfter = willInsertAfter;
  evt.originalEvent = originalEvent;
  fromEl.dispatchEvent(evt);

  if (onMoveFn) {
    retVal = onMoveFn.call(sortable, evt, originalEvent);
  }

  return retVal;
}

function _disableDraggable(el) {
  el.draggable = false;
}

function _unsilent() {
  _silent = false;
}

function _ghostIsFirst(evt, vertical, sortable) {
  var rect = getRect(getChild(sortable.el, 0, sortable.options, true));
  var spacer = 10;
  return vertical ? evt.clientX < rect.left - spacer || evt.clientY < rect.top && evt.clientX < rect.right : evt.clientY < rect.top - spacer || evt.clientY < rect.bottom && evt.clientX < rect.left;
}

function _ghostIsLast(evt, vertical, sortable) {
  var rect = getRect(lastChild(sortable.el, sortable.options.draggable));
  var spacer = 10;
  return vertical ? evt.clientX > rect.right + spacer || evt.clientX <= rect.right && evt.clientY > rect.bottom && evt.clientX >= rect.left : evt.clientX > rect.right && evt.clientY > rect.top || evt.clientX <= rect.right && evt.clientY > rect.bottom + spacer;
}

function _getSwapDirection(evt, target, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
  var mouseOnAxis = vertical ? evt.clientY : evt.clientX,
      targetLength = vertical ? targetRect.height : targetRect.width,
      targetS1 = vertical ? targetRect.top : targetRect.left,
      targetS2 = vertical ? targetRect.bottom : targetRect.right,
      invert = false;

  if (!invertSwap) {
    // Never invert or create dragEl shadow when target movemenet causes mouse to move past the end of regular swapThreshold
    if (isLastTarget && targetMoveDistance < targetLength * swapThreshold) {
      // multiplied only by swapThreshold because mouse will already be inside target by (1 - threshold) * targetLength / 2
      // check if past first invert threshold on side opposite of lastDirection
      if (!pastFirstInvertThresh && (lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) {
        // past first invert threshold, do not restrict inverted threshold to dragEl shadow
        pastFirstInvertThresh = true;
      }

      if (!pastFirstInvertThresh) {
        // dragEl shadow (target move distance shadow)
        if (lastDirection === 1 ? mouseOnAxis < targetS1 + targetMoveDistance // over dragEl shadow
        : mouseOnAxis > targetS2 - targetMoveDistance) {
          return -lastDirection;
        }
      } else {
        invert = true;
      }
    } else {
      // Regular
      if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) {
        return _getInsertDirection(target);
      }
    }
  }

  invert = invert || invertSwap;

  if (invert) {
    // Invert of regular
    if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) {
      return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
    }
  }

  return 0;
}
/**
 * Gets the direction dragEl must be swapped relative to target in order to make it
 * seem that dragEl has been "inserted" into that element's position
 * @param  {HTMLElement} target       The target whose position dragEl is being inserted at
 * @return {Number}                   Direction dragEl must be swapped
 */


function _getInsertDirection(target) {
  if (index(dragEl) < index(target)) {
    return 1;
  } else {
    return -1;
  }
}
/**
 * Generate id
 * @param   {HTMLElement} el
 * @returns {String}
 * @private
 */


function _generateId(el) {
  var str = el.tagName + el.className + el.src + el.href + el.textContent,
      i = str.length,
      sum = 0;

  while (i--) {
    sum += str.charCodeAt(i);
  }

  return sum.toString(36);
}

function _saveInputCheckedState(root) {
  savedInputChecked.length = 0;
  var inputs = root.getElementsByTagName('input');
  var idx = inputs.length;

  while (idx--) {
    var el = inputs[idx];
    el.checked && savedInputChecked.push(el);
  }
}

function _nextTick(fn) {
  return setTimeout(fn, 0);
}

function _cancelNextTick(id) {
  return clearTimeout(id);
} // Fixed #973:


if (documentExists) {
  on(document, 'touchmove', function (evt) {
    if ((Sortable.active || awaitingDragStarted) && evt.cancelable) {
      evt.preventDefault();
    }
  });
} // Export utils


Sortable.utils = {
  on: on,
  off: off,
  css: css,
  find: find,
  is: function is(el, selector) {
    return !!closest(el, selector, el, false);
  },
  extend: extend,
  throttle: throttle,
  closest: closest,
  toggleClass: toggleClass,
  clone: clone,
  index: index,
  nextTick: _nextTick,
  cancelNextTick: _cancelNextTick,
  detectDirection: _detectDirection,
  getChild: getChild
};
/**
 * Get the Sortable instance of an element
 * @param  {HTMLElement} element The element
 * @return {Sortable|undefined}         The instance of Sortable
 */

Sortable.get = function (element) {
  return element[expando];
};
/**
 * Mount a plugin to Sortable
 * @param  {...SortablePlugin|SortablePlugin[]} plugins       Plugins being mounted
 */


Sortable.mount = function () {
  for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
    plugins[_key] = arguments[_key];
  }

  if (plugins[0].constructor === Array) plugins = plugins[0];
  plugins.forEach(function (plugin) {
    if (!plugin.prototype || !plugin.prototype.constructor) {
      throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(plugin));
    }

    if (plugin.utils) Sortable.utils = _objectSpread2(_objectSpread2({}, Sortable.utils), plugin.utils);
    PluginManager.mount(plugin);
  });
};
/**
 * Create sortable instance
 * @param {HTMLElement}  el
 * @param {Object}      [options]
 */


Sortable.create = function (el, options) {
  return new Sortable(el, options);
}; // Export


Sortable.version = version;

var autoScrolls = [],
    scrollEl,
    scrollRootEl,
    scrolling = false,
    lastAutoScrollX,
    lastAutoScrollY,
    touchEvt$1,
    pointerElemChangedInterval;

function AutoScrollPlugin() {
  function AutoScroll() {
    this.defaults = {
      scroll: true,
      forceAutoScrollFallback: false,
      scrollSensitivity: 30,
      scrollSpeed: 10,
      bubbleScroll: true
    }; // Bind all private methods

    for (var fn in this) {
      if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
        this[fn] = this[fn].bind(this);
      }
    }
  }

  AutoScroll.prototype = {
    dragStarted: function dragStarted(_ref) {
      var originalEvent = _ref.originalEvent;

      if (this.sortable.nativeDraggable) {
        on(document, 'dragover', this._handleAutoScroll);
      } else {
        if (this.options.supportPointer) {
          on(document, 'pointermove', this._handleFallbackAutoScroll);
        } else if (originalEvent.touches) {
          on(document, 'touchmove', this._handleFallbackAutoScroll);
        } else {
          on(document, 'mousemove', this._handleFallbackAutoScroll);
        }
      }
    },
    dragOverCompleted: function dragOverCompleted(_ref2) {
      var originalEvent = _ref2.originalEvent;

      // For when bubbling is canceled and using fallback (fallback 'touchmove' always reached)
      if (!this.options.dragOverBubble && !originalEvent.rootEl) {
        this._handleAutoScroll(originalEvent);
      }
    },
    drop: function drop() {
      if (this.sortable.nativeDraggable) {
        off(document, 'dragover', this._handleAutoScroll);
      } else {
        off(document, 'pointermove', this._handleFallbackAutoScroll);
        off(document, 'touchmove', this._handleFallbackAutoScroll);
        off(document, 'mousemove', this._handleFallbackAutoScroll);
      }

      clearPointerElemChangedInterval();
      clearAutoScrolls();
      cancelThrottle();
    },
    nulling: function nulling() {
      touchEvt$1 = scrollRootEl = scrollEl = scrolling = pointerElemChangedInterval = lastAutoScrollX = lastAutoScrollY = null;
      autoScrolls.length = 0;
    },
    _handleFallbackAutoScroll: function _handleFallbackAutoScroll(evt) {
      this._handleAutoScroll(evt, true);
    },
    _handleAutoScroll: function _handleAutoScroll(evt, fallback) {
      var _this = this;

      var x = (evt.touches ? evt.touches[0] : evt).clientX,
          y = (evt.touches ? evt.touches[0] : evt).clientY,
          elem = document.elementFromPoint(x, y);
      touchEvt$1 = evt; // IE does not seem to have native autoscroll,
      // Edge's autoscroll seems too conditional,
      // MACOS Safari does not have autoscroll,
      // Firefox and Chrome are good

      if (fallback || this.options.forceAutoScrollFallback || Edge || IE11OrLess || Safari) {
        autoScroll(evt, this.options, elem, fallback); // Listener for pointer element change

        var ogElemScroller = getParentAutoScrollElement(elem, true);

        if (scrolling && (!pointerElemChangedInterval || x !== lastAutoScrollX || y !== lastAutoScrollY)) {
          pointerElemChangedInterval && clearPointerElemChangedInterval(); // Detect for pointer elem change, emulating native DnD behaviour

          pointerElemChangedInterval = setInterval(function () {
            var newElem = getParentAutoScrollElement(document.elementFromPoint(x, y), true);

            if (newElem !== ogElemScroller) {
              ogElemScroller = newElem;
              clearAutoScrolls();
            }

            autoScroll(evt, _this.options, newElem, fallback);
          }, 10);
          lastAutoScrollX = x;
          lastAutoScrollY = y;
        }
      } else {
        // if DnD is enabled (and browser has good autoscrolling), first autoscroll will already scroll, so get parent autoscroll of first autoscroll
        if (!this.options.bubbleScroll || getParentAutoScrollElement(elem, true) === getWindowScrollingElement()) {
          clearAutoScrolls();
          return;
        }

        autoScroll(evt, this.options, getParentAutoScrollElement(elem, false), false);
      }
    }
  };
  return _extends(AutoScroll, {
    pluginName: 'scroll',
    initializeByDefault: true
  });
}

function clearAutoScrolls() {
  autoScrolls.forEach(function (autoScroll) {
    clearInterval(autoScroll.pid);
  });
  autoScrolls = [];
}

function clearPointerElemChangedInterval() {
  clearInterval(pointerElemChangedInterval);
}

var autoScroll = throttle(function (evt, options, rootEl, isFallback) {
  // Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
  if (!options.scroll) return;
  var x = (evt.touches ? evt.touches[0] : evt).clientX,
      y = (evt.touches ? evt.touches[0] : evt).clientY,
      sens = options.scrollSensitivity,
      speed = options.scrollSpeed,
      winScroller = getWindowScrollingElement();
  var scrollThisInstance = false,
      scrollCustomFn; // New scroll root, set scrollEl

  if (scrollRootEl !== rootEl) {
    scrollRootEl = rootEl;
    clearAutoScrolls();
    scrollEl = options.scroll;
    scrollCustomFn = options.scrollFn;

    if (scrollEl === true) {
      scrollEl = getParentAutoScrollElement(rootEl, true);
    }
  }

  var layersOut = 0;
  var currentParent = scrollEl;

  do {
    var el = currentParent,
        rect = getRect(el),
        top = rect.top,
        bottom = rect.bottom,
        left = rect.left,
        right = rect.right,
        width = rect.width,
        height = rect.height,
        canScrollX = void 0,
        canScrollY = void 0,
        scrollWidth = el.scrollWidth,
        scrollHeight = el.scrollHeight,
        elCSS = css(el),
        scrollPosX = el.scrollLeft,
        scrollPosY = el.scrollTop;

    if (el === winScroller) {
      canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll' || elCSS.overflowX === 'visible');
      canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll' || elCSS.overflowY === 'visible');
    } else {
      canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll');
      canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll');
    }

    var vx = canScrollX && (Math.abs(right - x) <= sens && scrollPosX + width < scrollWidth) - (Math.abs(left - x) <= sens && !!scrollPosX);
    var vy = canScrollY && (Math.abs(bottom - y) <= sens && scrollPosY + height < scrollHeight) - (Math.abs(top - y) <= sens && !!scrollPosY);

    if (!autoScrolls[layersOut]) {
      for (var i = 0; i <= layersOut; i++) {
        if (!autoScrolls[i]) {
          autoScrolls[i] = {};
        }
      }
    }

    if (autoScrolls[layersOut].vx != vx || autoScrolls[layersOut].vy != vy || autoScrolls[layersOut].el !== el) {
      autoScrolls[layersOut].el = el;
      autoScrolls[layersOut].vx = vx;
      autoScrolls[layersOut].vy = vy;
      clearInterval(autoScrolls[layersOut].pid);

      if (vx != 0 || vy != 0) {
        scrollThisInstance = true;
        /* jshint loopfunc:true */

        autoScrolls[layersOut].pid = setInterval(function () {
          // emulate drag over during autoscroll (fallback), emulating native DnD behaviour
          if (isFallback && this.layer === 0) {
            Sortable.active._onTouchMove(touchEvt$1); // To move ghost if it is positioned absolutely

          }

          var scrollOffsetY = autoScrolls[this.layer].vy ? autoScrolls[this.layer].vy * speed : 0;
          var scrollOffsetX = autoScrolls[this.layer].vx ? autoScrolls[this.layer].vx * speed : 0;

          if (typeof scrollCustomFn === 'function') {
            if (scrollCustomFn.call(Sortable.dragged.parentNode[expando], scrollOffsetX, scrollOffsetY, evt, touchEvt$1, autoScrolls[this.layer].el) !== 'continue') {
              return;
            }
          }

          scrollBy(autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
        }.bind({
          layer: layersOut
        }), 24);
      }
    }

    layersOut++;
  } while (options.bubbleScroll && currentParent !== winScroller && (currentParent = getParentAutoScrollElement(currentParent, false)));

  scrolling = scrollThisInstance; // in case another function catches scrolling as false in between when it is not
}, 30);

var drop = function drop(_ref) {
  var originalEvent = _ref.originalEvent,
      putSortable = _ref.putSortable,
      dragEl = _ref.dragEl,
      activeSortable = _ref.activeSortable,
      dispatchSortableEvent = _ref.dispatchSortableEvent,
      hideGhostForTarget = _ref.hideGhostForTarget,
      unhideGhostForTarget = _ref.unhideGhostForTarget;
  if (!originalEvent) return;
  var toSortable = putSortable || activeSortable;
  hideGhostForTarget();
  var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
  var target = document.elementFromPoint(touch.clientX, touch.clientY);
  unhideGhostForTarget();

  if (toSortable && !toSortable.el.contains(target)) {
    dispatchSortableEvent('spill');
    this.onSpill({
      dragEl: dragEl,
      putSortable: putSortable
    });
  }
};

function Revert() {}

Revert.prototype = {
  startIndex: null,
  dragStart: function dragStart(_ref2) {
    var oldDraggableIndex = _ref2.oldDraggableIndex;
    this.startIndex = oldDraggableIndex;
  },
  onSpill: function onSpill(_ref3) {
    var dragEl = _ref3.dragEl,
        putSortable = _ref3.putSortable;
    this.sortable.captureAnimationState();

    if (putSortable) {
      putSortable.captureAnimationState();
    }

    var nextSibling = getChild(this.sortable.el, this.startIndex, this.options);

    if (nextSibling) {
      this.sortable.el.insertBefore(dragEl, nextSibling);
    } else {
      this.sortable.el.appendChild(dragEl);
    }

    this.sortable.animateAll();

    if (putSortable) {
      putSortable.animateAll();
    }
  },
  drop: drop
};

_extends(Revert, {
  pluginName: 'revertOnSpill'
});

function Remove() {}

Remove.prototype = {
  onSpill: function onSpill(_ref4) {
    var dragEl = _ref4.dragEl,
        putSortable = _ref4.putSortable;
    var parentSortable = putSortable || this.sortable;
    parentSortable.captureAnimationState();
    dragEl.parentNode && dragEl.parentNode.removeChild(dragEl);
    parentSortable.animateAll();
  },
  drop: drop
};

_extends(Remove, {
  pluginName: 'removeOnSpill'
});

var lastSwapEl;

function SwapPlugin() {
  function Swap() {
    this.defaults = {
      swapClass: 'sortable-swap-highlight'
    };
  }

  Swap.prototype = {
    dragStart: function dragStart(_ref) {
      var dragEl = _ref.dragEl;
      lastSwapEl = dragEl;
    },
    dragOverValid: function dragOverValid(_ref2) {
      var completed = _ref2.completed,
          target = _ref2.target,
          onMove = _ref2.onMove,
          activeSortable = _ref2.activeSortable,
          changed = _ref2.changed,
          cancel = _ref2.cancel;
      if (!activeSortable.options.swap) return;
      var el = this.sortable.el,
          options = this.options;

      if (target && target !== el) {
        var prevSwapEl = lastSwapEl;

        if (onMove(target) !== false) {
          toggleClass(target, options.swapClass, true);
          lastSwapEl = target;
        } else {
          lastSwapEl = null;
        }

        if (prevSwapEl && prevSwapEl !== lastSwapEl) {
          toggleClass(prevSwapEl, options.swapClass, false);
        }
      }

      changed();
      completed(true);
      cancel();
    },
    drop: function drop(_ref3) {
      var activeSortable = _ref3.activeSortable,
          putSortable = _ref3.putSortable,
          dragEl = _ref3.dragEl;
      var toSortable = putSortable || this.sortable;
      var options = this.options;
      lastSwapEl && toggleClass(lastSwapEl, options.swapClass, false);

      if (lastSwapEl && (options.swap || putSortable && putSortable.options.swap)) {
        if (dragEl !== lastSwapEl) {
          toSortable.captureAnimationState();
          if (toSortable !== activeSortable) activeSortable.captureAnimationState();
          swapNodes(dragEl, lastSwapEl);
          toSortable.animateAll();
          if (toSortable !== activeSortable) activeSortable.animateAll();
        }
      }
    },
    nulling: function nulling() {
      lastSwapEl = null;
    }
  };
  return _extends(Swap, {
    pluginName: 'swap',
    eventProperties: function eventProperties() {
      return {
        swapItem: lastSwapEl
      };
    }
  });
}

function swapNodes(n1, n2) {
  var p1 = n1.parentNode,
      p2 = n2.parentNode,
      i1,
      i2;
  if (!p1 || !p2 || p1.isEqualNode(n2) || p2.isEqualNode(n1)) return;
  i1 = index(n1);
  i2 = index(n2);

  if (p1.isEqualNode(p2) && i1 < i2) {
    i2++;
  }

  p1.insertBefore(n2, p1.children[i1]);
  p2.insertBefore(n1, p2.children[i2]);
}

var multiDragElements = [],
    multiDragClones = [],
    lastMultiDragSelect,
    // for selection with modifier key down (SHIFT)
multiDragSortable,
    initialFolding = false,
    // Initial multi-drag fold when drag started
folding = false,
    // Folding any other time
dragStarted = false,
    dragEl$1,
    clonesFromRect,
    clonesHidden;

function MultiDragPlugin() {
  function MultiDrag(sortable) {
    // Bind all private methods
    for (var fn in this) {
      if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
        this[fn] = this[fn].bind(this);
      }
    }

    if (sortable.options.supportPointer) {
      on(document, 'pointerup', this._deselectMultiDrag);
    } else {
      on(document, 'mouseup', this._deselectMultiDrag);
      on(document, 'touchend', this._deselectMultiDrag);
    }

    on(document, 'keydown', this._checkKeyDown);
    on(document, 'keyup', this._checkKeyUp);
    this.defaults = {
      selectedClass: 'sortable-selected',
      multiDragKey: null,
      setData: function setData(dataTransfer, dragEl) {
        var data = '';

        if (multiDragElements.length && multiDragSortable === sortable) {
          multiDragElements.forEach(function (multiDragElement, i) {
            data += (!i ? '' : ', ') + multiDragElement.textContent;
          });
        } else {
          data = dragEl.textContent;
        }

        dataTransfer.setData('Text', data);
      }
    };
  }

  MultiDrag.prototype = {
    multiDragKeyDown: false,
    isMultiDrag: false,
    delayStartGlobal: function delayStartGlobal(_ref) {
      var dragged = _ref.dragEl;
      dragEl$1 = dragged;
    },
    delayEnded: function delayEnded() {
      this.isMultiDrag = ~multiDragElements.indexOf(dragEl$1);
    },
    setupClone: function setupClone(_ref2) {
      var sortable = _ref2.sortable,
          cancel = _ref2.cancel;
      if (!this.isMultiDrag) return;

      for (var i = 0; i < multiDragElements.length; i++) {
        multiDragClones.push(clone(multiDragElements[i]));
        multiDragClones[i].sortableIndex = multiDragElements[i].sortableIndex;
        multiDragClones[i].draggable = false;
        multiDragClones[i].style['will-change'] = '';
        toggleClass(multiDragClones[i], this.options.selectedClass, false);
        multiDragElements[i] === dragEl$1 && toggleClass(multiDragClones[i], this.options.chosenClass, false);
      }

      sortable._hideClone();

      cancel();
    },
    clone: function clone(_ref3) {
      var sortable = _ref3.sortable,
          rootEl = _ref3.rootEl,
          dispatchSortableEvent = _ref3.dispatchSortableEvent,
          cancel = _ref3.cancel;
      if (!this.isMultiDrag) return;

      if (!this.options.removeCloneOnHide) {
        if (multiDragElements.length && multiDragSortable === sortable) {
          insertMultiDragClones(true, rootEl);
          dispatchSortableEvent('clone');
          cancel();
        }
      }
    },
    showClone: function showClone(_ref4) {
      var cloneNowShown = _ref4.cloneNowShown,
          rootEl = _ref4.rootEl,
          cancel = _ref4.cancel;
      if (!this.isMultiDrag) return;
      insertMultiDragClones(false, rootEl);
      multiDragClones.forEach(function (clone) {
        css(clone, 'display', '');
      });
      cloneNowShown();
      clonesHidden = false;
      cancel();
    },
    hideClone: function hideClone(_ref5) {
      var _this = this;

      var sortable = _ref5.sortable,
          cloneNowHidden = _ref5.cloneNowHidden,
          cancel = _ref5.cancel;
      if (!this.isMultiDrag) return;
      multiDragClones.forEach(function (clone) {
        css(clone, 'display', 'none');

        if (_this.options.removeCloneOnHide && clone.parentNode) {
          clone.parentNode.removeChild(clone);
        }
      });
      cloneNowHidden();
      clonesHidden = true;
      cancel();
    },
    dragStartGlobal: function dragStartGlobal(_ref6) {
      var sortable = _ref6.sortable;

      if (!this.isMultiDrag && multiDragSortable) {
        multiDragSortable.multiDrag._deselectMultiDrag();
      }

      multiDragElements.forEach(function (multiDragElement) {
        multiDragElement.sortableIndex = index(multiDragElement);
      }); // Sort multi-drag elements

      multiDragElements = multiDragElements.sort(function (a, b) {
        return a.sortableIndex - b.sortableIndex;
      });
      dragStarted = true;
    },
    dragStarted: function dragStarted(_ref7) {
      var _this2 = this;

      var sortable = _ref7.sortable;
      if (!this.isMultiDrag) return;

      if (this.options.sort) {
        // Capture rects,
        // hide multi drag elements (by positioning them absolute),
        // set multi drag elements rects to dragRect,
        // show multi drag elements,
        // animate to rects,
        // unset rects & remove from DOM
        sortable.captureAnimationState();

        if (this.options.animation) {
          multiDragElements.forEach(function (multiDragElement) {
            if (multiDragElement === dragEl$1) return;
            css(multiDragElement, 'position', 'absolute');
          });
          var dragRect = getRect(dragEl$1, false, true, true);
          multiDragElements.forEach(function (multiDragElement) {
            if (multiDragElement === dragEl$1) return;
            setRect(multiDragElement, dragRect);
          });
          folding = true;
          initialFolding = true;
        }
      }

      sortable.animateAll(function () {
        folding = false;
        initialFolding = false;

        if (_this2.options.animation) {
          multiDragElements.forEach(function (multiDragElement) {
            unsetRect(multiDragElement);
          });
        } // Remove all auxiliary multidrag items from el, if sorting enabled


        if (_this2.options.sort) {
          removeMultiDragElements();
        }
      });
    },
    dragOver: function dragOver(_ref8) {
      var target = _ref8.target,
          completed = _ref8.completed,
          cancel = _ref8.cancel;

      if (folding && ~multiDragElements.indexOf(target)) {
        completed(false);
        cancel();
      }
    },
    revert: function revert(_ref9) {
      var fromSortable = _ref9.fromSortable,
          rootEl = _ref9.rootEl,
          sortable = _ref9.sortable,
          dragRect = _ref9.dragRect;

      if (multiDragElements.length > 1) {
        // Setup unfold animation
        multiDragElements.forEach(function (multiDragElement) {
          sortable.addAnimationState({
            target: multiDragElement,
            rect: folding ? getRect(multiDragElement) : dragRect
          });
          unsetRect(multiDragElement);
          multiDragElement.fromRect = dragRect;
          fromSortable.removeAnimationState(multiDragElement);
        });
        folding = false;
        insertMultiDragElements(!this.options.removeCloneOnHide, rootEl);
      }
    },
    dragOverCompleted: function dragOverCompleted(_ref10) {
      var sortable = _ref10.sortable,
          isOwner = _ref10.isOwner,
          insertion = _ref10.insertion,
          activeSortable = _ref10.activeSortable,
          parentEl = _ref10.parentEl,
          putSortable = _ref10.putSortable;
      var options = this.options;

      if (insertion) {
        // Clones must be hidden before folding animation to capture dragRectAbsolute properly
        if (isOwner) {
          activeSortable._hideClone();
        }

        initialFolding = false; // If leaving sort:false root, or already folding - Fold to new location

        if (options.animation && multiDragElements.length > 1 && (folding || !isOwner && !activeSortable.options.sort && !putSortable)) {
          // Fold: Set all multi drag elements's rects to dragEl's rect when multi-drag elements are invisible
          var dragRectAbsolute = getRect(dragEl$1, false, true, true);
          multiDragElements.forEach(function (multiDragElement) {
            if (multiDragElement === dragEl$1) return;
            setRect(multiDragElement, dragRectAbsolute); // Move element(s) to end of parentEl so that it does not interfere with multi-drag clones insertion if they are inserted
            // while folding, and so that we can capture them again because old sortable will no longer be fromSortable

            parentEl.appendChild(multiDragElement);
          });
          folding = true;
        } // Clones must be shown (and check to remove multi drags) after folding when interfering multiDragElements are moved out


        if (!isOwner) {
          // Only remove if not folding (folding will remove them anyways)
          if (!folding) {
            removeMultiDragElements();
          }

          if (multiDragElements.length > 1) {
            var clonesHiddenBefore = clonesHidden;

            activeSortable._showClone(sortable); // Unfold animation for clones if showing from hidden


            if (activeSortable.options.animation && !clonesHidden && clonesHiddenBefore) {
              multiDragClones.forEach(function (clone) {
                activeSortable.addAnimationState({
                  target: clone,
                  rect: clonesFromRect
                });
                clone.fromRect = clonesFromRect;
                clone.thisAnimationDuration = null;
              });
            }
          } else {
            activeSortable._showClone(sortable);
          }
        }
      }
    },
    dragOverAnimationCapture: function dragOverAnimationCapture(_ref11) {
      var dragRect = _ref11.dragRect,
          isOwner = _ref11.isOwner,
          activeSortable = _ref11.activeSortable;
      multiDragElements.forEach(function (multiDragElement) {
        multiDragElement.thisAnimationDuration = null;
      });

      if (activeSortable.options.animation && !isOwner && activeSortable.multiDrag.isMultiDrag) {
        clonesFromRect = _extends({}, dragRect);
        var dragMatrix = matrix(dragEl$1, true);
        clonesFromRect.top -= dragMatrix.f;
        clonesFromRect.left -= dragMatrix.e;
      }
    },
    dragOverAnimationComplete: function dragOverAnimationComplete() {
      if (folding) {
        folding = false;
        removeMultiDragElements();
      }
    },
    drop: function drop(_ref12) {
      var evt = _ref12.originalEvent,
          rootEl = _ref12.rootEl,
          parentEl = _ref12.parentEl,
          sortable = _ref12.sortable,
          dispatchSortableEvent = _ref12.dispatchSortableEvent,
          oldIndex = _ref12.oldIndex,
          putSortable = _ref12.putSortable;
      var toSortable = putSortable || this.sortable;
      if (!evt) return;
      var options = this.options,
          children = parentEl.children; // Multi-drag selection

      if (!dragStarted) {
        if (options.multiDragKey && !this.multiDragKeyDown) {
          this._deselectMultiDrag();
        }

        toggleClass(dragEl$1, options.selectedClass, !~multiDragElements.indexOf(dragEl$1));

        if (!~multiDragElements.indexOf(dragEl$1)) {
          multiDragElements.push(dragEl$1);
          dispatchEvent({
            sortable: sortable,
            rootEl: rootEl,
            name: 'select',
            targetEl: dragEl$1,
            originalEvt: evt
          }); // Modifier activated, select from last to dragEl

          if (evt.shiftKey && lastMultiDragSelect && sortable.el.contains(lastMultiDragSelect)) {
            var lastIndex = index(lastMultiDragSelect),
                currentIndex = index(dragEl$1);

            if (~lastIndex && ~currentIndex && lastIndex !== currentIndex) {
              // Must include lastMultiDragSelect (select it), in case modified selection from no selection
              // (but previous selection existed)
              var n, i;

              if (currentIndex > lastIndex) {
                i = lastIndex;
                n = currentIndex;
              } else {
                i = currentIndex;
                n = lastIndex + 1;
              }

              for (; i < n; i++) {
                if (~multiDragElements.indexOf(children[i])) continue;
                toggleClass(children[i], options.selectedClass, true);
                multiDragElements.push(children[i]);
                dispatchEvent({
                  sortable: sortable,
                  rootEl: rootEl,
                  name: 'select',
                  targetEl: children[i],
                  originalEvt: evt
                });
              }
            }
          } else {
            lastMultiDragSelect = dragEl$1;
          }

          multiDragSortable = toSortable;
        } else {
          multiDragElements.splice(multiDragElements.indexOf(dragEl$1), 1);
          lastMultiDragSelect = null;
          dispatchEvent({
            sortable: sortable,
            rootEl: rootEl,
            name: 'deselect',
            targetEl: dragEl$1,
            originalEvt: evt
          });
        }
      } // Multi-drag drop


      if (dragStarted && this.isMultiDrag) {
        folding = false; // Do not "unfold" after around dragEl if reverted

        if ((parentEl[expando].options.sort || parentEl !== rootEl) && multiDragElements.length > 1) {
          var dragRect = getRect(dragEl$1),
              multiDragIndex = index(dragEl$1, ':not(.' + this.options.selectedClass + ')');
          if (!initialFolding && options.animation) dragEl$1.thisAnimationDuration = null;
          toSortable.captureAnimationState();

          if (!initialFolding) {
            if (options.animation) {
              dragEl$1.fromRect = dragRect;
              multiDragElements.forEach(function (multiDragElement) {
                multiDragElement.thisAnimationDuration = null;

                if (multiDragElement !== dragEl$1) {
                  var rect = folding ? getRect(multiDragElement) : dragRect;
                  multiDragElement.fromRect = rect; // Prepare unfold animation

                  toSortable.addAnimationState({
                    target: multiDragElement,
                    rect: rect
                  });
                }
              });
            } // Multi drag elements are not necessarily removed from the DOM on drop, so to reinsert
            // properly they must all be removed


            removeMultiDragElements();
            multiDragElements.forEach(function (multiDragElement) {
              if (children[multiDragIndex]) {
                parentEl.insertBefore(multiDragElement, children[multiDragIndex]);
              } else {
                parentEl.appendChild(multiDragElement);
              }

              multiDragIndex++;
            }); // If initial folding is done, the elements may have changed position because they are now
            // unfolding around dragEl, even though dragEl may not have his index changed, so update event
            // must be fired here as Sortable will not.

            if (oldIndex === index(dragEl$1)) {
              var update = false;
              multiDragElements.forEach(function (multiDragElement) {
                if (multiDragElement.sortableIndex !== index(multiDragElement)) {
                  update = true;
                  return;
                }
              });

              if (update) {
                dispatchSortableEvent('update');
              }
            }
          } // Must be done after capturing individual rects (scroll bar)


          multiDragElements.forEach(function (multiDragElement) {
            unsetRect(multiDragElement);
          });
          toSortable.animateAll();
        }

        multiDragSortable = toSortable;
      } // Remove clones if necessary


      if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') {
        multiDragClones.forEach(function (clone) {
          clone.parentNode && clone.parentNode.removeChild(clone);
        });
      }
    },
    nullingGlobal: function nullingGlobal() {
      this.isMultiDrag = dragStarted = false;
      multiDragClones.length = 0;
    },
    destroyGlobal: function destroyGlobal() {
      this._deselectMultiDrag();

      off(document, 'pointerup', this._deselectMultiDrag);
      off(document, 'mouseup', this._deselectMultiDrag);
      off(document, 'touchend', this._deselectMultiDrag);
      off(document, 'keydown', this._checkKeyDown);
      off(document, 'keyup', this._checkKeyUp);
    },
    _deselectMultiDrag: function _deselectMultiDrag(evt) {
      if (typeof dragStarted !== "undefined" && dragStarted) return; // Only deselect if selection is in this sortable

      if (multiDragSortable !== this.sortable) return; // Only deselect if target is not item in this sortable

      if (evt && closest(evt.target, this.options.draggable, this.sortable.el, false)) return; // Only deselect if left click

      if (evt && evt.button !== 0) return;

      while (multiDragElements.length) {
        var el = multiDragElements[0];
        toggleClass(el, this.options.selectedClass, false);
        multiDragElements.shift();
        dispatchEvent({
          sortable: this.sortable,
          rootEl: this.sortable.el,
          name: 'deselect',
          targetEl: el,
          originalEvt: evt
        });
      }
    },
    _checkKeyDown: function _checkKeyDown(evt) {
      if (evt.key === this.options.multiDragKey) {
        this.multiDragKeyDown = true;
      }
    },
    _checkKeyUp: function _checkKeyUp(evt) {
      if (evt.key === this.options.multiDragKey) {
        this.multiDragKeyDown = false;
      }
    }
  };
  return _extends(MultiDrag, {
    // Static methods & properties
    pluginName: 'multiDrag',
    utils: {
      /**
       * Selects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be selected
       */
      select: function select(el) {
        var sortable = el.parentNode[expando];
        if (!sortable || !sortable.options.multiDrag || ~multiDragElements.indexOf(el)) return;

        if (multiDragSortable && multiDragSortable !== sortable) {
          multiDragSortable.multiDrag._deselectMultiDrag();

          multiDragSortable = sortable;
        }

        toggleClass(el, sortable.options.selectedClass, true);
        multiDragElements.push(el);
      },

      /**
       * Deselects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be deselected
       */
      deselect: function deselect(el) {
        var sortable = el.parentNode[expando],
            index = multiDragElements.indexOf(el);
        if (!sortable || !sortable.options.multiDrag || !~index) return;
        toggleClass(el, sortable.options.selectedClass, false);
        multiDragElements.splice(index, 1);
      }
    },
    eventProperties: function eventProperties() {
      var _this3 = this;

      var oldIndicies = [],
          newIndicies = [];
      multiDragElements.forEach(function (multiDragElement) {
        oldIndicies.push({
          multiDragElement: multiDragElement,
          index: multiDragElement.sortableIndex
        }); // multiDragElements will already be sorted if folding

        var newIndex;

        if (folding && multiDragElement !== dragEl$1) {
          newIndex = -1;
        } else if (folding) {
          newIndex = index(multiDragElement, ':not(.' + _this3.options.selectedClass + ')');
        } else {
          newIndex = index(multiDragElement);
        }

        newIndicies.push({
          multiDragElement: multiDragElement,
          index: newIndex
        });
      });
      return {
        items: _toConsumableArray(multiDragElements),
        clones: [].concat(multiDragClones),
        oldIndicies: oldIndicies,
        newIndicies: newIndicies
      };
    },
    optionListeners: {
      multiDragKey: function multiDragKey(key) {
        key = key.toLowerCase();

        if (key === 'ctrl') {
          key = 'Control';
        } else if (key.length > 1) {
          key = key.charAt(0).toUpperCase() + key.substr(1);
        }

        return key;
      }
    }
  });
}

function insertMultiDragElements(clonesInserted, rootEl) {
  multiDragElements.forEach(function (multiDragElement, i) {
    var target = rootEl.children[multiDragElement.sortableIndex + (clonesInserted ? Number(i) : 0)];

    if (target) {
      rootEl.insertBefore(multiDragElement, target);
    } else {
      rootEl.appendChild(multiDragElement);
    }
  });
}
/**
 * Insert multi-drag clones
 * @param  {[Boolean]} elementsInserted  Whether the multi-drag elements are inserted
 * @param  {HTMLElement} rootEl
 */


function insertMultiDragClones(elementsInserted, rootEl) {
  multiDragClones.forEach(function (clone, i) {
    var target = rootEl.children[clone.sortableIndex + (elementsInserted ? Number(i) : 0)];

    if (target) {
      rootEl.insertBefore(clone, target);
    } else {
      rootEl.appendChild(clone);
    }
  });
}

function removeMultiDragElements() {
  multiDragElements.forEach(function (multiDragElement) {
    if (multiDragElement === dragEl$1) return;
    multiDragElement.parentNode && multiDragElement.parentNode.removeChild(multiDragElement);
  });
}

Sortable.mount(new AutoScrollPlugin());
Sortable.mount(Remove, Revert);

/* harmony default export */ __webpack_exports__["a"] = (Sortable);



/***/ }),

/***/ 587:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "background-3ef4649695b6bc42db9007f6bf8b719a.jpg";

/***/ }),

/***/ 588:
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 589:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(632)

var Component = __webpack_require__(12)(
  /* script */
  null,
  /* template */
  __webpack_require__(610),
  /* scopeId */
  "data-v-427f8d8a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 590:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(623)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(276),
  /* template */
  __webpack_require__(619),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 591:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(642)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(277),
  /* template */
  __webpack_require__(621),
  /* scopeId */
  "data-v-d7335fe8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 592:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(627)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(278),
  /* template */
  __webpack_require__(605),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 593:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(635)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(279),
  /* template */
  __webpack_require__(612),
  /* scopeId */
  "data-v-466d4f29",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 594:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(638)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(280),
  /* template */
  __webpack_require__(615),
  /* scopeId */
  "data-v-5d7eb81e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 595:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(637)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(281),
  /* template */
  __webpack_require__(614),
  /* scopeId */
  "data-v-5d6516da",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 596:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(629)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(282),
  /* template */
  __webpack_require__(607),
  /* scopeId */
  "data-v-3416d645",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 597:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(631)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(283),
  /* template */
  __webpack_require__(609),
  /* scopeId */
  "data-v-3e79cd4a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 598:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(641)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(284),
  /* template */
  __webpack_require__(620),
  /* scopeId */
  "data-v-7ffe1f52",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 599:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(630)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(289),
  /* template */
  __webpack_require__(608),
  /* scopeId */
  "data-v-35d65550",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 600:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(625)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(290),
  /* template */
  __webpack_require__(603),
  /* scopeId */
  "data-v-1b608816",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 601:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(640)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(291),
  /* template */
  __webpack_require__(618),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 602:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(639)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(292),
  /* template */
  __webpack_require__(617),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 603:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content border radius-10 mb-50"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "bg-gary p-10 skillListTitle"
  }, [_c('h2', [_vm._v("Extended Project Qualification")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": __webpack_require__(223)
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    }
  }, [_c('i', {
    staticClass: "icon ion-android-download"
  }), _vm._v(" EPQ offline document")])], 1)])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": _vm.loadingText
    }
  }, _vm._l((_vm.report.skillList), function(skill) {
    return (skill.pageList.length !== 0 && (skill.name !== 'Form 12' && skill.name !== 'Form 10')) ? _c('el-row', {
      key: skill.id,
      staticClass: "border-b-2 p-20 ml-none mr-none",
      attrs: {
        "gutter": 20
      }
    }, [_c('el-col', {
      staticClass: "mt-10 mb-20",
      attrs: {
        "span": 6
      }
    }, [_c('div', [_c('h2', {
      staticClass: "mb-2"
    }, [_vm._v(_vm._s(skill.name))])])]), _vm._v(" "), _c('el-col', {
      staticClass: "line-right",
      attrs: {
        "span": 18
      }
    }, _vm._l((skill.pageList), function(page) {
      return _c('div', {
        key: page.id,
        staticClass: "el-col-8"
      }, [(skill.name !== 'Form 13') ? _c('div', {
        staticClass: "border-b"
      }, [_c('el-button', {
        attrs: {
          "type": "text"
        },
        on: {
          "click": function($event) {
            _vm.showPageDialog(skill, page)
          }
        }
      }, [_vm._v(_vm._s(page.page))])], 1) : _vm._e(), _vm._v(" "), _c('router-link', {
        staticClass: "white mt-20",
        staticStyle: {
          "display": "inline-block",
          "vertical-align": "super"
        },
        attrs: {
          "to": {
            path: 'evidence',
            query: {
              studentId: _vm.studentId,
              pageId: page.id,
              skillAbbr: skill.abbr,
              skillName: skill.name,
              pageName: page.page,
              reportId: _vm.report.id,
              reportName: _vm.report.category,
              reportIndex: _vm.$route.path
            }
          },
          "append": ""
        }
      }, [_c('el-tooltip', {
        attrs: {
          "effect": "dark",
          "content": "Evidence",
          "placement": "top"
        }
      }, [(_vm.category === 'epq' && page.showUpload == true) ? _c('el-button', {
        attrs: {
          "type": "primary",
          "size": "mini",
          "plain": ""
        }
      }, [_vm._v(_vm._s(skill.name == 'Form 11' ? 'Result Download' : 'Submission Entry')), _c('i', {
        staticClass: "icon ion-folder ml-10"
      })]) : _vm._e()], 1)], 1)], 1)
    }), 0)], 1) : _vm._e()
  }), 1), _vm._v(" "), _c('skill-dialog', {
    ref: "reportDialog",
    attrs: {
      "report": _vm.report
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "generate-link"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 604:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": _vm.templateTypeText,
      "visible": _vm.editVisible,
      "width": "90%",
      "customClass": "dialogWidth-1000",
      "close-on-click-modal": false,
      "before-close": _vm.saveAlert,
      "close-on-press-escape": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editVisible = $event
      },
      "close": _vm.closeDialog
    }
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isDialogLoading),
      expression: "isDialogLoading"
    }]
  }, _vm._l((_vm.questions), function(questionGroup, index) {
    return _c('el-card', {
      key: index,
      staticClass: "mb-20"
    }, [_vm._l((questionGroup), function(question) {
      return [_c('el-row', [_c('el-col', [_c('el-tooltip', {
        staticClass: "mb-2 mt-5",
        attrs: {
          "effect": "dark",
          "placement": "bottom",
          "disabled": question.guidance == ''
        }
      }, [_c('div', {
        staticStyle: {
          "max-width": "1000px"
        },
        attrs: {
          "slot": "content"
        },
        domProps: {
          "innerHTML": _vm._s(question.guidance)
        },
        slot: "content"
      }), _vm._v(" "), _c('h4', {
        staticClass: "question-title",
        style: (question.highlighted ? 'background:yellow;' : ''),
        attrs: {
          "id": 'question' + question.id
        }
      }, [_vm._v("\n                                    " + _vm._s(question.title))])])], 1)], 1), _vm._v(" "), (question == 'table') ? [_c('el-row', [_c('el-col', [_c('el-table', {
        attrs: {
          "data": question.config.list
        }
      }, _vm._l((question.config.title), function(cell, index) {
        return _c('el-table-column', {
          key: index,
          attrs: {
            "label": cell.key
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('el-input', {
                attrs: {
                  "type": "textarea",
                  "maxlength": _vm.maxLength
                },
                on: {
                  "change": _vm.checkQuestionInput
                },
                model: {
                  value: (scope.row[cell.value]),
                  callback: function($$v) {
                    _vm.$set(scope.row, cell.value, $$v)
                  },
                  expression: "scope.row[cell.value]"
                }
              })]
            }
          }], null, true)
        })
      }), 1)], 1)], 1)] : _vm._e(), _vm._v(" "), _vm._l((question.config.list), function(row) {
        return [_c('el-row', {
          attrs: {
            "gutter": 20
          }
        }, [_vm._l((row), function(col, index) {
          return [(col.type == 'input' || col.type == 'link') ? _c('el-col', {
            attrs: {
              "span": Math.floor(col.spans * 24)
            }
          }, [_c('p', {
            staticClass: "gary mb-5"
          }, [_vm._v(_vm._s(col.description))]), _vm._v(" "), _c('el-form-item', {
            ref: "col",
            refInFor: true,
            staticClass: "mb-none",
            attrs: {
              "prop": "answer"
            }
          }, [_c('el-input', {
            attrs: {
              "maxlength": _vm.maxLength,
              "type": "textarea",
              "rows": col.rows,
              "placeholder": question.config.forTeacher ? 'To be edited by teacher' : '',
              "disabled": question.config.forTeacher
            },
            on: {
              "change": _vm.checkQuestionInput
            },
            model: {
              value: (col.answer),
              callback: function($$v) {
                _vm.$set(col, "answer", $$v)
              },
              expression: "col.answer"
            }
          })], 1)], 1) : _vm._e(), _vm._v(" "), (col.type == 'text') ? _c('el-col', {
            attrs: {
              "span": Math.floor(col.spans * 24),
              "disabled": true
            }
          }, [_c('p', {
            staticClass: "gary mb-5"
          }, [_vm._v(_vm._s(col.description))]), _vm._v(" "), _c('el-form-item', {
            staticClass: "mb-none",
            attrs: {
              "prop": "answer"
            }
          }, [_c('el-input', {
            attrs: {
              "maxlength": _vm.maxLength,
              "type": "text",
              "rows": col.rows,
              "placeholder": question.config.forTeacher ? 'To be edited by teacher' : '',
              "disabled": question.config.forTeacher
            },
            on: {
              "change": _vm.checkQuestionInput
            },
            model: {
              value: (col.answer),
              callback: function($$v) {
                _vm.$set(col, "answer", $$v)
              },
              expression: "col.answer"
            }
          })], 1)], 1) : _vm._e(), _vm._v(" "), (col.type == 'datetime') ? _c('el-col', {
            attrs: {
              "span": Math.floor(col.spans * 24)
            }
          }, [_c('p', {
            staticClass: "gary  mt-5"
          }, [_vm._v(_vm._s(col.dateDescription))]), _vm._v(" "), _c('el-date-picker', {
            staticClass: "mt-5",
            staticStyle: {
              "width": "100%"
            },
            attrs: {
              "picker-options": _vm.datePickerOptions.option1,
              "type": "date",
              "placeholder": question.config.forTeacher ? 'To be edited by teacher' : 'Select date',
              "disabled": question.config.forTeacher
            },
            on: {
              "change": function($event) {
                _vm.isDirty = true;
              }
            },
            model: {
              value: (col.date),
              callback: function($$v) {
                _vm.$set(col, "date", $$v)
              },
              expression: "col.date"
            }
          }), _vm._v(" "), _c('p', {
            staticClass: "gary mt-5"
          }, [_vm._v(_vm._s(col.timeDescription))]), _vm._v(" "), _c('el-time-picker', {
            staticClass: "mt-5",
            staticStyle: {
              "width": "100%"
            },
            attrs: {
              "placeholder": question.config.forTeacher ? 'To be edited by teacher' : 'Select time',
              "disabled": question.config.forTeacher
            },
            on: {
              "change": function($event) {
                _vm.isDirty = true;
              }
            },
            model: {
              value: (col.time),
              callback: function($$v) {
                _vm.$set(col, "time", $$v)
              },
              expression: "col.time"
            }
          })], 1) : _vm._e(), _vm._v(" "), (col.type == 'date') ? _c('el-col', {
            attrs: {
              "span": Math.floor(col.spans * 24)
            },
            on: {
              "change": function($event) {
                _vm.isDirty = true;
              }
            }
          }, [_c('p', {
            staticClass: "gary "
          }, [_vm._v(_vm._s(col.dateDescription))]), _vm._v(" "), _c('el-date-picker', {
            staticClass: "mt-5",
            staticStyle: {
              "width": "100%"
            },
            attrs: {
              "picker-options": _vm.datePickerOptions.option1,
              "type": "date",
              "placeholder": question.config.forTeacher ? 'To be edited by teacher' : 'Select date',
              "disabled": question.config.forTeacher
            },
            on: {
              "change": function($event) {
                _vm.isDirty = true;
              }
            },
            model: {
              value: (col.answer),
              callback: function($$v) {
                _vm.$set(col, "answer", $$v)
              },
              expression: "col.answer"
            }
          })], 1) : _vm._e(), _vm._v(" "), (col.type == 'checkbox') ? _c('el-col', {
            attrs: {
              "span": Math.floor(col.spans * 24)
            }
          }, [_c('span', [_c('p', {
            staticClass: "gary "
          }, [_vm._v(_vm._s(col.dateDescription))]), _vm._v(" "), _c('el-checkbox-group', {
            on: {
              "change": function($event) {
                _vm.isDirty = true;
              }
            },
            model: {
              value: (col.answer),
              callback: function($$v) {
                _vm.$set(col, "answer", $$v)
              },
              expression: "col.answer"
            }
          }, [(col.vertical) ? _vm._l((col.list), function(cb, index) {
            return _c('p', {
              key: index
            }, [_c('el-checkbox', {
              attrs: {
                "label": cb
              }
            })], 1)
          }) : _vm._l((col.list), function(cb, index) {
            return _c('el-checkbox', {
              key: index,
              attrs: {
                "label": cb,
                "disabled": question.config.forTeacher
              }
            })
          })], 2)], 1)]) : _vm._e(), _vm._v(" "), (col.type == 'radio') ? _c('el-col', {
            attrs: {
              "span": Math.floor(col.spans * 24)
            }
          }, [(col.vertical) ? _vm._l((col.list), function(lb, index) {
            return _c('p', {
              key: index
            }, [_c('el-radio', {
              staticClass: "radio mb-5",
              attrs: {
                "label": lb
              },
              on: {
                "change": function($event) {
                  _vm.isDirty = true;
                }
              },
              model: {
                value: (col.answer),
                callback: function($$v) {
                  _vm.$set(col, "answer", $$v)
                },
                expression: "col.answer"
              }
            })], 1)
          }) : _vm._l((col.list), function(lb, index) {
            return _c('el-radio', {
              key: index,
              staticClass: "radio mb-5 mt-5",
              attrs: {
                "label": lb
              },
              on: {
                "change": function($event) {
                  _vm.isDirty = true;
                }
              },
              model: {
                value: (col.answer),
                callback: function($$v) {
                  _vm.$set(col, "answer", $$v)
                },
                expression: "col.answer"
              }
            })
          })], 2) : _vm._e(), _vm._v(" "), (col.type == 'image') ? _c('el-col', {
            staticClass: "mt-5",
            attrs: {
              "span": Math.floor(col.spans * 24)
            }
          }, [_c('el-upload', {
            attrs: {
              "action": _vm.uploadUrl,
              "data": _vm.uploadFormData,
              "file-list": _vm.clonedImageList,
              "list-type": "picture",
              "accept": "image/jpeg, image/png",
              "beforeUpload": _vm.handleBeforeImageUpload,
              "on-success": function a(response, file, fileList) {
                _vm.handleUploadImageSuccess(response, file, fileList, col.answer)
              },
              "on-change": _vm.handleFileChanged,
              "on-preview": _vm.handlePictureCardPreview,
              "on-error": _vm.handleUploadError,
              "on-remove": function b(file, fileList) {
                _vm.handleImageRemove(file, fileList, col.answer)
              },
              "disabled": _vm.imageCount >= 5 || _vm.isAuthorizing
            }
          }, [_c('el-button', {
            attrs: {
              "size": "small",
              "type": "primary",
              "icon": "el-icon-upload",
              "disabled": _vm.imageCount >= 5 || _vm.isAuthorizing,
              "loading": _vm.isAuthorizing
            }
          }, [_vm._v("Upload\n                                        ")]), _vm._v(" "), _c('div', {
            staticClass: "el-upload__tip",
            attrs: {
              "slot": "tip"
            },
            slot: "tip"
          }, [_vm._v("\n                                            " + _vm._s(_vm.imageCount >= 5 ? 'You can only upload up to 5 images, please choose the best fit ones.' : '1 to 5 images, only jpg/png allowed, less than 4MB') + "\n                                        ")])], 1)], 1) : _vm._e(), _vm._v(" "), (col.type == 'pdf') ? _c('el-col', {
            staticClass: "mt-5",
            attrs: {
              "span": Math.floor(col.spans * 24)
            }
          }, [_c('el-upload', {
            attrs: {
              "action": _vm.uploadUrl,
              "data": _vm.uploadFormData,
              "file-list": _vm.clonedPDFList,
              "accept": "application/pdf",
              "beforeUpload": _vm.handleBeforePDFUpload,
              "on-success": function a(response, file, fileList) {
                _vm.handleUploadPDFSuccess(response, file, fileList, col.answer)
              },
              "on-change": _vm.handleFileChanged,
              "on-preview": _vm.handlePDFPreview,
              "on-error": _vm.handleUploadError,
              "on-remove": function b(file, fileList) {
                _vm.handlePDFRemove(file, fileList, col.answer)
              },
              "disabled": _vm.isUploading
            }
          }, [_c('el-button', {
            attrs: {
              "size": "small",
              "type": "primary",
              "icon": "el-icon-upload",
              "disabled": _vm.isUploading
            }
          }, [_vm._v("Upload")]), _vm._v(" "), _c('div', {
            staticClass: "el-upload__tip",
            attrs: {
              "slot": "tip"
            },
            slot: "tip"
          }, [_vm._v("only pdf allowed, less than 10MB")])], 1)], 1) : _vm._e()]
        })], 2)]
      }), _vm._v(" "), _c('el-row', [(question.config.more) ? _c('el-col', {
        staticClass: "mt-5",
        attrs: {
          "span": 5
        }
      }, [_c('el-button-group', [_c('el-button', {
        staticClass: "p-5",
        attrs: {
          "type": "danger",
          "size": "mini",
          "icon": "el-icon-plus"
        },
        on: {
          "click": function($event) {
            return _vm.more(question.config.list)
          }
        }
      }), _vm._v(" "), _c('el-button', {
        staticClass: "p-5",
        attrs: {
          "type": "success",
          "size": "mini",
          "icon": "el-icon-minus"
        },
        on: {
          "click": function($event) {
            return _vm.less(question.config.list)
          }
        }
      })], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.role == 'student' || _vm.role == 'ta') ? _c('el-row', [(question.commentList && question.commentList.length != 0) ? _c('el-col', {
        staticClass: "p-10 bg-lightgarg mt-5",
        attrs: {
          "span": 24
        }
      }, [(question.showCommentCount == 3 && question.commentList.length > 3) ? _c('el-button', {
        attrs: {
          "type": "text"
        },
        on: {
          "click": function($event) {
            question.showCommentCount = question.commentList.length
          }
        }
      }, [_vm._v("\n                                View " + _vm._s(question.commentList.length - _vm.showCommentCount) + " more comments\n                            ")]) : _vm._e(), _vm._v(" "), (question.showCommentCount != 3 && question.commentList.length > 3) ? _c('el-button', {
        attrs: {
          "type": "text"
        },
        on: {
          "click": function($event) {
            question.showCommentCount = 3
          }
        }
      }, [_vm._v("Hide more\n                            ")]) : _vm._e(), _vm._v(" "), _c('div', _vm._l((question.commentList), function(comment, commentIndex) {
        return _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (commentIndex > question.commentList.length - question.showCommentCount - 1),
            expression: "commentIndex > question.commentList.length-question.showCommentCount-1"
          }],
          key: commentIndex
        }, [_c('div', {
          staticClass: "commentContent dark mt-5 pb-0",
          style: (comment.highlighted ? 'background:yellow;' : ''),
          attrs: {
            "id": 'comment' + comment.id
          }
        }, [_c('span', {
          staticClass: "success"
        }, [_c('b', [_vm._v(_vm._s(comment.fromName))])]), _c('span', [_vm._v(" : " + _vm._s(comment.content))])]), _vm._v(" "), _c('div', {
          staticClass: "gary mb-2"
        }, [_vm._v(_vm._s(comment.time) + "\n                                        "), (comment.userId == _vm.currentCommentatorId) ? _c('el-button', {
          staticClass: "ml-5",
          attrs: {
            "type": "text",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.cancelComment(comment, question.commentList)
            }
          }
        }, [_vm._v("\n                                            remove\n                                        ")]) : _vm._e()], 1)])
      }), 0)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.role == 'student' || _vm.role == 'ta') ? _c('el-row', {
        staticClass: "mb-10 mt-5"
      }, [_c('el-col', {
        attrs: {
          "span": 1
        }
      }, [(!question.config.forTeacher) ? _c('el-button', {
        attrs: {
          "type": "success",
          "size": "mini"
        },
        on: {
          "click": function($event) {
            question.show = !question.show
          }
        }
      }, [_vm._v("\n                                " + _vm._s(question.show ? '    Hide     ' : 'Comment') + "\n                            ")]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (question.show),
          expression: "question.show"
        }, {
          name: "loading",
          rawName: "v-loading",
          value: (question.isSavingComment),
          expression: "question.isSavingComment"
        }],
        staticClass: "mb-10"
      }, [_c('el-col', {
        attrs: {
          "span": 20
        }
      }, [_c('el-input', {
        staticClass: "post-textarea",
        attrs: {
          "type": "textarea",
          "autofocus": "",
          "rows": 3,
          "resize": "none",
          "placeholder": "Press Ctrl + Enter to post"
        },
        on: {
          "change": _vm.checkEmoji
        },
        nativeOn: {
          "keyup": function($event) {
            return _vm.pressAction(question, question.commentList, $event)
          }
        },
        model: {
          value: (question.content),
          callback: function($$v) {
            _vm.$set(question, "content", $$v)
          },
          expression: "question.content"
        }
      })], 1), _vm._v(" "), _c('el-col', {
        attrs: {
          "span": 3
        }
      }, [_c('el-button', {
        staticClass: "comment-submit p-30",
        attrs: {
          "type": "success",
          "size": "small",
          "disabled": !question.content
        },
        on: {
          "click": function($event) {
            return _vm.saveComment(question, question.commentList)
          }
        }
      }, [_vm._v("Post\n                            ")])], 1)], 1)]
    })], 2)
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.saveAlert(function() {
          _vm.editVisible = false
        })
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saving,
      "disabled": _vm.isUploading || _vm.isDialogLoading
    },
    on: {
      "click": _vm.saveAnswer
    }
  }, [_vm._v("OK")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.picReview,
      "width": "90%",
      "customClass": "dialogWidth-1000",
      "title": "Preview",
      "modal": true
    },
    on: {
      "update:visible": function($event) {
        _vm.picReview = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })]), _vm._v(" "), _c('a', {
    ref: "pdfPreview",
    attrs: {
      "target": "_blank"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 605:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "asdan-background"
  }, [_c('common-header', {
    ref: "header"
  }), _vm._v(" "), _c('el-row', {
    staticClass: "main",
    attrs: {
      "type": "flex",
      "justify": "center",
      "id": "main"
    }
  }, [_c('el-col', {
    staticClass: "main-content mt-20 mb-20 p-20",
    attrs: {
      "span": 22
    }
  }, [
    [_c('el-tabs', {
      staticStyle: {
        "width": "100%"
      },
      on: {
        "tab-click": _vm.handleClick
      },
      model: {
        value: (_vm.activeName),
        callback: function($$v) {
          _vm.activeName = $$v
        },
        expression: "activeName"
      }
    }, _vm._l((_vm.tabLabel), function(item, index) {
      return _c('el-tab-pane', {
        key: item.name,
        attrs: {
          "label": item.title,
          "name": item.name
        }
      }, [_c('el-row', {
        staticClass: "row-bg p-10 mt-10 bg-lightgarg",
        attrs: {
          "type": "flex",
          "justify": "space-between"
        }
      }, [_c('el-col', {
        attrs: {
          "span": 5
        }
      }, [(item.role === 'teacher' || item.role === 'ta') ? _c('el-select', {
        directives: [{
          name: "loading",
          rawName: "v-loading",
          value: (_vm.loading),
          expression: "loading"
        }],
        attrs: {
          "clearable": "",
          "filterable": "",
          "placeholder": "Please Select Student",
          "element-loading-text": "loading...",
          "no-match-text": "No data",
          "no-data-text": "No data"
        },
        on: {
          "change": _vm.selectStuNoti
        },
        model: {
          value: (_vm.selectStu),
          callback: function($$v) {
            _vm.selectStu = $$v
          },
          expression: "selectStu"
        }
      }, _vm._l((_vm.stuOptions), function(stu) {
        return _c('el-option', {
          key: stu.id,
          attrs: {
            "label": stu.displayName + ' - ' + stu.givenName + ' ' + stu.familyName,
            "value": stu.id
          }
        })
      }), 1) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
        staticClass: "text-right",
        attrs: {
          "span": 19
        }
      }, [(item.role === 'teacher') ? _c('el-button', {
        staticStyle: {
          "background": "#eef1f6"
        },
        attrs: {
          "round": "",
          "disabled": item.isAllRead || _vm.isStuReadDisabled,
          "loading": _vm.studentReadLoading
        },
        on: {
          "click": _vm.whetherMarkStudent
        }
      }, [_vm._v("\n                                    Student Read\n                                ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
        staticStyle: {
          "background": "#eef1f6"
        },
        attrs: {
          "round": "",
          "disabled": item.isAllRead,
          "loading": _vm.allReadLoading
        },
        on: {
          "click": _vm.whetherMarkAll
        }
      }, [_vm._v("\n                                    All Read\n                                ")])], 1)], 1), _vm._v(" "), _c('el-table', {
        directives: [{
          name: "loading",
          rawName: "v-loading",
          value: (_vm.tableLoading),
          expression: "tableLoading"
        }],
        staticClass: "mb-50 table-pointer td-padding-small",
        staticStyle: {
          "width": "100%"
        },
        attrs: {
          "element-loading-text": "loading...",
          "data": _vm.tableData,
          "default-sort": {
            prop: 'date',
            order: this.order
          },
          "empty-text": "No data"
        },
        on: {
          "sort-change": _vm.sortList
        }
      }, [_c('el-table-column', {
        attrs: {
          "label": "Sender",
          "width": "190"
        },
        scopedSlots: _vm._u([{
          key: "default",
          fn: function(scope) {
            return [_c('span', [_vm._v(_vm._s(scope.row.fromName + ' - ' + scope.row.fromGivenName + ' ' + scope.row.fromFamilyName))])]
          }
        }], null, true)
      }), _vm._v(" "), _c('el-table-column', {
        attrs: {
          "sortable": "",
          "prop": "time",
          "label": "Date",
          "width": "170"
        }
      }), _vm._v(" "), _c('el-table-column', {
        attrs: {
          "label": "Information",
          "min-width": "400"
        },
        scopedSlots: _vm._u([{
          key: "default",
          fn: function(scope) {
            return [_c('span', {
              staticClass: "toDialog",
              on: {
                "click": function($event) {
                  return _vm.toDialog(scope.row)
                }
              }
            }, [_c('b', [_vm._v(_vm._s(scope.row.typeName))]), _vm._v("\n                                            " + _vm._s(scope.row.page) + " "), _c('span', [_vm._v(_vm._s(scope.row.templateHtml))]), _vm._v(" of\n                                            "), _c('span', [_vm._v(_vm._s(scope.row.category === 'epq' ? 'EPQ' : 'LOG'))]), _vm._v(" -\n                                            "), _c('b', [_vm._v("[ " + _vm._s(scope.row.skill) + " ]")]), _vm._v(" "), _c('span', {
              staticClass: "dark"
            }, [_vm._v(_vm._s(scope.row.type === 'comment' ? ': ' + scope.row.comment : ''))])])]
          }
        }], null, true)
      }), _vm._v(" "), _c('el-table-column', {
        attrs: {
          "label": "Actions",
          "width": "90",
          "align": "center"
        },
        scopedSlots: _vm._u([{
          key: "default",
          fn: function(scope) {
            return [_c('el-button', {
              attrs: {
                "type": "text",
                "disabled": scope.row.read === true
              },
              on: {
                "click": function($event) {
                  return _vm.setCurrentLine(scope.row)
                }
              }
            }, [_c('i', {
              staticClass: "el-icon-check",
              staticStyle: {
                "font-size": "22px",
                "font-weight": "bold"
              }
            })])]
          }
        }], null, true)
      })], 1), _vm._v(" "), _c('div', {
        staticClass: "text-center mt-20 mb-50"
      }, [_c('el-pagination', {
        attrs: {
          "layout": "prev, pager, next",
          "page-size": _vm.size,
          "current-page": _vm.currentPage,
          "page-count": _vm.totalPages
        },
        on: {
          "current-change": _vm.changeCurrentPage
        }
      })], 1)], 1)
    }), 1)]
  ], 2)], 1), _vm._v(" "), _c('skill-dialog', {
    ref: "reportDialog",
    attrs: {
      "isLineRead": this.isLineRead,
      "notificationId": this.notificationId
    },
    on: {
      "close": _vm.setCurrentLine
    }
  }), _vm._v(" "), _c('evidence-dialog', {
    ref: "evidenceDialog",
    attrs: {
      "userId": _vm.notificationUserId,
      "isLineRead": this.isLineRead,
      "notificationId": this.notificationId
    },
    on: {
      "close": _vm.setCurrentLine
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 606:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', [_c('el-col', {
    staticClass: "mt-10 mb-50",
    attrs: {
      "span": 10
    }
  }, [_c('el-card', {
    staticClass: "box-card",
    attrs: {
      "body-style": {
        minHeight: '830px'
      }
    }
  }, [_c('el-input', {
    staticClass: "mb-10",
    attrs: {
      "placeholder": !_vm.teacherId && _vm.role === 'admin' ? 'Please choose a teacher first' : _vm.searchPlaceHolder,
      "disabled": !_vm.teacherId && _vm.role === 'admin'
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleIconClickL.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.keywordsL),
      callback: function($$v) {
        _vm.keywordsL = $$v
      },
      expression: "keywordsL"
    }
  }, [_c('i', {
    staticClass: "el-input__icon el-icon-search",
    attrs: {
      "slot": "suffix"
    },
    on: {
      "click": _vm.handleIconClickL
    },
    slot: "suffix"
  })]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingL),
      expression: "loadingL"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "empty-text": (_vm.role === 'admin' && !_vm.tId) ? 'Please choose a teacher first' : 'No data',
      "data": _vm.AllStudents,
      "border": "",
      "tooltip-effect": "dark",
      "element-loading-text": "loading..."
    },
    on: {
      "selection-change": _vm.AddSelection
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": scope.row.school,
            "placement": "top-start"
          }
        }, [_c('span', [_vm._v(_vm._s(scope.row.displayName + ' - ' + scope.row.givenName + '  ' + scope.row.familyName))])])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center mt-20 mb-50"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.size,
      "current-page": _vm.currentPageL,
      "page-count": _vm.totalPagesL
    },
    on: {
      "current-change": _vm.pageCurrentChangeL
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "mb-50 actions",
    staticStyle: {
      "padding-left": "0",
      "padding-right": "0",
      "min-width": "85px"
    },
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    staticClass: "ml-5 mr-5 mb-10",
    staticStyle: {
      "padding": "4px 17px"
    },
    attrs: {
      "disabled": this.Addlist.length === 0 || _vm.addBtnIsLoading,
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.addRelation
    }
  }, [_vm._v("Add"), _c('i', {
    staticClass: "el-icon-arrow-right el-icon--right pl-10"
  })]), _vm._v(" "), _c('el-button', {
    staticClass: "pl-10 pr-10",
    staticStyle: {
      "padding": "4px 17px",
      "margin": "0 5px"
    },
    attrs: {
      "disabled": this.Removelist.length === 0 || _vm.removeBtnIsLoading,
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.removeRelation
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-left el-icon--left pr-10"
  }), _vm._v("Remove")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "mt-10 mb-50",
    attrs: {
      "span": 10
    }
  }, [_c('el-card', {
    attrs: {
      "body-style": {
        minHeight: '830px'
      }
    }
  }, [_c('el-input', {
    staticClass: "mb-10",
    attrs: {
      "placeholder": !_vm.teacherId && _vm.role === 'admin' ? 'Please choose a teacher first' : _vm.searchPlaceHolder,
      "disabled": !_vm.teacherId && _vm.role === 'admin'
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleIconClickR.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.keywordsR),
      callback: function($$v) {
        _vm.keywordsR = $$v
      },
      expression: "keywordsR"
    }
  }, [_c('i', {
    staticClass: "el-input__icon el-icon-search",
    attrs: {
      "slot": "suffix"
    },
    on: {
      "click": _vm.handleIconClickR
    },
    slot: "suffix"
  })]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingR),
      expression: "loadingR"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "empty-text": (_vm.role === 'admin' && !_vm.tId) ? 'Please choose a teacher first' : 'No data',
      "data": _vm.MyStudents,
      "border": "",
      "tooltip-effect": "dark",
      "element-loading-text": "loading...",
      "max-height": "641"
    },
    on: {
      "selection-change": _vm.RemoveSelection
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": scope.row.school,
            "placement": "top-start"
          }
        }, [_c('span', [_vm._v(_vm._s(scope.row.displayName + ' - ' + scope.row.givenName + '  ' + scope.row.familyName))])])]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "mt-20 mb-50",
    attrs: {
      "span": 2
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 607:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticClass: "breadcrumb"
  }, [_vm._v("MANAGE TEACHERS")]), _vm._v(" "), _c('el-row', {
    staticClass: "row-bg p-10 mt-10 bg-lightgarg",
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-input', {
    staticClass: "input-setMaxWidth",
    attrs: {
      "placeholder": "Search anything about users"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleIconClick.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.message),
      callback: function($$v) {
        _vm.message = $$v
      },
      expression: "message"
    }
  }, [_c('i', {
    staticClass: "el-input__icon el-icon-search",
    attrs: {
      "slot": "suffix"
    },
    on: {
      "click": _vm.handleIconClick
    },
    slot: "suffix"
  })])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-switch', {
    attrs: {
      "active-text": "Edit Enabled"
    },
    on: {
      "change": _vm.editEnabled
    },
    model: {
      value: (_vm.teacherEditEnabled),
      callback: function($$v) {
        _vm.teacherEditEnabled = $$v
      },
      expression: "teacherEditEnabled"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 16
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success",
      "icon": "el-icon-plus"
    },
    on: {
      "click": function($event) {
        _vm.Creatdialog = true
      }
    }
  }, [_vm._v("New Teacher")])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "mt-20",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "empty-text": "No data",
      "data": _vm.users,
      "border": "",
      "element-loading-text": "loading..."
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Name",
      "min-width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.displayName + ' - ' + scope.row.givenName + '  ' + scope.row.familyName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "email",
      "label": "Email",
      "min-width": "250"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "action",
      "label": "Actions",
      "width": "130",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini",
            "icon": "el-icon-edit"
          },
          on: {
            "click": function($event) {
              return _vm.EditUser(scope.row)
            }
          }
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "mini",
            "icon": "el-icon-delete"
          },
          on: {
            "click": function($event) {
              return _vm.TrashTeacher(scope.row)
            }
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center mt-20 mb-50"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.size,
      "current-page": _vm.currentPage,
      "page-count": _vm.totalPages
    },
    on: {
      "current-change": _vm.pageCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "New Teacher",
      "visible": _vm.Creatdialog,
      "customClass": "dialogStyle"
    },
    on: {
      "update:visible": function($event) {
        _vm.Creatdialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "Newform",
    attrs: {
      "model": _vm.Newform,
      "rules": _vm.Newrules,
      "label-width": "145px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Email Address",
      "prop": "Nemail"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Email Address"
    },
    model: {
      value: (_vm.Newform.Nemail),
      callback: function($$v) {
        _vm.$set(_vm.Newform, "Nemail", $$v)
      },
      expression: "Newform.Nemail"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Password",
      "prop": "Npassword"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "Password should contain 8 to 20 characters."
    },
    model: {
      value: (_vm.Newform.Npassword),
      callback: function($$v) {
        _vm.$set(_vm.Newform, "Npassword", $$v)
      },
      expression: "Newform.Npassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Confirm Password",
      "prop": "NconfirmPassword"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "Confirm Password"
    },
    model: {
      value: (_vm.Newform.NconfirmPassword),
      callback: function($$v) {
        _vm.$set(_vm.Newform, "NconfirmPassword", $$v)
      },
      expression: "Newform.NconfirmPassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Given Name",
      "prop": "NgivenName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Given Name"
    },
    model: {
      value: (_vm.Newform.NgivenName),
      callback: function($$v) {
        _vm.$set(_vm.Newform, "NgivenName", $$v)
      },
      expression: "Newform.NgivenName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Family Name",
      "prop": "NfamilyName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Family Name"
    },
    model: {
      value: (_vm.Newform.NfamilyName),
      callback: function($$v) {
        _vm.$set(_vm.Newform, "NfamilyName", $$v)
      },
      expression: "Newform.NfamilyName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Display Name",
      "prop": "NdisplayName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Display Name"
    },
    model: {
      value: (_vm.Newform.NdisplayName),
      callback: function($$v) {
        _vm.$set(_vm.Newform, "NdisplayName", $$v)
      },
      expression: "Newform.NdisplayName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Mobile Phone",
      "prop": "NmobilePhone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Mobile Phone"
    },
    model: {
      value: (_vm.Newform.NmobilePhone),
      callback: function($$v) {
        _vm.$set(_vm.Newform, "NmobilePhone", $$v)
      },
      expression: "Newform.NmobilePhone"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.Creatdialog = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.ntSaveBtnIsLoading
    },
    on: {
      "click": function($event) {
        return _vm.NewTeacher('Newform')
      }
    }
  }, [_vm._v("Save")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit User",
      "visible": _vm.Editdialog,
      "customClass": "dialogStyle"
    },
    on: {
      "update:visible": function($event) {
        _vm.Editdialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "editform",
    attrs: {
      "model": _vm.editform,
      "rules": _vm.editrules,
      "label-width": "145px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Email Address",
      "prop": "Eemail"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Email Address",
      "auto-complete": "off",
      "value": "ccccc"
    },
    model: {
      value: (_vm.editform.Eemail),
      callback: function($$v) {
        _vm.$set(_vm.editform, "Eemail", $$v)
      },
      expression: "editform.Eemail"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Change Password",
      "prop": "checked"
    }
  }, [_c('el-checkbox', {
    on: {
      "change": _vm.changePass
    },
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }, [_vm._v("Change Password")])], 1), _vm._v(" "), (_vm.willshow) ? [_c('el-form-item', {
    attrs: {
      "label": "Password",
      "prop": "Epassword"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "Password should contain 8 to 20 characters."
    },
    model: {
      value: (_vm.editform.Epassword),
      callback: function($$v) {
        _vm.$set(_vm.editform, "Epassword", $$v)
      },
      expression: "editform.Epassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Confirm Password",
      "prop": "EconfirmPassword"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "Confirm Password"
    },
    model: {
      value: (_vm.editform.EconfirmPassword),
      callback: function($$v) {
        _vm.$set(_vm.editform, "EconfirmPassword", $$v)
      },
      expression: "editform.EconfirmPassword"
    }
  })], 1)] : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Given Name",
      "prop": "EgivenName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Given Name",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editform.EgivenName),
      callback: function($$v) {
        _vm.$set(_vm.editform, "EgivenName", $$v)
      },
      expression: "editform.EgivenName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Family Name",
      "prop": "EfamilyName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Family Name",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editform.EfamilyName),
      callback: function($$v) {
        _vm.$set(_vm.editform, "EfamilyName", $$v)
      },
      expression: "editform.EfamilyName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Display Name",
      "prop": "EdisplayName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Display Name",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editform.EdisplayName),
      callback: function($$v) {
        _vm.$set(_vm.editform, "EdisplayName", $$v)
      },
      expression: "editform.EdisplayName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Mobile Phone",
      "prop": "EmobilePhone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Mobile Phone",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editform.EmobilePhone),
      callback: function($$v) {
        _vm.$set(_vm.editform, "EmobilePhone", $$v)
      },
      expression: "editform.EmobilePhone"
    }
  })], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.Editdialog = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.ctSaveBtnIsLoading
    },
    on: {
      "click": function($event) {
        return _vm.submitedit('editform')
      }
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 608:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    staticClass: "mb-10",
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('el-col', {
    staticClass: "breadcrumb",
    attrs: {
      "span": 20
    }
  }, [_c('p', {
    staticClass: "dark"
  }, [(_vm.role !== 'student') ? _c('el-tag', {
    attrs: {
      "type": "success",
      "color": "white"
    }
  }, [_vm._v(_vm._s(!_vm.studentName ? '' : _vm.studentName))]) : _vm._e(), _vm._v("\n                " + _vm._s(_vm.title) + "\n            ")], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-breadcrumb', {
    staticClass: "right breadcrumb",
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": this.$route.query.reportIndex + ((_vm.role === 'teacher' || _vm.role === 'ta') ? '?studentId=' + _vm.studentId : '')
    }
  }, [_vm._v(_vm._s(_vm.reportName))]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("Evidence")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mb-10 p-10 bg-lightgary"
  }, [_c('h4', {
    staticClass: "mb-10"
  }, [_vm._v(_vm._s(_vm.skillAbbr) + " - " + _vm._s(_vm.pageName) + " - Evidence Checklist")]), _vm._v(" "), _c('p', [_vm._v("每条证据请以PDF的格式上传，并在Description中简要描述该证据是什么。")]), _vm._v(" "), ((_vm.skillAbbr === 'IOLP' && _vm.pageName === 'Preparation/Plan') || (_vm.skillAbbr === 'PRL' && _vm.pageName === 'Preparation')) ? _c('table', [_vm._m(0), _vm._v(" "), _vm._m(1)]) : (_vm.pageName === 'Do' && (_vm.skillAbbr === 'PRL' || _vm.skillAbbr === 'IOLP')) ? _c('table', [_vm._m(2), _vm._v(" "), _vm._m(3)]) : (_vm.pageName === 'Review' && (_vm.skillAbbr === 'PRL' || _vm.skillAbbr === 'IOLP')) ? _c('table', [_vm._m(4), _vm._v(" "), _vm._m(5)]) : (_vm.pageName === 'Explore' && (_vm.skillAbbr === 'PS' || _vm.skillAbbr === 'TP')) ? _c('table', [_vm._m(6), _vm._v(" "), _vm._m(7)]) : (_vm.pageName === 'Plan/Do' && (_vm.skillAbbr === 'PS' || _vm.skillAbbr === 'TP')) ? _c('table', [_vm._m(8), _vm._v(" "), _vm._m(9)]) : (_vm.pageName === 'Review' && (_vm.skillAbbr === 'PS' || _vm.skillAbbr === 'TP')) ? _c('table', [_vm._m(10), _vm._v(" "), _vm._m(11)]) : (_vm.pageName === 'Planning' && (_vm.skillAbbr === 'R' || _vm.skillAbbr === 'RS')) ? _c('table', [_vm._m(12), _vm._v(" "), _vm._m(13)]) : (_vm.pageName === 'Carrying out the research' && (_vm.skillAbbr === 'R' || _vm.skillAbbr === 'RS')) ? _c('table', [_vm._m(14), _vm._v(" "), _vm._m(15)]) : (_vm.pageName === 'Presentation' && (_vm.skillAbbr === 'R' || _vm.skillAbbr === 'RS')) ? _c('table', [_vm._m(16), _vm._v(" "), _vm._m(17)]) : ((_vm.skillAbbr === 'WWO' && _vm.pageName === 'Preparation/Plan') || (_vm.skillAbbr === 'TW' && _vm.pageName === 'Preparation')) ? _c('table', [_vm._m(18), _vm._v(" "), _vm._m(19)]) : (_vm.pageName === 'Do' && (_vm.skillAbbr === 'WWO' || _vm.skillAbbr === 'TW')) ? _c('table', [_vm._m(20), _vm._v(" "), _vm._m(21)]) : (_vm.pageName === 'Review' && (_vm.skillAbbr === 'WWO' || _vm.skillAbbr === 'TW')) ? _c('table', [_vm._m(22), _vm._v(" "), _vm._m(23)]) : (_vm.skillAbbr === 'D') ? _c('table', [_vm._m(24), _vm._v(" "), _vm._m(25)]) : (_vm.skillAbbr === 'OP') ? _c('table', [_vm._m(26), _vm._v(" "), _vm._m(27)]) : _vm._e()]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.evidences,
      "empty-text": "No data",
      "default-expand-all": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.templateType === 1) ? _c('ul', {
          staticClass: "el-upload-list el-upload-list--picture-card"
        }, _vm._l((scope.row.answerList), function(answer, index) {
          return _c('li', {
            key: index,
            staticClass: "el-upload-list__item is-success",
            on: {
              "click": function($event) {
                return _vm.handlePictureCardPreview(answer)
              }
            }
          }, [_c('img', {
            staticClass: "el-upload-list__item-thumbnail",
            attrs: {
              "src": answer.thumb,
              "alt": ""
            }
          }), _vm._v(" "), _c('span', {
            staticClass: "el-upload-list__item-actions"
          }, [_c('span', {
            staticClass: "el-upload-list__item-preview"
          }, [_c('i', {
            staticClass: "el-icon-view"
          })])])])
        }), 0) : (scope.row.templateType === 0) ? _vm._l((scope.row.answerList), function(answer) {
          return _c('a', {
            attrs: {
              "href": answer.url,
              "target": "_blank"
            }
          }, [_c('img', {
            staticClass: "pdfIcon",
            attrs: {
              "src": __webpack_require__(588),
              "alt": ""
            }
          })])
        }) : (scope.row.templateType === 2) ? _c('a', {
          attrs: {
            "href": _vm.tryAddProtocol(scope.row.answerList.length === 0 ? '' : scope.row.answerList),
            "target": "_blank"
          }
        }, [_vm._v("\n                            " + _vm._s(scope.row.answerList.length === 0 ? '' : scope.row.answerList) + "\n                        ")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sequence",
      "label": "Seq",
      "width": "65",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "description",
      "label": "Description",
      "min-width": "125"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "templateType",
      "label": "Type",
      "min-width": "155",
      "formatter": _vm.getTemplateText
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "time",
      "label": "CreatedDate",
      "min-width": "125"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Confirmed",
      "min-width": "125"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.confirmed) ? _c('i', {
          staticClass: "el-icon-success",
          staticStyle: {
            "color": "#67C23A"
          }
        }) : _c('i', {
          staticClass: "el-icon-error",
          staticStyle: {
            "color": "#F56C6C"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Actions",
      "width": "180",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button-group', [_c('el-button', {
          staticClass: "p-5",
          attrs: {
            "type": "primary",
            "icon": "el-icon-edit",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.showDialog(scope.row.templateType, scope.$index, scope.row.confirmed)
            }
          }
        }), _vm._v(" "), _c('el-button', {
          staticClass: "p-5",
          attrs: {
            "type": "danger",
            "icon": "el-icon-delete",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.handleDeleteEvidence(scope.$index, scope.row)
            }
          }
        }), _vm._v(" "), _c('el-button', {
          staticClass: "p-5",
          attrs: {
            "type": "success",
            "icon": "el-icon-arrow-up",
            "size": "mini",
            "disabled": scope.$index == 0
          },
          on: {
            "click": function($event) {
              return _vm.handleMoveOrder(-1, scope.row.sequence, scope.row)
            }
          }
        }), _vm._v(" "), _c('el-button', {
          staticClass: "p-5",
          attrs: {
            "type": "success",
            "icon": "el-icon-arrow-down",
            "size": "mini",
            "disabled": scope.$index == _vm.evidences.length - 1
          },
          on: {
            "click": function($event) {
              return _vm.handleMoveOrder(1, scope.row.sequence, scope.row)
            }
          }
        })], 1)]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "mb-50"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-dropdown', {
    staticClass: "mt-10 mb-10",
    attrs: {
      "placement": "top-start"
    },
    on: {
      "command": _vm.addEvidence
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("\n                    Add more evidence "), _c('i', {
    staticClass: "el-icon-caret-bottom el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isBtnClick),
      expression: "isBtnClick"
    }],
    staticClass: "evidence-Dropdown",
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "0"
    }
  }, [_vm._v("PDF")]), _vm._v(" "), ((this.skillAbbr === 'TW' && this.pageName === 'Review') || (this.skillAbbr === 'WWO' && this.pageName === 'Review')) ? _c('el-dropdown-item', {
    attrs: {
      "command": "3"
    }
  }, [_vm._v("Peer/Witness statement")]) : _vm._e(), _vm._v(" "), (this.skillAbbr === 'D') ? _c('el-dropdown-item', {
    attrs: {
      "command": "4"
    }
  }, [_vm._v("Observation checklist")]) : _vm._e(), _vm._v(" "), (this.skillAbbr === 'OP') ? _c('el-dropdown-item', {
    attrs: {
      "command": "5"
    }
  }, [_vm._v("Observation checklist")]) : _vm._e(), _vm._v(" "), (this.skillAbbr === 'ISP' && this.pageName === 'Evaluating Presentation') ? _c('el-dropdown-item', {
    attrs: {
      "command": "6"
    }
  }, [_vm._v("Observation checklist")]) : _vm._e()], 1)], 1), _vm._v(" "), (this.templateName !== '') ? _c('a', {
    staticClass: "white",
    attrs: {
      "href": this.templateHref
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    }
  }, [_c('i', {
    staticClass: "icon ion-android-download"
  }), _vm._v(" " + _vm._s(_vm.templateName) + "\n                ")])], 1) : _vm._e(), _vm._v(" "), (this.templateName1 !== '') ? _c('a', {
    staticClass: "white",
    attrs: {
      "href": this.templateHref1
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    }
  }, [_c('i', {
    staticClass: "icon ion-android-download"
  }), _vm._v(" " + _vm._s(_vm.templateName1) + "\n                ")])], 1) : _vm._e(), _vm._v(" "), (_vm.role === 'teacher' || _vm.role === 'ta') ? _c('el-button', {
    attrs: {
      "type": "success",
      "plain": ""
    },
    on: {
      "click": _vm.confirmAll
    }
  }, [_vm._v("Confirm All")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('evidence-dialog', {
    ref: "evidenceDialog",
    attrs: {
      "userId": _vm.userId,
      "studentId": _vm.studentId
    },
    on: {
      "saved": _vm.getEvidences,
      "confirmed": _vm.getEvidences,
      "disapproved": _vm.getEvidences
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.picReview,
      "width": "90%",
      "customClass": "dialogWidth-1000",
      "title": "Preview",
      "modal": true
    },
    on: {
      "update:visible": function($event) {
        _vm.picReview = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })]), _vm._v(" "), _c('a', {
    ref: "pdfPreview",
    attrs: {
      "target": "_blank"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Mandatory Evidence: "), _c('span', [_vm._v("1. Action Plan(You can download Action Plan Template below);")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("必要证据："), _c('span', [_vm._v("1.个人行动计划（系统中有模板可下载：Action Plan Template）；")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Mandatory Evidence: "), _c('span', [_vm._v("1. Revised Action Plan; ")]), _c('span', [_vm._v("2. Time management Evidence")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("必要证据："), _c('span', [_vm._v("1. 修改后的个人行动计划；")]), _c('span', [_vm._v("2. 时间管理的证据，比如时间表，时间管理软件截屏等。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Mandatory Evidence: "), _c('span', [_vm._v("Result of each target")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("必要证据："), _c('span', [_vm._v("根据Plan部分的measurement确定的三个SMART Target完成结果的证据（每个目标至少1个），比如有资格的成人的反馈（如老师，教练，父母等，"), _c('span', [_vm._v("不可以是同学或朋友的反馈")]), _vm._v("），成绩单等。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Mandatory Evidence: "), _c('span', [_vm._v("Evidence of finding three options; ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("必要证据："), _c('span', [_vm._v("展示如何发现问题解决方案的证据，比如展示思考解决方案过程的思维导图（mind map），与别人讨论解决方案的记录（培训中使用的interview sheets），上网搜索解决方案的截屏或等。 ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Mandatory Evidence: "), _c('span', [_vm._v("1. Action Plan;")]), _vm._v(" "), _c('span', [_vm._v("2. Evidence showing process of problem solving.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("必要证据："), _c('span', [_vm._v("1.个人行动计划")]), _c('span', [_vm._v("2.展示三个sub-problem解决过程的证据，比如记录解决过程的视频，音频，照片，笔记等。 ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Mandatory Evidence: "), _c('span', [_vm._v("Result of each sub-problem")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("必要证据："), _c('span', [_vm._v("根据Plan部分制定的checking method确定的三个sub-problem解决结果的证据（每个sub-problem至少1个），比如有资格的成人给你的反馈（如老师，教练，父母等，"), _c('span', [_vm._v("不可以是同学或朋友的反馈")]), _vm._v("），评分表结果等。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Mandatory Evidence: "), _c('span', [_vm._v("Action Plan(You can download Action Plan Template below)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("必要证据："), _c('span', [_vm._v("个人行动计划（系统中有模板可下载：Action Plan Template）")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Mandatory Evidence: "), _c('span', [_vm._v("1. Evidence of Secondary Research; ")]), _c('span', [_vm._v("2. Evidence of Primary Research.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("必要证据："), _c('span', [_vm._v("1.展示二手调研过程的证据，如网页截屏，网页链接，读书笔记，查阅资料的整理等；")]), _c('span', [_vm._v("2.展示一手调研过程的证据，如采访照片，采访稿，调查问卷，实地考察的照片等。一共要提供使用至少三种不同调研方式的证据。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Mandatory Evidence: "), _c('span', [_vm._v("1. Evidence showing information analysis; ")]), _c('span', [_vm._v("2. Research Paper (800 English words); ")]), _c('span', [_vm._v("3. PPT; ")]), _c('span', [_vm._v("4. Feedback from others (tutors, parents and other qualified adults) to your research findings.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("必要证据："), _c('span', [_vm._v("1.展示对搜集到的信息进行分析的证据，如问卷调查结果的统计和分析图表，采访结果的整理和分析笔记等；")]), _c('span', [_vm._v("2.调研报告（不少于800英文单词）；")]), _c('span', [_vm._v("3.PPT；")]), _c('span', [_vm._v("4.别人对你调研结果，如调研报告，PPT和分析图表等的反馈，必须是有资格的成年人，如老师等的反馈。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Mandatory Evidence:"), _c('span', [_vm._v("1. Team Action Plan(You can download Team Action Plan Template below); ")]), _c('span', [_vm._v("2. Personal Action Plan(You can download Personal Action Plan Template below); ")]), _c('span', [_vm._v("3. First Team Meeting Minute; ")]), _c('span', [_vm._v("4. First Team Meeting Photos.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("必要证据："), _c('span', [_vm._v("1.团队行动计划（系统中有模板可下载：Team Action Plan Template），每个团队一份；")]), _c('span', [_vm._v("2.个人根据自己的分工制定的个人行动计划（系统中有模板可下载：Personal Action Plan Template）；")]), _c('span', [_vm._v("3.第一次团队会议记录；")]), _c('span', [_vm._v("4.第一次团队会议照片。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Mandatory Evidence: "), _c('span', [_vm._v("1. Evidence of carrying out personal action plan; ")]), _c('span', [_vm._v("2. Evidence showing personal contribution to the team; ")]), _c('span', [_vm._v("3.Second Team Meeting Minute; ")]), _c('span', [_vm._v("4. Second Team Meeting Photos.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("必要证据："), _c('span', [_vm._v("1.个人完成根据自己分工制定的个人行动计划的证据，比如负责财务管理的同学，需要提供财务预算表，每一笔开支的记录，查找并选择省钱的出行或就餐方案的网页截屏，每一笔花销的收据，制定的决算表等；")]), _c('span', [_vm._v("2.个人对团队贡献的证据，比如帮助解决团队分歧的证据，帮助团队成员完成任务的证据，充分利用团队时间的证据等；")]), _c('span', [_vm._v("3. 第二次团队会议记录；")]), _c('span', [_vm._v("4.第二次团队会议照片。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Mandatory Evidence: "), _c('span', [_vm._v("1. Team Video (at least 4 minutes);")]), _c('span', [_vm._v(" 2. Peer Statement; ")]), _c('span', [_vm._v("3. Third Team Meeting Minute and Photos (if any).")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("必要证据："), _c('span', [_vm._v("1.展示团队合作过程的视频（至少4分钟）；")]), _c('span', [_vm._v("2.一位团队成员对你团队合作中表现的评价表（系统中有模板可以下载：Peer Statement）")]), _c('span', [_vm._v("3.第三次团队会议记录及照片（如有）。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Mandatory Evidence: "), _c('span', [_vm._v("1. Prepared materials for the topic to be discussed;")]), _c('span', [_vm._v(" 2. Photos of discussion; ")]), _c('span', [_vm._v("3. Notes taken down during discussion; ")]), _c('span', [_vm._v("4. Observation Checklist from ASDAN tutor;  ")]), _c('span', [_vm._v("5. Feedback from group members in trial round of discussion.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("必要证据："), _c('span', [_vm._v("1.为讨论的主题准备的材料，比如上网搜索的相关信息的截屏或链接，查阅的资料的照片或记录的笔记；")]), _c('span', [_vm._v("2.小组讨论的照片；")]), _c('span', [_vm._v("3.讨论过程中做的笔记的照片；")]), _c('span', [_vm._v("4.ASDAN老师对你讨论过程中表现的评价表；")]), _c('span', [_vm._v("5.模拟讨论时同学给你的反馈。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Mandatory Evidence: "), _c('span', [_vm._v("1.PPT; ")]), _c('span', [_vm._v("2.Notes for presentation; ")]), _c('span', [_vm._v("3.Practice photos or videos; ")]), _c('span', [_vm._v("4. Other preparations for presentation; ")]), _c('span', [_vm._v("5.Observation Checklist from ASDAN Tutor; ")]), _c('span', [_vm._v("6. Feedback from group members in presentation practice.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("必要证据："), _c('span', [_vm._v("1.Research技能中做的PPT；")]), _c('span', [_vm._v("2.在演讲中给自己提词的笔记，演讲结构纲要等；")]), _c('span', [_vm._v("3. 做演讲练习时的照片或视频；")]), _c('span', [_vm._v("4.为演讲做的其他准备，比如学习名人演讲所看的网上视频的截屏，在网上查找的演讲技巧的笔记照片等；")]), _c('span', [_vm._v("5.ASDAN老师对你演讲过程中表现的评价表；")]), _c('span', [_vm._v("6.模拟演讲/演讲练习时同学给你的反馈。")])])])
}]}

/***/ }),

/***/ 609:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticClass: "breadcrumb"
  }, [_vm._v("MANAGE BIN")]), _vm._v(" "), _c('el-row', {
    staticClass: "row-bg p-10 mt-10 bg-lightgarg"
  }, [_c('el-col', {
    staticClass: "mr-10",
    attrs: {
      "span": 5
    }
  }, [_c('el-select', {
    staticClass: "select-bg-s",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "User Type",
      "no-match-text": "No data",
      "no-data-text": "No data"
    },
    on: {
      "change": _vm.getselectlist
    },
    model: {
      value: (_vm.selectUsertype),
      callback: function($$v) {
        _vm.selectUsertype = $$v
      },
      expression: "selectUsertype"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    staticClass: "input-setMaxWidth",
    attrs: {
      "placeholder": "Search anything about users"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleIconClick.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.message),
      callback: function($$v) {
        _vm.message = $$v
      },
      expression: "message"
    }
  }, [_c('i', {
    staticClass: "el-input__icon el-icon-search",
    attrs: {
      "slot": "suffix"
    },
    on: {
      "click": _vm.handleIconClick
    },
    slot: "suffix"
  })])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "mt-20",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.users,
      "element-loading-text": "loading...",
      "empty-text": "No data",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.displayName + ' - ' + scope.row.givenName + '  ' + scope.row.familyName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "action",
      "label": "Actions",
      "width": "130",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.restoreUser(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "icon ion-refresh"
        })]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "mini",
            "icon": "el-icon-delete"
          },
          on: {
            "click": function($event) {
              return _vm.RemoveUser(scope.row)
            }
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center mt-20 mb-50"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.size,
      "current-page": _vm.currentPage,
      "page-count": _vm.totalPages
    },
    on: {
      "current-change": _vm.pageCurrentChange
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 610:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-container"
  }, [_c('div', {
    staticClass: "info p-40 pt-30"
  }, [_c('i', {
    staticClass: "ion ion-heart-broken"
  }), _vm._v(" "), _c('h1', {
    staticClass: "mb-5"
  }, [_vm._v("404 page not found")]), _vm._v(" "), _c('p', {
    staticClass: "mb-5"
  }, [_vm._v("We couldn't find the page you are looking for. ")]), _vm._v(" "), _c('p', [_vm._v("You can browse our "), _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("homepage")]), _vm._v(" or use the navigation bar above.")], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 611:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 612:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticClass: "breadcrumb"
  }, [_vm._v("MANAGE RELATIONS")]), _vm._v(" "), _c('el-row', {
    staticClass: "row-bg p-10 mt-10 bg-lightgarg",
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('el-col', {
    staticClass: "mr-10",
    staticStyle: {
      "min-width": "232px"
    },
    attrs: {
      "span": 5
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "Please choose a teacher first",
      "no-match-text": "No data",
      "no-data-text": "No data"
    },
    on: {
      "change": _vm.changeTeacherId
    },
    model: {
      value: (_vm.selectTeacherValue),
      callback: function($$v) {
        _vm.selectTeacherValue = $$v
      },
      expression: "selectTeacherValue"
    }
  }, _vm._l((_vm.teachers), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.displayName + ' - ' + item.givenName + ' ' + item.familyName,
        "value": item.displayName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-select', {
    staticClass: "input-setMaxWidth select-bg-s",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "placeholder": "Trip",
      "disabled": !_vm.selectTeacherValue,
      "no-match-text": "No data",
      "no-data-text": "No data"
    },
    model: {
      value: (_vm.selecttripvalue),
      callback: function($$v) {
        _vm.selecttripvalue = $$v
      },
      expression: "selecttripvalue"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  })], 1), _vm._v(" "), _c('transfer-box', {
    attrs: {
      "selecttripvalue": _vm.selecttripvalue,
      "t-id": _vm.teacherId
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 613:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": _vm.currentSkill.name,
      "customClass": "dialogWidth-1000",
      "width": "90%",
      "visible": _vm.skilldialog,
      "close-on-click-modal": false,
      "before-close": _vm.saveAlert,
      "close-on-press-escape": false
    },
    on: {
      "update:visible": function($event) {
        _vm.skilldialog = $event
      },
      "close": _vm.closeDialog
    }
  }, [_c('el-row', {
    staticClass: "pb-20"
  }, [_c('el-col', {
    staticClass: "text-center p-10 bg-lightgarg",
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "el-col-20 el-col-offset-2"
  }, _vm._l((_vm.currentSkill.pageList), function(page, pageIndex) {
    return _c('span', {
      key: page.id
    }, [_c('el-button', {
      style: (page.page == _vm.currentPage ? 'text-decoration:underline; color:#13CE66' : ''),
      attrs: {
        "disabled": _vm.isDialogLoading,
        "type": "text"
      },
      on: {
        "click": function($event) {
          return _vm.showNextPage(_vm.currentSkill, page.page, page.id)
        }
      }
    }, [_c('b', [_vm._v(_vm._s(page.page))])]), _vm._v("  "), (pageIndex != (_vm.currentSkill.pageList.length - 1)) ? _c('i', {
      staticClass: "el-icon-caret-right"
    }) : _vm._e(), _vm._v("  \n                                ")], 1)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "owner"
  }, [_c('el-tag', {
    attrs: {
      "color": "white",
      "type": "success"
    }
  }, [_vm._v("owner: "), _c('b', [_vm._v(_vm._s(_vm.displayName))])])], 1)], 1), _vm._v(" "), (_vm.role == 'teacher' && _vm.pageLock) ? _c('el-main', {
    staticClass: "mb-20",
    staticStyle: {
      "border": "2px solid #dddddd",
      "text-align": "center"
    }
  }, [_c('span', [_vm._v("Locked: ")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#dddddd"
    },
    on: {
      "change": function($event) {
        return _vm.switchLock(_vm.lock)
      }
    },
    model: {
      value: (_vm.lock),
      callback: function($$v) {
        _vm.lock = $$v
      },
      expression: "lock"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isDialogLoading),
      expression: "isDialogLoading"
    }]
  }, _vm._l((_vm.questions), function(questionGroup, index) {
    return _c('el-card', {
      key: index,
      staticClass: "mb-20"
    }, [_vm._l((questionGroup), function(question) {
      return [_c('el-row', [_c('el-col', [_c('el-tooltip', {
        staticClass: "mb-2 mt-5",
        attrs: {
          "effect": "dark",
          "placement": "bottom",
          "disabled": question.guidance == null
        }
      }, [_c('div', {
        staticStyle: {
          "max-width": "1000px"
        },
        attrs: {
          "slot": "content"
        },
        domProps: {
          "innerHTML": _vm._s(question.guidance)
        },
        slot: "content"
      }), _vm._v(" "), _c('div', {
        staticClass: "inlineBlock"
      }, [_c('h4', {
        style: (question.highlighted ? 'background:yellow;' : ''),
        attrs: {
          "id": 'question' + question.id
        }
      }, [_c('el-tag', {
        attrs: {
          "type": "info",
          "size": "mini"
        }
      }, [_vm._v(_vm._s(question.sequence))]), _vm._v("\n                                            " + _vm._s(question.title) + "\n                                        ")], 1)])]), _vm._v(" "), ((_vm.role == 'teacher' || _vm.role == 'ta') && !question.confirmed) ? _c('el-button', {
        attrs: {
          "type": "primary",
          "size": "mini",
          "disabled": !question.canBeConfirm,
          "loading": question.isConfirmLoading
        },
        on: {
          "click": function($event) {
            return _vm.confirm(question)
          }
        }
      }, [_vm._v("confirm")]) : _vm._e(), _vm._v(" "), (_vm.role == 'student' && question.confirmed && !question.config.forTeacher) ? _c('el-tag', {
        attrs: {
          "type": "primary",
          "color": "white"
        }
      }, [_vm._v("confirmed")]) : _vm._e(), _vm._v(" "), ((_vm.role == 'teacher' || _vm.role == 'ta') && question.confirmed) ? _c('el-button', {
        attrs: {
          "type": "danger",
          "size": "mini",
          "loading": question.isDisapproveLoading
        },
        on: {
          "click": function($event) {
            return _vm.disapprove(question)
          }
        }
      }, [_vm._v("disapprove")]) : _vm._e()], 1)], 1), _vm._v(" "), (question.config.type == 'table') ? [_c('el-row', [_c('el-col', {
        staticClass: "mt-5"
      }, [_c('el-table', {
        class: ("drag" + index),
        attrs: {
          "data": question.config.list,
          "row-key": "id"
        }
      }, _vm._l((question.config.title), function(cell, index) {
        return _c('el-table-column', {
          key: index,
          attrs: {
            "label": cell,
            "width": question.config.width === undefined ? '' : question.config.width[index]
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.list && scope.row.list[index].type == 'tableDate') ? _c('el-date-picker', {
                staticClass: "mt-5 mb-5",
                staticStyle: {
                  "width": "100%"
                },
                attrs: {
                  "format": "yyyy-MM-dd",
                  "picker-options": _vm.datepickerOptions.option1,
                  "type": "date",
                  "disabled": _vm.lock || (_vm.role != 'teacher' && _vm.role !== 'ta') && question.config.forTeacher,
                  "title": _vm.disabledTips,
                  "placeholder": "Select date"
                },
                on: {
                  "change": function($event) {
                    _vm.isDirty = true;
                  }
                },
                model: {
                  value: (scope.row.list[index].answer),
                  callback: function($$v) {
                    _vm.$set(scope.row.list[index], "answer", $$v)
                  },
                  expression: "scope.row.list[index].answer"
                }
              }) : _vm._e(), _vm._v(" "), (scope.row.list && scope.row.list[index].type == 'tableInput') ? _c('el-input', {
                staticClass: "mt-5 mb-5",
                attrs: {
                  "type": "textarea",
                  "disabled": _vm.lock || (_vm.role != 'teacher' && _vm.role !== 'ta') && question.config.forTeacher,
                  "title": _vm.disabledTips,
                  "rows": scope.row.list[index].rows
                },
                on: {
                  "change": _vm.checkQuestionInput
                },
                model: {
                  value: (scope.row.list[index].answer),
                  callback: function($$v) {
                    _vm.$set(scope.row.list[index], "answer", $$v)
                  },
                  expression: "scope.row.list[index].answer"
                }
              }) : _vm._e()]
            }
          }], null, true)
        })
      }), 1)], 1)], 1)] : _vm._e(), _vm._v(" "), _vm._l((question.config.list), function(row, index) {
        return [_c('el-row', {
          attrs: {
            "gutter": 20
          }
        }, [_vm._l((row), function(col, index) {
          return [(col.type == 'input') ? _c('el-col', {
            attrs: {
              "span": col.spans * 24
            }
          }, [_c('p', {
            staticClass: "gary mb-5"
          }, [_vm._v(_vm._s(col.description))]), _vm._v(" "), _c('el-form-item', {
            ref: "col",
            refInFor: true,
            staticClass: "mb-none",
            attrs: {
              "prop": "answer"
            }
          }, [_c('el-input', {
            attrs: {
              "type": "textarea",
              "rows": col.rows,
              "title": _vm.disabledTips,
              "placeholder": (_vm.role != 'teacher' && _vm.role !== 'ta') && question.config.forTeacher ? 'To be edited by teacher' : '',
              "disabled": _vm.lock || (_vm.role != 'teacher' && _vm.role !== 'ta') && question.config.forTeacher
            },
            on: {
              "change": _vm.checkQuestionInput
            },
            model: {
              value: (col.answer),
              callback: function($$v) {
                _vm.$set(col, "answer", $$v)
              },
              expression: "col.answer"
            }
          })], 1)], 1) : _vm._e(), _vm._v(" "), (col.type == 'text') ? _c('el-col', {
            attrs: {
              "span": col.spans * 24,
              "disabled": true
            }
          }, [_c('p', {
            staticClass: "gary mb-5"
          }, [_vm._v(_vm._s(col.description))]), _vm._v(" "), _c('el-form-item', {
            staticClass: "mb-none",
            attrs: {
              "prop": "answer"
            }
          }, [_c('el-input', {
            attrs: {
              "type": "text",
              "rows": col.rows,
              "title": _vm.disabledTips,
              "placeholder": (_vm.role != 'teacher' && _vm.role !== 'ta') && question.config.forTeacher ? 'To be edited by teacher' : '',
              "disabled": _vm.lock || (_vm.role != 'teacher' && _vm.role !== 'ta') && question.config.forTeacher
            },
            on: {
              "change": _vm.checkQuestionInput
            },
            model: {
              value: (col.answer),
              callback: function($$v) {
                _vm.$set(col, "answer", $$v)
              },
              expression: "col.answer"
            }
          })], 1)], 1) : _vm._e(), _vm._v(" "), (col.type == 'datetime') ? _c('el-col', {
            attrs: {
              "span": col.spans * 24
            }
          }, [_c('p', {
            staticClass: "gary  mt-5"
          }, [_vm._v(_vm._s(col.dateDescription))]), _vm._v(" "), _c('el-date-picker', {
            staticClass: "mt-5",
            staticStyle: {
              "width": "100%"
            },
            attrs: {
              "format": "yyyy-MM-dd",
              "picker-options": _vm.datepickerOptions.option1,
              "type": "date",
              "title": _vm.disabledTips,
              "placeholder": (_vm.role != 'teacher' && _vm.role !== 'ta') && question.config.forTeacher ? 'To be edited by teacher' : 'Select date',
              "disabled": _vm.lock || (_vm.role != 'teacher' && _vm.role !== 'ta') && question.config.forTeacher
            },
            on: {
              "change": function($event) {
                _vm.isDirty = true;
              }
            },
            model: {
              value: (col.date),
              callback: function($$v) {
                _vm.$set(col, "date", $$v)
              },
              expression: "col.date"
            }
          }), _vm._v(" "), _c('p', {
            staticClass: "gary mt-5"
          }, [_vm._v(_vm._s(col.timeDescription))]), _vm._v(" "), _c('el-time-picker', {
            staticClass: "mt-5",
            staticStyle: {
              "width": "100%"
            },
            attrs: {
              "format": "HH:mm:ss",
              "title": _vm.disabledTips,
              "placeholder": (_vm.role != 'teacher' && _vm.role !== 'ta') && question.config.forTeacher ? 'To be edited by teacher' : 'Select time',
              "disabled": _vm.lock || (_vm.role != 'teacher' && _vm.role !== 'ta') && question.config.forTeacher
            },
            on: {
              "change": function($event) {
                _vm.isDirty = true;
              }
            },
            model: {
              value: (col.time),
              callback: function($$v) {
                _vm.$set(col, "time", $$v)
              },
              expression: "col.time"
            }
          })], 1) : _vm._e(), _vm._v(" "), (col.type == 'date') ? _c('el-col', {
            attrs: {
              "span": col.spans * 24
            }
          }, [_c('p', {
            staticClass: "gary "
          }, [_vm._v(_vm._s(col.dateDescription))]), _vm._v(" "), _c('el-date-picker', {
            staticClass: "mt-5",
            staticStyle: {
              "width": "100%"
            },
            attrs: {
              "format": "yyyy-MM-dd",
              "picker-options": _vm.datepickerOptions.option1,
              "type": "date",
              "title": _vm.disabledTips,
              "placeholder": (_vm.role != 'teacher' && _vm.role !== 'ta') && question.config.forTeacher ? 'To be edited by teacher' : 'Select date',
              "disabled": _vm.lock || (_vm.role != 'teacher' && _vm.role !== 'ta') && question.config.forTeacher
            },
            on: {
              "change": function($event) {
                _vm.isDirty = true;
              }
            },
            model: {
              value: (col.answer),
              callback: function($$v) {
                _vm.$set(col, "answer", $$v)
              },
              expression: "col.answer"
            }
          })], 1) : _vm._e(), _vm._v(" "), (col.type == 'checkbox') ? _c('el-col', {
            attrs: {
              "span": col.spans * 24
            }
          }, [_c('span', [_c('p', {
            staticClass: "gary "
          }, [_vm._v(_vm._s(col.description))]), _vm._v(" "), _c('el-checkbox-group', {
            staticStyle: {
              "vertical-align": "middle"
            },
            on: {
              "change": function($event) {
                _vm.isDirty = true;
              }
            },
            model: {
              value: (col.answer),
              callback: function($$v) {
                _vm.$set(col, "answer", $$v)
              },
              expression: "col.answer"
            }
          }, [(col.vertical) ? _vm._l((col.list), function(cb, index) {
            return _c('p', {
              key: index
            }, [_c('el-checkbox', {
              key: index,
              attrs: {
                "label": cb,
                "title": _vm.disabledTips,
                "disabled": _vm.lock || (_vm.role != 'teacher' && _vm.role !== 'ta') && question.config.forTeacher
              }
            }, [_c('span', {
              staticStyle: {
                "white-space": "normal",
                "word-wrap": "break-word",
                "vertical-align": "top",
                "display": "inline-block"
              }
            }, [_vm._v(_vm._s(cb))])])], 1)
          }) : _vm._l((col.list), function(cb, index) {
            return _c('el-checkbox', {
              key: index,
              attrs: {
                "label": cb,
                "title": _vm.disabledTips,
                "disabled": _vm.lock || (_vm.role != 'teacher' && _vm.role !== 'ta') && question.config.forTeacher
              }
            })
          })], 2)], 1)]) : _vm._e(), _vm._v(" "), (col.type == 'radio') ? _c('el-col', {
            attrs: {
              "span": Math.floor(col.spans * 24)
            }
          }, [_c('span', [_c('p', {
            staticClass: "gary "
          }, [_vm._v(_vm._s(col.description))]), _vm._v(" "), (col.vertical) ? _vm._l((col.list), function(lb, index) {
            return _c('p', {
              key: index
            }, [_c('el-radio', {
              staticClass: "radio mb-5",
              attrs: {
                "disabled": _vm.lock || (_vm.role != 'teacher' && _vm.role !== 'ta') && question.config.forTeacher,
                "label": lb
              },
              on: {
                "change": function($event) {
                  _vm.isDirty = true;
                }
              },
              model: {
                value: (col.answer),
                callback: function($$v) {
                  _vm.$set(col, "answer", $$v)
                },
                expression: "col.answer"
              }
            })], 1)
          }) : _vm._l((col.list), function(lb, index) {
            return _c('el-radio', {
              key: index,
              staticClass: "radio mb-5 mt-5",
              attrs: {
                "label": lb,
                "disabled": _vm.lock || (_vm.role != 'teacher' && _vm.role !== 'ta') && question.config.forTeacher
              },
              on: {
                "change": function($event) {
                  _vm.isDirty = true;
                }
              },
              model: {
                value: (col.answer),
                callback: function($$v) {
                  _vm.$set(col, "answer", $$v)
                },
                expression: "col.answer"
              }
            })
          })], 2)]) : _vm._e()]
        })], 2)]
      }), _vm._v(" "), _c('el-row', [(question.config.more) ? _c('el-col', {
        staticClass: " mt-5",
        attrs: {
          "span": 5
        }
      }, [_c('el-button-group', [_c('el-button', {
        staticClass: "p-5",
        attrs: {
          "type": "danger",
          "disabled": _vm.lock,
          "size": "mini",
          "icon": "el-icon-plus"
        },
        on: {
          "click": function($event) {
            return _vm.more(question.config.list)
          }
        }
      }), _vm._v(" "), _c('el-button', {
        staticClass: "p-5",
        attrs: {
          "type": "success",
          "disabled": _vm.lock,
          "size": "mini",
          "icon": "el-icon-minus"
        },
        on: {
          "click": function($event) {
            return _vm.less(question.config.list)
          }
        }
      })], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.role == 'ta' || _vm.role == 'student') ? _c('el-row', [(question.commentList && question.commentList.length != 0) ? _c('el-col', {
        staticClass: "p-10 bg-lightgarg mt-5",
        attrs: {
          "span": 24
        }
      }, [(question.showCommentCount == 3 && question.commentList.length > 3) ? _c('el-button', {
        attrs: {
          "type": "text"
        },
        on: {
          "click": function($event) {
            question.showCommentCount = question.commentList.length
          }
        }
      }, [_vm._v("View " + _vm._s(question.commentList.length - _vm.showCommentCount) + " more comments")]) : _vm._e(), _vm._v(" "), (question.showCommentCount != 3 && question.commentList.length > 3) ? _c('el-button', {
        attrs: {
          "type": "text"
        },
        on: {
          "click": function($event) {
            question.showCommentCount = 3
          }
        }
      }, [_vm._v("Hide more")]) : _vm._e(), _vm._v(" "), _c('div', _vm._l((question.commentList), function(comment, commentIndex) {
        return _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (commentIndex > question.commentList.length - question.showCommentCount - 1),
            expression: "commentIndex > question.commentList.length-question.showCommentCount-1"
          }],
          key: commentIndex
        }, [_c('div', {
          staticClass: "dark  mt-5 commentContent",
          style: (comment.highlighted ? 'background:yellow;' : ''),
          attrs: {
            "id": 'comment' + comment.id
          }
        }, [_c('span', {
          staticClass: "success"
        }, [_c('b', [_vm._v(_vm._s(comment.fromName))])]), _vm._v(" : " + _vm._s(comment.content))]), _vm._v(" "), _c('div', {
          staticClass: "gary mb-2"
        }, [_vm._v(_vm._s(comment.time)), (comment.userId == _vm.userId) ? _c('el-button', {
          staticClass: "ml-5",
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.cancelComment(comment, question.commentList)
            }
          }
        }, [_vm._v("remove")]) : _vm._e()], 1)])
      }), 0)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.role == 'ta' || _vm.role == 'student') ? _c('el-row', {
        staticClass: "mb-10 mt-5"
      }, [_c('el-col', {
        attrs: {
          "span": 1
        }
      }, [(!question.config.forTeacher) ? _c('el-button', {
        attrs: {
          "type": "success",
          "size": "mini"
        },
        on: {
          "click": function($event) {
            question.show = !question.show
          }
        }
      }, [_vm._v(_vm._s(question.show ? '    Hide     ' : 'Comment'))]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (question.show),
          expression: "question.show"
        }, {
          name: "loading",
          rawName: "v-loading",
          value: (question.isSavingComment),
          expression: "question.isSavingComment"
        }],
        staticClass: "mb-10"
      }, [_c('el-col', {
        attrs: {
          "span": 20
        }
      }, [_c('el-input', {
        staticClass: "post-textarea",
        attrs: {
          "type": "textarea",
          "placeholder": "Press Ctrl + Enter to post",
          "rows": 3,
          "autofocus": "",
          "resize": "none"
        },
        on: {
          "change": _vm.checkEmoji
        },
        nativeOn: {
          "keyup": function($event) {
            return _vm.pressAction(question, question.commentList, $event)
          }
        },
        model: {
          value: (question.content),
          callback: function($$v) {
            _vm.$set(question, "content", $$v)
          },
          expression: "question.content"
        }
      })], 1), _vm._v(" "), _c('el-col', {
        attrs: {
          "span": 3
        }
      }, [_c('el-button', {
        staticClass: "comment-submit pt-30 pb-30 pl-30 pr-30",
        attrs: {
          "type": "success",
          "disabled": !question.content,
          "size": "small"
        },
        on: {
          "click": function($event) {
            return _vm.saveComment(question, question.commentList)
          }
        }
      }, [_vm._v("Post")])], 1)], 1)]
    })], 2)
  }), 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.skilldialog && !_vm.isDialogLoading),
      expression: "this.skilldialog && !isDialogLoading"
    }],
    staticClass: "fixedFooter"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.saveAlert(function() {
          _vm.skilldialog = false
        })
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saving
    },
    on: {
      "click": function($event) {
        return _vm.saveAnswer()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), (_vm.nextPage != '') ? _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.showNextPage(_vm.currentSkill, _vm.nextPage.page, _vm.nextPage.id)
      }
    }
  }, [_vm._v("Next")]) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "是否保存当前修改",
      "visible": _vm.leaveDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.leaveDialog = $event
      }
    }
  }, [_c('span', [_vm._v("如果不保存，您更改的内容将会丢失。"), _c('br'), _vm._v("Changes you made may not be saved."), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.leaveDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "plain": true,
      "type": "danger"
    },
    on: {
      "click": _vm.unSaveAction
    }
  }, [_vm._v("Don't save")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saving
    },
    on: {
      "click": _vm.saveAction
    }
  }, [_vm._v("Save")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 614:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticClass: "breadcrumb"
  }, [_vm._v("MANAGE TEACHERS")]), _vm._v(" "), _c('el-row', {
    staticClass: "row-bg p-10 mt-10 bg-lightgarg",
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    staticClass: "input-setMaxWidth",
    attrs: {
      "placeholder": "Search anything about users"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleIconClick.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.message),
      callback: function($$v) {
        _vm.message = $$v
      },
      expression: "message"
    }
  }, [_c('i', {
    staticClass: "el-input__icon el-icon-search",
    attrs: {
      "slot": "suffix"
    },
    on: {
      "click": _vm.handleIconClick
    },
    slot: "suffix"
  })])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 16
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success",
      "icon": "el-icon-plus"
    },
    on: {
      "click": function($event) {
        _vm.Creatdialog = true
      }
    }
  }, [_vm._v("New Teacher")])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "mt-20",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "empty-text": "No data",
      "data": _vm.users,
      "border": "",
      "element-loading-text": "loading..."
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Name",
      "min-width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.displayName + ' - ' + scope.row.givenName + '  ' + scope.row.familyName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "email",
      "label": "Email",
      "min-width": "250"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "action",
      "label": "Actions",
      "width": "130",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini",
            "icon": "el-icon-edit"
          },
          on: {
            "click": function($event) {
              return _vm.EditUser(scope.row)
            }
          }
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "mini",
            "icon": "el-icon-delete"
          },
          on: {
            "click": function($event) {
              return _vm.TrashTeacher(scope.row)
            }
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center mt-20 mb-50"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.size,
      "current-page": _vm.currentPage,
      "page-count": _vm.totalPages
    },
    on: {
      "current-change": _vm.pageCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "New Teacher",
      "visible": _vm.Creatdialog,
      "customClass": "dialogStyle"
    },
    on: {
      "update:visible": function($event) {
        _vm.Creatdialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "Newform",
    attrs: {
      "model": _vm.Newform,
      "rules": _vm.Newrules,
      "label-width": "145px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Email Address",
      "prop": "Nemail"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Email Address"
    },
    model: {
      value: (_vm.Newform.Nemail),
      callback: function($$v) {
        _vm.$set(_vm.Newform, "Nemail", $$v)
      },
      expression: "Newform.Nemail"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Password",
      "prop": "Npassword"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "Password should contain 8 to 20 characters."
    },
    model: {
      value: (_vm.Newform.Npassword),
      callback: function($$v) {
        _vm.$set(_vm.Newform, "Npassword", $$v)
      },
      expression: "Newform.Npassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Confirm Password",
      "prop": "NconfirmPassword"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "Confirm Password"
    },
    model: {
      value: (_vm.Newform.NconfirmPassword),
      callback: function($$v) {
        _vm.$set(_vm.Newform, "NconfirmPassword", $$v)
      },
      expression: "Newform.NconfirmPassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Given Name",
      "prop": "NgivenName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Given Name"
    },
    model: {
      value: (_vm.Newform.NgivenName),
      callback: function($$v) {
        _vm.$set(_vm.Newform, "NgivenName", $$v)
      },
      expression: "Newform.NgivenName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Family Name",
      "prop": "NfamilyName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Family Name"
    },
    model: {
      value: (_vm.Newform.NfamilyName),
      callback: function($$v) {
        _vm.$set(_vm.Newform, "NfamilyName", $$v)
      },
      expression: "Newform.NfamilyName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Display Name",
      "prop": "NdisplayName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Display Name"
    },
    model: {
      value: (_vm.Newform.NdisplayName),
      callback: function($$v) {
        _vm.$set(_vm.Newform, "NdisplayName", $$v)
      },
      expression: "Newform.NdisplayName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Mobile Phone",
      "prop": "NmobilePhone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Mobile Phone"
    },
    model: {
      value: (_vm.Newform.NmobilePhone),
      callback: function($$v) {
        _vm.$set(_vm.Newform, "NmobilePhone", $$v)
      },
      expression: "Newform.NmobilePhone"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.Creatdialog = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.ntSaveBtnIsLoading
    },
    on: {
      "click": function($event) {
        return _vm.NewTeacher('Newform')
      }
    }
  }, [_vm._v("Save")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit User",
      "visible": _vm.Editdialog,
      "customClass": "dialogStyle"
    },
    on: {
      "update:visible": function($event) {
        _vm.Editdialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "editform",
    attrs: {
      "model": _vm.editform,
      "rules": _vm.editrules,
      "label-width": "145px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Email Address",
      "prop": "Eemail"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Email Address",
      "auto-complete": "off",
      "value": "ccccc"
    },
    model: {
      value: (_vm.editform.Eemail),
      callback: function($$v) {
        _vm.$set(_vm.editform, "Eemail", $$v)
      },
      expression: "editform.Eemail"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Change Password",
      "prop": "checked"
    }
  }, [_c('el-checkbox', {
    on: {
      "change": _vm.changePass
    },
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }, [_vm._v("Change Password")])], 1), _vm._v(" "), (_vm.willshow) ? [_c('el-form-item', {
    attrs: {
      "label": "Password",
      "prop": "Epassword"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "Password should contain 8 to 20 characters."
    },
    model: {
      value: (_vm.editform.Epassword),
      callback: function($$v) {
        _vm.$set(_vm.editform, "Epassword", $$v)
      },
      expression: "editform.Epassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Confirm Password",
      "prop": "EconfirmPassword"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "Confirm Password"
    },
    model: {
      value: (_vm.editform.EconfirmPassword),
      callback: function($$v) {
        _vm.$set(_vm.editform, "EconfirmPassword", $$v)
      },
      expression: "editform.EconfirmPassword"
    }
  })], 1)] : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Given Name",
      "prop": "EgivenName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Given Name",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editform.EgivenName),
      callback: function($$v) {
        _vm.$set(_vm.editform, "EgivenName", $$v)
      },
      expression: "editform.EgivenName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Family Name",
      "prop": "EfamilyName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Family Name",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editform.EfamilyName),
      callback: function($$v) {
        _vm.$set(_vm.editform, "EfamilyName", $$v)
      },
      expression: "editform.EfamilyName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Display Name",
      "prop": "EdisplayName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Display Name",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editform.EdisplayName),
      callback: function($$v) {
        _vm.$set(_vm.editform, "EdisplayName", $$v)
      },
      expression: "editform.EdisplayName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Mobile Phone",
      "prop": "EmobilePhone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Mobile Phone",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editform.EmobilePhone),
      callback: function($$v) {
        _vm.$set(_vm.editform, "EmobilePhone", $$v)
      },
      expression: "editform.EmobilePhone"
    }
  })], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.Editdialog = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.ctSaveBtnIsLoading
    },
    on: {
      "click": function($event) {
        return _vm.submitedit('editform')
      }
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 615:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticClass: "breadcrumb"
  }, [_vm._v("MANAGE STUDENTS")]), _vm._v(" "), _c('el-row', {
    staticClass: "row-bg p-10 mt-10 bg-lightgarg",
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('el-col', {
    staticClass: "mr-10",
    attrs: {
      "span": 5
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "no-match-text": "No data",
      "noDataText": "No data",
      "clearable": "",
      "placeholder": "Trip"
    },
    on: {
      "change": _vm.getselectlist
    },
    model: {
      value: (_vm.selecttripvalue),
      callback: function($$v) {
        _vm.selecttripvalue = $$v
      },
      expression: "selecttripvalue"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    staticClass: "input-setMaxWidth",
    attrs: {
      "placeholder": "Search anything about users"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleIconClick.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.message),
      callback: function($$v) {
        _vm.message = $$v
      },
      expression: "message"
    }
  }, [_c('i', {
    staticClass: "el-input__icon el-icon-search",
    attrs: {
      "slot": "suffix"
    },
    on: {
      "click": _vm.handleIconClick
    },
    slot: "suffix"
  })])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 11
    }
  }, [_c('div', {
    staticClass: "grid-content"
  }, [_c('a', {
    staticClass: "white",
    attrs: {
      "href": _vm.templateUrl
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_c('i', {
    staticClass: "icon ion-android-download"
  }), _vm._v(" Template")])], 1), _vm._v(" "), _c('el-upload', {
    staticClass: "upload",
    attrs: {
      "accept": ".xlsx",
      "show-file-list": false,
      "action": "/api/student/import",
      "on-success": _vm.importStudent,
      "on-error": _vm.failUpload,
      "before-upload": _vm.beforeUpload
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    }
  }, [_c('i', {
    staticClass: "icon ion-android-upload"
  }), _vm._v(" Import")])], 1)], 1)])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "mt-20",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "empty-text": "No data",
      "data": _vm.users,
      "border": "",
      "element-loading-text": "loading..."
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Name",
      "width": "210"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.displayName + ' - ' + scope.row.givenName + '  ' + scope.row.familyName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "school",
      "label": "Affiliation",
      "min-width": "190"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "trip",
      "label": "Trips",
      "width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "action",
      "label": "Edit Enabled",
      "width": "130",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-switch', {
          attrs: {
            "active-color": "#13ce66",
            "inactive-color": "#ff4949"
          },
          on: {
            "change": function($event) {
              return _vm.editEnable(scope.row)
            }
          },
          model: {
            value: (scope.row.editEnabled),
            callback: function($$v) {
              _vm.$set(scope.row, "editEnabled", $$v)
            },
            expression: "scope.row.editEnabled"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "action",
      "label": "Actions",
      "width": "130",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini",
            "icon": "el-icon-edit"
          },
          on: {
            "click": function($event) {
              return _vm.Editstudent(scope.row)
            }
          }
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "mini",
            "icon": "el-icon-delete"
          },
          on: {
            "click": function($event) {
              return _vm.removestudent(scope.row)
            }
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center mt-20 mb-50"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.size,
      "current-page": _vm.currentPage,
      "page-count": _vm.totalPages
    },
    on: {
      "current-change": _vm.pageCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit User",
      "customClass": "dialogStyle",
      "visible": _vm.Editdialog
    },
    on: {
      "update:visible": function($event) {
        _vm.Editdialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "editform",
    attrs: {
      "model": _vm.editform,
      "rules": _vm.editrules,
      "label-width": "145px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Email Address",
      "prop": "Eemail"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Email Address"
    },
    on: {
      "change": function($event) {
        _vm.isDirty = true
      }
    },
    model: {
      value: (_vm.editform.Eemail),
      callback: function($$v) {
        _vm.$set(_vm.editform, "Eemail", $$v)
      },
      expression: "editform.Eemail"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Change Password",
      "prop": "checked"
    }
  }, [_c('el-checkbox', {
    on: {
      "change": _vm.changePass
    },
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }, [_vm._v("Change Password")])], 1), _vm._v(" "), (_vm.willshow) ? [_c('el-form-item', {
    attrs: {
      "label": "Password",
      "prop": "Epassword"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "Password should contain 8 to 20 characters."
    },
    model: {
      value: (_vm.editform.Epassword),
      callback: function($$v) {
        _vm.$set(_vm.editform, "Epassword", $$v)
      },
      expression: "editform.Epassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Confirm Password",
      "prop": "EconfirmPassword"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "Confirm Password"
    },
    model: {
      value: (_vm.editform.EconfirmPassword),
      callback: function($$v) {
        _vm.$set(_vm.editform, "EconfirmPassword", $$v)
      },
      expression: "editform.EconfirmPassword"
    }
  })], 1)] : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Given Name",
      "prop": "EgivenName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Given Name"
    },
    on: {
      "change": function($event) {
        _vm.isDirty = true
      }
    },
    model: {
      value: (_vm.editform.EgivenName),
      callback: function($$v) {
        _vm.$set(_vm.editform, "EgivenName", $$v)
      },
      expression: "editform.EgivenName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Family Name",
      "prop": "EfamilyName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Family Name"
    },
    on: {
      "change": function($event) {
        _vm.isDirty = true
      }
    },
    model: {
      value: (_vm.editform.EfamilyName),
      callback: function($$v) {
        _vm.$set(_vm.editform, "EfamilyName", $$v)
      },
      expression: "editform.EfamilyName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Display Name",
      "prop": "EdisplayName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Display Name"
    },
    on: {
      "change": function($event) {
        _vm.isDirty = true
      }
    },
    model: {
      value: (_vm.editform.EdisplayName),
      callback: function($$v) {
        _vm.$set(_vm.editform, "EdisplayName", $$v)
      },
      expression: "editform.EdisplayName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Affiliation",
      "prop": "Eschool"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Affiliation"
    },
    on: {
      "change": function($event) {
        _vm.isDirty = true
      }
    },
    model: {
      value: (_vm.editform.Eschool),
      callback: function($$v) {
        _vm.$set(_vm.editform, "Eschool", $$v)
      },
      expression: "editform.Eschool"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Trips",
      "prop": "trip"
    }
  }, [_c('el-select', {
    attrs: {
      "no-match-text": "No data",
      "no-data-text": "No data",
      "filterable": "",
      "placeholder": "Please select trip"
    },
    on: {
      "change": function($event) {
        _vm.isTripDirty = true
      },
      "visible-change": _vm.showTripList
    },
    model: {
      value: (_vm.dialogtripid),
      callback: function($$v) {
        _vm.dialogtripid = $$v
      },
      expression: "dialogtripid"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Mobile Phone",
      "prop": "EmobilePhone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Mobile Phone"
    },
    on: {
      "change": function($event) {
        _vm.isDirty = true
      }
    },
    model: {
      value: (_vm.editform.EmobilePhone),
      callback: function($$v) {
        _vm.$set(_vm.editform, "EmobilePhone", $$v)
      },
      expression: "editform.EmobilePhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Father Phone",
      "prop": "EfatherPhone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Father Phone"
    },
    on: {
      "change": function($event) {
        _vm.isDirty = true
      }
    },
    model: {
      value: (_vm.editform.EfatherPhone),
      callback: function($$v) {
        _vm.$set(_vm.editform, "EfatherPhone", $$v)
      },
      expression: "editform.EfatherPhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Mother Phone",
      "prop": "EmotherPhone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Mother Phone"
    },
    on: {
      "change": function($event) {
        _vm.isDirty = true
      }
    },
    model: {
      value: (_vm.editform.EmotherPhone),
      callback: function($$v) {
        _vm.$set(_vm.editform, "EmotherPhone", $$v)
      },
      expression: "editform.EmotherPhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Deadline1",
      "prop": "EDeadline1"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "picker-options": _vm.pickerOptions,
      "placeholder": "Please select deadline"
    },
    on: {
      "change": function($event) {
        _vm.isDirty = true
      }
    },
    model: {
      value: (_vm.editform.EDeadline1),
      callback: function($$v) {
        _vm.$set(_vm.editform, "EDeadline1", $$v)
      },
      expression: "editform.EDeadline1"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Deadline2",
      "prop": "EDeadline2"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "picker-options": _vm.pickerOptions,
      "placeholder": "Please select deadline"
    },
    on: {
      "change": function($event) {
        _vm.isDirty = true
      }
    },
    model: {
      value: (_vm.editform.EDeadline2),
      callback: function($$v) {
        _vm.$set(_vm.editform, "EDeadline2", $$v)
      },
      expression: "editform.EDeadline2"
    }
  })], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.Editdialog = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveBtnIsLoading
    },
    on: {
      "click": function($event) {
        return _vm.submitedit('editform')
      }
    }
  }, [_vm._v("Save")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.existeddialog_title,
      "visible": _vm.existeddialog,
      "width": "90%",
      "customClass": "dialogWidth-1000"
    },
    on: {
      "update:visible": function($event) {
        _vm.existeddialog = $event
      }
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "mb-20",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "empty-text": "No data",
      "max-height": "250",
      "data": _vm.existedList,
      "border": "",
      "element-loading-text": "loading..."
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "60",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "Name",
      "width": "220"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.displayName + ' - ' + scope.row.givenName + '  ' + scope.row.familyName))]), _vm._v(" "), (scope.row.trashed == true) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Deleted",
            "placement": "right"
          }
        }, [_c('i', {
          staticClass: "el-icon-delete gary"
        })]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "email",
      "label": "Email",
      "min-width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "action",
      "label": "Actions",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-radio-group', {
          model: {
            value: (_vm.ExistAction[props.$index]),
            callback: function($$v) {
              _vm.$set(_vm.ExistAction, props.$index, $$v)
            },
            expression: "ExistAction[props.$index]"
          }
        }, [_c('el-radio', {
          attrs: {
            "label": "Update"
          }
        }, [_vm._v("Update")]), _vm._v(" "), _c('el-radio', {
          attrs: {
            "label": "New"
          }
        }, [_vm._v("New Report")]), _vm._v(" "), _c('el-radio', {
          attrs: {
            "label": "Skip"
          }
        }, [_vm._v("Skip")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('ul', {
    staticClass: "actionIntro p-20"
  }, [_c('li', [_vm._v("Update: 用新导入的学生信息覆盖更新已有信息")]), _vm._v(" "), _c('li', [_vm._v("Skip: 什么也不做跳过此条学生信息")]), _vm._v(" "), _c('li', [_vm._v("New Report: 适用于学生重复参加项目的情况，会将当前报告归档并生成新的报告，请谨慎选择")])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.importexitedAllSkip
    }
  }, [_vm._v("All Skip")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saving
    },
    on: {
      "click": _vm.importexitedStu
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 616:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://seed-static.seedasdan.com/wordpress/2024/09/aseeder-logo-new.png?x-oss-process=image/resize,m_fill,w_160,h_48"
    }
  })])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "mt-20 text-right",
    attrs: {
      "span": 18
    }
  }, [(this.Role != 'admin') ? _c('el-badge', {
    staticClass: "mr-40",
    attrs: {
      "value": _vm.NotificationCount
    }
  }, [_c('router-link', {
    staticClass: "dark",
    attrs: {
      "to": "/notification",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "el-icon-message"
  })])], 1) : _vm._e(), _vm._v(" "), _c('el-dropdown', {
    attrs: {
      "trigger": "hover"
    },
    on: {
      "command": _vm.handleCommand
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_vm._v("\n                        Hello " + _vm._s(_vm.LoginName) + " "), _c('i', {
    staticClass: "el-icon-caret-bottom el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [(this.Role == 'student') ? _c('el-dropdown-item', {
    staticClass: "font-eeSmall",
    attrs: {
      "command": "password"
    }
  }, [_c('i', {
    staticClass: "icon ion-unlocked mr-10"
  }), _vm._v(" Change Password\n                            ")]) : _vm._e(), _vm._v(" "), _c('el-dropdown-item', {
    staticClass: "font-eeSmall",
    attrs: {
      "command": "logout"
    }
  }, [_c('i', {
    staticClass: "icon ion-log-out mr-10"
  }), _vm._v("\n                                Log out\n                            ")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Change Password",
      "visible": _vm.changePassDialog,
      "customClass": "dialogStyle"
    },
    on: {
      "update:visible": function($event) {
        _vm.changePassDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "passform",
    attrs: {
      "model": _vm.passform,
      "rules": _vm.changePassRules,
      "label-width": "145px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Current Password",
      "prop": "oldPwd"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.passform.oldPwd),
      callback: function($$v) {
        _vm.$set(_vm.passform, "oldPwd", $$v)
      },
      expression: "passform.oldPwd"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "New Password",
      "prop": "newPwd"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.passform.newPwd),
      callback: function($$v) {
        _vm.$set(_vm.passform, "newPwd", $$v)
      },
      expression: "passform.newPwd"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.changePassDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.changeSaveBtnIsLoading
    },
    on: {
      "click": function($event) {
        return _vm.submitPass('passform')
      }
    }
  }, [_vm._v("Save")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit User",
      "visible": _vm.editDialog,
      "customClass": "dialogStyle"
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialog = $event
      }
    }
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.profileLoading),
      expression: "profileLoading"
    }],
    ref: "editform",
    attrs: {
      "model": _vm.editform,
      "rules": _vm.editrules,
      "label-width": "145px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Email Address",
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Email Address"
    },
    model: {
      value: (_vm.editform.email),
      callback: function($$v) {
        _vm.$set(_vm.editform, "email", $$v)
      },
      expression: "editform.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Given Name",
      "prop": "givenName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Given Name"
    },
    model: {
      value: (_vm.editform.givenName),
      callback: function($$v) {
        _vm.$set(_vm.editform, "givenName", $$v)
      },
      expression: "editform.givenName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Family Name",
      "prop": "familyName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Family Name"
    },
    model: {
      value: (_vm.editform.familyName),
      callback: function($$v) {
        _vm.$set(_vm.editform, "familyName", $$v)
      },
      expression: "editform.familyName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Display Name",
      "prop": "displayName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Display Name"
    },
    model: {
      value: (_vm.editform.displayName),
      callback: function($$v) {
        _vm.$set(_vm.editform, "displayName", $$v)
      },
      expression: "editform.displayName"
    }
  })], 1), _vm._v(" "), (this.Role === 'student') ? _c('el-form-item', {
    attrs: {
      "label": "Affiliation",
      "prop": "school"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Affiliation"
    },
    model: {
      value: (_vm.editform.school),
      callback: function($$v) {
        _vm.$set(_vm.editform, "school", $$v)
      },
      expression: "editform.school"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Mobile Phone",
      "prop": "mobilePhone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Mobile Phone"
    },
    model: {
      value: (_vm.editform.mobilePhone),
      callback: function($$v) {
        _vm.$set(_vm.editform, "mobilePhone", $$v)
      },
      expression: "editform.mobilePhone"
    }
  })], 1), _vm._v(" "), (this.Role == 'student') ? _c('el-form-item', {
    attrs: {
      "label": "Father Phone",
      "prop": "fatherPhone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Father Phone"
    },
    model: {
      value: (_vm.editform.fatherPhone),
      callback: function($$v) {
        _vm.$set(_vm.editform, "fatherPhone", $$v)
      },
      expression: "editform.fatherPhone"
    }
  })], 1) : _vm._e(), _vm._v(" "), (this.Role == 'student') ? _c('el-form-item', {
    attrs: {
      "label": "Mother Phone",
      "prop": "motherPhone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Mother Phone"
    },
    model: {
      value: (_vm.editform.motherPhone),
      callback: function($$v) {
        _vm.$set(_vm.editform, "motherPhone", $$v)
      },
      expression: "editform.motherPhone"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editSaveBtnIsLoading
    },
    on: {
      "click": function($event) {
        return _vm.submitedit('editform')
      }
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 617:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    staticClass: "row-bg p-10 mt-10 bg-lightgarg",
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "grid-content"
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "no-match-text": "No data",
      "no-data-text": "No data",
      "filterable": "",
      "clearable": "",
      "placeholder": "Trip"
    },
    on: {
      "change": function($event) {}
    },
    model: {
      value: (_vm.selecttripvalue),
      callback: function($$v) {
        _vm.selecttripvalue = $$v
      },
      expression: "selecttripvalue"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)])], 1), _vm._v(" "), _c('transfer-box', {
    attrs: {
      "selecttripvalue": _vm.selecttripvalue
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 618:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    staticClass: "row-bg p-10 mt-10 bg-lightgarg",
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('el-col', {
    staticClass: "mr-10",
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "Trip",
      "loading": _vm.loading,
      "loading-text": "loading...",
      "no-match-text": "No data",
      "no-data-text": "No data"
    },
    on: {
      "change": _vm.tripSelectList,
      "visible-change": _vm.showTripList
    },
    model: {
      value: (_vm.selectTripValue),
      callback: function($$v) {
        _vm.selectTripValue = $$v
      },
      expression: "selectTripValue"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-input', {
    staticClass: "input-setMaxWidth",
    attrs: {
      "placeholder": "Search anything about users"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleIconClick.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.keywords),
      callback: function($$v) {
        _vm.keywords = $$v
      },
      expression: "keywords"
    }
  }, [_c('i', {
    staticClass: "el-input__icon el-icon-search",
    attrs: {
      "slot": "suffix"
    },
    on: {
      "click": _vm.handleIconClick
    },
    slot: "suffix"
  })])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 15
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('a', {
    attrs: {
      "href": __webpack_require__(223)
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_c('i', {
    staticClass: "icon ion-android-download"
  }), _vm._v(" EPQ offline document")])], 1)])])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "mt-20",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "empty-text": "No data",
      "data": _vm.MyStudents,
      "element-loading-text": _vm.loadingText,
      "expand-row-keys": _vm.expandRowKeys,
      "row-key": _vm.getRowKey
    },
    on: {
      "expand-change": _vm.getExpand
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand",
      "prop": "id"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-tabs', {
          attrs: {
            "type": "border-card"
          },
          on: {
            "tab-click": function($event) {
              return _vm.getStuReport($event, props.$index, props.row)
            }
          }
        }, [_c('el-tab-pane', {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: (props.row.loadingReport),
            expression: "props.row.loadingReport"
          }],
          attrs: {
            "label": "EPQ",
            "element-loading-text": "loading..."
          }
        }, [_c('el-form', {
          staticClass: "demo-table-expand",
          attrs: {
            "label-position": "left",
            "inline": ""
          }
        }, [_vm._l((_vm.MyStudents[props.$index].reportC.skillList), function(skill, index) {
          return _c('el-form-item', {
            key: index,
            attrs: {
              "label": skill.abbr
            }
          }, _vm._l((skill.pageList), function(page, index) {
            return _c('el-button-group', {
              key: index,
              staticClass: "pt-7"
            }, [_c('el-button', {
              key: index,
              staticClass: "p-5",
              class: page.confirmed == null ? 'info' : page.confirmed ? 'success' : 'primary',
              attrs: {
                "plain": "",
                "icon": "el-icon-edit-outline"
              },
              on: {
                "click": function($event) {
                  _vm.showPage(skill, page.page, page.id, props.$index, 'epq')
                }
              }
            }), _vm._v(" "), _c('router-link', {
              staticClass: "white mr-10",
              attrs: {
                "target": "_blank",
                "to": {
                  path: 'evidence',
                  query: {
                    studentId: props.row.id,
                    studentName: (props.row.displayName + ' ' + props.row.givenName + ' ' + props.row.familyName),
                    pageId: page.id,
                    skillAbbr: skill.abbr,
                    skillName: skill.name,
                    pageName: page.page,
                    reportId: props.row.reportC.id,
                    reportName: props.row.reportC.category,
                    reportIndex: _vm.$route.path
                  }
                },
                "append": ""
              }
            }, [_c('el-button', {
              staticClass: "p-evidence",
              attrs: {
                "plain": ""
              }
            }, [_c('i', {
              staticClass: "icon ion-folder",
              class: page.evidenceConfirmed == null ? 'info' : page.evidenceConfirmed ? 'success' : 'primary'
            })])], 1)], 1)
          }), 1)
        }), _vm._v(" "), _c('el-form-item', {
          staticClass: "full-width"
        }, [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.download(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "icon ion-shuffle mt-none"
        }), _vm._v(" Generate Report (PDF)\n                                    ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "warning",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.downloadDocx(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "icon ion-shuffle mt-none"
        }), _vm._v(" Generate Report (DOCX)\n                                    ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "success",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.preview(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "icon el-icon-picture-outline"
        }), _vm._v(" Report Preview\n                                    ")])], 1)], 2)], 1), _vm._v(" "), _c('el-tab-pane', {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: (props.row.loadingReport),
            expression: "props.row.loadingReport"
          }],
          attrs: {
            "label": "LOG",
            "element-loading-text": "loading..."
          }
        }, [_c('el-form', {
          staticClass: "demo-table-expand",
          attrs: {
            "label-position": "left",
            "inline": ""
          }
        }, _vm._l((_vm.MyStudents[props.$index].report.skillList), function(skill, index) {
          return _c('el-form-item', {
            key: index,
            staticClass: "log",
            attrs: {
              "label": skill.abbr
            }
          }, _vm._l((skill.pageList), function(page, index) {
            return _c('el-button-group', {
              key: index,
              staticClass: "pt-7"
            }, [_c('el-button', {
              key: index,
              staticClass: "p-5",
              attrs: {
                "plain": "",
                "icon": "el-icon-edit-outline"
              },
              on: {
                "click": function($event) {
                  _vm.showPage(skill, page.page, page.id, props.$index, 'log')
                }
              }
            })], 1)
          }), 1)
        }), 1)], 1)], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Name",
      "width": "220"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.displayName + ' - ' + scope.row.givenName + '  ' + scope.row.familyName))]), _vm._v(" "), _c('router-link', {
          attrs: {
            "to": {
              path: '/notification',
              query: {
                studentId: scope.row.id,
                studentName: (scope.row.displayName + ' - ' + scope.row.givenName + '  ' + scope.row.familyName)
              }
            },
            "target": "_blank"
          }
        }, [_c('el-badge', {
          attrs: {
            "value": _vm.role === 'teacher' || _vm.role === 'ta' ? scope.row.notificationCount : 0,
            "hidden": scope.row.notificationCount === 0
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Affiliation",
      "prop": "school",
      "min-width": "190"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "deadline1",
      "prop": "deadline1",
      "min-width": "190"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "deadline2",
      "prop": "deadline2",
      "min-width": "190"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Terms",
      "prop": "trip"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center mt-20 mb-50"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.size,
      "current-page": _vm.currentPageTable,
      "page-count": _vm.totalPages
    },
    on: {
      "current-change": _vm.pageCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit User",
      "visible": _vm.Editdialog,
      "customClass": "dialogStyle"
    },
    on: {
      "update:visible": function($event) {
        _vm.Editdialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "editform",
    attrs: {
      "model": _vm.editform,
      "rules": _vm.editrules,
      "label-width": "145px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Email Address",
      "prop": "Eemail"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Email Address"
    },
    on: {
      "change": function($event) {
        _vm.isDirty = true
      }
    },
    model: {
      value: (_vm.editform.Eemail),
      callback: function($$v) {
        _vm.$set(_vm.editform, "Eemail", $$v)
      },
      expression: "editform.Eemail"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item-default",
    attrs: {
      "label": "Change Password",
      "prop": "checked"
    }
  }, [_c('el-checkbox', {
    on: {
      "change": _vm.changePass
    },
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }, [_vm._v("Change Password")])], 1), _vm._v(" "), (_vm.willshow) ? [_c('el-form-item', {
    attrs: {
      "label": "Password",
      "prop": "Epassword"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "Password should contain 8 to 20 characters."
    },
    model: {
      value: (_vm.editform.Epassword),
      callback: function($$v) {
        _vm.$set(_vm.editform, "Epassword", $$v)
      },
      expression: "editform.Epassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Confirm Password",
      "prop": "EconfirmPassword"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "Confirm Password"
    },
    model: {
      value: (_vm.editform.EconfirmPassword),
      callback: function($$v) {
        _vm.$set(_vm.editform, "EconfirmPassword", $$v)
      },
      expression: "editform.EconfirmPassword"
    }
  })], 1)] : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Given Name",
      "prop": "EgivenName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Given Name"
    },
    on: {
      "change": function($event) {
        _vm.isDirty = true
      }
    },
    model: {
      value: (_vm.editform.EgivenName),
      callback: function($$v) {
        _vm.$set(_vm.editform, "EgivenName", $$v)
      },
      expression: "editform.EgivenName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Family Name",
      "prop": "EfamilyName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Family Name"
    },
    on: {
      "change": function($event) {
        _vm.isDirty = true
      }
    },
    model: {
      value: (_vm.editform.EfamilyName),
      callback: function($$v) {
        _vm.$set(_vm.editform, "EfamilyName", $$v)
      },
      expression: "editform.EfamilyName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Display Name",
      "prop": "EdisplayName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Display Name"
    },
    on: {
      "change": function($event) {
        _vm.isDirty = true
      }
    },
    model: {
      value: (_vm.editform.EdisplayName),
      callback: function($$v) {
        _vm.$set(_vm.editform, "EdisplayName", $$v)
      },
      expression: "editform.EdisplayName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "School",
      "prop": "Eschool"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Affiliation"
    },
    on: {
      "change": function($event) {
        _vm.isDirty = true
      }
    },
    model: {
      value: (_vm.editform.Eschool),
      callback: function($$v) {
        _vm.$set(_vm.editform, "Eschool", $$v)
      },
      expression: "editform.Eschool"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Trips",
      "prop": "trip"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "no-match-text": "No data",
      "no-data-text": "No data",
      "placeholder": "Please select trip",
      "visible-change": "getTrip"
    },
    on: {
      "change": function($event) {
        _vm.isTripDirty = true
      }
    },
    model: {
      value: (_vm.dialogtripid),
      callback: function($$v) {
        _vm.dialogtripid = $$v
      },
      expression: "dialogtripid"
    }
  }, _vm._l((_vm.options), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Mobile Phone",
      "prop": "EmobilePhone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Mobile Phone"
    },
    on: {
      "change": function($event) {
        _vm.isDirty = true
      }
    },
    model: {
      value: (_vm.editform.EmobilePhone),
      callback: function($$v) {
        _vm.$set(_vm.editform, "EmobilePhone", $$v)
      },
      expression: "editform.EmobilePhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Father Phone",
      "prop": "EfatherPhone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Father Phone"
    },
    on: {
      "change": function($event) {
        _vm.isDirty = true
      }
    },
    model: {
      value: (_vm.editform.EfatherPhone),
      callback: function($$v) {
        _vm.$set(_vm.editform, "EfatherPhone", $$v)
      },
      expression: "editform.EfatherPhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Mother Phone",
      "prop": "EmotherPhone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Mother Phone"
    },
    on: {
      "change": function($event) {
        _vm.isDirty = true
      }
    },
    model: {
      value: (_vm.editform.EmotherPhone),
      callback: function($$v) {
        _vm.$set(_vm.editform, "EmotherPhone", $$v)
      },
      expression: "editform.EmotherPhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Deadline1",
      "prop": "EDeadline1"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "picker-options": _vm.pickerOptions,
      "placeholder": "Please select deadline"
    },
    on: {
      "change": function($event) {
        _vm.isDirty = true
      }
    },
    model: {
      value: (_vm.editform.EDeadline1),
      callback: function($$v) {
        _vm.$set(_vm.editform, "EDeadline1", $$v)
      },
      expression: "editform.EDeadline1"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Deadline2",
      "prop": "EDeadline2"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "picker-options": _vm.pickerOptions,
      "placeholder": "Please select deadline"
    },
    on: {
      "change": function($event) {
        _vm.isDirty = true
      }
    },
    model: {
      value: (_vm.editform.EDeadline2),
      callback: function($$v) {
        _vm.$set(_vm.editform, "EDeadline2", $$v)
      },
      expression: "editform.EDeadline2"
    }
  })], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.Editdialog = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveBtnIsLoading
    },
    on: {
      "click": function($event) {
        return _vm.submitedit('editform')
      }
    }
  }, [_vm._v("Save")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Generate Report",
      "visible": _vm.showReportDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.showReportDialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "inline": "",
      "label-position": "right",
      "label-width": "130px"
    },
    model: {
      value: (_vm.reportDialogParam),
      callback: function($$v) {
        _vm.reportDialogParam = $$v
      },
      expression: "reportDialogParam"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin-bottom": "15px",
      "color": "#C0C4CC"
    }
  }, [_c('el-col', [_c('span', [_vm._v("This will be used to sign the check list and all the pages, leave empty if you don't want to sign.")])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "Assessor"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.reportDialogParam.assessor),
      callback: function($$v) {
        _vm.$set(_vm.reportDialogParam, "assessor", $$v)
      },
      expression: "reportDialogParam.assessor"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "Internal Moderator"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.reportDialogParam.moderator),
      callback: function($$v) {
        _vm.$set(_vm.reportDialogParam, "moderator", $$v)
      },
      expression: "reportDialogParam.moderator"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showReportDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveBtnIsLoading
    },
    on: {
      "click": function($event) {
        return _vm.download(_vm.student, _vm.reportDialogParam.category)
      }
    }
  }, [_vm._v("OK")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.configSkillDialogLoading),
      expression: "configSkillDialogLoading"
    }],
    attrs: {
      "title": _vm.configSkillTitle,
      "visible": _vm.configSkillDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.configSkillDialog = $event
      }
    }
  }, [_c('el-checkbox-group', {
    attrs: {
      "max": 3,
      "min": 1
    },
    on: {
      "change": _vm.changeCheckedSkill
    },
    model: {
      value: (_vm.checkedSkillsName),
      callback: function($$v) {
        _vm.checkedSkillsName = $$v
      },
      expression: "checkedSkillsName"
    }
  }, [_c('div', {
    staticClass: "configAope"
  }, _vm._l((_vm.allAopeSkills), function(skill) {
    return _c('el-checkbox', {
      key: skill.id,
      attrs: {
        "label": skill.name
      }
    }, [_vm._v(_vm._s(skill.name))])
  }), 1)]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.configSkillDialog = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitAopeSkillLoading
    },
    on: {
      "click": _vm.submitAopeSkill
    }
  }, [_vm._v("Save")])], 1)], 1), _vm._v(" "), _c('skill-dialog', {
    ref: "reportDialog",
    attrs: {
      "report": _vm.report
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "generate-link"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 619:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "asdan-background"
  }, [_c('common-header'), _vm._v(" "), (_vm.Role == 'student' && _vm.tips !== '') ? _c('el-row', {
    staticClass: "mt-20",
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-alert', {
    attrs: {
      "title": _vm.tips,
      "type": "warning",
      "show-icon": ""
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
    staticClass: "main",
    attrs: {
      "type": "flex",
      "justify": "center",
      "id": "main"
    }
  }, [_c('el-col', {
    staticClass: "main-content mt-20 mb-20",
    attrs: {
      "span": 22
    }
  }, [_c('div', {
    staticClass: "main-left"
  }, [_c('div', {
    staticClass: "pt-20"
  }, _vm._l((_vm.$router.options.routes), function(roleRoot, index) {
    return (_vm.matchedPath(roleRoot)) ? _c('el-menu', {
      key: index,
      staticClass: "el-menu-vertical-demo",
      attrs: {
        "default-active": _vm.getMenuActive(),
        "router": ""
      }
    }, _vm._l((roleRoot.children), function(child, index) {
      return (!child.hiddenFromMenu) ? _c('el-menu-item', {
        key: index,
        attrs: {
          "index": roleRoot.path + '/' + child.path
        }
      }, [_c('i', {
        class: child.iconCls
      }), _vm._v(" "), _c('span', {
        staticClass: "ml-5"
      }), _vm._v(_vm._s(child.name) + "\n                        ")]) : _vm._e()
    }), 1) : _vm._e()
  }), 1)]), _vm._v(" "), _c('div', {
    staticClass: "main-right pl-20 pr-20 mt-20"
  }, [_c('div', {
    staticClass: "content-container"
  }, [_c('router-view', {
    on: {
      "setTips": _vm.handleTips
    }
  })], 1)])])], 1), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "copyright text-center pb-15"
  }, [_c('p', {
    staticClass: "gary"
  }, [_vm._v("© 2020 ASDAN China.")])])
}]}

/***/ }),

/***/ 620:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticClass: "breadcrumb"
  }, [_vm._v("MANAGE TRIP")]), _vm._v(" "), _c('el-row', {
    staticClass: "row-bg p-10 mt-10 bg-lightgarg",
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "grid-content"
  }, [_c('el-button', {
    attrs: {
      "type": "success",
      "icon": "el-icon-plus"
    },
    on: {
      "click": function($event) {
        _vm.CreatTripdialog = true
      }
    }
  }, [_vm._v("New Trip")])], 1)])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "mt-20",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "empty-text": "No data",
      "element-loading-text": "loading...",
      "data": _vm.TripData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "saEditEnabled",
      "label": "SA Edit Enabled",
      "width": "180",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-switch', {
          attrs: {
            "active-color": "#13ce66",
            "inactive-color": "#ff4949"
          },
          on: {
            "change": function($event) {
              return _vm.editSaEnable(scope.row)
            }
          },
          model: {
            value: (scope.row.saEditEnabled),
            callback: function($$v) {
              _vm.$set(scope.row, "saEditEnabled", $$v)
            },
            expression: "scope.row.saEditEnabled"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "taEditEnabled",
      "label": "TA Edit Enabled",
      "width": "180",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-switch', {
          attrs: {
            "active-color": "#13ce66",
            "inactive-color": "#ff4949"
          },
          on: {
            "change": function($event) {
              return _vm.editTaEnable(scope.row)
            }
          },
          model: {
            value: (scope.row.taEditEnabled),
            callback: function($$v) {
              _vm.$set(scope.row, "taEditEnabled", $$v)
            },
            expression: "scope.row.taEditEnabled"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "student",
      "label": "Student Edit Enabled",
      "width": "180",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-switch', {
          attrs: {
            "active-color": "#13ce66",
            "inactive-color": "#ff4949"
          },
          on: {
            "change": function($event) {
              return _vm.editStudentEnable(scope.row)
            }
          },
          model: {
            value: (scope.row.studentEditEnabled),
            callback: function($$v) {
              _vm.$set(scope.row, "studentEditEnabled", $$v)
            },
            expression: "scope.row.studentEditEnabled"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "action",
      "label": "Actions",
      "width": "130",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini",
            "icon": "el-icon-edit"
          },
          on: {
            "click": function($event) {
              return _vm.EditTrip(scope.row)
            }
          }
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "mini",
            "icon": "el-icon-delete"
          },
          on: {
            "click": function($event) {
              return _vm.DeleteTrip(scope.row)
            }
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Create Trip",
      "visible": _vm.CreatTripdialog,
      "customClass": "dialogStyle"
    },
    on: {
      "update:visible": function($event) {
        _vm.CreatTripdialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "Newform",
    attrs: {
      "model": _vm.Newform,
      "rules": _vm.newrules
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Trip Name",
      "prop": "NewName",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('div', {
    staticClass: "el-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Newform.NewName),
      expression: "Newform.NewName"
    }],
    staticClass: "el-input__inner",
    attrs: {
      "placeholder": "Trip Name",
      "auto-complete": "off"
    },
    domProps: {
      "value": (_vm.Newform.NewName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.NewTrip('Newform')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Newform, "NewName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Trip Tips",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.Newform.tips),
      callback: function($$v) {
        _vm.$set(_vm.Newform, "tips", $$v)
      },
      expression: "Newform.tips"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "period of Tips",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd",
      "range-separator": "to",
      "start-placeholder": "start",
      "end-placeholder": "end",
      "picker-options": _vm.endPickerOptions0
    },
    model: {
      value: (_vm.Newform.date),
      callback: function($$v) {
        _vm.$set(_vm.Newform, "date", $$v)
      },
      expression: "Newform.date"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.CreatTripdialog = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saving
    },
    on: {
      "click": function($event) {
        return _vm.NewTrip('Newform')
      }
    }
  }, [_vm._v("Save")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Trip",
      "visible": _vm.EditTripdialog,
      "customClass": "dialogStyle"
    },
    on: {
      "update:visible": function($event) {
        _vm.EditTripdialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "Editform",
    attrs: {
      "model": _vm.Editform,
      "rules": _vm.editrules
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Trip Name",
      "prop": "EditName",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "prop": "EditName",
      "placeholder": "Trip Name",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.Editform.EditName),
      callback: function($$v) {
        _vm.$set(_vm.Editform, "EditName", $$v)
      },
      expression: "Editform.EditName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Trip Tips",
      "prop": "tips",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.Editform.tips),
      callback: function($$v) {
        _vm.$set(_vm.Editform, "tips", $$v)
      },
      expression: "Editform.tips"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "period of Tips",
      "prop": "date",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd",
      "range-separator": "to",
      "start-placeholder": "start",
      "end-placeholder": "end",
      "picker-options": _vm.endPickerOptions0
    },
    model: {
      value: (_vm.Editform.date),
      callback: function($$v) {
        _vm.$set(_vm.Editform, "date", $$v)
      },
      expression: "Editform.date"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.EditTripdialog = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saving
    },
    on: {
      "click": function($event) {
        return _vm.submitedit('Editform')
      }
    }
  }, [_vm._v("Save")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center mt-20 mb-50"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.size,
      "current-page": _vm.currentPage,
      "page-count": _vm.totalPages
    },
    on: {
      "current-change": _vm.pageCurrentChange
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 621:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "asdan-background"
  }, [_c('header', [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('div', {
    staticClass: "grid-content"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://seed-static.seedasdan.com/wordpress/2024/09/aseeder-logo-new.png?x-oss-process=image/resize,m_fill,w_160,h_48"
    }
  })])], 1)])], 1), _vm._v(" "), _c('img', {
    staticClass: "asdan-background-image",
    attrs: {
      "src": __webpack_require__(587)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "asdan-background-mask"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "asdan-login"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body pl-20 pr-20"
  }, [_c('el-form', {
    ref: "logform",
    attrs: {
      "model": _vm.logform,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "username"
    }
  }, [_c('el-input', {
    staticClass: "pt-20",
    attrs: {
      "maxlength": _vm.Emaxlength,
      "placeholder": "Email Address",
      "name": "email",
      "auto-complete": "on"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitForm('logform')
      }
    },
    model: {
      value: (_vm.logform.username),
      callback: function($$v) {
        _vm.$set(_vm.logform, "username", $$v)
      },
      expression: "logform.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": _vm.Pmaxlength,
      "placeholder": "Password",
      "type": "password"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitForm('logform')
      }
    },
    model: {
      value: (_vm.logform.password),
      callback: function($$v) {
        _vm.$set(_vm.logform, "password", $$v)
      },
      expression: "logform.password"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('logform')
      }
    }
  }, [_vm._v("Log In to ASDAN")])], 1)], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-title"
  }, [_c('h5', {
    staticClass: "pb-5 pl-10"
  }, [_vm._v("Log In")])])
}]}

/***/ }),

/***/ 622:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(546);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(229)("520f97a6", content, true);

/***/ }),

/***/ 623:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(547);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(229)("3c0dfd95", content, true);

/***/ }),

/***/ 624:
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),

/***/ 625:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(528);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(13)("7651c0ae", content, true, {});

/***/ }),

/***/ 626:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(529);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(13)("a37f6476", content, true, {});

/***/ }),

/***/ 627:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(530);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(13)("1aba2648", content, true, {});

/***/ }),

/***/ 628:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(531);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(13)("63fe67e1", content, true, {});

/***/ }),

/***/ 629:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(532);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(13)("db745ed4", content, true, {});

/***/ }),

/***/ 630:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(533);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(13)("1f7f5a88", content, true, {});

/***/ }),

/***/ 631:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(534);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(13)("d3ce132a", content, true, {});

/***/ }),

/***/ 632:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(535);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(13)("d57f3d50", content, true, {});

/***/ }),

/***/ 633:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(536);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(13)("b31c13ea", content, true, {});

/***/ }),

/***/ 634:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(537);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(13)("31615bd6", content, true, {});

/***/ }),

/***/ 635:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(538);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(13)("579d8ce4", content, true, {});

/***/ }),

/***/ 636:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(539);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(13)("4fd76c0c", content, true, {});

/***/ }),

/***/ 637:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(540);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(13)("106d8eb5", content, true, {});

/***/ }),

/***/ 638:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(541);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(13)("469beff6", content, true, {});

/***/ }),

/***/ 639:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(542);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(13)("66fe1b1c", content, true, {});

/***/ }),

/***/ 640:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(543);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(13)("42c16c0f", content, true, {});

/***/ }),

/***/ 641:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(544);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(13)("164a72f6", content, true, {});

/***/ }),

/***/ 642:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(545);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(13)("5a2205c5", content, true, {});

/***/ }),

/***/ 643:
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ })

},[293]);


// WEBPACK FOOTER //
// index-f7cb631496a138bf5ab4.js